<template>
    <!-- Call Report Creation Page -->
    <div class="page-layout blank contacts-manage" v-if="ajaxCallInProgress">
        <div class="d-flex align-items-center justify-content-center h-100">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
    </div>
    <div class="page-layout blank contacts-manage" v-else>
        <div class="pb-10 pr-3 pl-3">
            <!-- Breadcrumb Section -->
            <div class="breadcrumbnew">
                <span>
                    <router-link to="/callreportlist" class="text-white pl-2 text-line">Call Report</router-link>
                </span>
                <span @click="dataClear" class="ml-2 mr-5">Create New</span>
                <a>{{ createJson.call_report_category }}</a>
            </div>
            <div>
                <div class="page-layout carded left-sidebar"
                    style="border: 0px solid rgb(148, 190, 240) !important;border-radius: 0px !important;display:block">
                    <div class="page-content-wrapper" style="padding: 0 0rem;">
                        <div class="page-content custom-scrollbar" style="background-color: transparent !important;">
                            <div class="center-content">
                                <div class="preview-elements px-3">
                                    <div id="myTabContent">
                                        <div class="row">
                                            <div class="col-lg-12 px-0">
                                                <!-- Call report section heading  -->
                                                <div class="block-callreport pt-10 pb-18 px-4 mb-0">
                                                    <div class="text-center fs-14 fw-700"
                                                        style="color: #003cb9;text-transform: uppercase;">
                                                        {{ callreporttab ? 'GENERAL INFORMATION' : meetingnotestab ? 'MEETING NOTES' : followuptab ? 'FOLLOW UP' : salestargettab ? 'SALES TARGET' : '' }}
                                                        - {{ createJson.call_report_category}}
                                                    </div>
                                                    <div
                                                        class="d-flex justify-content-center align-items-center w-100 mt-6 mx-2">
                                                        <span
                                                            :class="callreporttab ? 'selectedCircle' : meetingnotestab || salestargettab || followuptab ? 'finishedCircle' : 'unfinishedCircle'"
                                                            class="mx-5">
                                                            1
                                                            <span
                                                                :class="callreporttab || meetingnotestab || salestargettab || followuptab ? 'finishedCircleText' : 'unfinishedCircleText'">
                                                                General Information
                                                            </span>
                                                        </span>
                                                        <span
                                                            :class="meetingnotestab || salestargettab || followuptab ? 'finishedDash' : 'unfinishedDash'">
                                                        </span>
                                                        <span
                                                            :class="meetingnotestab ? 'selectedCircle' : salestargettab || followuptab ? 'finishedCircle' : 'unfinishedCircle'"
                                                            class="mx-5">
                                                            2
                                                            <span
                                                                :class="meetingnotestab || salestargettab || followuptab ? 'finishedCircleText' : 'unfinishedCircleText'">
                                                                <!-- Meeting Notes -->
                                                                {{ createJson.call_report_category == 'Release Notes' ? 'Release Notes' : 'Meeting Notes' }}
                                                            </span>
                                                        </span>
                                                        <span v-if="createJson.call_report_category == 'Sales Meeting'"
                                                            :class="salestargettab || followuptab ? 'finishedDash' : 'unfinishedDash'">
                                                        </span>
                                                        <span v-if="createJson.call_report_category == 'Sales Meeting'"
                                                            :class="salestargettab ? 'selectedCircle' : followuptab ? 'finishedCircle' : 'unfinishedCircle'"
                                                            class="mx-5">
                                                            3
                                                            <span
                                                                :class="salestargettab || followuptab ? 'finishedCircleText' : 'unfinishedCircleText'">
                                                                Sales Target
                                                            </span>
                                                        </span>
                                                        <span :class="followuptab ? 'finishedDash' : 'unfinishedDash'">
                                                        </span>
                                                        <span
                                                            :class="followuptab ? 'selectedCircle' : 'unfinishedCircle'"
                                                            class="mx-5">
                                                            {{createJson.call_report_category == "Sales Meeting" ? "4" : "3"}}
                                                            <span
                                                                :class="followuptab ? 'finishedCircleText' : 'unfinishedCircleText'">
                                                                Follow Up
                                                            </span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="padding: 0px 0px 10px 0px;" id="myTabContent">
                                        <div class="mt-5" v-if="callreporttab" role="tabpanel"
                                            aria-labelledby="callreport-tab">
                                            <div class="row">
                                                <div class="col-lg-12 px-0">
                                                    <form autocomplete="off">
                                                        <input autocomplete="off" name="hidden" type="text"
                                                            style="display:none;" />
                                                            <!-- Basic Information Section -->
                                                        <div class="block-callreport">
                                                            <div class="infoHeaderHideShow mt-3 mb-3">
                                                                <div class="descriptionheader">
                                                                    <div class="description-text-header-left">
                                                                        <h5 class="fw-500 whiteSpace">Basic Information
                                                                        </h5>
                                                                    </div>
                                                                    <div class="description-text-header-right">
                                                                        <span class="collapse-addon"
                                                                            @click="expandTitle()">
                                                                            <i v-if="showTitle"
                                                                                class="icon-chevron-double-up text-white"></i>
                                                                            <i v-else
                                                                                class="icon-chevron-double-down text-white"></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-5 mb-5" v-show="showTitle == true">
                                                                <div class="col-lg-4 col-md-4 col-sm-4">
                                                                    <div class="form-group">
                                                                        <input class="inputFieldNew mt-6"
                                                                            name="title_name" type="text"
                                                                            v-model="createJson.title"
                                                                            v-validate="{required:true}"
                                                                            placeholder="Enter Report Title"
                                                                            :maxlength="maxlengthtitlename"
                                                                            @input="createJson.meeting_notes_subject = createJson.title" />
                                                                        <span class="inputBorder"></span>
                                                                        <label class="inputLabel fs-14 fw-600">
                                                                            Report Title
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </label>
                                                                        <span
                                                                            class="character-count text-grey">{{maxlengthtitlename - createJson.title.length}}/100</span>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('title_name')">{{errors.first('title_name')}}</span>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-4 col-md-4 col-sm-4">
                                                                    <div class="d-flex align-items-center">
                                                                        <div class="form-group w-100">
                                                                            <input class="inputFieldNew mt-6"
                                                                                type="text" name="author_name"
                                                                                v-model="createJson.author_name"
                                                                                placeholder="Enter Author Name"
                                                                                disabled />
                                                                            <span class="inputBorder"></span>
                                                                            <label class="inputLabel fs-14 fw-600">
                                                                                Author Name
                                                                            </label>
                                                                        </div>
                                                                        <i
                                                                            class="icon icon-check-circle fs-30 text-success mt-9 ml-2"></i>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-4 col-md-4 col-sm-4">
                                                                    <div class="d-flex align-items-center">
                                                                        <div class="form-group w-100">
                                                                            <input class="inputFieldNew mt-6"
                                                                                type="text" name="author_email"
                                                                                v-model="createJson.author_email"
                                                                                placeholder="Enter Author Email"
                                                                                v-validate="{regex:email_regex}"
                                                                                disabled />
                                                                            <span class="inputBorder"></span>
                                                                            <label class="inputLabel fs-14 fw-600">
                                                                                Author Email
                                                                            </label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                style="text-transform: none !important;"
                                                                                v-show="errors.has('author_email')">Please
                                                                                Enter Valid Email Address</span>
                                                                        </div>
                                                                        <i
                                                                            class="icon icon-check-circle fs-30 text-success mt-9 ml-2"></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-5 mb-5" v-show="showTitle == true">
                                                                <div class="col-lg-4 col-md-4 col-sm-4 mt-3">
                                                                    <span
                                                                        class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                                        Report Owner
                                                                    </span>
                                                                    <div class="d-flex">
                                                                        <multiselect
                                                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-4"
                                                                            name="owner_name"
                                                                            v-model="createJson.owner_name"
                                                                            @search-change="loadEmployeeSearch(internalCompanyObject,$event, 'report_owner')"
                                                                            @open="getEmployeeDetails(internalCompanyObject, 'report_owner')"
                                                                            :options="optionsEmployeeAttendees"
                                                                            :loading="report_owner_loading"
                                                                            label="full_name" track-by="email"
                                                                            :searchable="true" :close-on-select="true"
                                                                            :show-labels="false"
                                                                            placeholder="Select Owner Name"
                                                                            @close="dropdownClosed">
                                                                            <template slot="afterList">
                                                                                <div
                                                                                    v-observe-visibility="getMoreEmployeeDetails" />
                                                                            </template>
                                                                            <template slot="noOptions">
                                                                                <div
                                                                                    class="text-secondary text-center fw-600">
                                                                                    No Owner Found</div>
                                                                            </template>
                                                                            <template slot="noResult">
                                                                                <div
                                                                                    class="text-secondary text-center fw-600">
                                                                                    No Results Found</div>
                                                                            </template>
                                                                        </multiselect>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-4 col-md-4 col-sm-4 mt-2">
                                                                    <div class="d-flex align-items-center">
                                                                        <div class="form-group w-100">
                                                                            <input class="inputFieldNew mt-6"
                                                                                type="text" name="owner_email"
                                                                                v-model="createJson.owner_email"
                                                                                placeholder="Owner Email"
                                                                                v-validate="{regex:email_regex}"
                                                                                disabled />
                                                                            <span class="inputBorder"></span>
                                                                            <label class="inputLabel fs-14 fw-600">
                                                                                Owner Email
                                                                            </label>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                style="text-transform: none !important;"
                                                                                v-show="errors.has('owner_email')">Please
                                                                                Enter Valid Email Address</span>
                                                                        </div>
                                                                        <i
                                                                            class="icon icon-check-circle fs-30 text-success mt-9 ml-2"></i>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Company Details Section -->
                                                        <div class="block-callreport">
                                                            <div class="infoHeaderHideShow mt-3 mb-3">
                                                                <div class="descriptionheader">
                                                                    <div class="description-text-header-left">
                                                                        <h5 class="fw-500 whiteSpace">
                                                                            Company Details
                                                                            <sup class="fs-14 ml-02 mandatory">
                                                                                <el-tooltip class="item" effect="dark"
                                                                                    content="Company Name for User"
                                                                                    placement="top">
                                                                                    <i
                                                                                        class="icons icon-information text-white iconsize-16"></i>
                                                                                </el-tooltip>
                                                                            </sup>
                                                                        </h5>
                                                                    </div>
                                                                    <div class="description-text-header-right">
                                                                        <span class="collapse-addon"
                                                                            @click="expandInternal()">
                                                                            <i v-if="showInternal"
                                                                                class="icon-chevron-double-up text-white"></i>
                                                                            <i v-else
                                                                                class="icon-chevron-double-down text-white"></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-show="showInternal == true">
                                                                <div class="row">
                                                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                                                        <div class="row">
                                                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                                                <span
                                                                                    class="text-secondary whiteSpace fs-14 fw-600">
                                                                                    Company Name
                                                                                    <sup class="fs-14 mandatory">
                                                                                        <el-tooltip class="item"
                                                                                            effect="dark"
                                                                                            content="The options for this list are obtained from Company module"
                                                                                            placement="right"
                                                                                            style="word-break: break-word;">
                                                                                            <i class="icon-information text-secondary"
                                                                                                style="font-size: 14px"></i>
                                                                                        </el-tooltip>
                                                                                    </sup>
                                                                                </span>
                                                                                <div class="d-flex align-items-center">
                                                                                    <div class="w-100">
                                                                                        <multiselect
                                                                                            class="diginew-multiselect new-align-multi no-default-icon mt-4"
                                                                                            name="internal_primary_name"
                                                                                            v-model="internalCompanyObject.company_name"
                                                                                            :options="[]"
                                                                                            :searchable="true"
                                                                                            :close-on-select="true"
                                                                                            :show-labels="false"
                                                                                            :loading="isLoading"
                                                                                            :taggable="false"
                                                                                            :disabled="true"
                                                                                            placeholder="Enter Company Name"
                                                                                            style="background: #eff1f4 !important">
                                                                                        </multiselect>
                                                                                    </div>
                                                                                    <i
                                                                                        class="icon icon-check-circle fs-30 text-success mt-4 ml-2"></i>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="row mt-5">
                                                                            <div class="col-lg-12 col-md-12 col-sm-12 ">
                                                                                <div class="form-group pt-0">
                                                                                    <span
                                                                                        class="text-secondary whiteSpace fs-14 fw-600">
                                                                                        Other Attendees
                                                                                    </span>
                                                                                    <multiselect
                                                                                        class="diginew-multiselect-long greyblack no-default-icon mt-4 multi-height-align"
                                                                                        name="internal_employee_attendees"
                                                                                        @search-change="loadEmployeeSearch(internalCompanyObject,$event)"
                                                                                        @open="getEmployeeDetails(internalCompanyObject, 'other_attendees')"
                                                                                        @select="addCompanyAttendees($event)"
                                                                                        @close="search_key = ''"
                                                                                        :loading="other_attendees_loading"
                                                                                        v-model="createJson.internal_company.other_attendees"
                                                                                        :block-keys="['Tab']"
                                                                                        :searchable="true"
                                                                                        :preserve-search="true"
                                                                                        placeholder="Enter Other Attendees"
                                                                                        label="email" track-by="email"
                                                                                        :options="optionsEmployeeAttendees"
                                                                                        :multiple="true"
                                                                                        :close-on-select="false"
                                                                                        :show-labels="false"
                                                                                        :clear-on-select="true"
                                                                                        :hide-selected="true"
                                                                                        :taggable="true"
                                                                                        :preselect-first="false"
                                                                                        :height="300"
                                                                                        @tag="addTagEmployeeOtherAttendees">
                                                                                        <template slot="tag"
                                                                                            slot-scope="{ option }">
                                                                                            <span class="custom__tag">
                                                                                                <span>{{ option.email }}</span>
                                                                                                <span
                                                                                                    class="custom__remove"
                                                                                                    @click="removeOther(option)">
                                                                                                    <i
                                                                                                        class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                                </span>
                                                                                            </span>
                                                                                        </template>
                                                                                        <template slot="afterList">
                                                                                            <div
                                                                                                v-observe-visibility="getMoreEmployeeDetails" />
                                                                                        </template>
                                                                                        <template slot="noOptions">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                No Attendee Found</div>
                                                                                        </template>
                                                                                        <template slot="noResult">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                No Results Found</div>
                                                                                        </template>
                                                                                        <span slot="noResult"
                                                                                            class="font-weight-bold text-center d-block">No
                                                                                            Results Found.</span>
                                                                                    </multiselect>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div class="col-lg-6 col-md-6 col-sm-6">
                                                                        <div class="form-group pt-0">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 fw-600">
                                                                                Company Attendees
                                                                            </span>
                                                                            <sup class="fs-14 ml-02 mandatory">*
                                                                                <el-tooltip class="item" effect="dark"
                                                                                    content="Attendees from your own company"
                                                                                    placement="bottom"
                                                                                    style="word-break: break-word;">
                                                                                    <i class="icon-information text-secondary"
                                                                                        style="font-size: 14px"></i>
                                                                                </el-tooltip>
                                                                            </sup>
                                                                            <multiselect
                                                                                class="diginew-multiselect-long multi-height-align new-align greyblack no-default-icon mt-4"
                                                                                name="internal_company_attendees"
                                                                                v-validate="{required:true}"
                                                                                @search-change="loadEmployeeSearch(internalCompanyObject,$event, 'company_attendees')"
                                                                                @open="getEmployeeDetails(internalCompanyObject, 'company_attendees')"
                                                                                @select="addCompanyAttendees($event)"
                                                                                :loading="company_attendees_loading"
                                                                                v-model="createJson.internal_company.company_attendees"
                                                                                :block-keys="['Tab']" :searchable="true"
                                                                                placeholder="Enter Company Attendees"
                                                                                label="full_name" track-by="full_name"
                                                                                :options="optionsEmployeeAttendees"
                                                                                :multiple="true"
                                                                                :close-on-select="false"
                                                                                :show-labels="false"
                                                                                :clear-on-select="true"
                                                                                :hide-selected="true" :taggable="false"
                                                                                :preselect-first="false"
                                                                                :height="300"
                                                                                @tag="addTagEmployeeAttendeesInternal">
                                                                                <template slot="tag"
                                                                                    slot-scope="{ option }">
                                                                                    <span class="custom__tag">
                                                                                        <span>{{ option.full_name }}</span>
                                                                                        <span class="custom__remove"
                                                                                            @click="removeCompanyAttendees(option)">
                                                                                            <i
                                                                                                class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                        </span>
                                                                                    </span>
                                                                                </template>
                                                                                <template slot="afterList">
                                                                                    <div
                                                                                        v-observe-visibility="getMoreEmployeeDetails" />
                                                                                </template>
                                                                                <template slot="noOptions">
                                                                                    <div
                                                                                        class="text-secondary text-center fw-600">
                                                                                        No Attendee Found</div>
                                                                                </template>
                                                                                <template slot="noResult">
                                                                                    <div
                                                                                        class="text-secondary text-center fw-600">
                                                                                        No Results Found</div>
                                                                                </template>
                                                                            </multiselect>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                style="text-transform: none !important;"
                                                                                v-show="errors.has('internal_company_attendees')">
                                                                                Company Attendees is required</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
                                                                        <div class="btn-align mt-8 w-100">
                                                                            <button type="button"
                                                                                :disabled="createJson.internal_company.company_attendees.length == 0 && createJson.internal_company.other_attendees.length == 0"
                                                                                class="btn btn-new-darksuccess text-white btn-smm btnlast"
                                                                                style="box-shadow: none;"
                                                                                @click="resetInternalCo()">
                                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg"
                                                                                    alt="" style="margin-right:1px;">
                                                                                Reset
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Receiver Details Section -->
                                                        <div class="mt-0" v-if="createJson.call_report_category == 'External Meeting' || createJson.call_report_category == 'Sales Meeting' || createJson.call_report_category == 'Release Notes'">
                                                            <div class="block-callreport mb-1">
                                                                <div class="infoHeaderHideShow mt-3 mb-3">
                                                                    <div class="descriptionheader">
                                                                        <div class="description-text-header-left">
                                                                            <h5 class="fw-500 whiteSpace">Receiver Details</h5>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                                                        <div class="d-flex align-items-center my-3">
                                                                            <span class="text-secondary whiteSpace fs-14 fw-600 mr-3">Receiver type :</span>
                                                                            <div
                                                                                class="d-flex justify-content-between mr-2 align-items-center">
                                                                                <div
                                                                                    class="form-check form-check-inline mb-1 ">
                                                                                    <label
                                                                                        class="form-check-label check-label-dc">
                                                                                        <input class="form-check-input"
                                                                                            type="radio"
                                                                                            value="lead"
                                                                                            name="receiver_lead"
                                                                                            @change="changeAccount(createJson.receiver_type)"
                                                                                            v-model="createJson.receiver_type" />
                                                                                        <span class="radio-icon"></span>
                                                                                    </label>
                                                                                </div>
                                                                                <span
                                                                                    class="text-secondary fs-14 fw-600 mr-7">Lead</span>
                                                                            </div>
                                                                            <div  class="d-flex justify-content-between align-items-center">
                                                                                <div class="form-check form-check-inline mr-2 mb-1">
                                                                                    <label
                                                                                        class="form-check-label check-label-dc">
                                                                                        <input class="form-check-input"
                                                                                            type="radio"
                                                                                            value="contact"
                                                                                            name="receiver_contact"
                                                                                            @change="changeAccount(createJson.receiver_type)"
                                                                                            v-model="createJson.receiver_type" />
                                                                                        <span class="radio-icon"></span>
                                                                                    </label>
                                                                                </div>
                                                                                <span class="text-secondary fs-14 fw-600 mr-7">Contact</span>
                                                                            </div>
                                                                            <div class="d-flex justify-content-between align-items-center">
                                                                                <div
                                                                                    class="form-check form-check-inline mr-2 mb-1  ">
                                                                                    <label
                                                                                        class="form-check-label check-label-dc">
                                                                                        <input class="form-check-input"
                                                                                            type="radio"
                                                                                            value="customer"
                                                                                            name="receiver_customer"
                                                                                            @change="changeAccount(createJson.receiver_type)"
                                                                                            v-model="createJson.receiver_type" />
                                                                                        <span class="radio-icon"></span>
                                                                                    </label>
                                                                                </div>
                                                                                <span
                                                                                    class="text-secondary fs-14 fw-600 mr-7">Customer</span>
                                                                            </div>
                                                                            <div class="d-flex justify-content-between align-items-center">
                                                                                <div
                                                                                    class="form-check form-check-inline mr-2 mb-1  ">
                                                                                    <label
                                                                                        class="form-check-label check-label-dc">
                                                                                        <input class="form-check-input"
                                                                                            type="radio"
                                                                                            value="vendor"
                                                                                            name="receiver_vendor"
                                                                                            @change="changeAccount(createJson.receiver_type)"
                                                                                            v-model="createJson.receiver_type" />
                                                                                        <span class="radio-icon"></span>
                                                                                    </label>
                                                                                </div>
                                                                                <span
                                                                                    class="text-secondary fs-14 fw-600 mr-7">Vendor</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-if="createJson.receiver_type=='lead'">
                                                                <div class="mt-3" v-for="(lead, index) in createJson.lead_info" :key="index">
                                                                    <div class="block-callreport">
                                                                        <div class="infoHeaderHideShow mt-3 mb-3">
                                                                            <div class="descriptionheader">
                                                                                <div class="description-text-header-left">
                                                                                    <h5 class="fw-500 whiteSpace">Receiver Details - {{index+1}}</h5>
                                                                                </div>
                                                                                <div class="description-text-header-right">
                                                                                    <span class="collapse-addon" >
                                                                                        <i v-if="lead.is_expanded" class="icon-chevron-double-up text-white"  @click="expandLead(lead)"></i>
                                                                                        <i v-else class="icon-chevron-double-down text-white"  @click="expandLead(lead)"></i>
                                                                                    </span>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                        <div v-if="lead.is_expanded">
                                                                            <div class="col-lg-12 col-md-12 col-sm-12 pb-3" >
                                                                                <div class="row">
                                                                                    <div class="col-lg-4 col-md-4 col-sm-12 " >
                                                                                        <span class="text-secondary whiteSpace fs-14 fw-600">Lead Name <sup class="fs-14 ml-02 text-danger">*</sup></span>
                                                                                        <div class="d-flex align-items-center">
                                                                                            <div class="w-100 mt-1">
                                                                                                <multiselect v-validate="((lead.company_name=='' && lead.full_name=='') ||( lead.company_name=='' && lead.full_name=='' ))? {required:false} : {required:true}" :show-labels="false" :name="'lead_name'+index" data-vv-as="Lead Name" @search-change="searchLeadName($event,index)" @open="leadNameList($event,index)" @select="selectedLead($event,index)" :custom-label="customLabel" @close="closeLeadNameDropdown(index)" track-by="id" :loading="lead.is_lead_loading" :limit="1" label="full_name" :limit-text="limitLeadName" v-model="lead.name" :blockKeys="['Delete']"  placeholder="Select Lead Name, Company Name" class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2"  :options="lead_name_options" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="true">
                                                                                                    <template  slot="singleLabel" slot-scope="props"><span class="option__title">{{props.option.full_name || '-'}}</span>
                                                                                                    </template>
                                                                                                    <template slot="option" slot-scope="props">
                                                                                                        <div class="option__desc"><span class="option__title">{{ props.option.full_name  }}</span><span class="option__small">{{ props.option.company_name }}</span></div>
                                                                                                    </template>
                                                                                                    <template slot="noResult">
                                                                                                        <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                                                    </template>
                                                                                                    <template slot="afterList">
                                                                                                        <div v-observe-visibility="reachedEndOfLeadName" />
                                                                                                    </template>
                                                                                                </multiselect>
                                                                                            </div>
                                                                                        </div>
                                                                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('lead_name'+index)">{{errors.first('lead_name'+index)}}</span>
                                                                                    </div>
                                                                                    <div class="col-lg-4 col-md-4 col-sm-12" >
                                                                                        <span class="text-secondary whiteSpace fs-14 fw-600">Company Name </span>
                                                                                        <div class="d-flex align-items-center">
                                                                                            <div class="w-100"  >
                                                                                                <input type="text" disabled class="input-field input-width" style="margin-top: 12px" placeholder="Enter Company Name" v-model="lead.company_name" name="company_name" />
                                                                                            </div>
                                                                                            <span class="mt-3">
                                                                                                <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="col-lg-4 col-md-4 col-sm-12" >
                                                                                        <span class="text-secondary whiteSpace fs-14 fw-600">Lead Status </span>
                                                                                        <div class="d-flex align-items-center">
                                                                                            <div class="w-100" >
                                                                                                <input type="text" disabled class="input-field input-width mt-3 text-capitalize" placeholder="Enter Lead Status" v-model="lead.status" />
                                                                                            </div>
                                                                                            <span class="mt-3">
                                                                                                <i class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-lg-12 col-md-12 col-sm-6" v-if="createJson.receiver_type=='lead'">
                                                                                <div class="row">
                                                                                    <div class="btn-align mt-4 w-100" style="justify-content:flex-end;">
                                                                                        <button type="button" class="btn btn-new-primary btn-smm mr-3" style="box-shadow: none !important;" v-if="index+1==createJson.lead_info.length" @click="createJson.lead_info.push(JSON.parse(JSON.stringify(lead_repeat))) && showReceiverDetails.push(index+1)">+ Add Lead</button>
                                                                                        <button type="button" class="btn btn-new-darkdanger btn-smm mr-2" v-if="index!=0" style="box-shadow: none;" @click="createJson.lead_info.splice(index, 1) && showReceiverDetails.splice(index,1)">- Delete Lead</button>
                                                                                        <button type="button" :disabled="lead.name == ''" class="btn btn-new-darksuccess text-white btn-smm" v-if="index>=0" style="box-shadow: none !important;" @click="resetReceiverDetails(index)"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg" class="mr-2">Reset</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-else-if="createJson.receiver_type=='contact'">
                                                                <div class="mt-3" v-for="(contact, index) in createJson.contact_info" :key="index">
                                                                    <div class="block-callreport mt-3">
                                                                        <div class="infoHeaderHideShow mt-3 mb-3">
                                                                            <div class="descriptionheader">
                                                                                <div class="description-text-header-left">
                                                                                    <h5 class="fw-500 whiteSpace">Receiver Details - {{index+1}}</h5>
                                                                                </div>
                                                                                <div class="description-text-header-right" >
                                                                                    <span class="collapse-addon" @click="expandContact(contact)">
                                                                                        <i v-if="contact.is_contact_expanded" class="icon-chevron-double-up text-white"></i>
                                                                                        <i v-else class="icon-chevron-double-down text-white"></i>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="contact.is_contact_expanded">
                                                                            <div class="col-lg-12 col-md-12 col-sm-12 pb-3">
                                                                                <div class="row">
                                                                                    <div class="col-lg-4 col-md-4 col-sm-12" >
                                                                                        <div>
                                                                                            <span class="text-secondary whiteSpace fs-14 fw-600">Contact Name <sup class="fs-14 text-danger">*</sup></span>
                                                                                            <div class="d-flex align-items-center">
                                                                                                <div class="w-100 mt-1">
                                                                                                    <multiselect v-validate="'required'" :name="'contact_name'+index" data-vv-as="Contact Name"
                                                                                                        label="full_name"
                                                                                                        @select="selectedContact($event,index)"
                                                                                                        @search-change="searchContactName($event,index)"
                                                                                                        @open="searchContactName(null,index)"
                                                                                                        track-by="id"
                                                                                                        :loading="contact.is_contact_loading"
                                                                                                        :limit="1"
                                                                                                        :limit-text="limitContactName"
                                                                                                        v-model="contact.name"
                                                                                                        :blockKeys="['Delete']"
                                                                                                        @remove="removeContactName"
                                                                                                        placeholder="Select Contact Name"
                                                                                                        class="diginew-multiselect new-align-multi customer-multiselect no-default-icon down-arrow mt-2"
                                                                                                        :options="contact_name_options"
                                                                                                        :multiple="false"
                                                                                                        :searchable="true"
                                                                                                        :internal-search="true"
                                                                                                        :clear-on-select="false"
                                                                                                        :close-on-select="true"
                                                                                                        :options-limit="3000"
                                                                                                        :max-height="200"
                                                                                                        :show-no-results="true"
                                                                                                        :hide-selected="false">
                                                                                                        <template
                                                                                                            slot="noOptions">
                                                                                                            <div
                                                                                                                class="text-secondary text-center font-weight-bold">
                                                                                                                Contact Name
                                                                                                                Not Found
                                                                                                            </div>
                                                                                                        </template>
                                                                                                        <template
                                                                                                            slot="noResult">
                                                                                                            <div
                                                                                                                class="text-secondary text-center fw-600">
                                                                                                                No Results
                                                                                                                Found</div>
                                                                                                        </template>
                                                                                                        <template
                                                                                                            slot="afterList">
                                                                                                            <div
                                                                                                                v-observe-visibility="reachedEndOfContactName" />
                                                                                                        </template>
                                                                                                    </multiselect>
                                                                                                </div>
                                                                                            </div>
                                                                                            <span
                                                                                                class="invalid-feedback-form text-danger"
                                                                                                style="text-transform: none !important;"
                                                                                                v-show="errors.has('contact_name'+index)">{{errors.first('contact_name'+index)}}</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div
                                                                                        class="col-lg-4 col-md-4 col-sm-12">
                                                                                        <span
                                                                                            class="text-secondary whiteSpace fs-14 fw-600">Company
                                                                                            Name </span>
                                                                                        <div
                                                                                            class="d-flex align-items-center">
                                                                                            <div class="w-100">
                                                                                                <input type="text" disabled
                                                                                                    class="input-field input-width"
                                                                                                    style="margin-top: 11px"
                                                                                                    placeholder="Enter Company Name"
                                                                                                    v-model="contact.company_name" />
                                                                                            </div>
                                                                                            <span class="mt-3">
                                                                                                <i
                                                                                                    class="icon icon-check-circle fs-30 ml-2 text-green"></i>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-lg-12 col-md-12 col-sm-6" v-if="createJson.receiver_type=='contact'">
                                                                                <div class="row">
                                                                                    <div class="btn-align mt-4 w-100" style="justify-content:flex-end;">
                                                                                        <button type="button" class="btn btn-new-primary btn-smm mr-3" style="box-shadow: none !important;" v-if="index+1==createJson.contact_info.length" @click="createJson.contact_info.push(JSON.parse(JSON.stringify(contact_repeat))) && showContactDetails.push(index+1)">+ Add Contact</button>
                                                                                        <button type="button" class="btn btn-new-darkdanger btn-smm mr-2" v-if="index!=0" style="box-shadow: none;" @click="createJson.contact_info.splice(index, 1) && showContactDetails.splice(index,1)">- Delete Contact</button>
                                                                                        <button type="button" :disabled="contact.name == ''" class="btn btn-new-darksuccess text-white btn-smm" v-if="index>=0" style="box-shadow: none !important;" @click="resetContactDetails(index)"><img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg" class="mr-2">Reset</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-else-if="createJson.receiver_type=='customer'">
                                                                <div class="mt-3" v-for="(company, index) in createJson.external_attendees" :key="index" >
                                                                    <div class="block-callreport">
                                                                        <div class="infoHeaderHideShow mt-3 mb-3">
                                                                            <div class="descriptionheader">
                                                                                <div class="description-text-header-left">
                                                                                    <h5 class="fw-500 whiteSpace">Receiver Details - {{index+1}}</h5>
                                                                                </div>
                                                                                <div class="description-text-header-right" >
                                                                                    <span class="collapse-addon" >
                                                                                        <i v-if="company.is_cust_expanded" @click="expandExternal(company)" class="icon-chevron-double-up text-white"></i>
                                                                                        <i v-else class="icon-chevron-double-down text-white" @click="expandExternal(company)"></i>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="company.is_cust_expanded">
                                                                            <div class="row" >
                                                                                <div class="col-lg-8 col-md-8 col-sm-8">
                                                                                    <div class="row">
                                                                                        <div class="col-lg-6 col-md-6 col-sm-6" >
                                                                                            <div>
                                                                                                <span
                                                                                                    class="text-secondary whiteSpace fs-14 fw-600">
                                                                                                    Company Name
                                                                                                    <sup
                                                                                                        class="text-danger fs-14">*</sup>
                                                                                                    <sup
                                                                                                        class="fs-14 mandatory">
                                                                                                        <el-tooltip
                                                                                                            class="item"
                                                                                                            effect="dark"
                                                                                                            content="The options for this list are obtained from Customers module"
                                                                                                            placement="right">
                                                                                                            <i class="icon-information text-secondary"
                                                                                                                style="font-size: 14px"></i>
                                                                                                        </el-tooltip>
                                                                                                    </sup>
                                                                                                </span>
                                                                                                <div class="d-flex align-items-center">
                                                                                                    <div class="w-100">
                                                                                                        <multiselect
                                                                                                            v-validate="'required'"
                                                                                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                                                                            :name="'external_company_name'+index"
                                                                                                            data-vv-as="Customer Company Name"
                                                                                                            @select="updateBranch(index)"
                                                                                                            @close="updateCompanyList();search_key = ''"
                                                                                                            @search-change="loadCompanySearch($event,index)"
                                                                                                            @open="loadCompanyName(null,index)"
                                                                                                            :loading="company.is_company_loading"
                                                                                                            v-model="company.company_name"
                                                                                                            :searchable="true"
                                                                                                            placeholder="Enter Company Name"
                                                                                                            label="customer_name"
                                                                                                            :options="optionsCompanies"
                                                                                                            :multiple="false"
                                                                                                            :internal-search="true"
                                                                                                            :close-on-select="true"
                                                                                                            :show-labels="false"
                                                                                                            :clear-on-select="false"
                                                                                                            :hide-selected="true"
                                                                                                            :show-no-results="true"
                                                                                                            tag-placeholder="Press Enter to Add"
                                                                                                            style="margin-top: 9px">
                                                                                                            <template slot="tag" slot-scope="{ option, remove }">
                                                                                                                <span class="custom__tag">
                                                                                                                    <span>{{ option.company_name }}</span>
                                                                                                                    <span class="custom__remove"
                                                                                                                        @click="remove(option)">
                                                                                                                        <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                                                    </span>
                                                                                                                </span>
                                                                                                            </template>
                                                                                                            <template slot="noOptions">
                                                                                                                <div class="text-secondary text-center fw-600">
                                                                                                                    List is Empty
                                                                                                                </div>
                                                                                                            </template>
                                                                                                            <template slot="noResult">
                                                                                                                <div class="text-secondary text-center fw-600">
                                                                                                                    No Results Found
                                                                                                                </div>
                                                                                                            </template>
                                                                                                            <template slot="afterList">
                                                                                                                <div v-observe-visibility="reachedEndOfListCompanyNew" />
                                                                                                            </template>
                                                                                                        </multiselect>
                                                                                                    </div>


                                                                                                </div>
                                                                                                <span
                                                                                                    class="invalid-feedback-form text-danger"
                                                                                                    style="text-transform: none !important;"
                                                                                                    v-show="errors.has('external_company_name'+index)">{{errors.first('external_company_name'+index)}}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-lg-6 col-md-6 col-sm-6">
                                                                                            <div>
                                                                                                <span class="text-secondary whiteSpace fs-14 fw-600">
                                                                                                    Primary Customer Attendee
                                                                                                    <sup class="fs-14 text-danger">*</sup>
                                                                                                </span>
                                                                                                <multiselect :disabled="company.company_name == ''"
                                                                                                v-validate="'required'"
                                                                                                data-vv-as="Primary Customer Attendee"
                                                                                                class="diginew-multiselect new-align-multi mt-3 no-default-icon down-arrow"
                                                                                                :name="'external_employee_attendee'+index"
                                                                                                @search-change="searchPrimaryAttendees($event,company.company_name,index)"
                                                                                                @open="searchPrimaryAttendees($event,company.company_name,index)"
                                                                                                @close="search_key = ''"
                                                                                                :multiple="false"
                                                                                                :allow-empty="true"
                                                                                                :searchable="true"
                                                                                                :taggable="true"
                                                                                                :preserve-search="true"
                                                                                                @tag="addTag"
                                                                                                :preselect-first="false"
                                                                                                :loading="external_primary_loading"
                                                                                                v-model="company.primary_employee"
                                                                                                :block-keys="['Tab']"
                                                                                                placeholder="Enter Primary Customer Attendee*"
                                                                                                :options="external_primary_options"
                                                                                                :close-on-select="true"
                                                                                                :show-labels="false"
                                                                                                :clear-on-select="true"
                                                                                                :hide-selected="false"
                                                                                                label="primary_email">
                                                                                                <template slot="tag"
                                                                                                    slot-scope="{ option, remove }">
                                                                                                    <span
                                                                                                        class="custom__tag">
                                                                                                        <span>{{ option.primary_email }}</span>
                                                                                                        <span
                                                                                                            class="custom__remove"
                                                                                                            @click="remove(option)">
                                                                                                            <i
                                                                                                                class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                                        </span>
                                                                                                    </span>
                                                                                                </template>
                                                                                                <template
                                                                                                    slot="afterList">
                                                                                                    <div
                                                                                                        v-observe-visibility="reachedEndOfPrimaryAttendees" />
                                                                                                </template>
                                                                                                <template
                                                                                                    slot="noOptions">
                                                                                                    <div
                                                                                                        class="text-secondary text-center fw-600">
                                                                                                        List is Empty
                                                                                                    </div>
                                                                                                </template>
                                                                                                <template
                                                                                                    slot="noResult">
                                                                                                    <div
                                                                                                        class="text-secondary text-center fw-600">
                                                                                                        No Results Found
                                                                                                    </div>
                                                                                                </template>
                                                                                            </multiselect>

                                                                                                <span
                                                                                                    class="invalid-feedback-form text-danger"
                                                                                                    style="text-transform: none !important;"
                                                                                                    v-show="errors.has('external_employee_attendee'+index)">{{errors.first('external_employee_attendee'+index)}}</span>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row">
                                                                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-5 ">
                                                                                            <div>
                                                                                                <span
                                                                                                    class="text-secondary whiteSpace fs-14 fw-600 vselectLabel">Branch
                                                                                                    Name
                                                                                                </span>
                                                                                                <!-- <div class="d-flex">
                                                                                                    <multiselect
                                                                                                        v-if="company.company_name == ''"
                                                                                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-4"
                                                                                                        label="name"
                                                                                                        :name="'external_branch_name'+index"
                                                                                                        :options="[]"
                                                                                                        :searchable="true"
                                                                                                        :close-on-select="true"
                                                                                                        :show-labels="false"
                                                                                                        placeholder="Enter Branch Name">
                                                                                                        <span
                                                                                                            slot="noOptions"
                                                                                                            class="font-weight-bold text-center d-block">Please
                                                                                                            Select or Add
                                                                                                            Company</span>
                                                                                                        <template
                                                                                                            slot="noOptions">
                                                                                                            <div
                                                                                                                class="text-secondary text-center fw-600">
                                                                                                                List is
                                                                                                                Empty</div>
                                                                                                        </template>
                                                                                                        <template
                                                                                                            slot="noResult">
                                                                                                            <div
                                                                                                                class="text-secondary text-center fw-600">
                                                                                                                No Results
                                                                                                                Found</div>
                                                                                                        </template>
                                                                                                    </multiselect>
                                                                                                    <multiselect v-else
                                                                                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-4"
                                                                                                        label="name"
                                                                                                        :name="'external_branch_name'+index"
                                                                                                        v-model="company.branch"
                                                                                                        @close="updateDepartment(company.branch)"
                                                                                                        @open="getBranch(company.company_name)"
                                                                                                        :options="branchs"
                                                                                                        :searchable="true"
                                                                                                        :close-on-select="true"
                                                                                                        :show-labels="false"
                                                                                                        placeholder="Select Branch Name"
                                                                                                        :taggable="true"
                                                                                                        @tag="addBranchName($event,index)"
                                                                                                        tag-placeholder="Press Enter to Add">
                                                                                                        <template
                                                                                                            slot="noOptions">
                                                                                                            <div
                                                                                                                class="text-secondary text-center fw-600">
                                                                                                                List is
                                                                                                                Empty</div>
                                                                                                        </template>
                                                                                                        <template
                                                                                                            slot="noResult">
                                                                                                            <div
                                                                                                                class="text-secondary text-center fw-600">
                                                                                                                No Results
                                                                                                                Found</div>
                                                                                                        </template>
                                                                                                    </multiselect>
                                                                                                </div> -->
                                                                                                <input type="text"
                                                                                                    class="input-field input-width mt-4"
                                                                                                    v-model="company.branch"
                                                                                                    placeholder="Enter Branch Name"
                                                                                                    name="external_branch_name" />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
                                                                                            <div>
                                                                                                <span
                                                                                                    class="text-secondary whiteSpace fs-14 fw-600 vselectLabel">
                                                                                                    Department Name
                                                                                                </span>
                                                                                                <input type="text"
                                                                                                    class="input-field input-width mt-4"
                                                                                                    v-model="company.department"
                                                                                                    placeholder="Enter Department Name"
                                                                                                    name="external_department_name" />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div class="row">
                                                                                        <div class="col-lg-6 col-md-6 col-sm-6 mt-5">
                                                                                            <div>
                                                                                                <span class="text-secondary whiteSpace fs-14 fw-600">Customer Status</span>
                                                                                                <div
                                                                                                    class="d-flex align-items-center">
                                                                                                    <div class="w-100">
                                                                                                        <multiselect
                                                                                                            class="diginew-multiselect mt-4 new-align-multi no-default-icon down-arrow"
                                                                                                            :name="'external_customer_status'+index"
                                                                                                            v-model="company.status"
                                                                                                            :options="customerStatusOptions"
                                                                                                            :searchable="true"
                                                                                                            :close-on-select="true"
                                                                                                            @select="selectCustomerStatus($event,index)"
                                                                                                            :show-labels="false"
                                                                                                            placeholder="Enter Status"
                                                                                                            >
                                                                                                        </multiselect>
                                                                                                    </div>
                                                                                                    <!--<span class="pointer"
                                                                                                        @click="changeView()">
                                                                                                        <el-tooltip class="item"
                                                                                                            effect="dark"
                                                                                                            content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                                                                            placement="bottom">
                                                                                                            <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                                                                                class="ml-2 mt-3"
                                                                                                                style="width:20px"
                                                                                                                alt="">
                                                                                                        </el-tooltip>
                                                                                                    </span>-->
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-lg-4 col-md-4 col-sm-4">

                                                                                                <div>
                                                                                                    <span
                                                                                                        class="text-secondary whiteSpace fs-14 fw-600">
                                                                                                        Secondary Customer
                                                                                                        Attendees
                                                                                                    </span>
                                                                                                    <multiselect :disabled="company.company_name == ''"
                                                                                                        class="multiselect diginew-multiselect-long multi-height-align greyblack no-default-icon mt-3"
                                                                                                        :name="'external_employee_attendee'+index"
                                                                                                        @search-change="searchSecondaryAttendees($event,company.company_name,index)"
                                                                                                        @open="searchSecondaryAttendees($event,company.company_name,index)"
                                                                                                        @select="secondaryAttendeeSelected($event, index)"
                                                                                                        @close="search_key = ''"
                                                                                                        :multiple="true"
                                                                                                        :searchable="true"
                                                                                                        :taggable="true"
                                                                                                        :preserve-search="true"
                                                                                                        @tag="addSecondaryTag"
                                                                                                        :loading="external_secondary_loading"
                                                                                                        v-model="company.secondary_employees"
                                                                                                        :block-keys="['Tab']"
                                                                                                        placeholder="Enter Secondary Customer Attendees"
                                                                                                        :options="external_secondary_options"
                                                                                                        :close-on-select="false"
                                                                                                        :show-labels="false"
                                                                                                        :clear-on-select="true"
                                                                                                        :hide-selected="false"
                                                                                                        label="primary_email"
                                                                                                        track-by="primary_email">
                                                                                                        <template slot="tag"
                                                                                                            slot-scope="{ option, remove }">
                                                                                                            <span
                                                                                                                class="custom__tag">
                                                                                                                <span>{{ option.primary_email }}</span>
                                                                                                                <span
                                                                                                                    class="custom__remove"
                                                                                                                    @click="remove(option)">
                                                                                                                    <i
                                                                                                                        class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                                                </span>
                                                                                                            </span>
                                                                                                        </template>
                                                                                                        <template
                                                                                                            slot="afterList">
                                                                                                            <div
                                                                                                                v-observe-visibility="reachedEndOfSecondaryAttendees" />
                                                                                                        </template>
                                                                                                        <template
                                                                                                            slot="noOptions">
                                                                                                            <div
                                                                                                                class="text-secondary text-center fw-600">
                                                                                                                List is Empty
                                                                                                            </div>
                                                                                                        </template>
                                                                                                        <template
                                                                                                            slot="noResult">
                                                                                                            <div
                                                                                                                class="text-secondary text-center fw-600">
                                                                                                                No Results Found
                                                                                                            </div>
                                                                                                        </template>
                                                                                                    </multiselect>
                                                                                                    <span
                                                                                                        class="invalid-feedback-form text-danger"
                                                                                                        style="text-transform: none !important;"
                                                                                                        v-show="errors.has('external_employee_attendees'+index)">{{errors.first('external_employee_attendees'+index)}}</span>
                                                                                                </div>
                                                                                    </div>
                                                                            </div>
                                                                            <div class="row mt-3" v-if="createJson.receiver_type =='customer'">
                                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                                    <div class="btn-align mt-5 px-4 w-100"
                                                                                        style="justify-content: flex-end;">
                                                                                        <button type="button"
                                                                                            class="btn btn-new-darkdanger btn-smm mr-2"
                                                                                            style="box-shadow: none;"
                                                                                            v-if="index!=0"
                                                                                            @click="createJson.external_attendees.splice(index, 1) && showExternal.splice(index,1)">-
                                                                                            Delete Customer</button>
                                                                                        <button type="button"
                                                                                            class="btn btn-new-primary btn-smm mr-2"
                                                                                            style="box-shadow: none;"
                                                                                            v-if="index+1==createJson.external_attendees.length"
                                                                                            @click="createJson.external_attendees.push(JSON.parse(JSON.stringify(companyRepeat))) && showExternal.push(index+1)">+
                                                                                            Add Customer</button>
                                                                                        <button type="button"
                                                                                            class="btn btn-new-darksuccess text-white btn-smm"
                                                                                            v-if="index>=0"
                                                                                            :disabled="company.company_name.length == 0 && company.primary_employee && company.branch == '' && company.department == '' && company.status.length == 0 && company.secondary_employees.length == 0"
                                                                                            style="box-shadow: none;"
                                                                                            @click="resetExternalCo(index)">
                                                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg"
                                                                                                alt=""
                                                                                                style="margin-right:1px;">
                                                                                            Reset</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-else-if="createJson.receiver_type=='vendor'">
                                                                <div class="mt-3" v-for="(vendor, index) in createJson.vendor_info" :key="index" >
                                                                    <div class="block-callreport">
                                                                        <div class="infoHeaderHideShow mt-3 mb-3">
                                                                            <div class="descriptionheader">
                                                                                <div class="description-text-header-left">
                                                                                    <h5 class="fw-500 whiteSpace">Receiver Details - {{index+1}}</h5>
                                                                                </div>
                                                                                <div class="description-text-header-right" >
                                                                                    <span class="collapse-addon" >
                                                                                        <i v-if="vendor.is_vendor_expanded" @click="expandExternalVendor(vendor)" class="icon-chevron-double-up text-white"></i>
                                                                                        <i v-else class="icon-chevron-double-down text-white" @click="expandExternalVendor(vendor)"></i>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="vendor.is_vendor_expanded">
                                                                            <div class="row">
                                                                                <div class="col-lg-6 col-md-6 col-sm-6" >
                                                                                    <div>
                                                                                        <span class="text-secondary whiteSpace fs-14 fw-600">Vendor Name<sup class="text-danger fs-14 pl-1">*</sup></span>
                                                                                        <div class="d-flex align-items-center">
                                                                                            <div class="w-100">
                                                                                                <multiselect
                                                                                                    v-validate="'required'"
                                                                                                    class="diginew-multiselect new-align-multi no-default-icon down-arrow"
                                                                                                    :name="'external_vendor_name'+index"
                                                                                                    data-vv-as="Vendor Name"
                                                                                                    @select="updateVendorBranch($event, index)"
                                                                                                    @close="checkVendorName(index)"
                                                                                                    @open="addVendorList(index)"
                                                                                                    @search-change="searchVendorList($event, index)"
                                                                                                    :loading="vendor.is_vendor_loading"
                                                                                                    v-model="vendor.vendor_name"
                                                                                                    :searchable="true"
                                                                                                    placeholder="Enter Vendor Name"
                                                                                                    label="company_name"
                                                                                                    :options="vendor_options"
                                                                                                    :multiple="false"
                                                                                                    :internal-search="false"
                                                                                                    :close-on-select="true"
                                                                                                    :show-labels="false"
                                                                                                    :clear-on-select="false"
                                                                                                    :show-no-results="true"
                                                                                                    track-by="_id"
                                                                                                    style="margin-top: 9px">
                                                                                                    <template slot="noOptions">
                                                                                                        <div class="text-secondary text-center fw-600">
                                                                                                            List is Empty
                                                                                                        </div>
                                                                                                    </template>
                                                                                                    <template slot="noResult">
                                                                                                        <div class="text-secondary text-center fw-600">
                                                                                                            No Results Found
                                                                                                        </div>
                                                                                                    </template>
                                                                                                    <template slot="afterList">
                                                                                                        <div v-observe-visibility="reachedEndOfVendorList" />
                                                                                                    </template>
                                                                                                </multiselect>
                                                                                            </div>
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;"
                                                                                            v-show="errors.has('external_vendor_name'+index)">The Vendor Name field is required
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                                                    <div>
                                                                                        <span
                                                                                            class="text-secondary whiteSpace fs-14 fw-600 vselectLabel">
                                                                                            Vendor Email ID
                                                                                        </span>
                                                                                        <div class="d-flex justify-content-center align-items-center">
                                                                                            <input type="text"
                                                                                                disabled
                                                                                                class="input-field input-width mt-2"
                                                                                                v-model="vendor.vendor_primary_attendee"
                                                                                                placeholder="Enter Vendor Email ID"
                                                                                                name="vendor_primary_attendee" />
                                                                                            <div class="mt-2">
                                                                                                <i class="icon icon-check-circle fs-30 text-success mt-4 ml-2"></i>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="row mt-3" v-if="createJson.receiver_type =='vendor'">
                                                                                <div class="col-lg-12 col-md-12 col-sm-12 pr-0">
                                                                                    <div class="btn-align mt-5 px-4 w-100"
                                                                                        style="justify-content: flex-end;">
                                                                                        <button type="button"
                                                                                            class="btn btn-new-darkdanger btn-smm mr-2"
                                                                                            style="box-shadow: none;"
                                                                                            v-if="index!=0"
                                                                                            @click="createJson.vendor_info.splice(index, 1)">-
                                                                                            Delete Vendor</button>
                                                                                        <button type="button"
                                                                                            class="btn btn-new-primary btn-smm mr-2"
                                                                                            style="box-shadow: none;"
                                                                                            v-if="index+1==createJson.vendor_info.length"
                                                                                            @click="addVendor()">+
                                                                                            Add Vendor</button>
                                                                                        <button type="button"
                                                                                            class="btn btn-new-darksuccess text-white btn-smm"
                                                                                            v-if="index>=0"
                                                                                            :disabled="vendor.vendor_name == null || vendor.vendor_name == ''"
                                                                                            style="box-shadow: none;"
                                                                                            @click="resetVendorData(index)">
                                                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg"
                                                                                                alt=""
                                                                                                style="margin-right:1px;">
                                                                                            Reset</button>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Email Shared Section -->
                                                        <div class="block-callreport">
                                                            <div class="infoHeaderHideShow mt-3 ">
                                                                <div class="descriptionheader">
                                                                    <div class="description-text-header-left">
                                                                        <h5 class="fw-500 whiteSpace">Email Shared
                                                                        </h5>
                                                                    </div>
                                                                    <div class="description-text-header-right">
                                                                        <span class="collapse-addon"
                                                                            @click="expandEmailRecipients()">
                                                                            <i v-if="showEmailRecipients"
                                                                                class="icon-chevron-double-up text-white"></i>
                                                                            <i v-else
                                                                                class="icon-chevron-double-down text-white"></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-show="showEmailRecipients == true">
                                                                <div class="row mt-1">
                                                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                                                        <div class="d-flex align-items-center my-3" >
                                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                                <div class="form-group pt-0">
                                                                                    <span class="text-secondary whiteSpace fs-14 fw-600">Individual</span>
                                                                                    <multiselect
                                                                                        class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                                                        name="email_recipients"
                                                                                        @search-change="searchCustomerInside"
                                                                                        @open="searchCustomerInside"
                                                                                        @close="dropdownEmailClosed"
                                                                                        @select="selectedEmail"
                                                                                        :loading="isCustomerLoading"
                                                                                        v-model="createJson.recipient_email.individual"
                                                                                        :searchable="true" :block-keys="['Tab']"
                                                                                        placeholder="Add Members"
                                                                                        :options="optionsEmailRecipients"
                                                                                        :multiple="true"
                                                                                        :close-on-select="false"
                                                                                        :show-labels="false"
                                                                                        :clear-on-select="true"
                                                                                        :hide-selected="true" :taggable="true"
                                                                                        label="email" track-by="email"
                                                                                        @tag="addCustomer($event,'individual')">
                                                                                        <template slot="tag"
                                                                                            slot-scope="{ option }">
                                                                                            <span class="custom__tag">
                                                                                                <span>{{ option.email }}</span>
                                                                                                <span class="custom__remove"
                                                                                                    @click="removeEmailIndividual(option)">
                                                                                                    <i
                                                                                                        class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                                </span>
                                                                                            </span>
                                                                                        </template>
                                                                                        <template slot="afterList">
                                                                                            <div
                                                                                                v-observe-visibility="reachedEndOfListCustomer" />
                                                                                        </template>
                                                                                        <template slot="noOptions">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                List is Empty</div>
                                                                                        </template>
                                                                                        <template slot="noResult">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                No Results Found</div>
                                                                                        </template>
                                                                                    </multiselect>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-lg-6 col-md-6 col-sm-6">
                                                                                <span class="text-secondary whiteSpace fs-14 fw-600">Team</span>
                                                                                <multiselect
                                                                                        class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                                                        name="email_recipients"
                                                                                        @search-change="searchPermissionEmail"
                                                                                        @open="searchPermissionEmail"
                                                                                        @close="dropdownEmailClosed"
                                                                                        :loading="isLoadingEmailTeam"
                                                                                        @select="selectedEmailTeam"
                                                                                        v-model="createJson.recipient_email.team"
                                                                                        :searchable="true" :block-keys="['Tab']"
                                                                                        placeholder="Add Team"
                                                                                        :options="optionsEmailRecipientsTeam"
                                                                                        :multiple="true"
                                                                                        :close-on-select="false"
                                                                                        :show-labels="false"
                                                                                        :clear-on-select="true"
                                                                                        :hide-selected="true" :taggable="true"
                                                                                        label="email_id" track-by="email_id"
                                                                                        @tag="addCustomer($event,'team')">
                                                                                        <template slot="tag"
                                                                                            slot-scope="{ option }">
                                                                                            <span class="custom__tag">
                                                                                                <span>{{ option.email_id }}</span>
                                                                                                <span class="custom__remove"
                                                                                                    @click="removeEmailTeam(option)">
                                                                                                    <i
                                                                                                        class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                                </span>
                                                                                            </span>
                                                                                        </template>
                                                                                        <template slot="afterList">
                                                                                            <div
                                                                                                v-observe-visibility="reachedEndOfPermissionEmail" />
                                                                                        </template>
                                                                                        <template slot="noOptions">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                List is Empty</div>
                                                                                        </template>
                                                                                        <template slot="noResult">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                No Results Found</div>
                                                                                        </template>
                                                                                </multiselect>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="d-flex flex-wrap align-items-center justify-content-between pl-1 w-100">
                                                                    <div
                                                                        class="d-flex align-items-center row mt-2 ml-0">
                                                                        <!-- <input type="checkbox"
                                                                            v-model="createJson.send_copy_to_me" /> -->
                                                                        <el-checkbox
                                                                            v-model="createJson.send_copy_to_me" class="mt-2">
                                                                        </el-checkbox>
                                                                        <span class="whiteSpace fw-600 fs-14 ml-2 mt-1">Send
                                                                            a Copy to Me</span>
                                                                    </div>
                                                                    <button type="button"
                                                                    :disabled="createJson.recipient_email.individual.length == 0 && createJson.recipient_email.team.length == 0"
                                                                        class="btn btn-new-darksuccess text-white btn-smm btnlast mt-4"
                                                                        style="box-shadow: none;"
                                                                        @click="resetEmailRecipients()">
                                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg"
                                                                            alt="" style="margin-right:1px;">
                                                                        Reset
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Permission Section -->
                                                        <div class="block-callreport">
                                                            <div class="infoHeaderHideShow mt-3">
                                                                <div class="descriptionheader">
                                                                    <div class="description-text-header-left">
                                                                        <h5 class="fw-500 whiteSpace">Call Report Permissions
                                                                        </h5>
                                                                    </div>
                                                                    <div class="description-text-header-right">
                                                                        <span class="collapse-addon"
                                                                            @click="expandPermission()">
                                                                            <i v-if="showPermissions"
                                                                                class="icon-chevron-double-up text-white"></i>
                                                                            <i v-else
                                                                                class="icon-chevron-double-down text-white"></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-show="showPermissions == true">
                                                                <div class="row mt-3">
                                                                    <div class="col-lg-12 col-md-12 col-sm-12">
                                                                        <div class="form-group pt-0">
                                                                            <div class="d-flex align-items-center my-3">
                                                                                <span class="text-secondary whiteSpace fs-14 fw-600 ml-3">Access To :</span>
                                                                                <div class="d-flex justify-content-between ml-4 align-items-center">
                                                                                    <div class="form-check form-check-inline mb-1 ">
                                                                                        <label class="form-check-label check-label-dc">
                                                                                            <input class="form-check-input"
                                                                                                type="radio"
                                                                                                value="private"
                                                                                                name="email_individual"
                                                                                                @change="changePermission('private')"
                                                                                                v-model="createJson.general_access" />
                                                                                            <span class="radio-icon"></span>
                                                                                        </label>
                                                                                    </div>
                                                                                    <span class="text-secondary fs-14 fw-600 mr-7">Individual and Team</span>
                                                                                </div>

                                                                                <div class="d-flex justify-content-between align-items-center">
                                                                                    <div
                                                                                        class="form-check form-check-inline mr-2 mb-1  ">
                                                                                        <label
                                                                                            class="form-check-label check-label-dc">
                                                                                            <input class="form-check-input"
                                                                                                type="radio"
                                                                                                value="public"
                                                                                                name="email_all"
                                                                                                @change="changePermission('public')"
                                                                                                v-model="createJson.general_access" />
                                                                                            <span class="radio-icon"></span>
                                                                                        </label>
                                                                                    </div>
                                                                                    <span class="text-secondary fs-14 fw-600">All</span>
                                                                                    <sup class="fs-14 ml-02 mandatory">
                                                                                        <el-tooltip class="item" effect="dark"
                                                                                            content="Visible to everyone within company"
                                                                                            placement="bottom"
                                                                                            style="word-break: break-word;">
                                                                                            <i class="icon-information text-secondary"
                                                                                                style="font-size: 14px"></i>
                                                                                        </el-tooltip>
                                                                                    </sup>
                                                                                </div>
                                                                            </div>
                                                                            <div class= "row ">
                                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                                    <div class="">
                                                                                        <div class="row mt-2">
                                                                                            <div class="col-lg-12 col-md-12 col-sm-12" >
                                                                                                <div class="ml-3" v-if="createJson.author_email">
                                                                                                    <span class="text-secondary whiteSpace fs-14 fw-600">Author :</span>
                                                                                                    <span class="chipmailCallReport" >
                                                                                                        {{createJson.author_email}}
                                                                                                    </span>
                                                                                                </div>
                                                                                                <div class="mt-3 ml-3" v-if="createJson.owner_email">
                                                                                                    <span class="text-secondary whiteSpace fs-14 fw-600">Owner :</span>
                                                                                                    <span class="chipmailCallReport" >
                                                                                                        {{createJson.owner_email }}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="d-flex align-items-center my-3" >
                                                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                                                    <span class="text-secondary whiteSpace fs-14 fw-600">Individual</span>
                                                                                    <multiselect :disabled="createJson.general_access == 'public'"
                                                                                        class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                                                        name="permission_individual"
                                                                                        @search-change="searchGroup"
                                                                                        @open="searchGroup"
                                                                                        @close="dropdownEmailClosed"
                                                                                        :loading="isGroupLoading"
                                                                                        v-model="createJson.permissions.individual"
                                                                                        :searchable="true" :block-keys="['Tab']"
                                                                                        placeholder="Add Members"
                                                                                        :options="optionsGroupEmailRecipients"
                                                                                        :multiple="true"
                                                                                        :close-on-select="false"
                                                                                        :show-labels="false"
                                                                                        :clear-on-select="true"
                                                                                        :hide-selected="true"
                                                                                        label="email" track-by="email"
                                                                                        >
                                                                                        <template slot="tag"
                                                                                            slot-scope="{ option, remove }">
                                                                                            <span class="custom__tag">
                                                                                                <span>{{ option.email }}</span>
                                                                                                <span class="custom__remove"
                                                                                                    @click="remove(option)">
                                                                                                    <i
                                                                                                        class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                                </span>
                                                                                            </span>
                                                                                        </template>
                                                                                        <template slot="afterList">
                                                                                            <div
                                                                                                v-observe-visibility="reachedEndOfGroupEmail" />
                                                                                        </template>
                                                                                        <template slot="noOptions">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                List is Empty</div>
                                                                                        </template>
                                                                                        <template slot="noResult">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                No Results Found</div>
                                                                                        </template>
                                                                                    </multiselect>
                                                                                </div>
                                                                                <div class="col-lg-6 col-md-6 col-sm-6">
                                                                                    <span class="text-secondary whiteSpace fs-14 fw-600">Team</span>
                                                                                    <multiselect :disabled="createJson.general_access == 'public'"
                                                                                        class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                                                        name="permission_individual"
                                                                                        @search-change="searchPermissionTeam($event,'permission')"
                                                                                        @open="searchPermissionTeam($event,'permission')"
                                                                                        @close="dropdownEmailClosed"
                                                                                        :loading="isLoadingPermissionTeam"
                                                                                        v-model="createJson.permissions.team"
                                                                                        :searchable="true" :block-keys="['Tab']"
                                                                                        placeholder="Add Team"
                                                                                        :options="optionsPemissionRecipientsTeam"
                                                                                        :multiple="true"
                                                                                        :close-on-select="false"
                                                                                        :show-labels="false"
                                                                                        :clear-on-select="true"
                                                                                        :hide-selected="true"
                                                                                        label="email_id" track-by="email_id"
                                                                                        >
                                                                                        <template slot="tag"
                                                                                            slot-scope="{ option, remove }">
                                                                                            <span class="custom__tag">
                                                                                                <span>{{ option.email_id }}</span>
                                                                                                <span class="custom__remove"
                                                                                                    @click="remove(option)">
                                                                                                    <i
                                                                                                        class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                                </span>
                                                                                            </span>
                                                                                        </template>
                                                                                        <template slot="afterList">
                                                                                            <div
                                                                                                v-observe-visibility="reachedEndOfPermissionTeam" />
                                                                                        </template>
                                                                                        <template slot="noOptions">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                List is Empty</div>
                                                                                        </template>
                                                                                        <template slot="noResult">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                No Results Found</div>
                                                                                        </template>
                                                                                    </multiselect>
                                                                                </div>

                                                                            </div>
                                                                            <!-- <vue-tags-input v-model="createJson.add_recipient" v-validate="'email'" class="inputFieldNew mt-4"   placeholder="Enter Email Recipients"
                                                                                name="email_recipients"  :tags="createJson.recipient_email" @tags-changed="newRecepients =>  createJson.recipient_email= newRecepients" />
                                                                                  <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('email_recipients')">{{errors.first('email_recipients')}}</span> -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                                    <div class="row">
                                                                        <div class="btn-align mt-2 w-100" style="justify-content:flex-end;">
                                                                            <button type="button" class="btn btn-new-darksuccess text-white btn-smm btnlast mt-4" style="box-shadow: none;" @click="resetPermissions()"
                                                                            :disabled="createJson.permissions.individual.length == 0 && createJson.permissions.team.length == 0">
                                                                                <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg" alt="" style="margin-right:1px;">
                                                                                Reset
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- Meeting Information Section -->
                                                        <div class="block-callreport">
                                                            <div class="infoHeaderHideShow mt-3 mb-3">
                                                                <div class="descriptionheader">
                                                                    <div class="description-text-header-left">
                                                                        <h5 class="fw-500 whiteSpace">Meeting
                                                                            Information</h5>
                                                                    </div>
                                                                    <div class="description-text-header-right">
                                                                        <span class="collapse-addon"
                                                                            @click="expandMeetingInformation()">
                                                                            <i v-if="showMeetingInformation"
                                                                                class="icon-chevron-double-up text-white"></i>
                                                                            <i v-else
                                                                                class="icon-chevron-double-down text-white"></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-show="showMeetingInformation == true">
                                                                <div class="row mt-3">
                                                                    <div class="col-lg-4 col-md-4 col-sm-4">
                                                                        <div class>
                                                                            <span
                                                                                class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                                Call Report Type
                                                                            </span>
                                                                            <div class="d-flex align-items-center">
                                                                                <multiselect
                                                                                    class="diginew-multiselect new-align-multi no-default-icon mt-4"
                                                                                    name="reportcall" :searchable="true"
                                                                                    v-model="createJson.call_report_type"
                                                                                    :options="[]" :disabled="true"
                                                                                    style="background: #eff1f4 !important">
                                                                                    <template slot="noOptions">
                                                                                        <div
                                                                                            class="text-secondary text-center fw-600">
                                                                                            List is Empty</div>
                                                                                    </template>
                                                                                    <template slot="noResult">
                                                                                        <div
                                                                                            class="text-secondary text-center fw-600">
                                                                                            No Results Found</div>
                                                                                    </template>
                                                                                </multiselect>
                                                                                <i class="icon icon-check-circle fs-30 text-success ml-2"
                                                                                    style="margin-top: 18px;"></i>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-4 col-md-4 col-sm-4">
                                                                        <div>
                                                                            <span
                                                                                class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                                Meeting Type
                                                                            </span>
                                                                            <div class="d-flex align-items-center">
                                                                                <div class="w-100">
                                                                                    <multiselect
                                                                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-4"
                                                                                        name="meetingcall"
                                                                                        :searchable="true"
                                                                                        v-model="createJson.meeting_type"
                                                                                        :options="organisationSettings.hasOwnProperty('call_report_settings') ? organisationSettings.call_report_settings.meeting_type : []">
                                                                                        <template slot="noOptions">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                List is Empty</div>
                                                                                        </template>
                                                                                        <template slot="noResult">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                No Results Found</div>
                                                                                        </template>
                                                                                    </multiselect>
                                                                                </div>
                                                                                <!--<span class="pointer"
                                                                                    @click="changeView()">
                                                                                    <el-tooltip class="item"
                                                                                        effect="dark"
                                                                                        content="The value is auto-filled and configurable in Settings. Click here to go to Settings"
                                                                                        placement="bottom">
                                                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                                                            class="ml-2 mt-5"
                                                                                            style="width:20px" alt="">
                                                                                    </el-tooltip>
                                                                                </span>-->
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                                                        <div class="w-100">
                                                                            <span
                                                                                class="text-secondary input-label fs-14 fw-600">Branch
                                                                                Name</span>
                                                                            <div
                                                                                class="d-flex align-content-center mt-4">
                                                                                <input type="text" name="owner_name"
                                                                                    disabled
                                                                                    class="input-field input-width"
                                                                                    v-model="createJson.branch_name"
                                                                                    placeholder="Enter Branch" />
                                                                                <span class="mt-2 ml-1">
                                                                                    <span class="mt-3"><i
                                                                                            class="icon text-green icon-check-circle"></i></span>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <!-- <div class="col-lg-4 col-md-4 col-sm-6 mt-3">
                                                                        <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">Branch Name</span>
                                                                        <input type="text" class="input-field input-width mt-4"  v-model="createJson.branch_name.name" placeholder="Enter Branch Name">
                                                                        <i class="icon icon-check-circle fs-30 text-success ml-2 mt-4"></i>
                                                                    </div> -->


                                                                </div>
                                                                <div class="row mt-6">
                                                                    <div class="col-lg-4 col-md-4 col-sm-4 d-flex">
                                                                        <div style="width:55%">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                                                Start Date
                                                                                <sup
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </span>
                                                                            <div
                                                                                class="d-flex align-items-center mt-4 mr-1">
                                                                                <date-picker
                                                                                    v-model="meeting_start_date"
                                                                                    @change="onChangeMeetingStartDate"
                                                                                    name="meetingstartdate"
                                                                                    class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                                                    format="MM/DD/YYYY" type="date"
                                                                                    value-type="format" lang="en"
                                                                                    :clearable="false" :editable="false"
                                                                                    confirm confirm-text="APPLY">
                                                                                </date-picker>
                                                                                <span><i class="icon icon-check-circle fs-30 ml-2"
                                                                                        style="color: #ff9a06;"></i></span>
                                                                            </div>
                                                                            <!-- <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('meetingstartdate')">Start
                                                                                Date is Required</span> -->
                                                                        </div>
                                                                        <div style="width:45%">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                                                Start Time
                                                                                <sup
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </span>
                                                                            <div class="d-flex align-items-center mt-4">
                                                                                <date-picker
                                                                                    @change="onChangeMeetingStartTime"
                                                                                    v-model="meeting_start_time"
                                                                                    name="meetingstarttime"
                                                                                    class="meetinfdatetime mx-left date-picker-clock-svg-icon calendar-down-arrow-grey mr-1 "
                                                                                    format="hh:mm A" type="time"
                                                                                    placeholder="HH:MM" lang="en"
                                                                                    v-validate="'required'"
                                                                                    :clearable="false" :editable="false"
                                                                                    value-type="format" :minute-step="1"
                                                                                    confirm confirm-text="APPLY">
                                                                                </date-picker>
                                                                                <span><i class="icon icon-check-circle fs-30 ml-2"
                                                                                        style="color: #ff9a06;"></i></span>
                                                                            </div>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('meetingstarttime')">Start
                                                                                Time is Required</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-4 col-md-4 col-sm-4 d-flex">
                                                                        <div style="width:55%">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                                                End Date
                                                                                <sup
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </span>
                                                                            <div
                                                                                class="d-flex align-items-center mt-4 mr-1">
                                                                                <date-picker
                                                                                    @change="onChangeMeetingEndDate"
                                                                                    v-model="meeting_end_date"
                                                                                    :not-before="meeting_start_date"
                                                                                    name="meetingenddate"
                                                                                    class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                                                    format="MM/DD/YYYY" type="date"
                                                                                    lang="en" :clearable="false"
                                                                                    value-type="format"
                                                                                    :editable="false" confirm
                                                                                    confirm-text="APPLY"></date-picker>
                                                                                <span><i class="icon icon-check-circle fs-30 ml-2"
                                                                                        style="color: #ff9a06;"></i></span>
                                                                            </div>
                                                                            <!-- <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('meetingenddate')">End
                                                                                Date is Required</span> -->
                                                                        </div>
                                                                        <div style="width:45%">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                                                End Time
                                                                                <sup
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </span>
                                                                            <div class="d-flex align-items-center mt-4">
                                                                                <date-picker
                                                                                    @change="onChangeMeetingEndTime"
                                                                                    v-model="meeting_end_time"
                                                                                    format="hh:mm A"
                                                                                    v-validate="'required'"
                                                                                    value-type="format"
                                                                                    name="meetingendtime"
                                                                                    class="meetinfdatetime mx-left date-picker-clock-svg-icon calendar-down-arrow-grey mr-1"
                                                                                    type="time" placeholder="HH:MM"
                                                                                    lang="en" :clearable="false"
                                                                                    :editable="false" :minute-step="1"
                                                                                    confirm confirm-text="APPLY">
                                                                                </date-picker>
                                                                                <span><i class="icon icon-check-circle fs-30 ml-2"
                                                                                        style="color: #ff9a06;"></i></span>
                                                                            </div>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('meetingendtime')">End
                                                                                Time is Required</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-4 col-md-4 col-sm-4">
                                                                        <div>
                                                                            <h6 class="fw-600 fs-14 defaultDarkBlue">
                                                                                Meeting Location <sup
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </h6>
                                                                            <div class="d-flex align-items-center">
                                                                                <div class="form-group pt-2 gMap"
                                                                                    style="width:85%">
                                                                                    <gmap-autocomplete
                                                                                        class="input-white" v-validate="'required'"
                                                                                        id="autocompleteInput"
                                                                                        name="get_location"
                                                                                        placeholder="Enter Location"
                                                                                        @place_changed="setPlace"
                                                                                        @blur="handleManualEntry"
                                                                                        @keyup.enter.native="handleManualEntry"
                                                                                        :value="meeting_location_vmodel"
                                                                                        @input.native="getLocationChange"
                                                                                        v-model="meeting_location_vmodel"
                                                                                        style="padding: 6px 32px 6px 12px !important;background-color: transparent;">
                                                                                    </gmap-autocomplete>
                                                                                    <!-- <gmap-autocomplete
                                                                                        class="input-white" v-validate="'required'"
                                                                                        id="autocompleteInput"
                                                                                        name="get_location"
                                                                                        placeholder="Enter Location"
                                                                                        @place_changed="setPlace"
                                                                                        :value="meeting_location_vmodel"
                                                                                        @input.native="getLocationChange"
                                                                                        v-model="meeting_location_vmodel"
                                                                                        style="padding: 6px 32px 6px 12px !important;background-color: transparent;">
                                                                                    </gmap-autocomplete> -->
                                                                                    <el-tooltip class="item"
                                                                                        effect="dark"
                                                                                        :content="meeting_location_vmodel"
                                                                                        placement="top">
                                                                                        <img src="/static/images/images-new-theme/icons/marker_pin.svg"
                                                                                            style="position: absolute;right: 12px;bottom: 10px;" />
                                                                                    </el-tooltip>
                                                                                </div>
                                                                                <div class="mt-1 ml-3"
                                                                                    style="cursor: pointer;width:10%;"
                                                                                    @click="getLocation">
                                                                                    <img src="/static/images/images-new-theme/icons/GPS 2.svg"
                                                                                        style="height: 40px;" />
                                                                                </div>
                                                                            </div>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('get_location')">Meeting
                                                                                Location is Required
                                                                            </span>
                                                                            <span v-if="showManualEntry && !manualFallback" @click="addAddressNew" class="btn-link text-danger mt-2 fs-14 fw-600 pointer">
                                                                                Can’t find your address? Click here to add
                                                                            </span> 
                                                                        </div>
                                                                    </div>
                                                                    <!-- <div class="col-lg-4 col-md-4 col-sm-4">
                                                                        <div>
                                                                            <span
                                                                                class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                                Country
                                                                                <sup
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </span>
                                                                            <multiselect
                                                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow comanyTimeSelect"
                                                                                placeholder="Enter Country"
                                                                                :clearable="false" :filterable="true"
                                                                                :options="countriesCaps"
                                                                                @input="createJson.meeting_location.state = '',createJson.meeting_location.city = '',createJson.meeting_location.township = '',createJson.meeting_location.zip_code = '',createJson.meeting_location.street = ''"
                                                                                style="margin-top: 18px;"
                                                                                v-validate="'required'"
                                                                                v-model="createJson.meeting_location.country"
                                                                                name="country">
                                                                                <template slot="noOptions">
                                                                                    <div
                                                                                        class="text-secondary text-center fw-600">
                                                                                        List is Empty</div>
                                                                                </template>
                                                                                <template slot="noResult">
                                                                                    <div
                                                                                        class="text-secondary text-center fw-600">
                                                                                        No Results Found</div>
                                                                                </template>
                                                                            </multiselect>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                v-show="errors.has('country')">Country
                                                                                is Required</span>
                                                                        </div>
                                                                    </div> -->
                                                                </div>
                                                                <!-- <div class="row mt-6">
                                                                    <div class="col-lg-4 col-md-4 col-sm-4">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew mt-6"
                                                                                type="text"
                                                                                v-model="createJson.meeting_location.state"
                                                                                v-validate="{regex:state_regex}"
                                                                                placeholder="Enter State Name"
                                                                                name="state" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel fs-14 fw-600">State</label>
                                                                        </div>
                                                                        <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('state')">State must
                                                                            contain only Alphabets</span>
                                                                    </div>
                                                                    <div class="col-lg-4 col-md-4 col-sm-4">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew mt-6"
                                                                                type="text" name="city"
                                                                                v-model="createJson.meeting_location.city"
                                                                                placeholder="Enter City Name" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel fs-14 fw-600">City</label>
                                                                        </div>

                                                                    </div>
                                                                    <div class="col-lg-4 col-md-4 col-sm-4">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew mt-6"
                                                                                type="text"
                                                                                v-model="createJson.meeting_location.township"
                                                                                placeholder="Enter Township"
                                                                                maxlength="30" name="township"
                                                                                @input="$refs.townshipCounter.updateProgress(createJson.meeting_location.township.length * 5)"
                                                                                @keyup="createJson.meeting_location.township.length > 16 ? $refs.townshipCounter.updateFill('#ff9a06') : $refs.townshipCounter.updateFill('#005dae')"
                                                                                style="padding-right: 40px !important" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel fs-14 fw-600">Township</label-->
                                                                <!-- <vue-circle ref="townshipCounter"
                                                                                :progress="0" :size="30"
                                                                                :reverse="false" line-cap="round"
                                                                                empty-fill="rgba(0, 0, 0, .1)"
                                                                                :animation-start-value="0.0"
                                                                                :start-angle="0" insert-mode="append"
                                                                                :thickness="2" :show-percent="false"
                                                                                :animation="{duration: 600}"
                                                                                style="position: absolute; top: 45px; right: 8px;">
                                                                                <p>{{30 - createJson.meeting_location.township.length}}
                                                                                </p>
                                                                            </vue-circle>
                                                                        </div-->
                                                                <!-- <span class="invalid-feedback-form text-danger"
                                                                            style="text-transform: none !important;"
                                                                            v-show="errors.has('township')">Township must contain only alphabets</span>
                                                                    </div>
                                                                </div>
                                                                <div class="row mt-6">
                                                                    <div class="col-lg-4 col-md-4 col-sm-4">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew mt-6"
                                                                                type="text"
                                                                                v-model="createJson.meeting_location.street"
                                                                                placeholder="Enter Street Name"
                                                                                maxlength="30"
                                                                                @input="$refs.streetCounter.updateProgress(createJson.meeting_location.street.length * 5)"
                                                                                @keyup="createJson.meeting_location.street.length > 16 ? $refs.streetCounter.updateFill('#ff9a06') : $refs.streetCounter.updateFill('#005dae')"
                                                                                style="padding-right: 40px !important" />
                                                                            <span class="inputBorder"></span>
                                                                            <label
                                                                                class="inputLabel fs-14 fw-600">Street</label>

                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-4 col-md-4 col-sm-4">
                                                                        <div class="form-group">
                                                                            <input class="inputFieldNew mt-6"
                                                                                type="text"
                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                v-model="createJson.meeting_location.zip_code"
                                                                                placeholder="Enter Zip Code" />
                                                                            <span class="inputBorder"></span>
                                                                            <label class="inputLabel fs-14 fw-600">Zip
                                                                                Code</label>
                                                                        </div>
                                                                    </div>
                                                                </div> -->
                                                                <div class="btn-align mt-4 pl-4 w-100">
                                                                    <button type="button"
                                                                        :disabled="createJson.meeting_type == '' && meeting_location_vmodel == ''"
                                                                        class="btn btn-new-darksuccess text-white btn-smm btnlast"
                                                                        style="box-shadow: none;"
                                                                        @click="resetMeting()">
                                                                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg"
                                                                            alt="" style="margin-right:1px;">
                                                                        Reset
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="row"> -->
                                                        <div
                                                            class="d-flex flex-wrap justify-content-center align-items-center pb-2">
                                                            <button type="button"
                                                                class="btn new-cancel-button mr-3"
                                                                style="height: 32px !important;"
                                                                @click="backToListView">DISCARD</button>
                                                            <button type="button"
                                                                class="btn btn-new-darksuccess text-white btn-smm mr-3"
                                                                style="box-shadow: none !important;"
                                                                @click="savecallReport">SAVE</button>
                                                            <button type="button"
                                                                v-if="userPermissions.draft_call_reports.permitted_actions.create"
                                                                class="btn btn-new-warning btn-smm mr-3"
                                                                style="box-shadow: none !important;"
                                                                @click="savecallReportclose">SAVE AND CLOSE</button>
                                                            <button type="button" class="btn btn-new-primary btn-smm"
                                                                style="box-shadow: none !important; width: 7em"
                                                                @click="nextvalidatecall">NEXT <i
                                                                    class="icon-chevron-right text-white fs-20 mt-1"
                                                                    style="position: absolute;"></i></button>
                                                        </div>
                                                        <!-- </div> -->
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Meeting Notes Section -->
                                        <div class="mt-5" v-if="meetingnotestab" role="tabpanel"
                                            aria-labelledby="meetingnotes-tab">
                                            <div class="row">
                                                <div class="col-lg-12 px-0">
                                                    <div class="block-callreport">
                                                        <div class="infoHeaderHideShow mt-6 mb-4">
                                                            <div class="descriptionheader">
                                                                <div class="description-text-header-left">
                                                                    <!-- <h5 class="fw-500 whiteSpace">Meeting Notes</h5> -->
                                                                    <h5 class="fw-500 whiteSpace">{{ createJson.call_report_category == 'Release Notes' ? 'Release Notes' : 'Meeting Notes' }}</h5>
                                                                </div>
                                                                <div class="description-text-header-right">
                                                                    <span class="collapse-addon"
                                                                        @click="expandMeetingNotes()">
                                                                        <i v-if="showMeetingNotes"
                                                                            class="icon-chevron-double-up text-white"></i>
                                                                        <i v-else
                                                                            class="icon-chevron-double-down text-white"></i>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="showMeetingNotes">
                                                            <div class="row">
                                                                <div class="col-lg-12">
                                                                    <div class>
                                                                        <span
                                                                            class="text-secondary whiteSpace fs-14 fw-600">
                                                                            Report Title
                                                                        </span>
                                                                        <div class="d-flex align-items-center">
                                                                            <input class="input-white mt-4"
                                                                                name="subject_name"
                                                                                v-model="createJson.meeting_notes_subject"
                                                                                placeholder="Enter Subject" type="text"
                                                                                :maxlength="maxlengthsubjectname"
                                                                                disabled
                                                                                style="background: #ecf1f9 !important;" />
                                                                            <i
                                                                                class="icon icon-check-circle fs-30 text-success ml-2 mt-4"></i>
                                                                        </div>
                                                                        <!-- <span
                                      class="text-grey"
                                      style="position: absolute; margin-top: -30px; right: 24px;"
                                    >{{maxlengthsubjectname - createJson.meeting_notes_subject.length}}/200</span> -->
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="mt-10">
                                                                <div>
                                                                    <button
                                                                        class="btn btn-new-primary btn-smm float-right"
                                                                        @click="addOneTable"
                                                                        style="margin-top: -20px;"><img class="mr-2"
                                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/table-white.svg"
                                                                            height="14px"> Add Table</button>
                                                                </div>
                                                                <div class="mb-4">
                                                                    <span
                                                                        class="text-secondary whiteSpace fs-14 fw-600">
                                                                        <!-- Add Meeting Notes -->
                                                                        Add {{ createJson.call_report_category == 'Release Notes' ? 'Release Notes' : 'Meeting Notes' }}
                                                                    </span>
                                                                </div>
                                                                <!-- <vue-editor ondrop="return false;" class="mt-2"
                                                                    name="meeting_decription"
                                                                    v-model="createJson.meeting_notes"
                                                                    placeholder="Add Description"></vue-editor> -->
                                                                <!-- <mc-wysiwyg class="mt-2 wyseditor"
                                                                    name="meeting_decription"
                                                                    v-model="createJson.meeting_notes"
                                                                    placeholder="Add Description" :height="300" :hide="hide">
                                                                </mc-wysiwyg> -->
                                                                <!-- <quill-editor
                                                                    class="editor"
                                                                    ref="myTextEditor"
                                                                    :value="content" v-model="createJson.meeting_notes"
                                                                    :options="editorOption"
                                                                    @change="onEditorChange"
                                                                /> -->
                                                                <div :class="{'editor-fullscreen': isFullscreen}" class="editor-container">
                                                                    <button v-if="!isFullscreen" @click="isFullscreen = true" class="btn btn-new-primary btn-smm fullscreen-btn">
                                                                    Fullscreen
                                                                    </button>
                                                                    <button v-if="isFullscreen" @click="isFullscreen = false" class="dg-btn dg-btn--cancel exit-fullscreen-btn">
                                                                    Exit Fullscreen
                                                                    </button>
                                                                    <mc-wysiwyg
                                                                        class="mt-2 wyseditor"
                                                                        name="meeting_description"
                                                                        v-model="createJson.meeting_notes"
                                                                        placeholder="Add Description"
                                                                        :height="isFullscreen ? fullscreenHeight : 300"
                                                                        :hide="hide"
                                                                        ref="wysiwygEditor">
                                                                    </mc-wysiwyg>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-for="(table,index) in createJson.meeting_notes_table"
                                                        :key="index" class="block-callreport">
                                                        <div
                                                            class="d-flex flex-wrap align-items-center justify-content-between flex-wrap">
                                                            <div class="mt-5">
                                                                <span
                                                                    class="text-secondary whiteSpace fs-14 fw-600">Table
                                                                    Name :</span>
                                                                <input type="text" class="px-2 ml-3" placeholder="Enter Table Name"
                                                                    v-model="table.meeting_notes_table_name"
                                                                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.41); height: 25px;" />
                                                            </div>
                                                            <div class="mt-5">
                                                                <span
                                                                    class="text-black whiteSpace fs-14 fw-600 ml-3 mb-2">No
                                                                    of Rows:
                                                                    <sup lass="fs-14 ml-02 mandatory">
                                                                        <el-tooltip content="Maximum of 10 Rows"
                                                                            placement="top">
                                                                            <i class="icon-information text-secondary"
                                                                                style="font-size: 14px"></i>
                                                                        </el-tooltip>
                                                                    </sup>
                                                                </span>
                                                                <input type="text" class="text-center ml-3 mb-2"
                                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                    v-model="table.meeting_notes_table_row"
                                                                    @input="table.meeting_notes_table_row > 10 ? table.meeting_notes_table_row = 10 : table.meeting_notes_table_row < 0 ? table.meeting_notes_table_row = 0 : ''"
                                                                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.41); height: 25px; width: 50px;" />
                                                                <span
                                                                    class="text-black whiteSpace fs-14 fw-600 ml-3 mb-2">No
                                                                    of Columns:
                                                                    <sup lass="fs-14 ml-02 mandatory">
                                                                        <el-tooltip content="Maximum of 5 Columns"
                                                                            placement="top">
                                                                            <i class="icon-information text-secondary"
                                                                                style="font-size: 14px"></i>
                                                                        </el-tooltip>
                                                                    </sup>
                                                                </span>
                                                                <input type="text" class="text-center ml-3 mb-2"
                                                                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                    v-model="table.meeting_notes_table_column"
                                                                    @input="table.meeting_notes_table_column > 5 ? table.meeting_notes_table_column = 5 : table.meeting_notes_table_column < 0 ? table.meeting_notes_table_column = 0 : ''"
                                                                    style="border-bottom: 1px solid rgba(0, 0, 0, 0.41); height: 25px; width: 50px;" />
                                                                <button class="btn btn-new-danger btn-smm ml-20"
                                                                    @click="deleteTableCells(index)">- Delete</button>
                                                                <button class="btn btn-new-green btn-smm ml-3"
                                                                    @click="addTableCells(index)"><img
                                                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/circle-right.svg">
                                                                    Apply</button>
                                                            </div>
                                                        </div>
                                                        <div style="overflow: auto;" v-if="table">
                                                            <table class="meeting-notes-table mt-10" style="width: 100%;">
                                                                <tbody>
                                                                    <tr v-for="(row,index) in table.meeting_notes_table_data"
                                                                        :key="index">
                                                                        <td v-for="(col,index) in row" :key="index"
                                                                            style="height: 38px;">
                                                                            <input type="text" maxlength="100" v-model="row[index]" style="width:100%;padding: 0 15px 0 15px;" placeholder="Enter text"/>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                    <div class="block-callreport">
                                                        <div class="infoHeaderHideShow mt-6 mb-4">
                                                            <div class="descriptionheader">
                                                                <div class="description-text-header-left">
                                                                    <h5 class="fw-500 whiteSpace">Attachments</h5>
                                                                </div>
                                                                <div class="description-text-header-right">
                                                                    <span class="collapse-addon"
                                                                        @click="expandAttachments()">
                                                                        <i v-if="showAttachments"
                                                                            class="icon-chevron-double-up text-white"></i>
                                                                        <i v-else
                                                                            class="icon-chevron-double-down text-white"></i>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="showAttachments" class="row px-4">
                                                            <div class="upload-main d-flex flex-column justify-content-center align-items-center attachment-bg pl-0"
                                                                :class="attachments.length ? 'col-4' : 'col-12'"
                                                                style="height: 18em;">
                                                                <div
                                                                    class="d-flex justify-content-center align-items-center">
                                                                    <div class="mb-10">
                                                                        <img class="upload-img"
                                                                            src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/upload-icon.svg"><br>
                                                                        <span class="fs-14 fw-500 mt-2 mr-3">Drag and
                                                                            Drop File or </span>
                                                                    </div>
                                                                    <file-upload
                                                                        :class="{'pointer-event':attachments.length >= 10}"
                                                                        class="choose-file btn btn-new-primary mt-2"
                                                                        :multiple="true" :drop="true"
                                                                        :drop-directory="true"
                                                                        accept=".doc, .docx, .pdf, .ppt, .pptx, .txt, .Xls, .xlsx, .bmp, .jpeg, .png, .svg, .mpeg, .avi, .mp3, .mp4"
                                                                        @input-file="uploadAttachment" ref="upload"
                                                                        style="text-transform: none !important">
                                                                        Browse
                                                                    </file-upload>
                                                                </div>
                                                                <span class="m-0 text-center">Supports .doc, .docx,
                                                                     .pdf, .ppt, .pptx, .txt, .Xls,</span>
                                                                <span class="m-0 text-center">.xlsx, .bmp, .jpeg,
                                                                    .png, .svg, .avi, .mp3, .mpeg,
                                                                    .mp4</span>
                                                                <p>Size limit- 25.00 MB (Max. 10 files)</p>
                                                            </div>
                                                            <div v-if="showAttachments && attachments.length"
                                                                class="col-8 pr-0"
                                                                style="height: 18em; overflow: auto;">
                                                                <div class="attachmentsdiv p-4 my-2"
                                                                    v-for="(attachment,index) in attachments"
                                                                    :key="index">
                                                                    <div
                                                                        class="d-flex align-items-center justify-content-between">
                                                                        <div class="d-flex align-items-center">
                                                                            <div>
                                                                                <img class="icon-img"
                                                                                    v-if="attachment.name.endsWith('.pdf')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pdf-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.png')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/png-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.jpg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.svg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/svg-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.xls')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xls-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.doc')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/doc-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.docx')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/docx-icon.svg" />
                                                                                <!-- <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.htm')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/htm-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.html')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/html-icon.svg" /> -->
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.ppt')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/ppt-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.pptx')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/pptx-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.txt')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/txt-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.xlsx')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/xlsx-icon.svg" />
                                                                                <!-- <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.bmp')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/bmp-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.gif')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/gif-icon.svg" /> -->
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.jpeg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg-icon.svg" />
                                                                                <!-- <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.tiff')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/jpg.png" /> -->
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.avi')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/avi-icon.svg" />
                                                                                <!-- <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.flv')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/flv-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.mpg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpg-icon.svg" /> -->
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.mpeg')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mpeg-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.mp3')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp3-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.mp4')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/mp4-icon.svg" />
                                                                                <!-- <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.wav')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wav-icon.svg" />
                                                                                <img class="icon-img"
                                                                                    v-else-if="attachment.name.endsWith('.wmv')"
                                                                                    src="https://cdn.digicollect.com/cdn/dc_crm_fe/attachment/wmv-icon.svg" /> -->
                                                                            </div>
                                                                            <div class="col">
                                                                                <div
                                                                                    class="d-flex justify-content-between">
                                                                                    <el-tooltip
                                                                                        :content="attachment.name"
                                                                                        placement="top">
                                                                                        <div
                                                                                            class="font-weight-bold text-truncate d-block mx-width-220">
                                                                                            {{attachment.name}}</div>
                                                                                    </el-tooltip>
                                                                                </div>
                                                                                <div
                                                                                    v-if="attachment.uploading || attachment.url == undefined">
                                                                                    <progress-bar
                                                                                        class="progressBar w-100"
                                                                                        :class="{'error-upload':attachment.url == undefined}"
                                                                                        :val="attachment.progress"
                                                                                        size="small"></progress-bar>
                                                                                </div>
                                                                                <div
                                                                                    class="d-flex justify-content-between">
                                                                                    <div class="text-danger pl-0 fw-500"
                                                                                        v-if="attachment.error != ''">
                                                                                        {{attachment.error}}...</div>
                                                                                    <div class="text-secondary fw-500"
                                                                                        v-if="attachment.progress<100 && attachment.error == ''">
                                                                                        {{attachment.progress}}%
                                                                                        Uploading</div>
                                                                                    <div class="text-secondary fw-500"
                                                                                        v-if="attachment.progress==100 && attachment.error == ''">
                                                                                        {{attachment.progress}}%
                                                                                        Uploaded</div>
                                                                                    <div class="fw-500">
                                                                                        ({{attachment.size | prettyBytes}})
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div v-if="attachment.uploading || attachment.url == undefined"
                                                                            class="pointer"
                                                                            @click="deleteAttachment(attachment,index)">
                                                                            <i
                                                                                class="icon icon-close fs-16 closeAttachment"></i>
                                                                        </div>
                                                                        <div v-else class="pointer"
                                                                            @click="deleteAttachment(attachment,index)">
                                                                            <i
                                                                                class="icon icon-close fs-16 closeAttachment"></i>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="row"> -->
                                                    <div
                                                        class="d-flex flex-wrap justify-content-center align-items-center pb-2">
                                                        <button type="button" class="btn btn-new-primary btn-smm mr-3"
                                                            style="box-shadow: none !important; width: 7em"
                                                            @click="cancelmeeting()"><i
                                                                class="icon-chevron-left text-white fs-20 mt-1"
                                                                style="position: absolute; margin-left: -22px;"></i>
                                                            BACK</button>
                                                        <button type="button"
                                                            class="btn new-cancel-button mr-3"
                                                            style="height: 32px !important;"
                                                            @click="backToListView">DISCARD</button>
                                                        <button type="button"
                                                            class="btn btn-new-darksuccess text-white btn-smm mr-3"
                                                            style="box-shadow: none !important;"
                                                            @click="saveMeetingInfo">SAVE</button>
                                                        <button type="button" class="btn btn-new-warning btn-smm mr-3"
                                                            style="box-shadow: none !important;"
                                                            @click="saveMeetingInfoClose">SAVE AND CLOSE</button>
                                                        <button type="button" class="btn btn-new-primary btn-smm"
                                                            style="box-shadow: none !important; width: 7em"
                                                            @click="meetingValidateNext">NEXT <i
                                                                class="icon-chevron-right text-white fs-20 mt-1"
                                                                style="position: absolute;"></i></button>
                                                    </div>
                                                    <!-- </div> -->
                                                </div>
                                            </div>
                                        </div>
                                         <!-- Follow Up Section -->
                                        <div class="mt-5" v-if="followuptab" role="tabpanel"
                                            aria-labelledby="followup-tab">
                                            <div class="row">
                                                <div class="col-lg-12 px-0">
                                                    <form autocomplete="off">
                                                        <div>
                                                            <div v-for="(follow,index) in createJson.follow_ups"
                                                                :key="index">
                                                                <div class="block-callreport">
                                                                    <div
                                                                        class="btn-align justify-content-end mt-9 w-100">
                                                                        <button type="button"
                                                                            class="btn btn-new-darkdanger btn-smm mr-3"
                                                                            style="box-shadow: none;" v-if="index!=0"
                                                                            @click="createJson.follow_ups.splice(index, 1) && showFollowUps.splice(index,1)">-
                                                                            Delete Follow Up</button>
                                                                        <button type="button"
                                                                            class="btn btn-new-green btn-smm mr-3"
                                                                            style="box-shadow: none !important;"
                                                                            v-if="index+1==createJson.follow_ups.length"
                                                                            @click="createJson.follow_ups.push(JSON.parse(JSON.stringify(follows))) && showFollowUps.push(index+1) && showFollowUpsNotes.push(index+1)">+
                                                                            Add Follow Up</button>
                                                                    </div>
                                                                    <div class="infoHeaderHideShow mt-8">
                                                                        <div class="descriptionheader">
                                                                            <div class="description-text-header-left">
                                                                                <h5 class="font-weight-bold whiteSpace">
                                                                                    Follow Up - {{index+1}}</h5>
                                                                            </div>
                                                                            <div class="description-text-header-right">
                                                                                <span class="collapse-addon">
                                                                                    <i v-if="follow.is_follow_expanded"
                                                                                        @click="expandFollowUps(follow)" class="icon-chevron-double-up text-white"></i>
                                                                                    <i v-else
                                                                                        @click="expandFollowUps(follow)" class="icon-chevron-double-down text-white"></i>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="follow.is_follow_expanded">
                                                                        <div class="row mt-5">
                                                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                                                <span class="text-secondary whiteSpace fs-14 vselectLabel fs-14 fw-600">
                                                                                    Product Name
                                                                                    <sup class="fs-14 ml-02 mandatory"
                                                                                        v-if="follow.products != ''">
                                                                                        <el-tooltip class="item"
                                                                                            effect="dark"
                                                                                            content="The products are listed from the product page"
                                                                                            placement="top">
                                                                                            <i
                                                                                                class="icons icon-information defaultDarkBlue iconsize-16"></i>
                                                                                        </el-tooltip>
                                                                                    </sup>
                                                                                </span>
                                                                                <multiselect :max="10"
                                                                                    class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                                                    name="email_recipients"
                                                                                    @search-change="searchProuctName"
                                                                                    :loading="products_loading"
                                                                                    v-model="follow.products" @open="resetData('name')"
                                                                                    :searchable="true" :block-keys="['Tab']"
                                                                                    placeholder="Select Product"
                                                                                    :options="products_options"
                                                                                    :multiple="true"
                                                                                    :close-on-select="true"
                                                                                    :show-labels="false"
                                                                                    :clear-on-select="true"
                                                                                    :hide-selected="true" :taggable="true"
                                                                                    label="name" track-by="name">
                                                                                    <template slot="tag"
                                                                                        slot-scope="{ option }">
                                                                                        <span class="custom__tag">
                                                                                            <span>{{ option.name }}</span>
                                                                                            <span class="custom__remove"
                                                                                                @click="removeProductsName(option)">
                                                                                                <i
                                                                                                    class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                            </span>
                                                                                        </span>
                                                                                    </template>
                                                                                    <template slot="afterList">
                                                                                        <div
                                                                                            v-observe-visibility="reachedEndOfProductName" />
                                                                                    </template>
                                                                                    <template slot="noOptions">
                                                                                        <div
                                                                                            class="text-secondary text-center fw-600">
                                                                                            List is Empty</div>
                                                                                    </template>
                                                                                    <template slot="noResult">
                                                                                        <div
                                                                                            class="text-secondary text-center fw-600">
                                                                                            No Results Found</div>
                                                                                    </template>
                                                                                </multiselect>
                                                                                <!-- <multiselect
                                                                                    class="diginew-multiselect-long greyblack no-default-icon mt-4 multi-height-align"
                                                                                    v-model="follow.products"
                                                                                    @search-change="getProduts"
                                                                                    :loading="products_loading"
                                                                                    :name="'product_name'+index"
                                                                                    :multiple="true"
                                                                                    :block-keys="['Tab']"
                                                                                    :options="productoptions"
                                                                                    :searchable="true"
                                                                                    :close-on-select="true"
                                                                                    :clear-on-select="true"
                                                                                    :hide-selected="true"
                                                                                    :show-labels="false"
                                                                                    :height="300"
                                                                                    label="name"
                                                                                    track-by="id"
                                                                                    placeholder="Select Product Name">
                                                                                    <template slot="tag" slot-scope="{ option }">
                                                                                        <span class="custom__tag">
                                                                                            <span>{{ option.name }}</span>
                                                                                            <span class="custom__remove" @click="removeProductName(option,follow)">
                                                                                                <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                            </span>
                                                                                        </span>
                                                                                    </template>
                                                                                    <template slot="afterList">
                                                                                        <div
                                                                                            v-observe-visibility="getProdutsAfter" />
                                                                                    </template>
                                                                                    <template slot="noOptions">
                                                                                        <div
                                                                                            class="text-secondary text-center fw-600">
                                                                                            List is Empty</div>
                                                                                    </template>
                                                                                    <template slot="noResult">
                                                                                        <div
                                                                                            class="text-secondary text-center fw-600">
                                                                                            No Results Found</div>
                                                                                    </template>
                                                                                </multiselect> -->
                                                                            </div>
                                                                        </div>
                                                                        <div class="row mt-4">
                                                                            <div class="col-lg-4 col-md-4 col-sm-6">
                                                                                <div class="w-100">
                                                                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600 ml-2">Price
                                                                                        <sup class="fs-14 ml-02 mandatory" v-if="follow.products != ''">
                                                                                            <el-tooltip class="item"
                                                                                                effect="dark"
                                                                                                content="Product Value"
                                                                                                placement="top">
                                                                                                <i class="icons icon-information defaultDarkBlue iconsize-16"></i>
                                                                                            </el-tooltip>
                                                                                        </sup>
                                                                                    </span>
                                                                                    <div class="d-flex align-content-center" v-if="follow.products != ''">
                                                                                        <input type="text" :readonly="true"  disabled class="input-field input-width mt-4 ml-2 text-center fw-600" v-model="transition_format" name="transition" style="width: 20% !important;"/>
                                                                                        <input v-if="$route.path.startsWith('/copycallreport')" type="text" data-vv-as="Price" v-validate="{max:12,regex: /^\d*\.?\d*$/}" :maxLength="12" onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46" class="placeholder-text-product input-field input-width mt-4 ml-2" v-model="follow.price" :name="'price'+index" placeholder="N/A"/>
                                                                                        <input v-else type="text" data-vv-as="Price" v-validate="{max:12,regex: /^\d*\.?\d*$/}" :maxLength="12" onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46" class="input-field input-width mt-4 ml-2" v-model="follow.price" :name="'price'+index" placeholder="Enter Price"/>
                                                                                    </div>
                                                                                    <div class="d-flex align-content-center" v-else>
                                                                                        <input type="text" :readonly="true" disabled class="input-field input-width mt-4 ml-2 text-center fw-600" v-model="transition_format" name="transition" style="width: 20% !important;" />
                                                                                        <input  type="text" v-if="$route.path.startsWith('/copycallreport')" data-vv-as="Price" onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46" readonly="true" disabled class="placeholder-text-product input-field input-width mt-4 ml-2" v-model="follow.price" :name="'price'+index" placeholder="N/A"/>
                                                                                        <input  type="text" v-else data-vv-as="Price" onkeypress="return event.charCode >= 48 && event.charCode <= 57 || event.charCode == 46" readonly="true" disabled class="input-field input-width mt-4 ml-2" v-model="follow.price" :name="'price'+index" placeholder="Enter Price"/>
                                                                                    </div>
                                                                                    <div class="text-right pr-10" v-if="follow.products != ''">
                                                                                        <span class="float-left text-danger mb-3" v-show="errors.has('price'+index)">{{errors.first('price'+index)}}</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-lg-4 col-md-4 col-sm-4">
                                                                                <div>
                                                                                    <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                                        Assigned To <sup class="fs-14 pl-1 text-danger" v-if="follow.products != '' && follow.assigned_to == ''">*</sup>
                                                                                    </span>
                                                                                    <multiselect
                                                                                        v-if="follow.products != ''"
                                                                                        :name="'assigned_to'+index"
                                                                                        label="full_name"
                                                                                        data-vv-as="Assigned To"
                                                                                        class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-4"
                                                                                        placeholder="Assigned To"
                                                                                        @open="assignToInside"
                                                                                        v-validate="'required'"
                                                                                        @search-change="assignToInside"
                                                                                        :loading="isLoadingAssigned"
                                                                                        :clear-on-select="true"
                                                                                        @close="dropdownEmailClosed"
                                                                                        :hide-selected="true"
                                                                                        :disabled="false"
                                                                                        :searchable="true"
                                                                                        v-model="follow.assigned_to"
                                                                                        :close-on-select="true"
                                                                                        :show-labels="false"
                                                                                        index="_id" track-by="id"
                                                                                        :options="assignUsers">
                                                                                        <template slot="tag"
                                                                                            slot-scope="{ option }">
                                                                                            <span>{{ option.first_name + ' ' + option.last_name }}</span>
                                                                                        </template>
                                                                                        <template slot="afterList">
                                                                                            <div v-observe-visibility="reachedEndOfListAssignedAfter" />
                                                                                        </template>
                                                                                        <template slot="noOptions">
                                                                                            <div class="text-secondary text-center fw-600"> List is Empty</div>
                                                                                        </template>
                                                                                        <template slot="noResult">
                                                                                            <div  class="text-secondary text-center fw-600">
                                                                                                No Results Found</div>
                                                                                        </template>
                                                                                    </multiselect>
                                                                                    <multiselect v-else
                                                                                        :name="'assigned_to'+index"
                                                                                        label="full_name"
                                                                                        class="diginew-multiselect new-align-multi no-default-icon disable-down-arrow mt-4"
                                                                                        placeholder="Assigned To"
                                                                                        @open="assignToInside"
                                                                                        @search-change="assignToInside"
                                                                                        :searchable="true"
                                                                                        v-model="follow.assigned_to"
                                                                                        index="_id" track-by="id"
                                                                                        data-vv-as="Assigned To"
                                                                                        :disabled="true"
                                                                                        :options="assignUsers"
                                                                                        :loading="isLoadingAssigned"
                                                                                        @close="dropdownEmailClosed"
                                                                                        :clear-on-select="true"
                                                                                        :close-on-select="true"
                                                                                        :show-labels="false"
                                                                                        :hide-selected="true">
                                                                                        <template slot="tag"
                                                                                            slot-scope="{ option }">
                                                                                            <span>{{ option.first_name + ' ' + option.last_name }}</span>
                                                                                        </template>
                                                                                        <template slot="afterList">
                                                                                            <div
                                                                                                v-observe-visibility="reachedEndOfListAssignedAfter" />
                                                                                        </template>
                                                                                        <template slot="noOptions">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                List is Empty</div>
                                                                                        </template>
                                                                                        <template slot="noResult">
                                                                                            <div
                                                                                                class="text-secondary text-center fw-600">
                                                                                                No Results Found</div>
                                                                                        </template>
                                                                                    </multiselect>
                                                                                    <span v-show="errors.has('assigned_to' +index) && follow.products != '' && follow.assigned_to == ''" class="invalid-feedback-form text-danger" style="text-transform: none !important;">The Assigned To Field is Required</span>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-lg-4 col-md-4 col-sm-4">
                                                                                <div class ="d-flex">
                                                                                    <div style="width:55%" >
                                                                                        <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                                            Due Date <sup class="fs-14 pl-1 text-danger" v-if="follow.products != '' && follow.due_date == ''">*</sup>
                                                                                        </span>
                                                                                        <date-picker
                                                                                            v-if="follow.products == ''"
                                                                                            data-vv-as="Due Date"
                                                                                            :name="'due_date'+index"
                                                                                            v-model="follow.due_date"
                                                                                            placeholder="Select Due Date"
                                                                                            @change="onChangeMeetingStartDate"
                                                                                            class="dateborderDarkGrey date-height mx-left calendar-edit-per mt-4 mr-3"
                                                                                            format="MM/DD/YYYY" lang="en"
                                                                                            :value-type="valueType"
                                                                                            :clearable="false"
                                                                                            :not-before="not_before_start_date"
                                                                                            :disabled="true"
                                                                                            :editable="false" confirm
                                                                                            confirm-text="APPLY"
                                                                                            style="width: 100%;">
                                                                                        </date-picker>
                                                                                        <date-picker v-else
                                                                                            :name="'due_date'+index"
                                                                                            v-model="follow.due_date"
                                                                                            data-vv-as="Due Date"
                                                                                            v-validate="'required'"
                                                                                            placeholder="Select Due Date"
                                                                                            class="dateborderDarkGrey mx-left date-height calendar-edit-per mt-4 mr-3"
                                                                                            format="MM/DD/YYYY" lang="en"
                                                                                            :value-type="valueType"
                                                                                            :not-before="new Date()"
                                                                                            @change="checkDate(follow,index)"
                                                                                            :clearable="false"
                                                                                            :disabled="false"
                                                                                            :editable="false" confirm
                                                                                            confirm-text="APPLY"
                                                                                            style="width: 100%;">
                                                                                        </date-picker>
                                                                                        <span class="invalid-feedback-form text-danger" style="text-transform: none !important;" v-show="errors.has('due_date' +index) && follow.products != '' && follow.due_date == ''">Date is Required</span>
                                                                                    </div>
                                                                                    <div style="width:45%">
                                                                                        <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600 ml-2">
                                                                                            Time <sup class="fs-14 pl-1 text-danger" v-if="follow.products != '' && follow.time == ''">*</sup>
                                                                                        </span>
                                                                                        <div class="d-flex align-items-center mt-4" v-if="follow.products == ''">
                                                                                            <date-picker :disabled="true" :minute-step="1"  v-model="follow.time" :name="'time'+index"  class="meetinfdatetime date-height mx-left date-picker-clock-svg-icon calendar-edit-per mr-1 calendar-down-arrow-grey" format="hh:mm A" type="time" placeholder="Select Time" value-type="format" lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker>
                                                                                        </div>
                                                                                        <div class="d-flex align-items-center mt-4 ml-3" v-else>
                                                                                            <el-select v-validate="'required'"
                                                                                                :name="'time'+index" class="mt-0 schedule_time" v-model="follow.time"
                                                                                                style="border-radius: 6px;border: 1px solid #3f3f3f !important;"
                                                                                                placeholder="Select Time"
                                                                                                :popper-append-to-body="false" @change="changeTimeFormat(index)">
                                                                                                <el-option v-for="(item, index) in time_format" :key="index"
                                                                                                    :label="item" :value="item">
                                                                                                </el-option>
                                                                                            </el-select>

                                                                                            <!-- <date-picker v-validate="'required'" :disabled="false"
                                                                                            :minute-step="1" v-model="follow.time" name="time"
                                                                                            class="meetinfdatetime date-height mx-left date-picker-clock-svg-icon calendar-edit-per mr-1 calendar-down-arrow-grey"
                                                                                            format="hh:mm A" type="time" placeholder="Select Time" value-type="format" lang="en"
                                                                                            :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker> -->
                                                                                        </div>
                                                                                        <span class="invalid-feedback-form text-danger pl-3" style="text-transform: none !important;" v-show="errors.has('time' +index) && follow.products != '' && follow.time == ''">Time is Required</span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="infoHeaderHideShow mt-14">
                                                                        <div class="descriptionheader">
                                                                            <div class="description-text-header-left">
                                                                                <h5 class="font-weight-bold whiteSpace">
                                                                                    Notes</h5>
                                                                            </div>
                                                                            <div class="description-text-header-right">
                                                                                <span class="collapse-addon"
                                                                                    @click="expandFollowUpsNotes(index)">
                                                                                    <i v-if="showFollowUpsNotes.includes(index)"
                                                                                        class="icon-chevron-double-up text-white"></i>
                                                                                    <i v-else
                                                                                        class="icon-chevron-double-down text-white"></i>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div v-if="showFollowUpsNotes.includes(index)">
                                                                        <div class="row">
                                                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                                                <div class>
                                                                                    <textarea-autosize
                                                                                        v-if="follow.products == ''"
                                                                                        class="digi-textarea white-background bordered"
                                                                                        placeholder="Enter Notes Here.."
                                                                                        v-model="follow.notes"
                                                                                        :min-height="minHeight"
                                                                                        :max-height="maxHeight"
                                                                                        :maxlength="maxlengthFollowUpNotes"
                                                                                        :name="'followup_meeting_notes'+index"
                                                                                        disabled
                                                                                        style="min-height: 10em" />
                                                                                    <textarea-autosize v-else
                                                                                        class="digi-textarea white-background bordered"
                                                                                        placeholder="Enter Notes Here.."
                                                                                        v-model="follow.notes"
                                                                                        :min-height="minHeight"
                                                                                        :max-height="maxHeight"
                                                                                        :maxlength="maxlengthFollowUpNotes"
                                                                                        :name="'followup_meeting_notes'+index"
                                                                                        style="min-height: 10em" />
                                                                                    <span v-if="follow.notes"
                                                                                        class="character-count text-grey"
                                                                                        style="right: 20px !important; margin-top: -20px;">{{maxlengthFollowUpNotes - follow.notes.length}}/500</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col-lg-12 text-center pb-2">
                                                                <button type="button"
                                                                    class="btn btn-new-primary btn-smm mr-3"
                                                                    style="box-shadow: none !important; width: 7em"
                                                                    @click="cancelfollow"><i
                                                                        class="icon-chevron-left text-white fs-20 mt-1"
                                                                        style="position: absolute; margin-left: -22px;"></i>
                                                                    BACK</button>
                                                                <button type="button"
                                                                    class="btn new-cancel-button mr-3"
                                                                    style="height: 32px !important;"
                                                                    @click="backToListView">DISCARD</button>
                                                                <button type="button"
                                                                    class="btn btn-new-darksuccess text-white btn-smm mr-3"
                                                                    style="box-shadow: none !important;"
                                                                    @click="savefollowup">SAVE</button>
                                                                <button type="button"
                                                                    class="btn btn-new-warning btn-smm mr-3"
                                                                    style="box-shadow: none !important;"
                                                                    @click="savefollowupClose">SAVE AND CLOSE</button>
                                                                <button type="button"
                                                                    v-if="userPermissions.call_reports.permitted_actions.create"
                                                                    class="btn btn-new-primary btn-smm"
                                                                    style="box-shadow: none !important;"
                                                                    @click="preview">PREVIEW</button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                         <!-- Sales Target Section -->
                                        <div v-if="createJson.call_report_category == 'Sales Meeting' && salestargettab"
                                            class="mt-5" role="tabpanel" aria-labelledby="salestarget-tab">
                                            <div class="row">
                                                <div class="col-lg-12 px-0">
                                                    <form autocomplete="off">
                                                        <input autocomplete="off" name="hidden" type="text"
                                                            style="display:none;" />
                                                        <div class="block-callreport">
                                                            <div class="infoHeaderHideShow mt-3 mb-3">
                                                                <div class="descriptionheader">
                                                                    <div class="description-text-header-left">
                                                                        <h5 class="fw-500 whiteSpace">Basic Information
                                                                        </h5>
                                                                    </div>
                                                                    <div class="description-text-header-right">
                                                                        <span class="collapse-addon"
                                                                            @click="expandTitleSales(index)">
                                                                            <i v-if="showTitleSales"
                                                                                class="icon-chevron-double-up text-white"></i>
                                                                            <i v-else
                                                                                class="icon-chevron-double-down text-white"></i>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row mt-2 mb-5" v-show="showTitleSales">
                                                                <div class="col">
                                                                    <div class="form-group">
                                                                        <input class="inputFieldNew mt-6" type="text"
                                                                            v-model="createJson.title"
                                                                            placeholder="Enter Title Name"
                                                                            :maxlength="maxlengthtitlename" disabled />
                                                                        <span class="inputBorder"></span>
                                                                        <label class="inputLabel fs-14 fw-600">
                                                                            Title Name
                                                                            <sup class="fs-14 ml-02 mandatory">*</sup>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-for="(sales,index) in createJson.sales_target.forecast"
                                                            :key="index">
                                                            <div class="block-callreport">
                                                                <div class="infoHeaderHideShow mt-3 mb-3">
                                                                    <div class="descriptionheader">
                                                                        <div class="description-text-header-left">
                                                                            <h5 class="fw-500 whiteSpace">Sales Target
                                                                                {{index+1}}</h5>
                                                                        </div>
                                                                        <div class="description-text-header-right">
                                                                            <span class="collapse-addon"
                                                                                @click="expandSales(index)">
                                                                                <i v-if="showSales.includes(index)"
                                                                                    class="icon-chevron-double-up text-white"></i>
                                                                                <i v-else
                                                                                    class="icon-chevron-double-down text-white"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div v-if="showSales.includes(index)">
                                                                    <div class="row mt-5">
                                                                        <div class="col-lg-4 col-md-4 col-sm-4">
                                                                            <div class style>
                                                                                <span
                                                                                    class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                                    Fiscal Year
                                                                                    <sup v-if="sales.customer_id != ''"
                                                                                        class="fs-14 ml-02 mandatory">*</sup>
                                                                                </span>
                                                                                <div class="d-flex">
                                                                                    <input
                                                                                        v-if="sales.customer_id == null || sales.customer_id == ''"
                                                                                        class="inputFieldNew"
                                                                                        type="text"
                                                                                        placeholder="Fiscal Year"
                                                                                        v-model="sales.target_year"
                                                                                        style="background: transparent !important; margin-top: 17px;"
                                                                                        disabled />
                                                                                    <div class="w-100" v-else>
                                                                                        <div class="filters-bordered"
                                                                                            style="background-color: transparent !important;">
                                                                                            <el-dropdown trigger="click"
                                                                                                :hide-on-click="hide_el_dropdown"
                                                                                                @visible-change="dropdownTriggered">
                                                                                                <span
                                                                                                    class="filters mr-1">
                                                                                                    <span
                                                                                                        v-if="sales.target_year">{{sales.target_year}}</span>
                                                                                                    <span v-else>Fiscal
                                                                                                        Year</span>
                                                                                                </span>
                                                                                                <el-dropdown-menu
                                                                                                    slot="dropdown"
                                                                                                    class="fiscal-year-el">
                                                                                                    <el-dropdown-item
                                                                                                        class="d-flex justify-content-between align-items-center">
                                                                                                        <i class="icon-chevron-double-left m-0"
                                                                                                            @click="yearPrev"></i>
                                                                                                        <span
                                                                                                            style="font-size: 12px; font-weight: 400">{{years_to_set[0]}}
                                                                                                            -
                                                                                                            {{years_to_set[5]}}</span>
                                                                                                        <i class="icon-chevron-double-right m-0"
                                                                                                            @click="yearNext"></i>
                                                                                                    </el-dropdown-item>
                                                                                                    <el-dropdown-item
                                                                                                        class="d-flex flex-column justify-content-center align-items-center">
                                                                                                        <span
                                                                                                            :class="{ 'selectedYear':yearSelected == `${years_to_set[0]}-${years_to_set[1]}` }"
                                                                                                            @click="yearSelected = years_to_set[0] + '-' + years_to_set[1]">{{years_to_set[0]}}
                                                                                                            -
                                                                                                            {{years_to_set[1]}}</span>
                                                                                                        <span
                                                                                                            :class="{ 'selectedYear':yearSelected == `${years_to_set[1]}-${years_to_set[2]}` }"
                                                                                                            @click="yearSelected = years_to_set[1] + '-' + years_to_set[2]">{{years_to_set[1]}}
                                                                                                            -
                                                                                                            {{years_to_set[2]}}</span>
                                                                                                        <span
                                                                                                            :class="{ 'selectedYear':yearSelected == `${years_to_set[2]}-${years_to_set[3]}` }"
                                                                                                            @click="yearSelected = years_to_set[2] + '-' + years_to_set[3]">{{years_to_set[2]}}
                                                                                                            -
                                                                                                            {{years_to_set[3]}}</span>
                                                                                                        <span
                                                                                                            :class="{ 'selectedYear':yearSelected == `${years_to_set[3]}-${years_to_set[4]}` }"
                                                                                                            @click="yearSelected = years_to_set[3] + '-' + years_to_set[4]">{{years_to_set[3]}}
                                                                                                            -
                                                                                                            {{years_to_set[4]}}</span>
                                                                                                        <span
                                                                                                            :class="{ 'selectedYear':yearSelected == `${years_to_set[4]}-${years_to_set[5]}` }"
                                                                                                            @click="yearSelected = years_to_set[4] + '-' + years_to_set[5]">{{years_to_set[4]}}
                                                                                                            -
                                                                                                            {{years_to_set[5]}}</span>
                                                                                                        <a href="javascript:;"
                                                                                                            class="btn btn-new-primary btn-xsm mt-2 mb-4"
                                                                                                            @click="yearClicked(index)">Apply</a>
                                                                                                    </el-dropdown-item>
                                                                                                </el-dropdown-menu>
                                                                                            </el-dropdown>
                                                                                        </div>
                                                                                        <span
                                                                                            v-if="noFiscalYear.includes(index)"
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;">Fiscal
                                                                                            Year is Required</span>
                                                                                    </div>
                                                                                    <span class="pointer mt-4"
                                                                                        @click="changeView()">
                                                                                        <img src="/static/images/images-new-theme/icons/settings-new-right.svg"
                                                                                            class="mt-3 ml-2"
                                                                                            style="width:20px" alt="">
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="col-lg-4 col-md-4 col-sm-4">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 vselectLabel fs-14 fw-600">
                                                                                Product Name
                                                                                <sup v-if="sales.customer_id != ''"
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </span>
                                                                            <multiselect :max="10"
                                                                                class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                                                name="email_recipients"
                                                                                @search-change="searchProuctName"
                                                                                :loading="products_loading" :disabled="sales.customer_id == null || sales.customer_id == ''"
                                                                                v-model="sales.product" @open="resetData('name')"
                                                                                :searchable="true" :block-keys="['Tab']"
                                                                                placeholder="Select Product"
                                                                                :options="products_options"
                                                                                :multiple="true"
                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                :close-on-select="true"
                                                                                :show-labels="false"
                                                                                :clear-on-select="true"
                                                                                :hide-selected="true" :taggable="true"
                                                                                label="name" track-by="name">
                                                                                <template slot="tag"
                                                                                    slot-scope="{ option }">
                                                                                    <span class="custom__tag">
                                                                                        <span>{{ option.name }}</span>
                                                                                        <span class="custom__remove"
                                                                                            @click="removeSalesProductsName(option)">
                                                                                            <i
                                                                                                class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                        </span>
                                                                                    </span>
                                                                                </template>
                                                                                <template slot="afterList">
                                                                                    <div
                                                                                        v-observe-visibility="reachedEndOfProductName" />
                                                                                </template>
                                                                                <template slot="noOptions">
                                                                                    <div
                                                                                        class="text-secondary text-center fw-600">
                                                                                        List is Empty</div>
                                                                                </template>
                                                                                <template slot="noResult">
                                                                                    <div
                                                                                        class="text-secondary text-center fw-600">
                                                                                        No Results Found</div>
                                                                                </template>
                                                                            </multiselect>
                                                                            <!-- <multiselect :max="10"
                                                                                class="diginew-multiselect-long multi-height-align new-align greyblack no-default-icon mt-4"
                                                                                    placeholder="Select Product" :name="'sales_product_name'+index"
                                                                                    label="name" open-direction="bottom"
                                                                                    v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                    v-model="sales.product" @open="resetData('name')"
                                                                                    :options="products_options" track-by="name" :disabled="sales.customer_id == null || sales.customer_id == ''"
                                                                                    :multiple="false" :searchable="true" :internal-search="true"
                                                                                    :clear-on-select="false" :close-on-select="true" :options-limit="3000"
                                                                                    :max-height="200" :show-no-results="true" :hide-selected="false"
                                                                                    :block-keys="['Tab']" :limit="1" :limit-text="limitProducts" :loading="products_loading" @search-change="searchProuctName"
                                                                                >
                                                                                <template slot="option" slot-scope="props" class="d-flex">
                                                                                    {{ props.option.name }}
                                                                                </template>
                                                                                <template slot="afterList">
                                                                                    <div v-observe-visibility="reachedEndOfProductName" />
                                                                                </template>
                                                                                <template slot="noOptions">
                                                                                    <div class="text-secondary text-center fw-600">Products Not Found</div>
                                                                                </template>
                                                                                <template slot="noResult">
                                                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                                                </template>
                                                                            </multiselect> -->
                                                                            <!-- <multiselect
                                                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow loaderbg mt-4"
                                                                                v-model="sales.product"
                                                                                @search-change="getProduts"
                                                                                :loading="products_loading"
                                                                                :name="'sales_product_name'+index"
                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                :options="productoptions"
                                                                                :searchable="true"
                                                                                :close-on-select="true"
                                                                                :show-labels="false"
                                                                                label="name"
                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''"
                                                                                placeholder="Select Product Name">
                                                                                <template slot="afterList">
                                                                                    <div
                                                                                        v-observe-visibility="getProdutsAfter" />
                                                                                </template>
                                                                                <template slot="noOptions">
                                                                                    <div
                                                                                        class="text-secondary text-center fw-600">
                                                                                        List is Empty</div>
                                                                                </template>
                                                                                <template slot="noResult">
                                                                                    <div
                                                                                        class="text-secondary text-center fw-600">
                                                                                        No Results Found</div>
                                                                                </template>
                                                                            </multiselect> -->

                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                style="text-transform: none !important;"
                                                                                v-show="errors.has('sales_product_name'+index)">Product
                                                                                Name is Required</span>
                                                                        </div>
                                                                        <div class="col-lg-4 col-md-4 col-sm-4">
                                                                            <div>
                                                                                <span
                                                                                    class="text-secondary whiteSpace vselectLabel fs-14 fw-600">
                                                                                    Customer Name
                                                                                    <sup v-if="sales.customer_id != ''"
                                                                                        class="fs-14 ml-02 mandatory">
                                                                                        *
                                                                                        <el-tooltip class="item"
                                                                                            effect="dark"
                                                                                            content="The options for this list are obtained from Customers module"
                                                                                            placement="top">
                                                                                            <i
                                                                                                class="icons icon-information defaultDarkBlue iconsize-16"></i>
                                                                                        </el-tooltip>
                                                                                    </sup>
                                                                                </span>
                                                                                <multiselect
                                                                                    v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                    class="diginew-multiselect new-align-multi no-default-icon down-arrow loaderbg mt-4"
                                                                                    :name="'sales_customer_name'+index"
                                                                                    @open="searchCompaniesInside"
                                                                                    @select="updateSales(index)"
                                                                                    @close="updateCompanyList()"
                                                                                    @search-change="searchCompaniesInside"
                                                                                    :loading="isLoading"
                                                                                    v-model="sales.customer_id"
                                                                                    :searchable="true"
                                                                                    placeholder="Select Customer Name"
                                                                                    label="customer_name" track-by="id"
                                                                                    :options="optionsCompanies"
                                                                                    :multiple="false"
                                                                                    :close-on-select="true"
                                                                                    :show-labels="false"
                                                                                    :clear-on-select="true"
                                                                                    :hide-selected="true">
                                                                                    <template slot="tag"
                                                                                        slot-scope="{ option, remove }">
                                                                                        <span class="custom__tag">
                                                                                            <span>{{ option.company_name }}</span>
                                                                                            <span class="custom__remove"
                                                                                                @click="remove(option)">
                                                                                                <i
                                                                                                    class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                                            </span>
                                                                                        </span>
                                                                                    </template>
                                                                                    <template slot="afterList">
                                                                                        <div
                                                                                            v-observe-visibility="reachedEndOfListCompany" />
                                                                                    </template>
                                                                                    <span slot="noResult"
                                                                                        class="font-weight-bold text-center d-block">No
                                                                                        Results Found.</span>
                                                                                </multiselect>

                                                                                <span v-if="sales.customer_id != ''"
                                                                                    class="invalid-feedback-form text-danger"
                                                                                    style="text-transform: none !important;"
                                                                                    v-show="errors.has('sales_customer_name'+index)">Customer
                                                                                    Name is Required</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mt-5">
                                                                        <div class="col-lg-4 col-md-4 col-sm-4"
                                                                            style="margin-top: 6px;">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 vselectLabel fs-14 fw-600">
                                                                                Sales Person
                                                                                <sup v-if="sales.customer_id != ''"
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </span>
                                                                            <multiselect
                                                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow loaderbg mt-4"
                                                                                v-model="sales.sales_person"
                                                                                :name="'sales_person'+index"
                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                :options="salesperson"
                                                                                @open="fetchSalesPerson"
                                                                                @search-change="fetchSalesPerson"
                                                                                @close="search_key = ''"
                                                                                :loading="loading_sales_person"
                                                                                :searchable="true"
                                                                                :close-on-select="true"
                                                                                :show-labels="false" label="full_name"
                                                                                track-by="id"
                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''"
                                                                                placeholder="Select Sales Person">
                                                                                <template slot="afterList">
                                                                                    <div
                                                                                        v-observe-visibility="fetchMoreSalesPerson" />
                                                                                </template>
                                                                                <span slot="noOptions"
                                                                                    class="font-weight-bold text-center d-block">Please
                                                                                    Select Sales Person
                                                                                </span>
                                                                            </multiselect>
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                style="text-transform: none !important;"
                                                                                v-show="errors.has('sales_person'+index)">Sales
                                                                                Person is Required</span>
                                                                        </div>
                                                                        <div class="col-lg-4 col-md-4 col-sm-4"
                                                                            style="margin-top: 6px;">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 vselectLabel fs-14 fw-600">
                                                                                Department Name
                                                                                <sup v-if="sales.customer_id != ''"
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </span>
                                                                            <!-- <multiselect
                                                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow loaderbg mt-4"
                                                                                v-model="sales.department"
                                                                                :name="'sales_department_name'+index"
                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                :options="departmentNameOptions"
                                                                                :searchable="true"
                                                                                :close-on-select="true"
                                                                                :show-labels="false"
                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''"
                                                                                placeholder="Select Department Name">
                                                                                <span slot="noOptions"
                                                                                    class="font-weight-bold text-center d-block">Please
                                                                                    Select Department Name</span>
                                                                            </multiselect> -->
                                                                            <input type="text"
                                                                                class="input-field input-width mt-4"
                                                                                v-model="sales.department"
                                                                                placeholder="Enter Department Name"
                                                                                :name="'sales_department_name'+index"
                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}" />
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                style="text-transform: none !important;"
                                                                                v-show="errors.has('sales_department_name'+index)">Department
                                                                                Name is Required</span>
                                                                        </div>
                                                                        <div class="col-lg-4 col-md-4 col-sm-4"
                                                                            style="margin-top: 6px;">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                                                Branch Name
                                                                                <sup v-if="sales.customer_id != ''"
                                                                                    class="fs-14 ml-02 mandatory">*</sup>
                                                                            </span>
                                                                            <input type="text"
                                                                                class="input-field input-width mt-4"
                                                                                v-model="sales.branch"
                                                                                placeholder="Enter Branch Name"
                                                                                :name="'sales_branch_name'+index"
                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}" />
                                                                            <span
                                                                                class="invalid-feedback-form text-danger"
                                                                                style="text-transform: none !important;"
                                                                                v-show="errors.has('sales_branch_name'+index)">Branch
                                                                                Name is Required</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row mt-5">
                                                                        <div class="col-lg-4 col-md-4 col-sm-4"
                                                                            style="margin-top: 6px;">
                                                                            <span
                                                                                class="text-secondary whiteSpace fs-14 vselectLabel fs-14 fw-600">
                                                                                Unit of Measure
                                                                                <sup v-if="sales.customer_id!=''"
                                                                                    class="fs-14 ml-02 mandatory">
                                                                                    <el-tooltip class="item"
                                                                                        effect="dark"
                                                                                        content="The options for this list are obtained from POS module"
                                                                                        placement="top">
                                                                                        <i
                                                                                            class="icons icon-information defaultDarkBlue iconsize-16"></i>
                                                                                    </el-tooltip>
                                                                                </sup>
                                                                            </span>
                                                                            <multiselect
                                                                                class="diginew-multiselect new-align-multi no-default-icon down-arrow loaderbg mt-4"
                                                                                v-model="sales.uom" :name="'uom'+index"
                                                                                :options="uoms" @open="searchUoms"
                                                                                @search-change="searchUoms"
                                                                                :loading="isUomLoading"
                                                                                @close="search_key = ''"
                                                                                :searchable="true"
                                                                                :close-on-select="true"
                                                                                :show-labels="false"
                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''"
                                                                                placeholder="Select Unit of Measure">
                                                                                <span slot="noOptions"
                                                                                    class="font-weight-bold text-center d-block">Please
                                                                                    Select Unit of Measure</span>
                                                                            </multiselect>
                                                                        </div>
                                                                    </div>
                                                                    <div class="table-responsive mt-10"
                                                                        style="overflow-x:auto;">
                                                                        <table class="table-sales">
                                                                            <thead>
                                                                                <tr style="background-color: #005dae;">
                                                                                    <th>Jan</th>
                                                                                    <th>Feb</th>
                                                                                    <th>Mar</th>
                                                                                    <th>Apr</th>
                                                                                    <th>May</th>
                                                                                    <th>June</th>
                                                                                    <th>July</th>
                                                                                    <th>Aug</th>
                                                                                    <th>Sep</th>
                                                                                    <th>Oct</th>
                                                                                    <th>Nov</th>
                                                                                    <th>Dec</th>
                                                                                    <th>Total Sales Target</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_jan'+index"
                                                                                                v-model.number="sales.target.jan"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_jan'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_feb'+index"
                                                                                                v-model.number="sales.target.feb"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_feb'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_mar'+index"
                                                                                                v-model.number="sales.target.mar"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_mar'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_apr'+index"
                                                                                                v-model.number="sales.target.apr"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_apr'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_may'+index"
                                                                                                v-model.number="sales.target.may"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_may'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_jun'+index"
                                                                                                v-model.number="sales.target.jun"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_jun'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_jul'+index"
                                                                                                v-model.number="sales.target.jul"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_jul'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_aug'+index"
                                                                                                v-model.number="sales.target.aug"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_aug'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_sept'+index"
                                                                                                v-model.number="sales.target.sept"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_sept'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_oct'+index"
                                                                                                v-model.number="sales.target.oct"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_oct'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_nov'+index"
                                                                                                v-model.number="sales.target.nov"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_nov'+index)">Required</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <div
                                                                                            class="d-flex inputFieldSalesTableFlex">
                                                                                            <label
                                                                                                style="padding-top: 16px;padding-right: 3px;">{{currency_symbol}}</label>
                                                                                            <input
                                                                                                class="inputFieldSalesTable"
                                                                                                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                                                                                                :name="'target_dec'+index"
                                                                                                v-model.number="sales.target.dec"
                                                                                                type="text"
                                                                                                placeholder="Add Value"
                                                                                                required
                                                                                                v-validate="sales.customer_id == '' || sales.customer_id == null ? {required:false} : {required:true}"
                                                                                                :disabled="sales.customer_id == null || sales.customer_id == ''" />
                                                                                        </div>
                                                                                        <span
                                                                                            class="invalid-feedback-form text-danger"
                                                                                            style="text-transform: none !important;margin-top: -2rem;"
                                                                                            v-show="errors.has('target_dec'+index)">Required</span>
                                                                                    </td>
                                                                                    <td
                                                                                        style="background-color: rgb(197, 218, 242);">
                                                                                        <span
                                                                                            disabled="disabled">{{currency_symbol}}
                                                                                            {{ sales.target.jan + sales.target.feb + sales.target.mar + sales.target.apr + sales.target.may + sales.target.jun + sales.target.jul + sales.target.aug + sales.target.sept + sales.target.oct + sales.target.nov + sales.target.dec }}</span>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                    <div class="btn-align mt-4 w-100"
                                                                        style="justify-content: flex-end;">
                                                                        <button type="button"
                                                                            class="btn btn-new-primary btn-smm mr-3"
                                                                            style="box-shadow: none !important;"
                                                                            v-if="index+1==createJson.sales_target.forecast.length"
                                                                            @click="createJson.sales_target.forecast.push(JSON.parse(JSON.stringify(salestarget))) && showSales.push(index+1)">+
                                                                            Add Target</button>
                                                                        <button type="button"
                                                                            class="btn btn-new-darkdanger btn-smm mr-3"
                                                                            style="box-shadow: none;" v-if="index!=0"
                                                                            @click="createJson.sales_target.forecast.splice(index, 1) && showSales.splice(index,1)">-
                                                                            Delete</button>
                                                                        <button type="button"
                                                                            :disabled="(sales.customer_id == null || sales.customer_id == '') && sales.department && sales.branch == ''"
                                                                            class="btn btn-new-darksuccess text-white btn-smm"
                                                                            v-if="index>=0"
                                                                            style="box-shadow: none !important;"
                                                                            @click="resetSales(index)"><img
                                                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reset.svg">
                                                                            Reset</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- <div class="row"> -->
                                                        <div
                                                            class="d-flex flex-wrap justify-content-center align-items-center pb-2">
                                                            <button type="button" class="btn btn-new-primary btn-smm mr-3"
                                                            style="box-shadow: none !important; width: 7em"
                                                            @click="cancelsales"><i
                                                                    class="icon-chevron-left text-white fs-20 mt-1"
                                                                    style="position: absolute;margin-left: -22px;margin-left: -22px;"></i>
                                                                BACK</button>

                                                            <button type="button"
                                                                class="btn new-cancel-button mr-3"
                                                                style="height: 32px !important;"
                                                                @click="backToListView">DISCARD</button>
                                                            <button type="button"
                                                                class="btn btn-new-darksuccess text-white btn-smm mr-3 "
                                                                style="box-shadow: none !important;"
                                                                @click="savesalestarget">SAVE</button>
                                                            <button type="button"
                                                                class="btn btn-new-warning btn-smm mr-3 "
                                                                style="box-shadow: none !important;"
                                                                @click="savesalestargetclose">SAVE AND CLOSE</button>
                                                            <button type="button" class="btn btn-new-primary btn-smm "
                                                                style="box-shadow: none !important; width: 7em"
                                                                @click="salesValidateNext">NEXT <i
                                                                    class="icon-chevron-right text-white fs-20 mt-1"
                                                                    style="position: absolute;"></i></button>
                                                        </div>
                                                        <!-- </div> -->
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <department-new-modal modal_name="department_modal"></department-new-modal>
        <company-new-modal modal_name="company_modal"></company-new-modal>
        <branch-new-modal modal_name="branch_modal"></branch-new-modal>
        <time-zone-modal v-if="timezoneShow" modal_name="timezone_modal" :time_zone="createJson.meeting_timezone"
            @hidetimezone="hidetimezone" @savenewtimezone="savenewtimezone" @removetimezone="removetimezone">
        </time-zone-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
         <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <loader-modal modal_name="loader_modal" :message="loadingMessage"></loader-modal>
        <confirm-submit-callreport modal_name="confirmSubmitCR" @callReportData="callReportData" @cancelreportData="cancelreportData"></confirm-submit-callreport>
        <add-address v-if="add_address" modal_name="add_address" @hideAddress="hideAddress" @saveAddress="saveAddress"></add-address>
    </div>
</template>
<script> 
    const AddAddress = () => import ("./AddressCallReport.vue");
    import { quillEditor } from 'vue-quill-editor' 
    import dedent from 'dedent'
    import hljs from 'highlight.js'
    // import 'highlight.js/styles/tomorrow.css'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    // import navbarMixin from "./mixins/navbarMixin.js";
    //import uploadCallReportFile from "./mixins/uploadCallReportFile.js";
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import moment from "moment";
    import VueTelInput from "vue-tel-input";
    import VueTagsInput from "@johmun/vue-tags-input";
    import deals from "./mixins/deals";
    import countries from "./json/countries.json";
    import contacts from "./mixins/contacts"
    import schedule from "./mixins/scheduleMeeting.js"
    import {
        VueEditor
    } from "vue2-editor";
    import vSelect from "vue-select";
    import VueTextareaAutosize from "vue-textarea-autosize";
    import timezone from "./json/timezone.json";
    import callreport from "./mixins/callreport";
    import teams from './mixins/teams';
    import CompanyNewModal from "./CompanyNewModal";
    import DepartmentNewModal from "./DepartmentNewModal";
    import BranchNewModal from "./BranchNewModal";
    import TimeZoneModal from "./TimeZoneModal";
    import globals from "./globals";
    import leads from "./mixins/leads"
    import customer from "./mixins/customer"
    import LoaderModal from "./alertModals/LoaderModal";
    import time_utils from './mixins/time_utils';
    import ConfirmSubmitCallreport from "./alertModals/ConfirmSubmitCallreport";
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import axios from "axios";
    import { debounce } from 'lodash';
    import convert from './mixins/convert'
    import productList from './mixins/productList'
    export default {
        name: 'quill-example-snow',
        title: 'Theme: snow',
        data() {
            const value2date = (dateRange) => {
                const date = new Date(dateRange)
                return dateRange ? new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000) : null
            }
            const date2value = (date) => {
                return date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) : null
            }
            return {
                isFullscreen: false,
                fullscreenHeight: window.innerHeight - 100,
                showManualEntry: false,
                manualFallback: false,
                add_address: false,
                contact_scrollable: false,
                lead_visible: false,
                selected_vendor_index: 0,
                vendor_search_key: '',
                vendor_options: [],
                temp_selected_vendor: [],
                vendor_count: 0,
                vendor_scrollable :false,
                vendor_visible: false,
                temp_vendor: [],
                hide: {
                    table: true
                },
                temp_assigned:[],
                is_validation:false,
                transition_format:'$',
                search_lead:'',
                data:[],
                user_ids_ind:[],
                isUomLoading:false,
                owner_ids_ind:[],
                author_data:[],
                owner_data:[],
                email_skip_count: 0,
                email_ind_skip_count:0,
                assigned_count:0,
                scrollableAssigned:false,
                permission_skip_count:0,
                editPreview: false,
                valueType: {
                    value2date,
                    date2value
                },
                timeSingapore: moment().tz("Asia/Singapore").format("LTS"),
                warning_msg: '',
                success_msg:'',
                local_time: [],
                subsidiary_data: [],
                is_enable: false,
                combinedTo: '',
                combinedFrom: '',
                products_count: 0,
                products_loading: false,
                products_scrollable: false,
                products_visible: false,
                temp_products: [],
                loading_sales_person: false,
                currency_symbol: "$",
                organisationSettings: [],
                internalCompanyObject: "",
                internal_primary_attendee: [],
                internal_primary_attendee_id: "",
                internalPrimaryAttendee: "",
                callreporttab: true,
                meetingnotestab: false,
                followuptab: false,
                salestargettab: false,
                showAddress: false,
                countriesCaps: [],
                newplace: "",
                newplaceFormat: "",
                title: "",
                callReportType: "Internal",
                meetingType: "",
                countries: countries,
                maxlengthaccountzipcode: 10,
                maxlengthaccounttownship: 20,
                maxlengthaccountstreet: 50,
                addressField: "",
                addressFieldCompany: "",
                addressFieldMeeting: "",
                meetingstartdate: new Date(),
                meetingstarttime: new Date().getTime(),
                meetingenddate: new Date(),
                meetingendtime: new Date().getTime(),
                content: "",
                assignedTo: "",
                statusMeeting: "",
                selectQuarter: "",
                salesYear: "",
                salesYearType: "",
                selectQuarterRevenue: "",
                places: [],
                //currentPlace: null,
                attendeesUserCompany: "",
                showTitle: true,
                showTitleSales: true,
                showExternal: [0],
                showReceiverDetails: [0],
                showContactDetails:[0],
                showInternal: true,
                showEmailRecipients: true,
                showMeetingNotes: true,
                showAttachments: true,
                showMeetingInformation: true,
                showPermissions: true,
                showFollowUps: [0],
                showFollowUpsNotes: [0],
                showSales: [0],
                productName: "",
                meetingNotes: "",
                meetingNotesSubject: "",
                maxlengthFollowUpNotes: 500,
                minHeight: 63,
                maxHeight: 350,
                productSalesQuarter: "",
                locations: [],
                formatedAddresses: [],
                userAttendees: [],
                optionsUserAttendees: [],
                push_optionsUserAttendees: [],
                optionsEmailRecipients: [],
                optionsGroupEmailRecipients:[],
                salesPerson: "",
                timezone: timezone,
                time_zone: "",
                timezoneShow: false,
                total: 0,
                skip: 0,
                skip_count: 0,
                limit: 10,
                search_term: "",
                search_key: "",
                isLoading: false,
                //email_recipient_type:'individual',
                general_access:'private',
                scrollableCustomer: false,
                scrollableCustomerInside: false,
                scrollableEmailTeam:false,
                scrollablePerTeam:false,
                count: 0,
                tempoptionsUserAttendees: [],
                isVisible: false,
                email_regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/,
                state_regex: /^[a-zA-Z][a-zA-Z ]*$/,
                invalidEmail: false,
                noEmail: false,
                companyList: [],
                optionsCompanies: [],
                tempoptionsCompanies: [],
                scrollableCompanies: false,
                optionsCustomers: [],
                employeeAttendees: [],
                optionsEmployeeAttendeesExternal: [],
                tempoptionsEmployeeAttendeesExternal: [],
                optionsEmployeeAttendees: [],
                push_optionsEmployeeAttendeesInternal: [],
                tempoptionsEmployeeAttendees: [],
                push_optionsEmployeeAttendees: [],
                scrollableEmployee: false,
                scrollableData:false,
                reportScrollable: false,
                otherAttendeeScrollable:false,
                isLoadingemployees: false,
                isLoadingemployeesExternal: false,
                scrollableEmployeeExternal: false,
                isLoadingAssigned:false,
                company_attendees: [{
                    companyList: [],
                    employeeAttendees: [],
                }, ],
                follow_ups: [{
                    products: "",
                    assigned_to: "",
                    notes: "",
                    due_date: "",
                    time:"",
                    price: null,
                    is_follow_expanded:true
                }, ],
                companyRepeat: {
                    company_name: "",
                    primary_employee: "",
                    secondary_employees: [],
                    customer_attendes: "",
                    department: "",
                    branch: "",
                    status: "",
                    is_cust_expanded:true
                },
                follows: {
                    products: "",
                    assigned_to: "",
                    status: "",
                    notes: "",
                    due_date: "",
                    time:"",
                    is_follow_expanded:true,
                    price: null,

                },
                meeting_location: {
                    city: "",
                    street: "",
                    state: "",
                    township: "",
                    country: "",
                    zip_code: "",
                    address_type: "",
                },
                assignUsers: [],
                firstTab: false,
                customerStatusValue: "",
                customerStatusOptions: [
                    "Demo",
                    "Existing Customer",
                    "Follow Up",
                    "Hot Lead",
                    "Interested",
                    "Negative Lead",
                    "New Customer",
                    "Positive Customer",
                    "Potential Customer",
                    "Referral Lead",
                    "Unassigned Lead",
                ],
                issueTypeOptions: [],
                due_date: "",
                customerNameValue: "",
                customerNameOptions: ["Company 1", "Company 2"],
                branchNameValue: "",
                branchs: [],
                internal_branchs: [],
                internal_development: [],
                internal_employees: [],
                departmentNameValue: "",
                departmentNameOptions: [],
                maxlengthtitlename: 100,
                maxlengthsubjectname: 200,
                maxlengthproductname: 50,
                tempcompany_ids: [],
                // CreateJson
                salestarget: {
                    customer_id: "",
                    branch: "",
                    department: "",
                    product: "",
                    target_year: "",
                    target: {
                        jan: 0,
                        feb: 0,
                        mar: 0,
                        apr: 0,
                        may: 0,
                        jun: 0,
                        jul: 0,
                        aug: 0,
                        sept: 0,
                        oct: 0,
                        nov: 0,
                        dec: 0,
                        sum: 0,
                    },
                },
                lead_repeat: {
                    id: "",
                    name: "",
                    company_name: "",
                    status:"",
                    is_lead_loading:false,
                    is_expanded:true
                },
                contact_repeat: {
                    id: "",
                    name: "",
                    company_name: "",
                    is_contact_loading:false,
                    is_contact_expanded:true
                },
                compressed_external_attendees: {},
                compressed_sales_target: {},
                createJson: {
                    email_individual:[],
                    general_access:"private",
                    receiver_type: "lead",
                    author_name: "",
                    author_email: "",
                    call_report_category: [],
                    meeting_notes_table: [],
                    title: "",
                    meeting_time_from: new Date(),
                    meeting_time_to: new Date(),
                    meeting_date_from: new Date(),
                    meeting_date_to: new Date(),
                    branch_name: "",
                    meeting_type: "",
                    meeting_notes_subject: "",
                    call_report_type: "",
                    teams: [],
                    Individual: "",
                    meeting_location: {
                        street: "",
                        city: "",
                        township: "",
                        state: "",
                        zip_code: "",
                        country: "",
                        address_type: "",
                    },
                    internal_company: {
                        other_attendees: [],
                        company_attendees: [],
                        branch: "",
                        department: "",
                        //subsidiary_attendees: []
                    },
                    external_attendees: [{
                        company_name: "",
                        primary_employee: "",
                        secondary_employees: [],
                        customer_attendes: "",
                        department: "",
                        branch: "",
                        status: "",
                        is_cust_expanded:true,
                        is_company_loading:false
                    }, ],
                    vendor_info: [{
                        vendor_name: "",
                        vendor_primary_attendee: "",
                        is_vendor_expanded:true,
                        is_vendor_loading: false,
                    }],
                    follow_ups: [{
                        products: "",
                        assigned_to: "",
                        notes: "",
                        due_date: "",
                        time:"",
                        price: null,
                        is_follow_expanded:true
                    }, ],
                    meeting_timezone: {},
                    meeting_notes: "",
                    sales_target: {
                        forecast: [{
                            product_code: "",
                            customer_id: "",
                            branch: "",
                            department: "",
                            product: "",
                            target_year: "",
                            sales_person: "",
                            uom: "",
                            target: {
                                jan: 0,
                                feb: 0,
                                mar: 0,
                                apr: 0,
                                may: 0,
                                jun: 0,
                                jul: 0,
                                aug: 0,
                                sept: 0,
                                oct: 0,
                                nov: 0,
                                dec: 0,
                                sum: 0,
                            },
                        }, ],
                    },
                    lead_info: [{
                        id: "",
                        full_name: "",
                        company_name: "-",
                        status:"",
                        is_lead_loading: false,
                        is_expanded:true

                    }],
                    contact_info: [{
                        id: "",
                        full_name: "",
                        company_name: "",
                        is_contact_loading:false,
                        is_contact_expanded:true

                    }],
                    recipient_email: {
                       individual:[],
                       team:[]
                    },
                    permissions: {
                        individual:[],
                        team:[]
                    },
                    add_recipient: [],
                    status: "",
                    send_copy_to_me: false,
                    owner_email: "",
                    owner_name: "",
                },
                meeting_location_vmodel: "",
                countPrimaryAttendee: 0,
                search_key_internal_primary: "",
                indexToPass: "",
                indexToExt:"",
                indexToSecondary:"",
                attachments: [],
                hide_el_dropdown: false,
                years_to_set: [],
                yearSelected: "",
                productoptions: [],
                saveandclose: false,
                noFiscalYear: [],
                disableSend: false,
                loadingMessage: "",
                salesperson: [],
                uoms: [],
                uom_loading: false,
                issueTypeLoading: false,
                dropdown_type: '',
                report_owner_loading: false,
                //subsidiary_attendees_loading: false,
                company_attendees_loading: false,
                other_attendees_loading: false,
                ajaxCallInProgress: false,
                dateFrom: '',
                dateTo: '',
                timeFrom: '',
                timeTo: '',
                combinedTo: '',
                combinedFrom: '',
                meeting_start_date: '',
                meeting_start_time: '',
                meeting_end_date: '',
                meeting_end_time: '',
                not_before_start_date: '',
                total_file_size: 0,
                receiver_lead: true,
                receiver_contact: false,
                contact_name: '',
                receiver_customer: false,
                receiver_vendor: false,
                lead_name_loading: false,
                lead_name: '',
                lead_name_options: [],
                lead_scrollable: false,
                lead_name_count: 0,
                temp_lead_name: '',
                lead_true: false,
                contact_true: false,
                customer_true: false,
                leadDetails: true,
                contactDetails: false,
                custDetails: false,
                contact_name_loading: false,
                contact_name: '',
                contact_name_options: [],
                conatact_scrollable: false,
                contact_name_count: 0,
                contact_visible:false,
                employee_visible:false,
                temp_contact_name: '',
                lead_status: '',
                lead_company_name: '',
                lead_index: null,
                contact_index: 0,
                customer_index:0,
                external_primary_options:[],
                external_primary_loading:false,
                external_primary_scrollable:false,
                external_primary_count:0,
                temp_external_primary:'',
                ext_company_id:[],
                external_secondary_options:[],
                external_secondary_loading:false,
                external_secondary_scrollable:false,
                external_secondary_count:0,
                temp_external_secondary:'',
                secondary_company_id:[],
                email_individual :true,
                email_all:false,
                group_skip_count:0,
                isGroupLoading:false,
                optionsGroupEmailRecipients:[],
                optionsEmailRecipientsTeam:[],
                optionsPemissionRecipientsTeam:[],
                isLoadingPermissionTeam:false,
                isLoadingEmailTeam:false,
                isCustomerLoading:false,
                time_format: [
                    '00:00',
                    '00:30',
                    '01:00',
                    '01:30',
                    '02:00',
                    '02:30',
                    '03:00',
                    '03:30',
                    '04:00',
                    '04:30',
                    '05:00',
                    '05:30',
                    '06:00',
                    '06:30',
                    '07:00',
                    '07:30',
                    '08:00',
                    '08:30',
                    '09:00',
                    '09:30',
                    '10:00',
                    '10:30',
                    '11:00',
                    '11:30',
                    '12:00',
                    '12:30',
                    '13:00',
                    '13:30',
                    '14:00',
                    '14:30',
                    '15:00',
                    '15:30',
                    '16:00',
                    '16:30',
                    '17:00',
                    '17:30',
                    '18:00',
                    '18:30',
                    '19:00',
                    '19:30',
                    '20:00',
                    '20:30',
                    '21:00',
                    '21:30',
                    '22:00',
                    '22:30',
                    '23:00',
                    '23:30',
                ],
                selected_field: '',
                products_options: [],
                meeting_details: [],
                meetingLoader: false,
                meeting_id: '',
                schedule_meeting: false,
                call_report_id: "",
                editorOption: {
                    placeholder: 'Add Description',
                    modules: {
                        toolbar: [
                        ['bold', 'italic', 'underline', 'strike'],
                        ['blockquote', 'code-block'],
                        [{ 'header': 1 }, { 'header': 2 }],
                        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                        [{ 'script': 'sub' }, { 'script': 'super' }],
                        [{ 'indent': '-1' }, { 'indent': '+1' }],
                        [{ 'direction': 'rtl' }],
                        [{ 'size': ['small', false, 'large', 'huge'] }],
                        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                        [{ 'font': [] }],
                        [{ 'color': [] }, { 'background': [] }],
                        [{ 'align': [] }],
                        ['clean'],
                        // ['link', 'image', 'video']
                        ],
                        clipboard: {
                            matchVisual: false, 
                            onPaste: (data, delta, source) => {
                                const html = (data || '').trim();
                                if (html.includes('<img') || html.includes('<video')) {
                                    return false; 
                                }
                                return data;
                            }
                        },
                        syntax: {
                        highlight: text => hljs.highlightAuto(text).value
                        }
                    },
                }
            };
        },
        mixins: [callreport, leads, customer, deals, time_utils, contacts,teams,convert, productList, schedule],
        components: {
            quillEditor,
            VueTelInput,
            VueEditor,
            vSelect,
            VueTextareaAutosize,
            CompanyNewModal,
            ConfirmSubmitCallreport,
            DepartmentNewModal,
            BranchNewModal,
            TimeZoneModal,
            LoaderModal,
            HalfCircleSpinner,
            VueTagsInput,
            moment,
            SweetModal,
            AddAddress
        },
        watch: {
            isFullscreen(val) {
                if (val) {
                    document.body.style.overflow = 'hidden';
                    this.fullscreenHeight = window.innerHeight - 100;
                    window.addEventListener('resize', this.updateHeight);
                    window.addEventListener('keydown', this.handleEscape);
                } else {
                    document.body.style.overflow = '';
                    window.removeEventListener('resize', this.updateHeight);
                    window.removeEventListener('keydown', this.handleEscape);
                }
            },
            meeting_location_vmodel(val) {
                this.showManualEntry = val && val.length > 3;
            },
            callreporttab(newValue) {
                if (newValue) {
                    this.meetingnotestab = false;
                    this.followuptab = false;
                    this.salestargettab = false;
                }
            },
            meetingnotestab(newValue) {
                if (newValue) {
                    this.callreporttab = false;
                    this.followuptab = false;
                    this.salestargettab = false;
                }
            },
            followuptab(newValue) {
                if (newValue) {
                    this.meetingnotestab = false;
                    this.callreporttab = false;
                    this.salestargettab = false;
                }
            },
            salestargettab(newValue) {
                if (newValue) {
                    this.meetingnotestab = false;
                    this.followuptab = false;
                    this.callreporttab = false;
                }
            },

            callReportCategory(newValue, oldValue) {
                if (newValue) {
                    if (oldValue != newValue) {
                        this.owner_name = "",
                            this.owner_email = "",
                            this.internal_primary_attendee = [];
                        this.internal_primary_attendee_id = "";
                        this.internalPrimaryAttendee = "";
                        this.callreporttab = true;
                        this.meetingnotestab = false;
                        this.followuptab = false;
                        this.salestargettab = false;
                        this.showAddress = false;
                        this.countriesCaps = [];
                        this.newplace = "";
                        this.newplaceFormat = "";
                        this.title = "";
                        this.callReportType = "";
                        this.meetingType = "";
                        this.countries = countries;
                        this.maxlengthaccountzipcode = 10;
                        this.maxlengthaccounttownship = 20;
                        this.maxlengthaccountstreet = 50;
                        this.addressField = "";
                        this.addressFieldCompany = "";
                        this.addressFieldMeeting = "";
                        this.meetingstartdate = new Date();
                        this.meetingstarttime = new Date().getTime();
                        this.meetingenddate = new Date();
                        this.meetingendtime = new Date().getTime();
                        this.content = "";
                        this.assignedT = "";
                        this.statusMeeting = "";
                        this.selectQuarter = "";
                        this.salesYear = "";
                        this.salesYearType = "";
                        this.selectQuarterRevenue = "";
                        this.places = [];
                        this.attendeesUserCompany = "";
                        this.showTitle = true;
                        this.showTitleSales = true;
                        this.showExternal = [0];
                        this.showReceiverDetails = [0];
                        this.showContactDetails=[0];
                        this.showInternal = true;
                        this.showEmailRecipients = true;
                        this.showMeetingNotes = true;
                        this.showAttachments = true;
                        this.showMeetingInformation = true;
                        this.showPermissions = true;
                        this.showFollowUps = [0];
                        this.showFollowUpsNotes = [0];
                        this.showSales = [0];
                        this.productName = "";
                        this.meetingNotes = "";
                        this.meetingNotesSubject = "";
                        this.maxlengthFollowUpNotes = 500;
                        this.minHeight = 63;
                        this.maxHeight = 350;
                        this.productSalesQuarter = "";
                        this.locations = [];
                        this.formatedAddresses = [];
                        this.userAttendees = [];
                        this.optionsUserAttendees = [];
                        this.push_optionsUserAttendees = [];
                        this.optionsEmailRecipients = [];
                        this.optionsGroupEmailRecipients = [];
                        this.salesPerson = "";
                        this.timezone = timezone;
                        this.time_zone = "";
                        this.timezoneShow = false;
                        this.total = 0;
                        this.skip = 0;
                        this.limit = 10;
                        this.search_term = "";
                        this.isLoading = false;
                        this.scrollableCustomer = false;
                        this.scrollableCustomerInside = false;
                        this.scrollableEmailTeam = false;
                        this.scrollablePerTeam=false;
                        this.count = 0;
                        this.tempoptionsUserAttendees = [];
                        this.isVisible = false;
                        this.email_regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/;
                        this.invalidEmail = false;
                        this.noEmail = false;
                        this.companyList = [];
                        this.optionsCompanies = [];
                        this.tempoptionsCompanies = [];
                        this.scrollableCompanies = false;
                        this.search_key = "";
                        this.optionsCustomers = [];
                        this.employeeAttendees = [];
                        this.optionsEmployeeAttendeesExternal = [];
                        this.tempoptionsEmployeeAttendeesExternal = [];
                        this.optionsEmployeeAttendees = [];
                        this.push_optionsEmployeeAttendeesInternal = [];
                        this.push_emailRecipients = [];
                        this.tempoptionsEmployeeAttendees = [];
                        this.push_optionsEmployeeAttendees = [];
                        this.scrollableEmployee = false;
                        this.scrollableData = false;
                        this.reportScrollable = false;
                        this.otherAttendeeScrollable = false;
                        this.isLoadingemployees = false;
                        this.isLoadingemployeesExternal = false;
                        this.scrollableEmployeeExternal = false;
                        this.company_attendees = [{
                            companyList: [],
                            employeeAttendees: [],
                        }, ];
                        this.follow_ups = [{
                            products: "",
                            assigned_to: "",
                            notes: "",
                            due_date: "",
                            time:"",
                            price: null,
                            is_follow_expanded:true
                        }, ];
                        this.companyRepeat = {
                            company_name: "",
                            primary_employee: "",
                            secondary_employees: [],
                            customer_attendes: "",
                            department: "",
                            branch: "",
                            status: "",
                        },
                        this.lead_info= [{
                            id: "",
                            full_name: "",
                            company_name: "",
                            status: ""
                        }];
                        this.contact_info= [{
                            id: "",
                            full_name: "",
                            company_name: "",
                            status: "",
                        }];
                        this.follows = {
                            products: "",
                            assigned_to: "",
                            status: "",
                            notes: "",
                            due_date: "",
                            time:"",
                            is_follow_expanded:true,
                            price: null,
                        };
                        this.meeting_location = {
                            city: "",
                            street: "",
                            state: "",
                            township: "",
                            country: "",
                            zip_code: "",
                            address_type: "",
                        };
                        this.assignUsers = [];
                        this.firstTab = false;
                        this.customerStatusValue = "";
                        this.customerStatusOptions = [
                            "Demo",
                            "Existing Customer",
                            "Follow Up",
                            "Hot Lead",
                            "Interested",
                            "Negative Lead",
                            "New Customer",
                            "Positive Customer",
                            "Potential Customer",
                            "Referral Lead",
                            "Unassigned Lead",
                        ];
                        this.issueTypeOptions = [];
                        this.due_date = "";
                        this.customerNameValue = "";
                        this.customerNameOptions = ["Company 1", "Company 2"];
                        this.branchNameValue = "";
                        this.branchs = [];
                        this.internal_branchs = "";
                        this.internal_development = [];
                        this.internal_employees = [];
                        this.departmentNameValue = "";
                        this.departmentNameOptions = [];
                        this.maxlengthtitlename = 100;
                        this.maxlengthsubjectname = 200;
                        this.maxlengthproductname = 50;
                        this.tempcompany_ids = [];
                        // CreateJson
                        this.salestarget = {
                            customer_id: "",
                            branch: "",
                            department: "",
                            product: "",
                            target_year: "",
                            target: {
                                jan: 0,
                                feb: 0,
                                mar: 0,
                                apr: 0,
                                may: 0,
                                jun: 0,
                                jul: 0,
                                aug: 0,
                                sept: 0,
                                oct: 0,
                                nov: 0,
                                dec: 0,
                                sum: 0,
                            },
                        };
                        this.compressed_external_attendees = {};
                        this.compressed_sales_target = {};
                        this.createJson = {
                            author_name: this.createJson.author_name,
                            author_email: this.createJson.author_email,
                            call_report_category: [],
                            meeting_notes_table: [],
                            title: "",
                            meeting_time_from: new Date(),
                            meeting_time_to: new Date(),
                            meeting_type: "",
                            branch_name: this.createJson.branch_name,
                            meeting_notes_subject: "",
                            call_report_type: "",
                            meeting_location: {
                                street: "",
                                city: "",
                                township: "",
                                state: "",
                                zip_code: "",
                                country: "",
                                address_type: "",
                            },
                            internal_company: {
                                other_attendees: [],
                                company_attendees: [],
                                branch: this.createJson.internal_company.branch,
                                department: this.createJson.internal_company.department,
                                //subsidiary_attendees: [],
                            },
                            external_attendees: [{
                                company_name: "",
                                primary_employee: "",
                                secondary_employees: [],
                                customer_attendes: "",
                                department: "",
                                branch: "",
                                status: "",
                                lead_name: []
                            }, ],
                            follow_ups: [{
                                products: "",
                                assigned_to: "",
                                notes: "",
                                due_date: "",
                                time: "",
                                price: null,
                                is_follow_expanded:true
                            }, ],
                            meeting_timezone: {},
                            meeting_notes: "",
                            sales_target: {
                                forecast: [{
                                    product_code: "",
                                    customer_id: "",
                                    branch: "",
                                    department: "",
                                    product: "",
                                    target_year: "",
                                    sales_person: "",
                                    uom: "",
                                    target: {
                                        jan: 0,
                                        feb: 0,
                                        mar: 0,
                                        apr: 0,
                                        may: 0,
                                        jun: 0,
                                        jul: 0,
                                        aug: 0,
                                        sept: 0,
                                        oct: 0,
                                        nov: 0,
                                        dec: 0,
                                        sum: 0,
                                    },
                                }, ],
                            },
                            recipient_email: {
                                individual:[],
                                team:[]
                            },
                            permissions: {
                                individual:[],
                                team:[]
                            },
                            add_recipient: [],
                            status: "",
                            send_copy_to_me: false,
                            general_access:"private",
                            receiver_type: "lead"
                        };
                        this.meeting_location_vmodel = "";
                        this.countPrimaryAttendee = 0;
                        this.search_key_internal_primary = "";
                        this.indexToPass = "";
                        this.indexToExt="";
                        this.attachments = [];
                        this.hide_el_dropdown = false;
                        this.years_to_set = [];
                        this.productoptions = [];
                        this.saveandclose = false;
                        this.noFiscalYear = [];
                        this.disableSend = false;
                        this.callreporttab = true;

                    }
                    this.createJson.call_report_category = newValue;
                    this.createJson.call_report_type = newValue;
                    this.issueTypeLoading = false;

                }
            },
        },
        methods: {
            updateHeight() {
                this.fullscreenHeight = window.innerHeight - 100;
            },
            handleEscape(event) {
                if (event.key === 'Escape' || event.keyCode === 27) {
                    this.isFullscreen = false;
                }
            },
            saveAddress(value) {
                    //getting address form the address popup
                    this.createJson.meeting_location.city = value.city
                    this.createJson.meeting_location.country = value.country
                    this.createJson.meeting_location.state = value.state
                    this.createJson.meeting_location.street = value.street
                    this.createJson.meeting_location.zip_code = value.zip_code
                    this.createJson.meeting_location.township = value.township
                    this.meeting_location_vmodel = this.createJson.meeting_location.street + ", " + this.createJson.meeting_location.township + ", " +
                            this
                            .createJson.meeting_location.city + ", " + this.createJson.meeting_location
                            .state +
                            ", " + this.createJson.meeting_location.zip_code + ", " + this.createJson
                            .meeting_location.country;
                    this.manualFallback = true;
            },
            addAddressNew() {
                this.add_address = true
                // localStorage.setItem("selected_address",null)
                setTimeout(() => {
                    this.$modal.show("add_address");
                }, 500);
            },
            //hiding the address
            hideAddress() {
                this.add_address = false
                setTimeout(() => {
                    this.$modal.hide("add_address");
                }, 500);
            },
            handleManualEntry() {
                this.$forceUpdate();
                this.showManualEntry = ''
                this.manualFallback = false;
                const address = this.meeting_location_vmodel;
                if (!address || !address.trim()) return;
                const geocoder = new google.maps.Geocoder();
                geocoder.geocode({ address }, (results, status) => {
                    if (status === 'OK' && results.length > 0) {
                        this.manualFallback = false;
                        const result = results[0];
                        this.meeting_location_vmodel = result.formatted_address;
                        let street = '', city = '', state = '', zip = '', country = '', township = '';

                        result.address_components.forEach(component => {
                            if (component.types.includes('route')) street = component.long_name;
                            if (component.types.includes('locality')) city = component.long_name;
                            if (component.types.includes('administrative_area_level_2')) township = component.long_name;
                            if (component.types.includes('administrative_area_level_1')) state = component.long_name;
                            if (component.types.includes('postal_code')) zip = component.long_name;
                            if (component.types.includes('country')) country = component.long_name;
                        });

                        this.createJson.meeting_location = {
                            street,
                            city,
                            township,
                            state,
                            zip_code: zip,
                            country
                        };
                        // Rebuild the v-model string if needed
                        this.meeting_location_vmodel = [
                            street, city, state, zip, country
                        ].filter(x => x).join(', ');
                    } else {
                        this.manualFallback = true;
                        console.warn('Manual geocode failed:', status);
                    }
                });
            },
            removeOther(option){
                this.createJson.internal_company.other_attendees.forEach((el,index)=>{
                    if(option.email){
                        if(el.email == option.email){
                            this.createJson.internal_company.other_attendees.splice(index,1)
                        }
                    } else if(option.email_id){
                        if(el.email == option.email_id){
                            this.createJson.internal_company.other_attendees.splice(index,1)
                        }
                    }
                })
                this.createJson.recipient_email.individual.forEach((el,index)=>{
                    if(option.email){
                        if(el.email == option.email){
                            this.createJson.recipient_email.individual.splice(index,1)
                        }
                    } else if(option.email_id){
                        if(el.email == option.email_id){
                            this.createJson.recipient_email.individual.splice(index,1)
                        }
                    }
                })
            },
            onEditorChange: debounce(function(value) {
                this.content = value.html
            }, 466),
            async getMeetingData(){
                this.meetingLoader = true
                let params = {
                    id: this.meeting_id
                }
                let response = await this.getScheduleMeetingById(params)
                this.meeting_details = response.response
                // this.createJson.recipient_email.individual = this.meeting_details.invitees
                // this.createJson.recipient_email.individual = this.meeting_details.other_invitees
                // this.createJson
                // this.createJson.internal_company.other_attendees = this.meeting_details.other_invitees
                this.meetingLoader = false
            },
            limitProducts(count){
                return `+${count} more`
            },
            resetData(type){
                this.selected_field = type
                this.products_options = [];
                this.products_count = 0;
            },
            async searchProuctNameDebouncer(search){
                this.products_loading = true
                this.products_count = 0
                let params = {
                    skip: this.skip,
                    limit: 10,
                    search_key: search,
                    sort_key: "name",
                    sort_value: 1,
                    category_ids:[],
                    sub_category_ids:[],
                    product_type_ids:[],
                    product_ids:[],
                    brand_ids:[],
                    outlet_ids:[],
                    status:[],  
                    visibility:"Manufacturing"
                }
                let response = await this.ProductsList(params)
                this.products_options = response.response.result
                
                this.products_count = this.products_options.length
                this.products_loading = false
            },
            async reachedEndOfProductName(reached){
                if(reached){
                    if(this.products_scrollable == false){
                        this.products_loading = true
                        let response = await this.ProductsList({
                            skip: this.products_count,
                            limit: 10,
                            search_key: '',
                            sort_key: "name",
                            sort_value: 1,
                            category_ids:[],
                            sub_category_ids:[],
                            product_type_ids:[],
                            product_ids:[],
                            brand_ids:[],
                            outlet_ids:[],
                            status:[],  
                            visibility:"Manufacturing"
                        } )
                        let temp_products_options = response.response.result.length;
                        if(response.response.filter_data.skip == this.products_count){
                            if(temp_products_options > 0){
                                let tempfiles = response.response.result
                                // tempfiles.forEach(el => {
                                //     if(el[this.selected_field] != '' && el.hasOwnProperty(this.selected_field)){
                                //         this.products_options.push(el)
                                //     }
                                // })
                                // let uniqueArray = this.products_options.filter((value, index_dd) => {
                                //     const _value = value[this.selected_field];
                                //     return index_dd === this.products_options.findIndex(obj => {
                                //         return obj[this.selected_field] === _value;
                                //     });
                                // });
                                this.products_options = tempfiles
                                this.products_count += response.response.result.length;
                                this.products_loading = false
                            } else {
                                this.products_scrollable = true
                                this.products_loading = false
                            }
                            this.products_scrollable = false
                        }
                    }
                }
            },
            getLocationChange(data){
                this.manualFallback = false;
                 // if(data.target.value == ""){
                //     this.meeting_location_vmodel = '';
                // } else {
                //     this.meeting_location_vmodel = data.target.value;
                // }
                const val = data.target.value;
                this.meeting_location_vmodel = val;

                // Show manual entry if user types more than 3 characters or clears the input
                if (!val || val.trim().length === 0 || val.length > 3) {
                this.showManualEntry = true;
                } else {
                this.showManualEntry = false;
                }
            },
            removeCompanyAttendees(option){
                this.createJson.internal_company.company_attendees.forEach((el, index)=>{
                    if(el.full_name == option.full_name){
                        this.createJson.internal_company.company_attendees.splice(index,1)
                    }
                })
                this.createJson.recipient_email.individual.forEach((el,index)=>{
                    if(option.email){
                        if(el.email == option.email){
                            this.createJson.recipient_email.individual.splice(index,1)
                        }
                    } else if(option.email_id){
                        if(el.email == option.email_id){
                            this.createJson.recipient_email.individual.splice(index,1)
                        }
                    }
                })
                this.createJson.permissions.individual.forEach((el,index)=>{
                    if(option.email){
                        if(el.email == option.email ){
                            this.createJson.permissions.individual.splice(index,1)
                        } 
                    } else if(option.email_id){
                        if(el.email == option.email_id ){
                            this.createJson.permissions.individual.splice(index,1)
                        } 
                    }
                })
            },
            addCompanyAttendees(data){
                let check_permissions_duplicate = false;
                let check_recipients_duplicate = false;
                if(this.createJson.permissions.individual.length == 0){
                    this.createJson.permissions.individual.push(data)
                } else {
                    this.createJson.permissions.individual.forEach((el_per) => {
                        if(el_per.id == data.id){
                            check_permissions_duplicate = true;
                        }
                    })
                    if(check_permissions_duplicate == false){
                        this.createJson.permissions.individual.push(data)
                    }
                }
                if(this.createJson.recipient_email.individual.length == 0){
                    this.createJson.recipient_email.individual.push(data)
                } else {
                    this.createJson.recipient_email.individual.forEach((el_rec) => {
                        if(el_rec.id == data.id){
                            check_recipients_duplicate = true;
                        }
                    })
                    if(check_recipients_duplicate == false){
                        this.createJson.recipient_email.individual.push(data)
                    }
                }
            },
            //selected the recipient emails of individual
            /**@params = data */
            selectedEmail(data){
                if(this.createJson.general_access == 'private'){
                    this.createJson.permissions.individual.push(data)
                    if(this.createJson.permissions.individual.length) {
                        let stored_data = JSON.parse(JSON.stringify(this.createJson.permissions.individual))
                        this.createJson.permissions.individual = Array.from(new Set(stored_data.map(a => a.email)))
                        .map(email => {
                            return stored_data.find(a => a.email === email)
                        })
                        localStorage.setItem('individual_data', JSON.stringify(this.createJson.permissions.individual))
                    }
                } else {
                    this.createJson.permissions.individual = []
                }
            },
            //selected the recipient emails of teams
            /**@params = data */
            selectedEmailTeam(data){
                if(this.createJson.general_access == 'private'){
                    this.createJson.permissions.team.push(data)
                    if(this.createJson.permissions.individual.length) {
                        let stored_data = JSON.parse(JSON.stringify(this.createJson.permissions.individual))
                        this.createJson.permissions.individual = Array.from(new Set(stored_data.map(a => a.email)))
                        .map(email => {
                            return stored_data.find(a => a.email === email)
                        })
                        localStorage.setItem('team_data', JSON.stringify(this.createJson.permissions.team))
                    }
                } else {
                    this.createJson.permissions.team = []
                }
            },
            //remove email team data
            /**@params = option */
            removeEmailTeam(option){
                this.createJson.recipient_email.team.forEach((el,index)=>{
                    if(el.email_id == option.email_id){
                        this.createJson.recipient_email.team.splice(index,1)
                    }
                })
                this.createJson.permissions.team.forEach((el,index)=>{
                    if(el.email_id == option.email_id ){
                        this.createJson.permissions.team.splice(index,1)
                    }
                })
            },
            //remove email individual data
            /**@params = option */
            removeEmailIndividual(option){
                this.createJson.recipient_email.individual.forEach((el,index)=>{
                    if(el.email== option.email){
                        this.createJson.recipient_email.individual.splice(index,1)
                    }
                })
                this.createJson.permissions.individual.forEach((el,index)=>{
                    if(el.email == option.email ){
                        this.createJson.permissions.individual.splice(index,1)
                    }
                })
            },
            removeProductsName(option){
                this.createJson.follow_ups.forEach((el,index)=>{
                    el.products.forEach((product,product_index)=>{
                        if(product.name == option.name){
                            el.products.splice(product_index,1)
                        }
                    })
                })
            },
            removeSalesProductsName(option){
                this.createJson.sales_target.forecast.forEach((el,index)=>{
                    el.product.forEach((product,el_index)=>{
                        if(product.name == option.name){
                            el.product.splice(el_index,1)
                        }
                    })
                })
                // this.createJson.sales_target.forEach((el,index)=>{
                //     el.forecast.forEach((product,el_index)=>{
                //         product.product.forEach((pr,product_index)=>{
                //             if(pr.name == option.name){
                //                 product.product.splice(product_index,1)
                //             }
                //         })
                //     })
                // })
            },
            //expand the follow up tab
            /**@params = follow */
            expandFollowUps(follow) {
                follow.is_follow_expanded = !follow.is_follow_expanded
                this.$forceUpdate();
            },
            //change the time format
            changeTimeFormat(i){
                this.createJson.follow_ups[i].time = moment(this.createJson.follow_ups[i].time, ["HH:mm"]).format("hh:mm A")
            },
            checkDate(data,i){
                data.time = ""
                this.time_format = [
                    '00:00',
                    '00:30',
                    '01:00',
                    '01:30',
                    '02:00',
                    '02:30',
                    '03:00',
                    '03:30',
                    '04:00',
                    '04:30',
                    '05:00',
                    '05:30',
                    '06:00',
                    '06:30',
                    '07:00',
                    '07:30',
                    '08:00',
                    '08:30',
                    '09:00',
                    '09:30',
                    '10:00',
                    '10:30',
                    '11:00',
                    '11:30',
                    '12:00',
                    '12:30',
                    '13:00',
                    '13:30',
                    '14:00',
                    '14:30',
                    '15:00',
                    '15:30',
                    '16:00',
                    '16:30',
                    '17:00',
                    '17:30',
                    '18:00',
                    '18:30',
                    '19:00',
                    '19:30',
                    '20:00',
                    '20:30',
                    '21:00',
                    '21:30',
                    '22:00',
                    '22:30',
                    '23:00',
                    '23:30',
                ]
                let dueDate = this.createJson.follow_ups[i].due_date
                if(String(new Date()).slice(0,16) == String(new Date(dueDate)).slice(0,16)){
                    let meridian_time = this.formatDateTime(new Date()).slice(11, )
                    let r_time = this.convertTime12to24(meridian_time)
                    if(r_time.slice(3,) < 30){
                        let hour = new Date().getHours()
                        if(hour < 10){
                            r_time = '0' + hour + ':' + '00'
                        } else {
                            r_time = hour + ':' + '00'

                        }
                    } else {
                        let hour = new Date().getHours()
                        if(hour < 10){
                            r_time = '0' + hour + ':' + '00'
                        } else {
                           r_time = hour + ':' + '00'
                        }
                    }
                    this.time_format = this.time_format.slice(this.time_format.indexOf(r_time)+1, )
                }
            },
            convertTime12to24(time12h){
                const [time, modifier] = time12h.split(' ');
                let [hours, minutes] = time.split(':');
                if (hours === '12') {
                    hours = '00';
                }
                if (modifier === 'PM') {
                    hours = parseInt(hours, 10) + 12;
                }
                return `${hours}:${minutes}`;
            },
            //checking the type number format
            /**@params = evt, @params = index */
            isNumber: function(evt, index) {
                evt = evt ? evt : window.event
                var charCode = evt.which ? evt.which : evt.keyCode
                if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                    evt.preventDefault()
                } else {
                    return true
                }
            },
            //remove product name
            /**@params = option, @params = follow */
            removeProductName(option,follow) {
                if(follow.products.length == 1){
                    follow.products.forEach((el,index)=>{
                        if(el.id == option.id){
                            follow.products.splice(index,1)
                        }
                    })
                    follow.assigned_to = ''
                    follow.due_date = ''
                    follow.time = ''
                    follow.price = null
                } else {
                    follow.products.forEach((el,index)=>{
                        if(el.id == option.id){
                            follow.products.splice(index,1)
                        }
                    })
                }

            },
            //custom label to show both company name and lead name in the dropdown
            /**@params = full_name, @params = company_name */
            customLabel ({ full_name, company_name }) {
                return `${full_name} – ${company_name}`
            },
            //close the lead drodown
            /**@params = index */
            closeLeadNameDropdown(index){
                this.search_lead = '';
                this.lead_index = null;
                this.createJson.lead_info[index].is_lead_loading = false;
            },
            //API call to search permission for team
            /**@params = key, @params = value */
            async searchPermissionTeamDebouncer(key,value) {
                this.isLoadingPermissionTeam = true
                if (key) {
                    this.search_term = key ;
                }
                /**@params = skip, @params = limit, @params = search_key */
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_term
                };
                let res = await this.getPermissionList(params);
                this.optionsPemissionRecipientsTeam = res.response;
                this.optionsPemissionRecipientsTeam = this.optionsPemissionRecipientsTeam.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.optionsPemissionRecipientsTeam.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.permission_skip_count = res.response.length
                this.count = 0;
                this.isLoadingPermissionTeam = false
            },
            //lazy laoding to fetch permission for team
            /**@params = reached */
            async reachedEndOfPermissionTeam(reached) {
                this.isVisible = reached;
                if (reached) {
                    if (this.scrollableCustomer == false) {
                        //this.isLoadingPermissionTeam = true;
                        /**@params = skip, @params = limit*/
                        let res = await this.getPermissionList({
                            skip: this.permission_skip_count,
                            limit: 10
                        });
                        if(res.skip == this.permission_skip_count){
                            if (res.response.length > 0) {
                                let tempFiles = res.response;
                                tempFiles.forEach(el => {
                                    this.optionsPemissionRecipientsTeam.push(el);
                                });
                                this.optionsPemissionRecipientsTeam = this.optionsPemissionRecipientsTeam.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.optionsPemissionRecipientsTeam.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.permission_skip_count += res.response.length;
                                this.isLoadingPermissionTeam = false;
                            } else {
                                this.scrollableCustomer = true;
                                this.isLoadingPermissionTeam = false;
                            }
                        }
                        this.isLoadingPermissionTeam = false;
                    }
                }
            },
            //API call to search permission individual
            /**@params = key */
            async searchPermissionEmailDebouncer(key) {
                this.isLoadingEmailTeam = true
                if (key) {
                    this.search_term = key ;
                }
                 /**@params = skip, @params = limit, @params = search_key */
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_term
                };
                let res = await this.getPermissionList(params);
                this.optionsEmailRecipientsTeam = res.response;
                this.optionsEmailRecipientsTeam = this.optionsEmailRecipientsTeam.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.optionsEmailRecipientsTeam.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.email_skip_count = res.response.length
                this.count = 0;
                this.isLoadingEmailTeam = false

            },
            //lazy laoding to fetch permission for individual
            /**@params = reached */
            async reachedEndOfPermissionEmail(reached) {
                this.isVisible = reached;
                if (reached) {
                    if (this.scrollablePerTeam == false) {
                        /**@params = skip, @params = limit*/
                        this.isLoadingEmailTeam = true;
                        let res = await this.getPermissionList({
                            skip: this.email_skip_count,
                            limit: 10
                        });
                        if(res.skip == this.email_skip_count){
                            if (res.response.length > 0) {
                                let tempFiles = res.response;
                                tempFiles.forEach(el => {
                                    this.optionsEmailRecipientsTeam.push(el);
                                });
                                this.optionsEmailRecipientsTeam = this.optionsEmailRecipientsTeam.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.optionsEmailRecipientsTeam.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.email_skip_count += res.response.length;
                               this.isLoadingEmailTeam = false;
                            } else {
                                this.scrollablePerTeam = true;
                                this.isLoadingEmailTeam = false;
                            }
                        }

                        this.isLoadingEmailTeam = false;
                    }
                }
            },
            //reset permission data
            resetPermissions() {
                this.createJson.permissions = {
                    individual :[],
                    team:[]
                };
                this.$validator.reset();
            },
            //API call to search permission individual
            /**@params = key, @params = value  */
            async searchGroupDebouncer(key,value) {
                this.owner_ids_ind = []
                if (key) {
                    this.search_term = key ;
                }
                if(this.loggedInUser != ''){
                    this.author_data= JSON.parse(JSON.stringify(this.loggedInUser.user_id))
                    this.owner_ids_ind.push(this.author_data)
                }
                if(this.user_ids_ind!=''){
                    this.user_ids_ind.forEach((x,index)=>{
                        this.owner_ids_ind.push(x)
                    })
                }
                /**@params = skip, @params = limit, @params = search_key, @params = exclude */
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_term,
                    exclude: this.owner_ids_ind || ''

                };
                let res = await this.getMembersData(params);
                this.optionsGroupEmailRecipients = res.response;
                this.optionsGroupEmailRecipients = this.optionsGroupEmailRecipients.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.optionsGroupEmailRecipients.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.group_skip_count = res.response.length
                this.count = 0;
                this.isGroupLoading = false;

            },
            //lazy loading for froup email
            /**@params = reached */
            async reachedEndOfGroupEmail(reached) {
                this.owner_ids_ind = []
                if(this.loggedInUser != ''){
                    this.author_data= JSON.parse(JSON.stringify(this.loggedInUser.user_id))
                    this.owner_ids_ind.push(this.author_data)
                }
                if(this.user_ids_ind!=''){
                    this.user_ids_ind.forEach((x,index)=>{
                        this.owner_ids_ind.push(x)
                    })
                }
                this.isVisible = reached;
                if (reached) {
                    if (this.scrollableEmailTeam == false) {
                        this.isGroupLoading = true;
                         /**@params = skip, @params = limit, @params = search_key, @params = exclude */
                        let res = await this.getMembersData({
                            skip: this.group_skip_count,
                            limit: this.limit,
                            search_key: this.search_term,
                            exclude: this.owner_ids_ind || ''
                        });
                        if(res.skip == this.group_skip_count){
                            if (res.response.length > 0) {
                                let tempFiles = res.response;
                                tempFiles.forEach(el => {
                                    this.optionsGroupEmailRecipients.push(
                                        el);
                                });
                                this.optionsGroupEmailRecipients = this.optionsGroupEmailRecipients.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.optionsGroupEmailRecipients.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.group_skip_count += res.response.length;
                                this.isGroupLoading = false;
                            } else {
                                this.scrollableEmailTeam = true;
                                this.isGroupLoading = false;
                            }
                        }
                        this.isGroupLoading = false;
                    }
                }
            },
            //change permission
            /**@params = selected_type*/
            changePermission(selected_type) {
                var data = selected_type;
                if (data == 'private') {
                    this.email_individual = true;
                    this.email_all = false;
                    if(this.createJson.recipient_email.individual.length > 0){
                        let ind_data = JSON.parse(localStorage.getItem('individual_data'))
                        this.createJson.permissions.individual = ind_data
                        this.createJson.permissions.individual = Array.from(new Set(this.createJson.permissions.individual.map(a => a.email)))
                        .map(email => {
                            return this.createJson.permissions.individual.find(a => a.email === email)
                        })
                    } else{
                        this.createJson.permissions.individual = []
                    }
                    if(this.createJson.recipient_email.team.length > 0){
                        let team_data = JSON.parse(localStorage.getItem('team_data'))
                        this.createJson.permissions.team = team_data
                        this.createJson.permissions.team = Array.from(new Set(this.createJson.permissions.team.map(a => a.email_id)))
                        .map(email => {
                            return this.createJson.permissions.team.find(a => a.email_id === email)
                        })
                    } else{
                        this.createJson.permissions.team = [];
                    }
                } else  {
                    this.email_individual = false;
                    this.email_all = true;
                    this.createJson.permissions.individual = [];
                    this.createJson.permissions.team= [];
                }
            },
            //dropdown email closed
            dropdownEmailClosed(){
                //this.createJson.recipient_email =""
                this.search_term ="";
                this.skip = 0;
            },
            //API call to Search Secondary Attendees
            /**@params = value, @params =comp , @params = index */
            async searchSecondaryAttendeesDebouncer(value,comp,index){
                this.indexToSecondary = index
                this.secondary_company_id = []
                this.secondary_company_id.push(comp.id)
                this.external_secondary_loading = true
                /**@params = skip, @params = limit, @params = search_key, @params = sort_key,@params = sort_value, @params = status, @params = filter_json*/
                let params = {
                    search_key: value || '',
                    sort_key: "full_name",
                    sort_value: 1,
                    limit: this.limit,
                    skip : this.skip,
                    status: 'active' ,
                    filter_json : {
                        customer_id: this.secondary_company_id
                    }
                }
                let response = await this.getBusinessConatactList(params)
                this.external_secondary_options = response.response
                this.external_secondary_options = this.external_secondary_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.external_secondary_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.external_secondary_count = this.external_secondary_options.length
                this.external_secondary_loading  = false
                this.external_secondary_scrollable = false
            },
            //Lazy loading of Secondary Attendees
            /**@params = reached */
            async reachedEndOfSecondaryAttendees(reached){
                this.contact_visible = reached
                if (reached) {
                    if (this.external_secondary_scrollable == false) {
                        this.external_secondary_loading = true
                        /**@params = skip, @params = limit, @params = search_key, @params = sort_key,@params = sort_value, @params = status, @params = filter_json*/
                        let response = await this.getBusinessConatactList({
                            skip: this.external_secondary_count,
                            limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                            search_key: "",
                            sort_key: "full_name",
                            sort_value: 1,
                            status: this.status,
                            filter_json : {
                                customer_id: this.secondary_company_id
                            }
                        })
                        this.temp_external_secondary = response.response.length;
                        if (response.skip == this.external_secondary_count) {
                            if (this.temp_external_secondary > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.external_secondary_options.push(el);
                                });
                                this.external_secondary_options = this.external_secondary_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.external_secondary_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.external_secondary_count += response.response.length;
                                this.external_secondary_loading = false
                            } else {
                                this.external_secondary_scrollable = true
                                this.external_secondary_loading = false
                            }
                        }
                        this.external_secondary_loading = false
                    }
                }
            },
            //selected secondary attendees
            /**@params = data , @params = index */
            secondaryAttendeeSelected(data, index) {
                // this.createJson.external_attendees[index].secondary_employees = data;
                this.$forceUpdate();
            },
            //Add manual data for secondary attendees
            /**@params = newTag */
            addSecondaryTag(newTag){
                const element = newTag;
                if (String(element).match(this.email_regex)) {
                    this.external_secondary_options.push({
                        primary_email: element
                    });
                    this.createJson.external_attendees[this.indexToSecondary].secondary_employees.push({
                        primary_email: element
                    });
                } else {
                    this.$awn.success(
                        "As Your Email ID Was Not Valid It is Removed"
                    );
                    this.invalidEmail = true;
                    return;
                }
                this.$forceUpdate();
            },
            //Add manual data for primary attendees
            /**@params = newTag */
            addTag(newTag){
                const element = newTag;
                if (String(element).match(this.email_regex)) {
                    this.external_primary_options.push({
                        primary_email: element
                    });
                    this.createJson.external_attendees[this.indexToExt].primary_employee = {
                        primary_email: element
                    }
                } else {
                    this.$awn.success(
                        "As Your Email ID Was Not Valid It is Removed"
                    );
                    this.invalidEmail = true;
                    return;
                }
                this.$forceUpdate()
            },
            //Api call to search Primary Attendees
            /**@params = value, @params =comp , @parmas = index */
            async searchPrimaryAttendeesDebouncer(value,comp,index){
                this.indexToExt = index
                this.ext_company_id = []
                this.ext_company_id.push(comp.id)
                this.external_primary_loading = true
                /**@params = skip, @params = limit, @params = search_key, @params = sort_key,@params = sort_value, @params = status, @params = filter_json*/
                let params = {
                    search_key: value || '',
                    sort_key: "full_name",
                    sort_value: 1,
                    limit: this.limit,
                    skip : this.skip,
                    status: 'active' ,
                    filter_json : {
                        customer_id: this.ext_company_id
                    }
                }
                let response = await this.getBusinessConatactList(params)
                this.external_primary_options = response.response
                this.external_primary_options = this.external_primary_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.external_primary_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.external_primary_count = this.external_primary_options.length
                this.external_primary_loading  = false
                this.external_primary_scrollable = false
            },
            //Lazy loading of Secondary Attendees
            /**@params = reached */
            async reachedEndOfPrimaryAttendees(reached){
                this.employee_visible = reached
                if (reached) {
                    if (this.external_primary_scrollable == false) {
                        this.external_primary_loading = true
                        let response = await this.getBusinessConatactList({
                            /**@params = skip, @params = limit, @params = search_key, @params = sort_key,@params = sort_value, @params = status, @params = filter_json*/
                            skip: this.external_primary_count,
                            limit: this.limit == '' || 0 || null || undefined ? 10 : this.limit,
                            search_key: "",
                            sort_key: "full_name",
                            sort_value: 1,
                            status: this.status,
                            filter_json : {
                                customer_id: this.ext_company_id
                            }

                        })
                        this.temp_external_primary = response.response.length;
                        if (response.skip == this.external_primary_count) {
                            if (this.temp_external_primary > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.external_primary_options.push(el);
                                });
                                this.external_primary_options = this.external_primary_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.external_primary_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.external_primary_count += response.response.length;
                                this.external_primary_loading = false
                            } else {
                                this.external_primary_scrollable = true
                                this.external_primary_loading = false
                            }
                        }
                        this.external_primary_loading = false
                    }
                }
            },
            //checking validation on click of preview
            preview(){
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.getDomain()
                    }
                })
            },
            //compare the logged in user domain and entered email domain to share the emails
            getDomain(){
                let domain = this.loggedInUser.primary_email.split('@')[1];
                let email_domain =[]
                let list1 = this.createJson.recipient_email.individual.filter(email => domain !=(email.email.split('@')[1]))
                let teamEmail1 = this.createJson.recipient_email.team.filter(email => domain !=(email.email_id.split('@')[1]))
                if((list1.length != 0 && teamEmail1.length != 0) || (list1.length != 0 &&  teamEmail1) || (list1 &&  teamEmail1.length != 0)){
                    EventBus.$emit("userData",list1)
                    EventBus.$emit("userDataEmail",teamEmail1)
                    this.showCallReport();
                } else{
                    this.callReportData()
                }

            },
            //show the call report submit confirmation modal
            showCallReport(){
                this.callReportData()
                // this.$modal.show("confirmSubmitCR")
            },
            //calling the save data API
            callReportData(){
                this.saveData();
            },
            //cancel the report data modal
            cancelreportData(){
                this.$modal.hide("confirmSubmitCR")
            },
            /**assiging the values to the lead */
            /**@params = value, @params = index */
            selectedLead(value,index) {
                this.createJson.lead_info[index].id = value.id
                this.createJson.lead_info[index].full_name = value.full_name == '' ? "-" : value.full_name
                this.createJson.lead_info[index].company_name = value.company_name ? value.company_name : '-'
                this.createJson.lead_info[index].status = value.lead_type== 'cold_lead' ? "Cold Lead" : value.lead_type == 'hot_lead' ? 'Hot Lead' : value.lead_type == 'warm_lead' ? 'Warm Lead' : '-'
                this.resetContactDetails(index);
            },
            /**assiging the values to the contact */
            /**@params = value, @params = index */
            selectedContact(value,index) {
                this.createJson.contact_info[index].company_name = value.company_name ? value.company_name : '-'
                this.createJson.contact_info[index].id = value.id
                this.createJson.contact_info[index].full_name = value.full_name == '' ? "-" : value.full_name
                this.resetReceiverDetails(index);
                this.$forceUpdate();
            },
            //API call to search Contact Name
            /**@params = value, @params = index */
            async searchContactNameDebouncer(value,index) {
                this.contact_index = index
                this.createJson.contact_info[this.contact_index].is_contact_loading = true
                /**@params = search_key, @params = sort_key,@params = search_value, @params = limit, @params = skip, @params = status */
                let params = {
                    search_key: value || '',
                    sort_key: "full_name",
                    sort_value: 1,
                    limit: 10,
                    skip: 0,
                    status: 'active'
                }
                let response = await this.getBusinessConatactList(params)
                this.contact_name_options = response.response
                // this.contact_name_options = this.contact_name_options.filter((thing, index) => {
                //     const payload = JSON.stringify(thing);
                //     return index === this.contact_name_options.findIndex(obj => {
                //         return JSON.stringify(obj) === payload;
                //     });
                // });
                // this.createJson.contact_info.forEach((contact_name_el, contact_name_index) => {
                //     let index = this.contact_name_options.findIndex((x) => x.id === contact_name_el.name.id)
                //     this.contact_name_options.splice(index, 1)
                // })
                this.contact_name_count = this.contact_name_options.length
                this.createJson.contact_info[this.contact_index].is_contact_loading = false
                this.conatact_scrollable = false
            },
            //Lazy loading of the contact name data
            /**@params = reached */
            async reachedEndOfContactName(reached) {
                this.contact_visible = reached
                if (reached) {
                    if (this.contact_scrollable == false) {
                        this.createJson.contact_info[this.contact_index].is_contact_loading = true
                        /**@params = search_key, @params = sort_key,@params = search_value, @params = limit, @params = skip, @params = status */
                        let response = await this.getBusinessConatactList({
                            skip: this.contact_name_count,
                            limit: 10,
                            search_key: "",
                            sort_key: "full_name",
                            sort_value: 1,
                            status: this.status,
                        })
                        this.temp_contact_name = response.response.length;
                        if (response.skip == this.contact_name_count) {
                            if (this.temp_contact_name > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.contact_name_options.push(el);
                                });
                                this.contact_name_options = this.contact_name_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.contact_name_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.createJson.contact_info.forEach((contact_name_el, contact_name_index) => {
                                    let index = this.contact_name_options.findIndex((x) => x.id === contact_name_el.name.id)
                                    this.contact_name_options.splice(index, 1)
                                })
                                this.contact_name_count += response.response.length;
                                this.createJson.contact_info[this.contact_index].is_contact_loading = false
                            } else {
                                this.contact_scrollable = true
                                this.createJson.contact_info[this.contact_index].is_contact_loading = false
                            }
                        }
                        this.createJson.contact_info[this.contact_index].is_contact_loading = false
                    }
                }
            },
            //set the limit contact name
            /**@params = count */
            limitContactName(count) {
                return `+ ${count} more`
            },
            removeContactName(option) {
                /*this.temp_contact_name.forEach((el,index)=>{
                    if(el._id == option._id){
                        this.temp_contact_name.splice(index,1)
                    }
                })*/
            },
            //API call to Search Lead Name
            /**@params = value, @params = index */
            async searchLeadNameDebouncer(search,index) {
                this.lead_index = index
                this.createJson.lead_info[this.lead_index].is_lead_loading = true
                /**@params = search_key, @params = sort_key,@params = sort_value, @params = skip, @params = limit */
                let params = {
                    search_key: search || '',
                    sort_key: "full_name",
                    sort_value: 1,
                    skip: 0,
                    limit: 10
                }
                let response = await this.getLeadList(params)
                this.lead_name_options = response.response
                this.lead_name_options = this.lead_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.lead_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.createJson.lead_info.forEach((lead_name_el, lead_name_index) => {
                    let index = this.lead_name_options.findIndex((x) => x.id === lead_name_el.name.id)
                    if(index >= 0){
                        this.lead_name_options.splice(index, 1)
                    }
                })
                this.lead_name_count = this.lead_name_options.length
                this.createJson.lead_info[this.lead_index].is_lead_loading = false
                this.lead_scrollable = false
                this.$forceUpdate();
            },
            //API call to Fetch Lead Name
            /**@params = search, @params = index */
            async leadNameList(search,index) {
                this.lead_index = index
                this.createJson.lead_info[this.lead_index].is_lead_loading = true
                /**@params = search_key, @params = sort_key, @params = sort_value, @params = skip, @params = limit */
                let params = {
                    search_key:  "",
                    sort_key: "full_name",
                    sort_value: 1,
                    skip: 0,
                    limit: 10
                }
                let response = await this.getLeadList(params)
                this.lead_name_options = response.response
                //To show two values in dropdown option values
                this.lead_name_options = this.lead_name_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.lead_name_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                //Remove selected value from lead info options
                this.createJson.lead_info.forEach((lead_name_el, lead_name_index) => {
                    let index = this.lead_name_options.findIndex((x) => x.id === lead_name_el.id)
                    if(index >= 0){
                        this.lead_name_options.splice(index, 1)
                    }
                })
                this.lead_name_count = this.lead_name_options.length
                this.createJson.lead_info[this.lead_index].is_lead_loading = false
                this.lead_scrollable = false
            },
            //Lazy loading of the contact name data
            /**@params = reached */
            async reachedEndOfLeadName(reached) {
                this.lead_visible = reached
                if (reached) {
                    if (this.lead_scrollable == false) {
                        this.createJson.lead_info[this.lead_index].is_lead_loading = true
                        /**@params = search_key, @params = sort_key, @params = sort_value, @params = skip, @params = limit */
                        let response = await this.getLeadList({
                            skip: this.lead_name_count,
                            limit: 10,
                            search_key: "",
                            sort_key: "full_name",
                            sort_value: 1
                        })
                        this.temp_lead_name = response.response.length;
                        if (response.skip == this.lead_name_count) {
                            if (this.temp_lead_name > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.lead_name_options.push(el);
                                });
                                this.lead_name_options = this.lead_name_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.lead_name_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.createJson.lead_info.forEach((lead_name_el, lead_name_index) => {
                                    let index = this.lead_name_options.findIndex((x) => x.id === lead_name_el.name.id)
                                    this.lead_name_options.splice(index, 1)
                                })
                                this.lead_name_count += response.response.length;
                                this.createJson.lead_info[this.lead_index].is_lead_loading = false
                            } else {
                                this.lead_scrollable = true
                                this.createJson.lead_info[this.lead_index].is_lead_loading = false
                            }
                        }
                        this.createJson.lead_info[this.lead_index].is_lead_loading = false
                    }
                    this.$forceUpdate();
                }
            },
            limitLeadName(count) {
                return `+ ${count} more`
            },
            addVendor(){
                this.createJson.vendor_info.push({
                    vendor_name: "",
                    vendor_primary_attendee: "",
                    is_vendor_expanded:true,
                    is_vendor_loading: false,
                });
                this.$forceUpdate();
            },
            resetVendorData(index){
                this.createJson.vendor_info[index].vendor_name = "";
                this.createJson.vendor_info[index].vendor_primary_attendee = "";
                this.createJson.vendor_info[index].is_vendor_expanded = true;
                this.createJson.vendor_info[index].is_vendor_loading = false;
            },
            //change the account in receiver details
            /**@params = selected_account */
            changeAccount(selected_account) {
                var data = selected_account;
                if (data == 'lead') {
                    this.receiver_lead = true;
                    this.receiver_vendor = false;
                    this.receiver_customer = false;
                    this.receiver_contact = false;
                    this.createJson.lead_info = [{
                        id: "",
                        name: "",
                        company_name: "",
                        status:"",
                        is_lead_loading:false,
                        is_expanded:true

                    }];
                    this.createJson.contact_info = []
                    this.createJson.external_attendees = []
                    this.createJson.vendor_info = []
                } else if (data == 'customer') {
                    this.createJson.external_attendees = []
                    this.createJson.vendor_info = []
                    this.receiver_lead = false;
                    this.receiver_customer = true;
                    this.receiver_contact = false;
                    this.receiver_vendor = false;
                    this.createJson.lead_info = [];
                    this.createJson.contact_info = []
                    this.createJson.external_attendees = [{
                        company_name: "",
                        primary_employee: "",
                        secondary_employees: [],
                        department: "",
                        branch: "",
                        status: "",
                        is_cust_expanded:true
                    }];
                } else if (data == 'vendor') {
                    this.createJson.external_attendees = []
                    this.createJson.vendor_info = []
                    this.receiver_lead = false;
                    this.receiver_customer = false;
                    this.receiver_vendor = true;
                    this.receiver_contact = false;
                    this.createJson.lead_info = [];
                    this.createJson.contact_info = []
                    this.createJson.vendor_info = [{
                        vendor_name: "",
                        vendor_primary_attendee: "",
                        is_vendor_expanded:true,
                        is_vendor_loading: false,
                    }];
                } else {
                    this.createJson.vendor_info = []
                    this.receiver_lead = false;
                    this.receiver_customer = false;
                    this.receiver_contact = true;
                    this.receiver_vendor = false;
                    this.createJson.lead_info = [];
                    this.createJson.contact_info = [{
                        id: "",
                        name: "",
                        company_name: "",
                        is_contact_expanded:true,
                        is_contact_loading:false
                    }];
                    this.createJson.external_attendees = []
                }
            },

            onChangeMeetingStartDate(value) {
                let value_n = value
                let value_n_split = value_n.split("/")
                var date1 = value_n_split[2] + '-' + value_n_split[1] + '-' + value_n_split[0];
                let d_obj = new Date(date1 + ' ' + '00:00:00');
                this.not_before_start_date = d_obj;
            },
            onChangeMeetingStartTime(value) {
            },
            onChangeMeetingEndDate(value) {
            },
            onChangeMeetingEndTime(value) {
            },
            //API call to set the local time into the start and end date and time
            async loadUTCTime() {
                let value = this.meeting_end_date.split("/")
                let value1 = this.meeting_start_date.split("/")
                var date1 = value[1] + '/' + value[0] + '/' + value[2];
                var date2 = value1[1] + '/' + value1[0] + '/' + value1[2];
                let data
                try {
                    /**@params = end_date, @params = end_time, @params = start_date, @params = start_time */
                    let params = {
                        end_date: date1,
                        end_time: this.meeting_end_time,
                        start_date: date2,
                        start_time: this.meeting_start_time,
                        timezone:this.loggedInUser.time_zone

                    }
                    let response = await this.getUTCTime(params)
                    data= response.response;
                    this.combinedTo = data.meeting_time_to
                    this.combinedFrom = data.meeting_time_from
                    this.$forceUpdate()
                } catch (error) {
                }
            },
            //check the date validation is end date and time are greater than start date and time.
            async validateDateTime(){
                this.loadUTCTime();
                let params = {
                    meeting_start_date_time: this.combinedFrom,
                    meeting_end_date_time: this.combinedTo,
                }
                let response = await this.validateFutureDate(params)
                try{
                    if(response.status_id == 1) {
                        this.meetingnotestab = true
                        EventBus.$emit("scrollToTop");
                    }
                    else {
                        this.warning_msg = response.reason
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 1000);
                        this.meetingnotestab = false
                    }
                }
                catch(error){
                    this.meetingnotestab = false
                }
            },
            //upload attachments
            /**@params = newFile, @params = oldFile */
            uploadAttachment(newFile, oldFile) {
                var input = newFile;
                this.total_file_size = this.total_file_size + input.file.size
                if(this.attachments.map(x => x.name).includes(input.file.name)){
                    this.$toasted.global.error("This file already exists")
                } else if(!input.file.name.endsWith('.htm') && !input.file.name.endsWith('.html') && !input.file.name.endsWith('.flv')){
                    if (input.file) {
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();
                        /**@params = name, @params = size,@params = source, @params = progress, @params = error */
                        let attachment = {
                            name: input.file.name,
                            size: JSON.stringify(input.file.size),
                            source: source,
                            progress: 0,
                            created_time: new Date(),
                            error: ""
                        }
                        if (this.attachments.length >= 10) {
                            this.$toasted.global.error("you're not allowed to upload more than 10 attachments")
                            this.total_file_size = this.total_file_size - input.file.size
                        } else if (this.total_file_size > 25000 * 1000) {
                            this.$toasted.global.error("Attachments Size Cannot Exceed 25mb")
                            this.total_file_size = this.total_file_size - input.file.size
                        } else {
                            this.attachments.push(attachment);
                            this.getResumableURL(input.file, this.attachments[this.attachments.length - 1]);
                        }
                    }
                } else {
                    this.$toasted.global.error("This file is not supported")
                }
            },
            //APi call to save a cloud API
            /**@params = file, @params = attachment*/
            getResumableURL(file, attachment) {
                this.isUploadingInProgress = true;
                attachment.uploading = true;
                let data = {
                    file: attachment.name
                }
                data = new FormData()
                data.append('file', file)
                this.$http.post('https://cloudapis.digicollect.com/external/upload_file', data, {
                        onUploadProgress: function (progressEvent) {
                            let progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent
                                .total));
                            if (progress < 100) {
                                attachment.progress = progress;
                            }
                        }.bind(this)
                    })
                    .then(response => {
                        let resumable_url = response.data.url;
                        attachment.url = resumable_url;
                        attachment.progress = 100;
                        attachment.uploading = false;
                        this.isUploadingInProgress = false;
                        delete attachment['source'];
                        setTimeout(() => {
                            // this.saveFiles();
                        }, 500);
                    })
                    .catch(error => {
                    })
            },
            //API call to set the local time into the start and end date and time
            async loadLocalTime() {
                if(this.editPreview == false){
                    //this.ajaxCallInProgress = true
                    try {
                        let response = await this.getLocalTime()
                        let data = response.response;
                        //Start Date & Time
                        this.meeting_start_date = data.start_date
                        this.meeting_start_time = data.start_time
                        this.meeting_end_date = data.end_date
                        this.meeting_end_time = data.end_time
                        let value_n = data.start_date
                        let value_n_split = value_n.split("/")
                        var date1 = value_n_split[2] + '-' + value_n_split[1] + '-' + value_n_split[0];
                        let d_obj = new Date(date1 + ' ' + '00:00:00');
                        this.not_before_start_date = d_obj;
                    } catch (error) {
                        //this.ajaxCallInProgress = false
                    }
                }
                //this.ajaxCallInProgress = false
            },
            //select the status of the customer
            /**@params = event, @params = index*/
            selectCustomerStatus(event, index) {
                this.createJson.external_attendees[index].status = event;
                this.$forceUpdate();
            },
            //redirect tot he lsit view of call reports
            backToListView() {
                // this.$router.go(-1)
                this.$router.push('/callreportlist')
            },
            //Redirect to the ssales settings
            changeView() {
                let sales = true
                let routeData = this.$router.resolve({
                    name: 'Settings',
                    query: {
                        sales: sales
                    }
                });
                window.open(routeData.href, '_blank');
            },
            //API call of copy call report
            /**@params = id */
            async copyCallReport(id) {
                try {
                    this.ajaxCallInProgress = true;
                    let params ={
                        id: id,
                        source:'',
                        category:this.createJson.call_report_category
                    }
                    let res = await this.copyCallReportById(params);
                    this.createJson = res.response;
                    if(this.createJson.hasOwnProperty("vendor_info")){
                        if (this.createJson.vendor_info.length < 1) {
                            this.createJson.vendor_info = [{
                                vendor_name: "",
                                vendor_primary_attendee:"",
                                is_vendor_loading:false,
                                is_vendor_expanded:true
                            }]
                        } else{
                            this.createJson.vendor_info.forEach((vendor_data, vendor_data_index)=>{
                                this.createJson.vendor_info[vendor_data_index].vendor_name = {
                                    _id: vendor_data.id,
                                    company_name: vendor_data.name
                                }
                                vendor_data['is_vendor_expanded'] = true;
                                vendor_data['is_vendor_loading'] = false;
                                delete vendor_data.name
                                delete vendor_data.id
                            })
                        }
                    }
                    this.createJson.meeting_attachments.forEach((el, index) => {
                        this.total_file_size = this.total_file_size + el.size
                    })

                    if(this.editPreview == false){
                        setTimeout(() => {
                            let value = this.createJson.start_date.split("/")
                            let value1 = this.createJson.end_date.split("/")
                            var date1 = value[1] + '/' + value[0] + '/' + value[2];
                            var date2 = value1[1] + '/' + value1[0] + '/' + value1[2];
                            this.meeting_start_date = date1
                            this.meeting_start_time = this.createJson.start_time
                            this.meeting_end_date = date2
                            this.meeting_end_time = this.createJson.end_time
                            let value_n = this.createJson.start_date
                            let value_n_split = value_n.split("/")
                            var date1 = value_n_split[2] + '-' + value_n_split[1] + '-' + value_n_split[0];
                            let d_obj = new Date(date1 + ' ' + '00:00:00');
                            this.not_before_start_date = d_obj;
                        }, 500);
                        this.loadUTCTime();
                    }
                    this.meeting_location_vmodel = this.createJson.meeting_location.street + ((this.createJson
                            .meeting_location.street).length > 0 ? "," : '') + this.createJson
                        .meeting_location.city + ((this.createJson.meeting_location.city).length > 0 ? "," : '') +
                        this.createJson.meeting_location.state + ((this.createJson.meeting_location.state).length >
                            0 ? "," : '') + this
                        .createJson.meeting_location.zip_code + ((this.createJson.meeting_location.zip_code)
                            .length > 0 ? "," : '') + this.createJson.meeting_location.country;
                    if (this.createJson.meeting_attachments.length) {
                        if (this.editPreview == false) {
                            this.attachments = this.createJson.meeting_attachments;
                        } else {
                            if (localStorage.hasOwnProperty("attachments")) {
                                this.attachments = JSON.parse(localStorage.getItem("attachments"));
                                this.$forceUpdate()
                            }
                        }
                    }
                    if (!this.createJson.hasOwnProperty("owner_email")) {
                        Object.assign(this.createJson, {
                            owner_email: "-",
                        });
                    }
                    if (this.createJson.owner_name) {
                        this.createJson.owner_name = {
                            full_name: this.createJson.owner_name,
                            email: this.createJson.owner_email,
                        };
                    }
                    if (this.createJson.recipient_email.length > 0) {
                        this.createJson.recipient_email.forEach((email, index) => {
                            this.createJson.recipient_email[index] = {
                                email: email
                            };
                        });

                    }
                    if (this.createJson.lead_info.length < 1) {
                        this.createJson.lead_info = [{
                            id: "",
                            name: "",
                            company_name: "",
                            status:""  ,
                            is_lead_loading:false,
                            is_expanded:true
                        }]
                    } else{
                        this.createJson.lead_info.forEach((x, index) => {

                            this.createJson.lead_info[index] = ({
                                id: x.id,
                                name: {
                                    full_name: x.name
                                },
                                company_name: x.company_name,
                                status:x.status ,
                                is_lead_loading:false,
                                is_expanded:true
                            });
                        });
                    }

                    if (this.createJson.internal_company.other_attendees) {
                        this.createJson.internal_company.other_attendees.forEach((email, index) => {
                            this.createJson.internal_company.other_attendees[index] = {
                                email: email.email_id,
                                full_name: email.full_name
                            };

                        });
                    }
                    if(this.createJson.hasOwnProperty("external_attendees")){
                        if(this.createJson.external_attendees.length < 1){
                            this.createJson.external_attendees = [{
                                company_name: "",
                                primary_employee: "",
                                secondary_employees: [],
                                department: "",
                                branch: "",
                                status: "",
                                id:"",
                                is_cust_expanded:true,
                            }]
                        }
                        else {
                            this.createJson.external_attendees.forEach((item, index) => {
                                if(item.hasOwnProperty('secondary_employees')) {
                                    // item.secondary_employees.forEach((element, item_index) => {
                                    //     item.secondary_employees[item_index] = {
                                    //         primary_email: element
                                    //     };
                                    // });
                                    let secondary_list = []
                                    if (Array.isArray(item.secondary_employees)) {
                                        secondary_list = item.secondary_employees
                                    } else if (item.secondary_employees) {
                                        secondary_list = [item.secondary_employees]
                                    }
                                    item.secondary_employees = secondary_list.map((element) => {
                                        if (element && element.primary_email && typeof element.primary_email == 'string') {
                                            return { primary_email: element.primary_email }
                                        } else if (typeof element == 'string' && element != '') {
                                            return { primary_email: element }
                                        }
                                        return null
                                    }).filter((element) => element)
                                }
                                this.createJson.external_attendees[index] = {
                                    branch: item.branch,
                                    department: item.department,
                                    company_name: {
                                        customer_name: item.name,
                                        id:item.id
                                    },
                                    primary_employee: {
                                        primary_email:item.primary_employee
                                    },
                                    // secondary_employees: item.secondary_employees || '',
                                    secondary_employees: item.secondary_employees || [],
                                    status: item.status,
                                    is_cust_expanded:true
                                }
                                this.showExternal.push(index)
                            });
                        }
                    }
                    else {
                        Object.assign(this.createJson, {
                            external_attendees: [{
                                company_name: "",
                                primary_employee: "",
                                secondary_employees: [],
                                department: "",
                                branch: "",
                                status: "",
                                id:"",
                                is_cust_expanded:true
                            }, ],
                        });
                    }
                    if (this.createJson.contact_info.length < 1) {
                        this.createJson.contact_info = [{
                            id: "",
                            name: "",
                            company_name: "",
                            is_contact_loading:false,
                            is_contact_expanded:true
                        }]
                    } else{
                        this.createJson.contact_info.forEach((x, index) => {
                            this.createJson.contact_info[index] =({
                                id: x.id,
                                name: {
                                    full_name: x.name
                                },
                                company_name: x.company_name,
                                is_contact_loading:false,
                                is_contact_expanded:true
                            });
                        });
                        //this.showContactDetails.push(index)
                    }
                    if (this.createJson.recipient_email.length < 1) {
                        this.createJson.recipient_email = [{
                            individual:[],
                            team:[]
                        }]
                    } else{
                        if(this.createJson.recipient_email.hasOwnProperty('individual')){
                            this.createJson.recipient_email.individual.forEach((element, item_index) => {
                                this.createJson.recipient_email.individual[item_index] = {
                                    email: element
                                };
                            });
                        }
                        if(this.createJson.recipient_email.hasOwnProperty('team')){
                            this.createJson.recipient_email.team.forEach((element, item_index) => {
                                this.createJson.recipient_email.team[item_index] = {
                                    email_id: element
                                };
                            });
                        }
                    }
                    if (this.createJson.permissions.length < 1) {
                        this.createJson.permissions = [{
                            individual:[],
                            team:[]
                        }]
                    } else{
                        if(this.createJson.permissions.hasOwnProperty('individual')){
                            this.createJson.permissions.individual.forEach((element, item_index) => {
                                this.createJson.permissions.individual[item_index] = {
                                    email: element.email_id,
                                    id:element.id,
                                    name:element.name
                                };
                            });
                            localStorage.setItem("individual_data",JSON.stringify(this.createJson.permissions.individual))
                            this.user_ids_ind = this.createJson.permissions.individual.map(x => {return x.id})
                        }
                        if(this.createJson.permissions.hasOwnProperty('team')){
                            this.createJson.permissions.team.forEach((element, item_index) => {
                                this.createJson.permissions.team[item_index] = {
                                    email_id: element.email_id,
                                    id:element.id,
                                    name:element.name
                                };
                            });
                            localStorage.setItem("team_data",JSON.stringify(this.createJson.permissions.team))
                        }
                    }
                    if (!this.createJson.hasOwnProperty("sales_target")) {
                        this.createJson.sales_target = {
                            forecast: [{
                                product_code: "",
                                customer_id: "",
                                branch: "",
                                department: "",
                                product: "",
                                target_year: "",
                                target: {
                                    jan: 0,
                                    feb: 0,
                                    mar: 0,
                                    apr: 0,
                                    may: 0,
                                    jun: 0,
                                    jul: 0,
                                    aug: 0,
                                    sept: 0,
                                    oct: 0,
                                    nov: 0,
                                    dec: 0,
                                    sum: 0,
                                },
                            }, ],
                        };
                    } else {
                        this.createJson.sales_target.forecast.forEach((x, index) => {
                            if (x.product_id) {
                                x.product = x.product
                                // {
                                //     name: x.product,
                                //     _id: x.product_id,
                                //     product_code: "",
                                //     sub_category: x.sub_category || '',
                                //     category: x.category || '',
                                // };
                            } else {
                                x.product = x.product
                                // {
                                //     name: x.product,
                                //     _id: '',
                                    // product_code: x.product_code,
                                    // sub_category: x.sub_category,
                                    // category: x.category,
                                // };
                            }
                            if(x.customer){
                                x.customer_id = {
                                    customer_name: x.customer
                                }
                            }
                            if (x.sales_person) {
                                x.sales_person = {
                                    full_name: x.sales_person
                                }
                            } else {
                                x.sales_person = null
                            }
                            this.showSales.push(index)
                        });
                    }

                    if (this.createJson.meeting_notes_table.length) {
                        this.addTableNotes = true;
                    }
                    if(this.createJson.follow_ups.length < 1){
                        this.createJson.follow_ups = [{
                            products: "",
                            assigned_to: "",
                            notes: "",
                            due_date: "",
                            price: null,
                            time:"",
                            is_follow_expanded:true
                        }]
                    } else if (this.createJson.hasOwnProperty("follow_ups")) {
                            if (this.createJson.follow_ups.length) {
                                this.createJson.follow_ups.forEach((x, index) => {
                                    x['is_follow_expanded'] = true
                                    //this.showFollowUps.push(index)
                                    this.showFollowUpsNotes.push(index);
                                    this.$forceUpdate()
                                });
                            } else {
                                this.createJson.follow_ups.push({
                                    products: "",
                                    assigned_to: "",
                                    notes: "",
                                    due_date: "",
                                    price: null,
                                    time:"",
                                    is_follow_expanded:true,
                                }, );
                            }
                        }
                    if (this.editPreview == false) {
                        if(this.createJson.follow_ups.length < 1){
                            this.createJson.follow_ups = [{
                                products: "",
                                assigned_to: "",
                                notes: "",
                                due_date: "",
                                price: null,
                                time:"",
                                is_follow_expanded:true
                            }]
                        }
                        else if (this.createJson.hasOwnProperty("follow_ups")) {
                            if (this.createJson.follow_ups.length) {
                                this.createJson.follow_ups.forEach((x, index) => {

                                    this.createJson.follow_ups[index] = {
                                        assigned_to: {
                                            id: x.assigned_to.id || "",
                                            full_name: x.assigned_to.full_name || "",
                                        },
                                        due_date: x.due_date,
                                        notes: x.notes,
                                        time: x.time,
                                        price: x.price,
                                        product: products,
                                        is_follow_expanded:true

                                    };
                                    //this.showFollowUps.push(index)
                                    this.showFollowUpsNotes.push(index);
                                    this.$forceUpdate()
                                });
                            } else {
                                this.createJson.follow_ups.push({
                                    products: "",
                                    assigned_to: "",
                                    notes: "",
                                    due_date: "",
                                    price: null,
                                    time:"",
                                    is_follow_expanded:true,
                                }, );
                            }
                        }

                    } else {
                        setTimeout(() => {
                            if (localStorage.hasOwnProperty("callReportReviewData")) {
                                this.createJson = JSON.parse(localStorage.getItem("callReportReviewData"));
                                if (this.createJson.follow_ups) {
                                    if (this.createJson.follow_ups.length) {
                                        this.createJson.follow_ups.forEach((x, index) => {
                                            x['is_follow_expanded'] = true
                                            this.$forceUpdate()
                                           // this.showFollowUps.push(index);
                                            this.showFollowUpsNotes.push(index);
                                            this.$forceUpdate()
                                        });
                                    }
                                }
                            }
                        }, 1000);
                        this.$forceUpdate()
                    }

                    this.ajaxCallInProgress = false;
                } catch (reason) {
                    this.ajaxCallInProgress = false;
                }
        },
            getLocation() {
                if (navigator.geolocation) {
                    // timeout at 60000 milliseconds (60 seconds)
                    var options = {
                        enableHighAccuracy: false,
                        timeout: 30000, // milliseconds (30 seconds)
                        maximumAge: 600000
                    }; // milliseconds (10 minutes)
                    navigator.geolocation.getCurrentPosition(
                        this.showLocation,
                        this.errorHandler,
                        options
                    );
                } else {
                    alert("Sorry, browser does not support geolocation");
                }
            },
            showLocation(position) {
                this.latitude = position.coords.latitude;
                this.longitude = position.coords.longitude;
                let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
                let calllatlong = axios.create();
                delete calllatlong.defaults.headers.common['Authorization'];
                calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
                        latlongvalue +
                        "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
                    .then(response => {
                        let address = response.data.results[0].formatted_address.split(", ");
                        this.showAddress = true;
                        this.createJson.meeting_location.street =
                            address[address.length - 3] || "";
                        this.createJson.meeting_location.township =
                            address[address.length - 3] || "";
                        this.createJson.meeting_location.city = address[address.length - 3] || "";
                        let statezip = address[address.length - 2] ?
                            address[address.length - 2].split(" ") : ["", ""];
                        this.createJson.meeting_location.zip_code = statezip[0].match(/^[0-9]+$/) ?
                            statezip[0] :
                            statezip[1].match(/^[0-9]+$/) ?
                            statezip[1] :
                            "";
                        this.createJson.meeting_location.state = statezip[0].match(/^[a-zA-Z]+$/) ?
                            statezip[0] :
                            statezip[1].match(/^[a-zA-Z]+$/) ?
                            statezip[1] :
                            "";
                        if (address[address.length - 1].includes("-")) {
                            let countrySelected = address[address.length - 1].split(" - ");
                            countrySelected.forEach(x => {
                                if (this.countries.includes(x)) {
                                    this.createJson.meeting_location.country = x;
                                } else {
                                    this.createJson.meeting_location.country = "";
                                }
                            });
                        } else {
                            this.createJson.meeting_location.country = address[address.length - 1];
                        }

                        this.meeting_location_vmodel = this.createJson.meeting_location.street + ", " + this.createJson.meeting_location.township + ", " +
                            this
                            .createJson.meeting_location.city + ", " + this.createJson.meeting_location
                            .state +
                            ", " + this.createJson.meeting_location.zip_code + ", " + this.createJson
                            .meeting_location.country;
                    })
                    .catch(e => {
                        // this.errors.push(e)
                    });
            },
            errorHandler(err) {
                if (err.code == 1) {
                    // alert("Error: Access is denied!");
                } else if (err.code == 2) {
                    // alert("Error: Position is unavailable!");
                }
            },
            addOneTable() {
                this.createJson.meeting_notes_table.push({
                    meeting_notes_table_name: "",
                    meeting_notes_table_row: 0,
                    meeting_notes_table_column: 0,
                    meeting_notes_table_data: [],
                });
            },
            //delete Attachments
            /**@params =  attachment, @params = index*/
            deleteAttachment(attachment, index) {
                this.total_file_size = this.total_file_size - attachment.size
                this.attachments.splice(index, 1);
                //document.getElementById("multiple").value = "";
                if (attachment.url == undefined) {
                    this.check_attachments = false;
                }
            },
            //update the branch data
            /**@params = index */
            updateBranch(index) {
                this.ext_company_id = []
                this.createJson.external_attendees[index].primary_employee = [];
                this.createJson.external_attendees[index].secondary_employees = [];
                this.createJson.external_attendees[index].employees = [];
                this.createJson.external_attendees[index].employee = "";
                this.createJson.external_attendees[index].department = "";
                this.createJson.external_attendees[index].branch = "";
            },
            updateVendorBranch(data, index){
                this.createJson.vendor_info[index].vendor_primary_attendee = data.email_id;
            },
            checkVendorName(index){
                if(this.createJson.vendor_info[index].vendor_name == null){
                    this.createJson.vendor_info[index].vendor_primary_attendee = ""
                }
            },
            //update the sales data
            /**@params = index */
            updateSales(index) {
                (this.createJson.sales_target.forecast[index].branch = ""),
                (this.createJson.sales_target.forecast[index].department = "");
            },
            //Reset the External company
            /**@params = index */
            resetExternalCo(index) {
                this.createJson.external_attendees[index].company_name = [];
                this.createJson.external_attendees[index].department = "";
                this.createJson.external_attendees[index].branch = "";
                this.createJson.external_attendees[index].status = "";
                (this.createJson.external_attendees[index].primary_employee = ""),
                (this.createJson.external_attendees[index].secondary_employees = []);
            },
            //Reset the Internal company
            resetInternalCo() {
                this.createJson.internal_company.other_attendees = [];
                this.createJson.internal_company.company_attendees = [];

                this.internalPrimaryAttendee = "";
                this.$validator.reset();
            },
            //Reset the Email Recepients
            resetEmailRecipients() {
                this.createJson.recipient_email.individual = [];
                this.createJson.recipient_email.team = [];
                this.createJson.send_copy_to_me = '';
                this.$validator.reset();
            },
            //Reset the Meeting
            resetMeting() {
                this.createJson.meeting_type = "";
                this.createJson.meeting_location = {
                    street: "",
                    city: "",
                    township: "",
                    state: "",
                    zip_code: "",
                    country: "",
                    address_type: "",
                };
                this.meeting_location_vmodel = "";
                this.createJson.meeting_time_from = new Date();
                this.createJson.meeting_time_to = new Date();
                this.manualFallback = false,
                // this.convertTimeDate()
                this.loadLocalTime()
                this.$validator.reset();
            },
            //Reset the FollowUp
            /**@params = index */
            resetFollowUp(index) {
                this.createJson.follow_ups[index].products = "";
                this.createJson.follow_ups[index].assigned_to = "";
                this.createJson.follow_ups[index].price = null;
                this.createJson.follow_ups[index].notes = "";
                this.createJson.follow_ups[index].due_date = "";
                this.createJson.follow_ups[index].time = "";
            },
            //Reset the Sales
            /**@params = index */
            resetSales(index) {
                this.createJson.sales_target.forecast[index].customer_id = "";
                this.createJson.sales_target.forecast[index].branch = "";
                this.createJson.sales_target.forecast[index].department = "";
                this.createJson.sales_target.forecast[index].product = "";
                this.createJson.sales_target.forecast[index].target_year = "";
                this.createJson.sales_target.forecast[index].uom = "";
                this.createJson.sales_target.forecast[index].sales_person = "";
                this.createJson.sales_target.forecast[index].target = {
                    jan: 0,
                    feb: 0,
                    mar: 0,
                    apr: 0,
                    may: 0,
                    jun: 0,
                    jul: 0,
                    aug: 0,
                    sept: 0,
                    oct: 0,
                    nov: 0,
                    dec: 0,
                    sum: 0,
                };
            },
            //reset the values of the reciver details
            /**@params = index */
            resetReceiverDetails(index) {
                this.createJson.lead_info[index].id = ""
                this.createJson.lead_info[index].name = ""
                this.createJson.lead_info[index].company_name = ""
                this.createJson.lead_info[index].status = ""
            },
            //reset the values of the contact details
            /**@params = index */
            resetContactDetails(index) {
                this.createJson.contact_info[index].name = ""
                this.createJson.contact_info[index].company_name = ""
                this.createJson.contact_info[index].id = ""
            },
            disabledDays(value) {
                const date = new Date(value);
                const year = date.getFullYear();
                return year >= 2031;
            },
            //cancel the sales
            cancelsales() {
                this.meetingnotestab = true;
            },
            //cancel the follow ups data
            cancelfollow() {
                if (this.createJson.call_report_type == "Sales Meeting") {
                //this.createJson.call_report_category == "Sales Meeting"
                    this.salestargettab = true;
                } else {
                   // this.createJson.call_report_category == "Review Meeting"
                    this.meetingnotestab = true;
                }
            },
            //cancel the meeting
            cancelmeeting() {
                this.callreporttab = true;
            },
            //checking the validation before go tot he next page
            nextvalidatecall() {
                //this.search_term = ""
                this.$validator.validateAll().then(result => {
                    if (this.meeting_location_vmodel != "") {
                        if (result) {
                            this.firstTab = true;
                            this.loadUTCTime()
                            setTimeout(() => {
                                this.validateDateTime()
                            }, 1000);
                        }
                    } else {
                        this.warning_msg = "Please Enter Mandatory Fields"
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                });
            },
            //save the call report
            savecallReport() {
                this.$validator.validateAll().then(result => {
                    if (Object.values(this.createJson.meeting_location.country).length !== 0) {
                        if (result) {
                            this.createJson.status = "draft";
                            this.loadUTCTime()
                            setTimeout(() => {
                                this.saveDataconfirm();
                            }, 2000);
                        }
                    } else {
                        this.warning_msg = "Please Enter Mandatory Fields"
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                });
            },
            //Draft the call report
            savecallReportclose() {
                this.$validator.validateAll().then(result => {
                    if (Object.values(this.createJson.meeting_location.country).length !== 0) {
                        if (result) {
                            this.createJson.status = "draft";
                            this.saveandclose = true;
                            this.loadUTCTime();
                            setTimeout(() => {
                                this.saveDataconfirm();
                            }, 2000);

                        }
                    } else {
                        this.warning_msg = "Please Enter Mandatory Fields"
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 3000);
                    }
                });
            },
            //save the meeting info data
            saveMeetingInfo() {
                this.createJson.status = "draft";
                this.saveDataconfirm();
            },
            //save and draft the meeting info data
            saveMeetingInfoClose() {
                this.createJson.status = "draft";
                this.saveandclose = true;
                this.saveDataconfirm();
            },
            //save followup data
            savefollowup() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.createJson.status = "draft";
                        this.saveDataconfirm();
                    }
                });
            },
            //save and draft the followup data
            savefollowupClose() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.createJson.status = "draft";
                        this.saveandclose = true;
                        setTimeout(() => {
                            this.saveDataconfirm();
                        }, 1000);
                    }
                });
            },
            //save the sales target
            savesalestarget() {
                if ("sales_target" in this.createJson) {
                    this.createJson.sales_target.forecast.forEach((x, index) => {
                        if (!(x.target_year)) {
                            this.noFiscalYear.push(index);
                        }
                    });
                }
                if (this.noFiscalYear) {
                    this.createJson.status = "draft";
                    this.saveDataconfirm();
                }
            },
            //save and draft the sales target
            savesalestargetclose() {
                if ("sales_target" in this.createJson) {
                    this.createJson.sales_target.forecast.forEach((x, index) => {
                        if (!(x.target_year)) {
                            this.noFiscalYear.push(index);
                        }
                    });
                }
                if (this.noFiscalYear) {
                    this.createJson.status = "draft";
                    this.saveandclose = true;
                    this.saveDataconfirm();
                }
            },
            //check the meeting validation
            meetingValidateNext() {
                //this.search_term = ""
                this.$validator.validateAll().then(result => {
                    if (result) {
                        if (this.createJson.call_report_category == "Sales Meeting") {
                            this.salestargettab = true;
                            EventBus.$emit("scrollToTop");
                        } else {
                            this.followuptab = true;
                            EventBus.$emit("scrollToTop");
                        }
                    }
                });
            },
            //checking the validation to sales
            salesValidateNext() {
                //this.search_term = ""
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.followuptab = true;
                        EventBus.$emit("scrollToTop");
                    }
                });
            },
            //save call report data
            saveData() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        //this.loadUTCTime();
                        this.disableSend = true;
                        this.createJson.status = "sent";
                        this.saveandclose = true;
                        this.createJson['meeting_start_date'] = this.meeting_start_date;
                        this.createJson['meeting_start_time'] = this.meeting_start_time;
                        this.createJson['meeting_end_date'] = this.meeting_end_date;
                        this.createJson['meeting_end_time'] = this.meeting_end_time;
                        localStorage.setItem("callReportReviewData", JSON.stringify(this
                            .createJson));
                        localStorage.setItem("meetingId", JSON.stringify(this.meeting_id));
                        localStorage.setItem("scheduleMeeting", JSON.stringify(this.schedule_meeting));
                        localStorage.setItem("internalCompanyObject", JSON.stringify(this
                            .internalCompanyObject));
                        localStorage.setItem("attachments", JSON.stringify(this.attachments));
                        if (this.$route.params.id) {
                            localStorage.setItem("call_report_edit_create", 'edit');
                            this.$router.push("/copycallreportreview/" + this.$route.params.id);
                        } else {
                            localStorage.setItem("call_report_edit_create", 'create');
                            this.$router.push("/callreportreview");
                        }
                    }
                });
            },
            //redirecting to the  call report tab
            gotocallreporttab() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.callreporttab = true;
                    }
                });
            },
            //redirecting to the meeting tab
            gotomeetingnotestab() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.meetingnotestab = true;
                    }
                });
            },
            //redirecting to follow up tab
            gotofollowuptab() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.followuptab = true;
                    }
                });
            },
            //redirecting to sales target tab
            gotosalestargettab() {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.salestargettab = true;
                    }
                });
            },
            //set the sales target format
            salestargetFormat() {
                let data = this.createJson.sales_target.forecast;
                const result = [];
                const map = new Map();
                for (const item of data) {
                    if (!map.has(item)) {
                        map.set(item, true); // set any value to Map
                        result.push({
                            department: item.department,
                            branch: item.branch._id,
                            customer_id: item.customer_id._id,
                            product: item.product,
                            target: item.target,
                            target_year: item.target_year,
                            product_code:  "",
                        });
                    }
                }
                this.compressed_sales_target = result;
            },
            //save the data of the call report into localstorage
            async saveDataconfirm() {
                let copied_create_json_data = JSON.parse(JSON.stringify(this.createJson));
                try {
                    //checking the attachments data
                    let attachmentstosend = [];
                    if (this.attachments.length) {
                        this.attachments.forEach(x => {
                            attachmentstosend.push({
                                name: x.name,
                                size: Number(x.size),
                                url: x.url,
                            });
                        });
                    }
                    if (this.createJson.status == "draft") {
                        this.loadingMessage = "Saving Call Report Please Wait...";
                        this.$modal.show("loader_modal");
                        let external_attendees_data = [];
                        //deep copied the exteranl attendees data
                        if (copied_create_json_data.external_attendees && copied_create_json_data.external_attendees.length) {
                            copied_create_json_data.external_attendees.forEach(x => {
                                // x.secondary_employees.forEach((element, index) => {
                                //     x.secondary_employees[index] = element.primary_email
                                // });
                                if (Array.isArray(x.secondary_employees)) {
                                    x.secondary_employees.forEach((element, index) => {
                                        x.secondary_employees[index] = element && element.primary_email ? element.primary_email : (typeof element == 'string' ? element : '')
                                    });
                                    x.secondary_employees = x.secondary_employees.filter(el => el)
                                } else {
                                    x.secondary_employees = []
                                }
                                //pushing the external attendees data
                                external_attendees_data.push({
                                    branch: x.branch,
                                    name: x.company_name.customer_name || '',
                                    department: x.department,
                                    primary_employee: x.primary_employee.primary_email,
                                    secondary_employees: x.secondary_employees,
                                    status: x.status,
                                    id:x.company_name.id || ''
                                });
                            });
                        };
                        //adding the internal company data
                        let internal_company_data = {};
                        if (Object.keys(this.createJson.internal_company).length > 0) {
                            if (this.$route.params.id) {
                                Object.assign(internal_company_data, {
                                    company_attendees: [],
                                    other_attendees: [],
                                });
                            } else {
                                Object.assign(internal_company_data, {
                                    company_attendees: [],
                                    other_attendees: [],
                                });
                            }
                            this.createJson.internal_company.company_attendees.forEach(x => {
                                internal_company_data.company_attendees.push({
                                    email_id: x.email ? x.email : x.email_id,
                                    full_name: x.full_name || '',
                                });
                            });
                            this.createJson.internal_company.other_attendees.forEach(x => {
                                internal_company_data.other_attendees.push({
                                    email_id: x.email ? x.email : x.email_id,
                                    full_name: x.full_name || '',
                                });
                            });
                        };
                         //passing the followup data to save
                        let follow_ups_data = [];
                        if (this.createJson.follow_ups && this.createJson.follow_ups.length) {
                            this.createJson.follow_ups.forEach((x, index) => {
                                if(x.products){
                                    let products = []
                                    x.products.forEach((product, pro_index) => {
                                        products.push({
                                            id: product._id ? product._id : product.id,
                                            name: product.name,
                                        })
                                    })
                                    follow_ups_data.push({
                                        assigned_to: {
                                            id: x.assigned_to.user_id ? x.assigned_to.user_id : x.assigned_to.id,
                                            full_name: x.assigned_to.full_name || "",
                                        },
                                        due_date: x.due_date,
                                        status: x.status,
                                        notes: x.notes,
                                        products: products,
                                        time: x.time,
                                        price: x.price
                                    });
                                }

                            });

                        };
                        //passing the lead info data to save
                        let lead_info_data =[]
                        if (this.createJson.lead_info && this.createJson.lead_info.length) {
                            this.createJson.lead_info.forEach((x, index) => {
                                lead_info_data.push({
                                    id: x.id,
                                    name: x.full_name || '',
                                    company_name: x.company_name,
                                    status:x.status,
                                });
                            });
                        }
                        //passing the contact info data to save
                        let contact_info_data =[]
                        if (this.createJson.contact_info && this.createJson.contact_info.length) {
                            this.createJson.contact_info.forEach((x, index) => {
                                contact_info_data.push({
                                    id: x.id,
                                    name: x.full_name || '',
                                    company_name: x.company_name
                                });
                            });
                        }
                        let vendor_info_data =[]
                        if(this.createJson.hasOwnProperty('vendor_info')) {
                            if (this.createJson.vendor_info && this.createJson.vendor_info.length) {
                                this.createJson.vendor_info.forEach((x, index) => {
                                    vendor_info_data.push({
                                        id: x.vendor_name._id,
                                        name: x.vendor_name.company_name || '',
                                        vendor_primary_attendee: x.vendor_primary_attendee
                                    });
                                });
                            }
                        }
                        //passing the sales target data to save
                        let sales_target_data = {
                            forecast: [],
                            document_type: "forecast",
                        };
                        //checking the sales target property if present or not
                        if (!this.createJson.hasOwnProperty("sales_target")) {
                            this.createJson['sales_target_data'] = []
                        }
                        //if present then assignign the data
                        else if (this.createJson.sales_target.forecast && this.createJson.sales_target.forecast.length) {
                            this.createJson.sales_target.forecast.forEach((x, index) => {
                                if (x.customer !== '') {
                                    sales_target_data.forecast.push({
                                        target_year: x.target_year || "",
                                        customer: x.customer_id ? x.customer_id.customer_name : "",
                                        branch: x.branch || "",
                                        department: x.department,
                                        // product: x.product.name,
                                        product: x.product,
                                        product_code: "",
                                        product_id: x.product._id ? x.product._id : x.product.id,
                                        category: x.product.category,
                                        sub_category: x.product.sub_category,
                                        sales_person: x.sales_person ? x.sales_person.full_name : '',
                                        uom: x.uom,
                                        target: {
                                            jan: x.target.jan,
                                            feb: x.target.feb,
                                            mar: x.target.mar,
                                            apr: x.target.apr,
                                            may: x.target.may,
                                            jun: x.target.jun,
                                            jul: x.target.jul,
                                            aug: x.target.aug,
                                            sept: x.target.sept,
                                            oct: x.target.oct,
                                            nov: x.target.nov,
                                            dec: x.target.dec,
                                        },
                                    });
                                } else {
                                    sales_target_data.forecast.push({
                                        target_year: "",
                                        customer: "",
                                        branch: "",
                                        department: "",
                                        product: "",
                                        product_code: "",
                                        product_id: "",
                                        category: "",
                                        sub_category: "",
                                        sales_person: '',
                                        uom: "",
                                        target: {
                                            jan: x.target.jan,
                                            feb: x.target.feb,
                                            mar: x.target.mar,
                                            apr: x.target.apr,
                                            may: x.target.may,
                                            jun: x.target.jun,
                                            jul: x.target.jul,
                                            aug: x.target.aug,
                                            sept: x.target.sept,
                                            oct: x.target.oct,
                                            nov: x.target.nov,
                                            dec: x.target.dec,
                                        },
                                    });
                                }
                                this.showSales.push(index)
                            });
                        }
                        //assigning recipient email individual data into the recipientEmailIndividual, avoiding to modify the structure of original data
                        let recipientEmailIndividual =[]
                        if (this.createJson.recipient_email.individual && this.createJson.recipient_email.individual.length) {
                            recipientEmailIndividual = JSON.parse(JSON.stringify(this.createJson.recipient_email.individual));
                            recipientEmailIndividual.forEach((x, index) => {
                                recipientEmailIndividual[index] = x.email
                            })
                        }
                        //assigning recipient email team data into the recipientEmailTeam, avoiding to modify the structure of original data
                        let recipientEmailTeam = []
                        if (this.createJson.recipient_email.team && this.createJson.recipient_email.team.length) {
                            recipientEmailTeam = JSON.parse(JSON.stringify(this.createJson.recipient_email.team));
                            recipientEmailTeam.forEach((x, index) => {
                                recipientEmailTeam[index] = x.email_id
                            })
                        }
                        //assigning permission individual data into the permissionsEmailIndividual, avoiding to modify the structure of original data
                        let permissionsEmailIndividual =[]
                        let permission_ind_data =[]
                        if (this.createJson.permissions.individual) {
                            permissionsEmailIndividual = JSON.parse(JSON.stringify(this.createJson.permissions.individual))
                            if (permissionsEmailIndividual && permissionsEmailIndividual.length) {
                                permissionsEmailIndividual.forEach((x, index) => {
                                    permission_ind_data.push({
                                        email_id : x.email,
                                        id :x.user_id || x.id,
                                        name: x.full_name || x.name
                                    })
                                })
                            }
                        }
                        //assigning permission team data into the recipientEmailIndividual, avoiding to modify the structure of original data
                        let permissionsEmailTeam = []
                        let permission_team_data =[]
                        if (this.createJson.permissions.team) {
                            permissionsEmailTeam = JSON.parse(JSON.stringify(this.createJson.permissions.team))
                            if (permissionsEmailTeam && permissionsEmailTeam.length) {
                                permissionsEmailTeam.forEach((x, index) => {
                                    permission_team_data.push({
                                        email_id : x.email_id,
                                        id :x.id,
                                        name: x.full_name || x.name
                                    })
                                })
                            }
                        }
                        let params = {
                            _id: this.createJson._id || "",
                            title: this.createJson.title,
                            owner_email: this.createJson.owner_email,
                            owner_name: this.createJson.owner_name ? this.createJson.owner_name.full_name : "",
                            meeting_time_from: this.combinedFrom,
                            meeting_time_to: this.combinedTo,
                            meeting_type: this.createJson.meeting_type,
                            meeting_notes_subject: this.createJson.meeting_notes_subject,
                            call_report_type: this.createJson.call_report_type,
                            meeting_location: this.createJson.meeting_location,
                            internal_company: internal_company_data,
                            external_attendees: external_attendees_data,
                            follow_ups: follow_ups_data,
                            lead_info:lead_info_data,
                            contact_info:contact_info_data,
                            vendor_info:vendor_info_data,
                            receiver_type:this.createJson.receiver_type,
                            meeting_timezone: this.createJson.meeting_timezone.value,
                            meeting_notes: this.createJson.meeting_notes,
                            meeting_attachments: attachmentstosend,
                            sales_target: sales_target_data,
                            general_access:this.createJson.general_access,
                            recipient_email:{
                                individual : recipientEmailIndividual,
                                team : recipientEmailTeam
                            },
                            permissions: {
                                individual : permission_ind_data,
                                team : permission_team_data
                            },

                            status: this.createJson.status,
                            send_copy_to_me: this.createJson.send_copy_to_me,
                            author_name: this.createJson.author_name,
                            author_email: this.createJson.author_email,
                            meeting_notes_table: this.createJson.meeting_notes_table,
                            call_report_category: this.createJson.call_report_category,
                            branch_name: this.createJson.branch_name

                        };
                        //deleting the ids and other data after saving the created/copied/drafted call report

                        if (!(params._id)) {
                            delete params["_id"];
                        }
                        if (!(params.owner_name)) {
                            delete params["owner_name"];
                            delete params["owner_email"];
                        }
                        if (params.external_attendees.length) {
                            params.external_attendees.forEach(x => {
                                if (x.company_name == "") {
                                    params.external_attendees = params.external_attendees
                                        .filter(i => i !=
                                            x);
                                }
                            });
                        }
                        if (!params.external_attendees.length) {
                            delete params["external_attendees"];
                        }
                        if(this.createJson.receiver_type != 'customer') {
                            delete params["external_attendees"];
                        }
                        if (params.follow_ups.length) {
                            params.follow_ups.forEach(x => {
                                if (x.products == "") {
                                    params.follow_ups = params.follow_ups.filter(i => i !=
                                        x);
                                }
                            });
                        }
                        if (params.sales_target.forecast.length) {
                            params.sales_target.forecast.forEach(x => {
                                if (x.customer_id == "") {
                                    params.sales_target.forecast = params.sales_target
                                        .forecast.filter(i =>
                                            i != x);
                                }
                            });
                        }
                        if (!params.sales_target.forecast.length) {
                            params.sales_target = {};
                        }
                        //API call to save the call report
                        let res = await this.storeCallReport(params);
                        if (res.status_id == 1 && this.createJson.status == "draft") {
                            Object.assign(this.createJson, {
                                _id: res.id,
                            });
                            this.$modal.hide("loader_modal");
                            this.$swal({
                                text: "Call Report Saved Successfully",
                                type: "success",
                                confirmButtonText: "OK",
                                confirmButtonColor: "#005dae",
                            }).then(() => {
                                if (this.saveandclose) {
                                    localStorage.setItem("backtodraft", "yes");
                                    this.$router.push("/callreportlist");
                                }
                            });
                        } else {
                            this.$modal.hide("loader_modal");
                        }
                    }
                } catch (reason) {
                    this.disableSend = false;
                    this.$swal({
                        text: reason,
                        type: "warning",
                        confirmButtonText: "OK",
                        confirmButtonColor: "#005dae",
                    });
                }
            },
            async scheduleMeeting(){
                let params = {
                    "product_name": "CRM",
                    "_id": this.meeting_id,
                    "call_report_id": this.call_report_id,
                    "call_report" : true, 
                    "reminder_id": "" 
                }
                let res = await this.MeetingCallreports(params);
            },
            //show the time zone
            showTimezone() {
                this.timezoneShow = true;
                setTimeout(() => {
                    this.$modal.show("timezone_modal");
                }, 500);
            },
            //hide the time zone
            hidetimezone() {
                this.timezoneShow = false;
            },
            savenewtimezone(option) {
                this.timezoneShow = false;
                this.createJson.meeting_timezone = option.value;
            },
            removetimezone() {
                this.timezoneShow = false;
                this.createJson.meeting_timezone = {};
            },
            //Add the employee attendee data manually
            addTagEmployeeAttendees(newTag) {
                const element = newTag;
                if (String(element).match(this.email_regex)) {
                    this.optionsEmployeeAttendeesExternal.push({
                        email_id: element,
                    });
                    this.createJson.external_attendees[
                        this.indexToPass
                    ].secondary_employees.push({
                        email_id: element,
                    });
                } else {
                    this.$awn.success("As Your Email ID Was Not Valid It is Removed");
                    this.invalidEmail = true;
                    return;
                }
            },
             //Add the employee attendee primary data manually
            addTagEmployeeAttendeesPrimary(newTag) {
                const element = newTag;
                if (String(element).match(this.email_regex)) {
                    this.optionsEmployeeAttendeesExternal.push({
                        email_id: element,
                    });
                    this.createJson.external_attendees[
                        this.indexToPass
                    ].primary_employee = {
                        email_id: element,
                    };
                } else {
                    this.$awn.success("As Your Email ID Was Not Valid It is Removed");
                    this.invalidEmail = true;
                    return;
                }
            },
            //Add the employee attendee internal data manually
            addTagEmployeeAttendeesInternal(newTag) {
                const tag = {
                    email_id: newTag,
                    first_name: newTag.substring(0, 2) +
                        Math.floor(Math.random() * 10000000),
                };
                let element = tag.email_id;
                if (element["text"]) {
                    if (element["text"].match(this.email_regex)) {
                        this.optionsEmployeeAttendees.push(tag);
                        this.push_optionsEmployeeAttendeesInternal.push(tag);
                    } else {
                        this.invalidEmail = true;
                        this.$awn.success("As Your Email ID Was Not Valid It is Removed");
                        return;
                    }
                } else {
                    if (element.match(this.email_regex)) {
                        this.optionsEmployeeAttendees.push(tag);
                        this.push_optionsEmployeeAttendeesInternal.push(tag);
                    } else {
                        this.$awn.success("As Your Email ID Was Not Valid It is Removed");
                        this.invalidEmail = true;
                        return;
                    }
                }
            },
            //Add customerdata manually
            /**@params = data , @params = type */
            addCustomer(data,type) {
                this.optionsEmailRecipients.push({data,});
                const element =  data;
                if (String(element).match(this.email_regex)) {
                    if(type == 'individual'){
                        this.createJson.recipient_email.individual.push({
                            email: element
                        })
                    } else {
                        this.createJson.recipient_email.team.push({
                            email_id: element
                        })
                    }
                }
                else {
                    this.$awn.success("As Your Email ID Was Not Valid It is Removed");
                    this.invalidEmail = true;
                    return;
                }
            },
            //Add companies data manually
            /**@params = newTagCompanies */
            addTagCompanies(newTagCompanies) {
                this.companyList = [];
                const tag = {
                    company_name: newTagCompanies,
                };
                this.optionsCompanies.push(tag);
                this.companyList.push(tag);
            },
            setPlace (place) {
                this.manualFallback = true;
                this.meeting_location_vmodel = place.formatted_address;
                this.showAddress = true;
                let currentPlace = place;
                let address = place.formatted_address.split(", ");
                this.createJson.meeting_location.street =
                    address[address.length - 4] || "";
                this.createJson.meeting_location.township =
                    address[address.length - 3] || "";
                this.createJson.meeting_location.city = address[address.length - 3] || "";
                let statezip = address[address.length - 2] ?
                    address[address.length - 2].split(" ") : ["", ""];
                if (address[address.length - 1].includes("-")) {
                    let countrySelected = address[address.length - 1].split(" - ");
                    countrySelected.forEach(x => {
                        if (this.countries.includes(x)) {
                            this.createJson.meeting_location.country = x;
                        } else {
                            this.createJson.meeting_location.country = "";
                        }
                    });
                } else {
                    this.createJson.meeting_location.country = address[address.length - 1];
                }
                this.createJson.meeting_location.state = statezip[0].match(/^[a-zA-Z]+$/) ?
                    statezip[0] :
                    statezip[1].match(/^[a-zA-Z]+$/) ?
                    statezip[1] :
                    "";
                this.createJson.meeting_location.zip_code = statezip[0].match(/^[0-9]+$/) ?
                    statezip[0] :
                    statezip[1].match(/^[0-9]+$/) ?
                    statezip[1] :
                    "";
            },
            //show/hide the title section
            expandTitle() {
                if (!this.showTitle) {
                    this.showTitle = true;
                } else {
                    this.showTitle = false;
                }
            },
            //show/hide the title sales
            expandTitleSales() {
                if (!this.showTitleSales) {
                    this.showTitleSales = true;
                } else {
                    this.showTitleSales = false;
                }
            },
            //show/hide the external data
            /**@params = company */
            expandExternal(company) {
                company.is_cust_expanded = !company.is_cust_expanded
                this.$forceUpdate();
            },
            expandExternalVendor(vendor) {
                vendor.is_vendor_expanded = !vendor.is_vendor_expanded
                this.$forceUpdate();
            },
            //show/hide the contact
            /**@params = lead */
            expandLead(lead) {
                lead.is_expanded = !lead.is_expanded
                this.$forceUpdate();
            },
            //show/hide the contact
            expandContact(contact) {
                contact.is_contact_expanded = !contact.is_contact_expanded
                this.$forceUpdate();
            },
            //show/hide the internal
            expandInternal() {
                if (!this.showInternal) {
                    this.showInternal = true;
                } else {
                    this.showInternal = false;
                }
            },
            //show/hide the email recipients
            expandEmailRecipients() {
                if (!this.showEmailRecipients) {
                    this.showEmailRecipients = true;
                } else {
                    this.showEmailRecipients = false;
                }
            },
            //show/hide the permission tab
            expandPermission() {
                if (!this.showPermissions) {
                    this.showPermissions = true;
                } else {
                    this.showPermissions = false;
                }
            },
            //show/hide the meeting information tab
            expandMeetingInformation() {
                if (!this.showMeetingInformation) {
                    this.showMeetingInformation = true;
                } else {
                    this.showMeetingInformation = false;
                }
            },
            //show/hide meeting notes
            expandMeetingNotes() {
                if (!this.showMeetingNotes) {
                    this.showMeetingNotes = true;
                } else {
                    this.showMeetingNotes = false;
                }
            },
            //show/hide attachments
            expandAttachments() {
                if (!this.showAttachments) {
                    this.showAttachments = true;
                } else {
                    this.showAttachments = false;
                }
            },
            //show/hide followup notes
            /**@params = index */
            expandFollowUpsNotes(index) {
                if (!this.showFollowUpsNotes.includes(index)) {
                    this.showFollowUpsNotes.push(index);
                } else {
                    this.showFollowUpsNotes.splice(index, 1);
                }
            },
            //show/hide Sales
            /**@params = index */
            expandSales(index) {
                if (!this.showSales.includes(index)) {
                    this.showSales.push(index);
                } else {
                    this.showSales.splice(index, 1);
                }
            },
            //Api call to get the customer list
            async getCustomers() {
                let response = await this.getCustomerList({
                    search_key: search,
                    status: this.status
                })
                this.optionsCustomers = [];
                this.optionsCustomers = response.response;
            },
            //Api call to update internal primary attendee
            /**@params = co */
            async updateInternalPrimaryAttendee(co) {
                /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = active_status,@params = sort_key,@params = sort_value, */
                let params = {
                    search_key: "",
                    skip: 0,
                    limit: 10,
                    company_id: this.loggedInUser.company_id,
                    sort_key: 'full_name',
                    sort_value: 1
                }
                let res = await this.getAssigned(params)
                    (this.internal_primary_attendee = [])
                res.data.response.forEach(ele => {
                    this.internal_primary_attendee.push(ele);
                });
            },
            //Lazy loading of the list of primary employee
            async reachedEndOfListPrimaryEmployee(reached) {
                this.isVisible = reached;
                if (reached) {
                    this.countPrimaryAttendee += 10;
                    /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = active_status,@params = sort_key,@params = sort_value, */
                    let params = {
                        skip: this.countPrimaryAttendee,
                        limit: 10,
                        search_key: this.search_key_internal_primary,
                        company_id: this.loggedInUser.company_id,
                        sort_key: 'full_name',
                        sort_value: 1
                    }
                    let res = await this.getAssigned(params)
                        (this.internal_primary_attendee = [])
                    res.response.forEach(ele => {
                        this.internal_primary_attendee.push(ele);
                    });
                }
            },
            //APi call to search internal primary attendees
            async searchInternalPrimaryAttendee(co, search_key) {
                this.search_key_internal_primary = search_key;
                /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = company_id,@params = sort_key,@params = sort_value, */
                let params = {
                    skip: this.skip_count,
                    limit: 10,
                    search_key: this.search_key_internal_primary,
                    company_id: this.loggedInUser.company_id,
                    sort_key: 'full_name',
                    sort_value: 1
                }
                let res = await this.getAssigned(params)
                    (this.internal_primary_attendee = [])
                res.data.response.forEach(ele => {
                    this.internal_primary_attendee.push(ele);
                });
                //this.updatePrimaryAttendeeId();
            },
            // Customer Start
            async searchCustomerInsideDebouncer(key,value) {
                this.isCustomerLoading = true
                if (key) {
                    this.search_term = key ;
                }
                 /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = company_id,@params = sort_key,@params = sort_value, */
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_term,
                    company_id: this.loggedInUser.company_id,
                    sort_key: 'full_name',
                    sort_value: 1
                };
                let res = await this.getAssigned(params);
                this.optionsEmailRecipients = res.response;
                this.optionsEmailRecipients = this.optionsEmailRecipients.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.optionsEmailRecipients.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.email_ind_skip_count = res.response.length
                this.count = 0;
                this.isCustomerLoading = false;
            },
            //lazy loading of the list of customer
            async reachedEndOfListCustomer(reached) {
                this.isVisible = reached;
                if (reached) {
                    if (this.scrollableCustomerInside == false) {
                        this.isCustomerLoading = true;
                        /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = company_id,@params = sort_key,@params = sort_value, */
                        let res = await this.getAssigned({
                            skip: this.email_ind_skip_count,
                            limit: 10,
                            search_key: this.search_term,
                            company_id: this.loggedInUser.company_id,
                            sort_key: 'full_name',
                            sort_value: 1
                        });
                        if(res.skip == this.email_ind_skip_count){
                            if (res.response.length > 0) {
                                let tempFiles = res.response;
                                tempFiles.forEach(el => {
                                    this.optionsEmailRecipients.push(
                                        el);
                                });
                                this.optionsEmailRecipients = this.optionsEmailRecipients.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.optionsEmailRecipients.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.email_ind_skip_count += res.response.length;
                                this.isCustomerLoading = false;
                            } else {
                                this.scrollableCustomerInside = true;
                                this.isCustomerLoading = false;
                            }
                        }
                        this.isCustomerLoading = false;
                    }
                }
            },
            // Customer End

            //search the company inside
            async searchCompaniesInsideDebouncer(key) {
                //this.optionsCompanies = [];
                let search_key = "";
                if (key) {
                    search_key = key;
                }
                /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = company_id,@params = status */
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: search_key,
                    sort_key: "customer_name",
                    sort_value: 1,
                    status: "active"
                };
                let res = await this.getCustomerList(params);
                this.count = 0;
                this.optionsCompanies = res.response;
                this.tempoptionsCompanies = res.response;
                this.isLoading = false;
            },
            async addVendorList(index) {
                this.selected_vendor_index = index
                this.createJson.vendor_info[this.selected_vendor_index].is_vendor_loading = true
                try {
                    let params = {
                        searchdata: this.vendor_search_key,
                        filter_json: {},
                        skip: 0,
                        limit: 10,
                        sort_key: "company_name",
                        sort_value: 1
                    };
                    let response = await this.getVendorList(params)
                    this.vendor_options = response.result;
                    this.vendor_count = response.result.length;
                    this.createJson.vendor_info[this.selected_vendor_index].is_vendor_loading = false;
                    this.createJson.vendor_info.forEach((vendor_el) => {
                        let index = this.vendor_options.findIndex((x) => x._id === vendor_el.vendor_name._id)
                        if(index >=0) {
                            this.vendor_options.splice(index, 1)
                        }
                    })
                    this.vendor_options = this.vendor_options.filter((obj, index) => {
                        return index === this.vendor_options.findIndex(o => obj._id === o._id);
                    });
                    this.$forceUpdate();
                }
                catch(error) {
                }
            },
            async searchVendorList(search_key, index) {
                this.selected_vendor_index = index
                this.createJson.vendor_info[this.selected_vendor_index].is_vendor_loading = true;
                this.vendor_search_key = search_key || ''
                try {
                    let params = {
                        searchdata: this.vendor_search_key,
                        filter_json: {},
                        skip: 0,
                        limit: 10,
                        sort_key: "company_name",
                        sort_value: 1
                    };
                    let response = await this.getVendorList(params)
                    this.vendor_options = response.result;
                    this.vendor_count = 0;
                    this.createJson.vendor_info[this.selected_vendor_index].is_vendor_loading = false;
                    this.createJson.vendor_info.forEach((vendor_el) => {
                        let index = this.vendor_options.findIndex((x) => x._id === vendor_el.vendor_name._id)
                        if(index >=0) {
                            this.vendor_options.splice(index, 1)
                        }
                    });
                    this.vendor_options = this.vendor_options.filter((obj, index) => {
                        return index === this.vendor_options.findIndex(o => obj._id === o._id);
                    });
                    this.$forceUpdate();
                }
                catch(error) {
                }
            },
            async reachedEndOfVendorList(reached) {
                this.vendor_visible = reached
                if (reached) {
                    if (this.vendor_scrollable == false) {
                        this.createJson.vendor_info[this.selected_vendor_index].is_vendor_loading = true
                        let params = {
                            searchdata: this.vendor_search_key,
                            filter_json: {},
                            skip: this.vendor_count,
                            limit: 10,
                            sort_key: "company_name",
                            sort_value: 1
                        };
                        let response = await this.getVendorList(params)
                        this.temp_vendor = response.result.length;
                        if (response.skip == this.vendor_count) {
                            if (this.temp_vendor > 0) {
                                let tempFiles = response.result;
                                tempFiles.forEach(el => {
                                    this.vendor_options.push(el);
                                });
                                this.createJson.vendor_info.forEach((vendor_el) => {
                                    let index = this.vendor_options.findIndex((x) => x._id === vendor_el.vendor_name._id)
                                    if(index >=0) {
                                        this.vendor_options.splice(index, 1)
                                    }
                                })
                                this.vendor_options = this.vendor_options.filter((obj, index) => {
                                    return index === this.vendor_options.findIndex(o => obj._id === o._id);
                                });
                                this.vendor_count += response.result.length;
                                this.createJson.vendor_info[this.selected_vendor_index].is_vendor_loading = false
                            } else {
                                this.products_scrollable = true
                                this.createJson.vendor_info[this.selected_vendor_index].is_vendor_loading = false
                            }
                        }
                        this.createJson.vendor_info[this.selected_vendor_index].is_vendor_loading = false
                    }
                }
            },
            //load Company name
            async loadCompanyName() {
                //this.isLoading = true;
                this.createJson.external_attendees[this.customer_index].is_company_loading = true
                this.optionsCompanies = [];
                /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = company_id,@params = status */
                let res = await this.getCustomerList({
                    search_key: "",
                    skip: this.skip,
                    limit: this.limit,
                    company_id: this.loggedInUser.company_id,
                    sort_key: "customer_name",
                    sort_value: 1,
                    status: "active"
                });
                this.optionsCompanies = res.response;
                this.createJson.external_attendees.forEach((comp_name_el, comp_name_index) => {
                    let index = this.optionsCompanies.findIndex((x) => x.id === comp_name_el.company_name.id)
                    this.optionsCompanies.splice(index, 1)
                })
                this.count = this.optionsCompanies.length;
                //this.isLoading = false;
                this.createJson.external_attendees[this.customer_index].is_company_loading = false
                this.scrollableCompanies = false;
            },
            //search the company list
            async loadCompanySearchDebouncer(search_key,index) {
                this.search_key = search_key;
                //this.isLoading = true;
                this.customer_index = index
                this.createJson.external_attendees[this.customer_index].is_company_loading = true
                /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = company_id,@params = status */
                let res = await this.getCustomerList({
                    search_key: this.search_key,
                    skip: this.skip,
                    limit: this.limit,
                    sort_key: "customer_name",
                    sort_value: 1,
                    status: "active"
                });
                this.optionsCompanies = res.response;
                this.count = this.optionsCompanies.length;
                this.createJson.external_attendees[this.customer_index].is_company_loading = false;
                this.scrollableCompanies = false;
                this.createJson.external_attendees.forEach((comp_name_el, comp_name_index) => {
                    let index = this.optionsCompanies.findIndex((x) => x.id === comp_name_el.company_name.id)
                    this.optionsCompanies.splice(index, 1)
                })
            },
            //lazy loading of the list of company new
            async reachedEndOfListCompanyNew(reached) {
                this.isVisible = reached;
                if (reached && this.optionsCompanies.length) {
                    this.createJson.external_attendees[this.customer_index].is_company_loading = true;
                    /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = sort_key,@params = sort_value,@params = status */
                    let res = await this.getCustomerList({
                        skip: this.optionsCompanies.length,
                        limit: 10,
                        search_key: this.search_key,
                        company_id: this.loggedInUser.company_id,
                        sort_key: "customer_name",
                        sort_value: 1,
                        status: "active"
                    });
                    if (res.response.length > 0) {
                        res.response.forEach(x => {
                            this.optionsCompanies
                                .push(x);
                        });
                        this.createJson.external_attendees[this.customer_index].is_company_loading = false;
                        this.createJson.external_attendees.forEach((comp_name_el, comp_name_index) => {
                            let index = this.optionsCompanies.findIndex((x) => x.id === comp_name_el.company_name.id)
                            this.optionsCompanies.splice(index, 1)
                        })
                    }
                    this.createJson.external_attendees[this.customer_index].is_company_loading = false;
                }
            },
            //Search the customer name
            async loadCustomerNameSearch(search_key) {
                this.isLoading = true;
                 /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = sort_key,@params = sort_value,@params = status */
                let res = await this.getCustomerList({
                    search_key: search_key,
                    skip: this.skip,
                    limit: this.limit,
                    company_id: this.loggedInUser.company_id,
                    sort_key: "customer_name",
                    sort_value: 1,
                    status: "active"
                });
                this.optionsCustomers = [];
                this.optionsCustomers = res.data
                    .response;
                this.count = this.optionsCompanies
                    .length;
                this.isLoading = false;
                this.scrollableCompanies = false;
            },
            //lazy loading of the list of company
            /**@params =reached */
            async reachedEndOfListCompany(reached) {
                this.isVisible = reached;
                if (reached) {
                    if (this.scrollableCompanies ==
                        false) {
                        this.isLoading = true;
                        /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = sort_key,@params = sort_value,@params = status */
                        let res = await this
                            .getCustomerList({
                                skip: this
                                    .count,
                                limit: 10,
                                search_key: this
                                    .search_key,
                                    sort_key: "customer_name",
                                    sort_value: 1,
                                    status: "active"
                            });
                        this.tempoptionsCompanies =
                            res.response.length;
                        if (res.skip == this
                            .count) {
                            if (this
                                .tempoptionsCompanies >
                                0) {
                                let tempFiles = res
                                    .response;
                                tempFiles.forEach(
                                    el => {
                                        this.optionsCompanies
                                            .push(
                                                el
                                            );
                                    });
                                this.count += res
                                    .response
                                    .length;
                                this.isLoading =
                                    false;
                            } else {
                                this.scrollableCompanies =
                                    true;
                                this.isLoading =
                                    false;
                            }
                        }
                        this.isLoading = false;
                    }
                }
            },
            // Comapnies End

            // External Employee Start
            async getEmployeeDetailsExternal(co,
                index) {
                this.indexToPass = index;
                if (this.search_key ==
                    undefined) {
                    this.search_key = ""
                }
                this
                    .optionsEmployeeAttendeesExternal = [];
                this.isLoadingemployeesExternal =
                    true;
                /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = sort_key,@params = sort_value*/
                let res = await this
                    .getAssigned({
                        search_key: this
                            .search_key,
                        skip: 0,
                        limit: 10,
                        company_id: this.loggedInUser.company_id,
                        sort_key: 'full_name',
                        sort_value: 1
                    });
                this
                    .optionsEmployeeAttendeesExternal = [];
                res.response.forEach(x => {
                    this.optionsEmployeeAttendeesExternal
                        .push({
                            email_id: x
                                .email,
                            full_name: x
                                .full_name,
                        });
                });
                this.isLoadingemployeesExternal =
                    false;
                this.scrollableEmployeeExternal =
                    false;
                // this.optionsEmployeeAttendeesExternal = this.optionsEmployeeAttendeesExternal.concat(
                //   this.push_optionsEmployeeAttendees
                // );
                // }
            },
            addTagEmployeeOtherAttendees(
                newTag) {
                const element = newTag;
                if (String(element).match(this.email_regex)) {
                    this.optionsEmployeeAttendees.push({
                        full_name: "",
                        email: element,
                    });
                    this.createJson.internal_company.other_attendees.push({
                        full_name: "",
                        email: element,
                    });
                    this.createJson.recipient_email.individual.push({
                        full_name: "",
                        email: element,
                    });
                } else {
                    this.$awn.success(
                        "As Your Email ID Was Not Valid It is Removed"
                    );
                    this.invalidEmail = true;
                    return;
                }
            },
            //load Employee search exteranl data
            /**@params = co, @params = search_key */
            async loadEmployeeSearchExternalDebouncer(co,
                search_key) {
                if (search_key ==
                    undefined) {
                    this.search_key = ""
                } else {
                    this.search_key =
                        search_key;
                }
                this.search_key =
                    search_key;
                // if (co == "" || co == "undefined") {} else {
                this.isLoadingemployeesExternal =
                    true;
                /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = sort_key,@params = sort_value */
                let res = await this
                    .getAssigned({
                        search_key: this
                            .search_key,
                        skip: 0,
                        limit: 10,
                        company_id: this
                            .loggedInUser
                            .company_id,
                        sort_key: 'full_name',
                        sort_value: 1
                    });
                this
                    .optionsEmployeeAttendeesExternal = [];
                res.response.forEach(x => {
                    this.optionsEmployeeAttendeesExternal
                        .push({
                            email_id: x
                                .email,
                            full_name: x
                                .full_name,
                        });
                });
                this.isLoadingemployeesExternal =
                    false;
                this.scrollableEmployeeExternal =
                    false;
                // }
            },

            // get employee details based on the dropdown type
            async getEmployeeDetails(co,type) {
                if (this .search_key ==undefined) {
                    this.search_key =""
                }
                this.dropdown_type =type;
                if (co == "" ||co == undefined) {} else {
                    this.co_id = co._id;
                    this.optionsEmployeeAttendees = [];
                    this.count = 0;
                    if (this.dropdown_type =='report_owner') {
                        this.report_owner_loading = true;
                        this.reportScrollable = true
                    }else if (this.dropdown_type =='company_attendees') {
                        this.company_attendees_loading = true;
                        this.scrollableData =true;
                    } else if (this.dropdown_type =='other_attendees') {
                        this.other_attendees_loading =true;
                        this.otherAttendeeScrollable = true;
                    }
                    /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = sort_key, @params = sort_value*/
                    let params = {
                        search_key: this.search_key,
                        skip: 0,
                        limit: 10,
                        company_id: this.loggedInUser.company_id,
                        sort_key: 'full_name',
                        sort_value: 1
                    }
                    let res =await this.getAssigned(params)
                    this.optionsEmployeeAttendees =res.response;
                    this.count =this.optionsEmployeeAttendees.length;
                    this.skip_count = res.response.length;
                    this.optionsEmployeeAttendees =this.optionsEmployeeAttendees.concat(this.push_optionsEmployeeAttendeesInternal);
                    if (this.dropdown_type == 'report_owner') {
                        this.report_owner_loading = false;
                        this.reportScrollable = false;
                    } else if (this.dropdown_type =='company_attendees') {
                        this.company_attendees_loading =false;
                        this.scrollableData =false;
                    } else if (this.dropdown_type =='other_attendees') {
                        this.other_attendees_loading = false;
                        this.otherAttendeeScrollable = false;
                    }
                }
            },
            //load employee search details
            /**@params = co, @params = search_key, @params = type */
            async loadEmployeeSearchDebouncer(co, search_key,type) {
                this.dropdown_type =type;
                if (co == "" ||co =="undefined") {}
                else {
                    if (this.dropdown_type =='report_owner') {
                        this.report_owner_loading = true;
                    }else if (this.dropdown_type =='company_attendees') {
                        this.company_attendees_loading = true;
                    } else if (this.dropdown_type =='other_attendees') {
                        this.other_attendees_loading =true;
                    }
                    this.search_key =search_key;
                    let params = {
                        search_key: this.search_key,
                        skip: 0,
                        limit: 10,
                        company_id: this.loggedInUser.company_id,
                        sort_key: 'full_name',
                        sort_value: 1
                    }
                    let res =await this.getAssigned(params)
                    this.optionsEmployeeAttendees =res.response;
                    this.count =this.optionsEmployeeAttendees.length;
                    this.getMoreEmployeeDetails = false;
                    this.optionsEmployeeAttendees =this.optionsEmployeeAttendees.concat(this.push_optionsEmployeeAttendeesInternal);
                    this.skip_count =res.response.length
                    if (this.dropdown_type == 'report_owner') {
                        this.report_owner_loading = false;
                    } else if (this.dropdown_type =='company_attendees') {
                        this.company_attendees_loading =false;
                    } else if (this.dropdown_type =='other_attendees') {
                        this.other_attendees_loading = false;
                    }
                }
            },
            dropdownClosed() {
                this.createJson.owner_email = this.createJson.owner_name.email;
                this.search_key ="";
                this.skip_count =0;
               // this.owner_data = []
            },
            async getMoreEmployeeDetails(reached) {
                if (reached) {
                    // this.isLoadingemployees = true;
                    if (this.dropdown_type =='report_owner') {
                        this.report_owner_loading =true;
                        this.reportScrollable = true;
                    } else if (this.dropdown_type =='company_attendees') {
                        this.company_attendees_loading =true;
                        this.scrollableData =true;
                    } else if (this.dropdown_type =='other_attendees') {
                        this.other_attendees_loading = true;
                        this.otherAttendeeScrollable = true;
                    }
                    let res =await this.getAssigned({
                        skip: this.count,
                        limit: 10,
                        search_key: "",
                        company_id: this.loggedInUser.company_id,
                        sort_key: 'full_name',
                        sort_value: 1
                    });
                    if (res.skip ==this.count) {
                        let tempFiles =res.response;
                        tempFiles.forEach(el => {
                            this.optionsEmployeeAttendees.push(el);
                        });
                        this.optionsEmployeeAttendees = this.optionsEmployeeAttendees.filter((thing,index) => {
                            const payload =JSON.stringify(thing);
                            return index ===this.optionsEmployeeAttendees.findIndex(obj => {
                                return JSON.stringify(obj) ===payload;
                            });
                        });
                        this.count +=res.response.length;
                        if (this.dropdown_type == 'report_owner') {
                            this.report_owner_loading = false;
                            this.reportScrollable = false;
                        } else if (this.dropdown_type =='company_attendees') {
                            this.company_attendees_loading =false;
                            this.scrollableData =false;
                        } else if (this.dropdown_type =='other_attendees') {
                            this.other_attendees_loading = false;
                            this.otherAttendeeScrollable = false;
                        }
                    }
                }
            },
             //lazy laoding of the list of employees
            /**@params = co, @params = reached*/
            async reachedEndOfListEmployee(
                co,
                reached
            ) {
                this.isVisible =
                    reached;
                if (
                    reached) {
                    if (this
                        .scrollableEmployee ==
                        false
                    ) {
                        this.isLoadingemployees =
                            true;
                        /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = sort_key,@params = sort_value*/
                        let res =
                            await this
                            .getAssigned({
                                skip: this
                                    .count,
                                limit: 10,
                                search_key: this
                                    .search_key,
                                company_id: this
                                    .loggedInUser
                                    .company_id,
                                sort_key: 'full_name',
                                sort_value: 1
                            });
                        this.tempoptionsEmployeeAttendees =
                            res
                            .response
                            .length;
                        if (res
                            .skip ==
                            this
                            .count
                        ) {
                            if (this
                                .tempoptionsEmployeeAttendees >
                                0
                            ) {
                                let tempFiles =
                                    res
                                    .response;
                                tempFiles
                                    .forEach(
                                        el => {
                                            this.optionsEmployeeAttendees
                                                .push(
                                                    el
                                                );
                                        }
                                    );
                                this.count +=
                                    res
                                    .response
                                    .length;
                                this.isLoadingemployees =
                                    false;
                            } else {
                                this.scrollableEmployee =
                                    true;
                                this.isLoadingemployees =
                                    false;
                            }
                        }
                        this.isLoadingemployees =
                            false;
                    }
                }
            },
            // Get the assign to inside data
            /**@params = search */
            async assignToInsideDebouncer(search) {
                if (search ==undefined) {
                    this.search_key = ""
                } else {
                    this.search_key =search;
                }
                /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = sort_key,@params = sort_value*/
                try {
                    let params = {
                        skip: this.skip,
                        limit: this.limit,
                        search_key: this.search_key,
                        company_id: this.loggedInUser.company_id,
                        sort_key: 'full_name',
                        sort_value: 1
                    }
                    let res =await this.getAssigned(params)
                    this.assigned_count = res.response.length
                    this.assignUsers =res.response;


                } catch (reason) {}
            },

            async assignTo() {
                try {
                    /**@params = search_key, @params = skip,@params = limit,@params = company_id,@params = sort_key,@params = sort_value*/
                    let res = await this.getAssigned({
                        skip: this.skip,
                        limit: this.limit,
                        search_key: "",
                        company_id: this.account.company_id,
                        active_status: "active",
                        sort_key:'full_name',
                        sort_value:1
                    });
                    this.assigned_count = res.response.length
                    this.assignUsers = res.response;
                } catch (reason) {}
            },
            async reachedEndOfListAssignedAfter(reached){
                this.isVisible = reached;
                if (reached) {
                    if (this.scrollableAssigned == false) {
                        this.isLoadingAssigned = true;
                        let res = await this.getAssigned({
                            skip: this.assigned_count,
                            limit: this.limit,
                            search_key: "",
                            company_id: this.account.company_id,
                            active_status: "active",
                            sort_key:'full_name',
                            sort_value:1
                        });
                        this.temp_assigned= res.response.length;
                        if (res.skip == this.assigned_count) {
                            if (this.temp_assigned > 0 ) {
                                let tempFiles = res.response;
                                tempFiles.forEach(el => {
                                    this.assignUsers.push(el);
                                });
                                this.assigned_count += res.response.length;
                                this.isLoadingAssigned = false;
                            } else {
                                this.scrollableAssigned = true;
                                this.isLoadingAssigned = false;
                            }
                        }
                        this.isLoadingAssigned = false;
                    }
                }
            },
            //check the selected company
            checkCompanySelected() {
                if (this
                    .createJson
                    .external_attendees[
                        0
                    ]
                    .company_name !=
                    ""
                ) {
                    this.tempcompany_ids = [
                        ...
                        new Set(
                            this
                            .createJson
                            .external_attendees
                            .map(
                                x =>
                                x
                                .company_name
                                .company_id
                            )
                        ),
                    ];
                    this.optionsCompanies
                        .forEach(
                            (co,
                                index) => {
                                this.tempcompany_ids
                                    .forEach(
                                        (t,
                                            i) => {
                                            if (co
                                                .company_id ==
                                                t
                                            ) {
                                                this.optionsCompanies
                                                    .splice(
                                                        i,
                                                        1
                                                    );
                                            }
                                        }
                                    );
                            }
                        );
                }
            },
            updateCompanyList() {
                this
                    .checkCompanySelected();
                this
                    .branch = [];
            },
            updateCustomerList() {
                this.optionsCustomers
                    .forEach(
                        ele => {
                            if (
                                ele
                                .company_name ===
                                this
                                .createJson
                                .sales_target
                                .forecast
                                .customer_id
                                .name
                            ) {
                                this.createJson
                                    .sales_target
                                    .forecast
                                    .customer_id =
                                    ele
                                    ._id;
                            }
                        }
                    );
            },

            update_InternalDepartment(
                department
            ) {
                this.internal_development = [
                    department
                ];
            },
            updateDepartment(
                branch
            ) {
                if ("departments" in
                    branch
                ) {
                    this.departmentNameOptions =
                        branch
                        .departments;
                };
            },
            formatPrice(
                value
            ) {
                let val =
                    (value /
                        1
                    )
                    .toFixed(
                        2
                    )
                    .replace(
                        ",",
                        "."
                    );
                return val
                    .toString()
                    .replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        ","
                    );
            },
            yearNext() {
                let year =
                    this
                    .years_to_set[
                        5
                    ];
                this
                    .years_to_set = [];
                for (
                    let i =
                        0; i <
                    6; i++
                ) {
                    this.years_to_set
                        .push(
                            year +
                            i
                        );
                }
            },
            yearPrev() {
                let year =
                    this
                    .years_to_set[
                        0
                    ];
                this
                    .years_to_set = [];
                for (
                    let i =
                        0; i <
                    6; i++
                ) {
                    this.years_to_set
                        .push(
                            year -
                            i
                        );
                }
                this.years_to_set
                    .reverse();
            },
            yearClicked(
                index
            ) {
                this.hide_el_dropdown =
                    true;
                this.createJson
                    .sales_target
                    .forecast[
                        index
                    ]
                    .target_year =
                    this
                    .yearSelected;
                if (this
                    .noFiscalYear
                    .includes(
                        index
                    )
                ) {
                    this.noFiscalYear =
                        this
                        .noFiscalYear
                        .filter(
                            x =>
                            x !=
                            index
                        );
                }
            },
            dropdownTriggered(
                event
            ) {
                if (
                    event) {
                    this.hide_el_dropdown =
                        false;
                }
            },
            async getProductsDebouncer(
                search_key
            ) {
                this.search_key =
                    search_key
                this.products_loading =
                    true
                try {
                    let params = {
                        skip: 0,
                        limit: 10,
                        search_key: this
                            .search_key,
                        sort_value: 1,
                        sort_key: "is_star"
                    };
                    let response =
                        await this
                        .getProductsList(
                            params
                        )
                    this.productoptions =
                        response
                        .response;
                    this.products_count =
                        response
                        .response
                        .length;
                    this.products_loading =
                        false
                } catch (error){
                }
            },
            async getProdutsAfter(
                reached
            ) {
                this.products_visible =
                    reached
                if (
                    reached) {
                    if (this
                        .products_scrollable ==
                        false
                    ) {
                        this.products_loading =
                            true
                        let response =
                            await this
                            .getProductsList({
                                skip: this
                                    .products_count,
                                limit: 10,
                                search_key: this
                                    .search_key,
                                sort_value: 1,
                                sort_key: "is_star"
                            })
                        this.temp_products =
                            response
                            .response
                            .length;
                        if (response
                            .skip ==
                            this
                            .products_count
                        ) {
                            if (this
                                .temp_products >
                                0
                            ) {
                                let tempFiles =
                                    response
                                    .response;
                                tempFiles
                                    .forEach(
                                        el => {
                                            this.productoptions
                                                .push(
                                                    el
                                                );
                                        }
                                    );
                                this.productoptions =
                                    this
                                    .productoptions
                                    .filter(
                                        (thing,
                                            index
                                        ) => {
                                            const
                                                payload =
                                                JSON
                                                .stringify(
                                                    thing
                                                );
                                            return index ===
                                                this
                                                .productoptions
                                                .findIndex(
                                                    obj => {
                                                        return JSON
                                                            .stringify(
                                                                obj
                                                            ) ===
                                                            payload;
                                                    }
                                                );
                                        }
                                    );
                                this.products_count +=
                                    response
                                    .response
                                    .length;
                                this.products_loading =
                                    false
                            } else {
                                this.products_scrollable =
                                    true
                                this.products_loading =
                                    false
                            }
                        }
                        this.products_loading =
                            false
                    }
                }
            },
            addTableCells(
                index
            ) {
                if (this
                    .createJson
                    .meeting_notes_table[
                        index
                    ]
                    .meeting_notes_table_data
                    .length
                ) {
                    if (
                        this
                        .createJson
                        .meeting_notes_table[
                            index
                        ]
                        .meeting_notes_table_data
                        .length <=
                        this
                        .createJson
                        .meeting_notes_table[
                            index
                        ]
                        .meeting_notes_table_row
                    ) {
                        let row =
                            this
                            .createJson
                            .meeting_notes_table[
                                index
                            ]
                            .meeting_notes_table_row -
                            this
                            .createJson
                            .meeting_notes_table[
                                index
                            ]
                            .meeting_notes_table_data
                            .length;
                        for (
                            let i =
                                0; i <
                            row; i++
                        ) {
                            let
                                cell = [];
                            for (
                                let i =
                                    0; i <
                                this
                                .createJson
                                .meeting_notes_table[
                                    index
                                ]
                                .meeting_notes_table_column; i++
                            ) {
                                cell.push(
                                    ""
                                );
                            }
                            this.createJson
                                .meeting_notes_table[
                                    index
                                ]
                                .meeting_notes_table_data
                                .push(
                                    cell
                                );
                        }
                        this.createJson
                            .meeting_notes_table[
                                index
                            ]
                            .meeting_notes_table_data
                            .forEach(
                                x => {
                                    if (x
                                        .length <
                                        this
                                        .createJson
                                        .meeting_notes_table[
                                            index
                                        ]
                                        .meeting_notes_table_column
                                    ) {
                                        let column =
                                            this
                                            .createJson
                                            .meeting_notes_table[
                                                index
                                            ]
                                            .meeting_notes_table_column -
                                            x
                                            .length;
                                        for (
                                            let i =
                                                0; i <
                                            column; i++
                                        ) {
                                            x.push(
                                                "");
                                        }
                                    } else if (
                                        x
                                        .length >
                                        this
                                        .createJson
                                        .meeting_notes_table[
                                            index
                                        ]
                                        .meeting_notes_table_column
                                    ) {
                                        let column =
                                            x
                                            .length -
                                            this
                                            .createJson
                                            .meeting_notes_table[
                                                index
                                            ]
                                            .meeting_notes_table_column;
                                        for (
                                            let i =
                                                0; i <
                                            column; i++
                                        ) {
                                            x
                                                .pop();
                                        }
                                    }
                                }
                            );
                    } else if (
                        this
                        .createJson
                        .meeting_notes_table[
                            index
                        ]
                        .meeting_notes_table_data
                        .length >
                        this
                        .createJson
                        .meeting_notes_table[
                            index
                        ]
                        .meeting_notes_table_row
                    ) {
                        let row =
                            this
                            .createJson
                            .meeting_notes_table[
                                index
                            ]
                            .meeting_notes_table_data
                            .length -
                            this
                            .createJson
                            .meeting_notes_table[
                                index
                            ]
                            .meeting_notes_table_row;
                        for (
                            let i =
                                0; i <
                            row; i++
                        ) {
                            let
                                cell = [];
                            for (
                                let i =
                                    0; i <
                                this
                                .createJson
                                .meeting_notes_table[
                                    index
                                ]
                                .meeting_notes_table_column; i++
                            ) {
                                cell
                                    .pop();
                            }
                            this.createJson
                                .meeting_notes_table[
                                    index
                                ]
                                .meeting_notes_table_data
                                .pop(
                                    cell
                                );
                        }
                        this.createJson
                            .meeting_notes_table[
                                index
                            ]
                            .meeting_notes_table_data
                            .forEach(
                                x => {
                                    if (x
                                        .length <
                                        this
                                        .createJson
                                        .meeting_notes_table[
                                            index
                                        ]
                                        .meeting_notes_table_column
                                    ) {
                                        let column =
                                            this
                                            .createJson
                                            .meeting_notes_table[
                                                index
                                            ]
                                            .meeting_notes_table_column -
                                            x
                                            .length;
                                        for (
                                            let i =
                                                0; i <
                                            column; i++
                                        ) {
                                            x.push(
                                                "");
                                        }
                                    } else if (
                                        x
                                        .length >
                                        this
                                        .createJson
                                        .meeting_notes_table[
                                            index
                                        ]
                                        .meeting_notes_table_column
                                    ) {
                                        let column =
                                            x
                                            .length -
                                            this
                                            .createJson
                                            .meeting_notes_table[
                                                index
                                            ]
                                            .meeting_notes_table_column;
                                        for (
                                            let i =
                                                0; i <
                                            column; i++
                                        ) {
                                            x
                                                .pop();
                                        }
                                    }
                                }
                            );
                    }

                } else {
                    for (
                        let i =
                            0; i <
                        this
                        .createJson
                        .meeting_notes_table[
                            index
                        ]
                        .meeting_notes_table_row; i++
                    ) {
                        let
                            cell = [];
                        for (
                            let i =
                                0; i <
                            this
                            .createJson
                            .meeting_notes_table[
                                index
                            ]
                            .meeting_notes_table_column; i++
                        ) {
                            cell.push(
                                ""
                            );
                        }
                        this.createJson
                            .meeting_notes_table[
                                index
                            ]
                            .meeting_notes_table_data
                            .push(
                                cell
                            );
                    }
                }
            },
            deleteTableCells(
                index
            ) {
                this.createJson
                    .meeting_notes_table[
                        index
                    ]
                    .meeting_notes_table_data = [];
                this.createJson
                    .meeting_notes_table[
                        index
                    ]
                    .meeting_notes_table_row =
                    0;
                this.createJson
                    .meeting_notes_table[
                        index
                    ]
                    .meeting_notes_table_column =
                    0;
                this.createJson
                    .meeting_notes_table[
                        index
                    ]
                    .meeting_notes_table_name =
                    "";
                this.createJson
                    .meeting_notes_table
                    .splice(
                        index,
                        1
                    );
            },
            //Get the type of the callreport from api
            async getCallReportTypes(
                event,
                type
            ) {
                this.issueTypeLoading =
                    true;
                let params = {
                    type: type,
                };
                let res =
                    await this
                    .$http
                    .post(
                        "/call_report/get_call_report_dropdown",
                        params
                    );
                if (res
                    .data
                    .status_id ==
                    1
                ) {
                    if (type ==
                        "follow_up_issue_type"
                    ) {
                        this.issueTypeOptions =
                            res
                            .data
                            .response
                            .value;
                    }
                    this.issueTypeLoading =
                        false;
                }
            },
            addCustomerName(
                data,
                index
            ) {
                this.optionsCompanies
                    .push({
                        data,
                    });
                this.createJson
                    .external_attendees[
                        index
                    ]
                    .company_name =
                    data,
                    this
                    .branchs = [];
            },
            addBranchName(
                data,
                index
            ) {
                this.branchs
                    .push({
                        data,
                    });
                this.createJson
                    .external_attendees[
                        index
                    ]
                    .branch =
                    data;
                this
                    .departmentNameOptions = [];
            },
            addDepartmentName(
                data,
                index
            ) {
                this.departmentNameOptions
                    .push({
                        data
                    });
                this.createJson
                    .external_attendees[
                        index
                    ]
                    .department =
                    data;
            },
            //fetch the sales person data
            async fetchSalesPersonDebouncer(
                key
            ) {
                this.loading_sales_person =
                    true;

                if (
                    key) {
                    this.search_key =
                        key;
                }
                if (this
                    .search_key ==
                    undefined
                ) {
                    this.search_key =
                        ""
                }
                /**@params = search_key, @params = skip,@params = limit,@params = sort_key,@params = sort_value,@params = active_status*/
                let params = {
                    search_key: this
                        .search_key,
                    skip: this
                        .skip,
                    limit: this
                        .limit,
                    company_id: this
                        .loggedInUser
                        .company_id,
                    sort_key: 'full_name',
                    sort_value: 1,
                    active_status: "active",
                };
                let res =
                    await this
                    .getAssigned(
                        params
                    );
                if (res
                    .status_id ==
                    1
                ) {
                    this
                        .salesperson = [];
                    res.response
                        .forEach(
                            x => {
                                this.salesperson
                                    .push(
                                        x
                                    );
                            }
                        );
                    this.skip =
                        res
                        .response
                        .length
                }
                this.loading_sales_person =
                    false;
            },
            //fetch sales perosn data
            /**@params = reached */
            async fetchMoreSalesPerson(
                reached
            ) {
                if (
                    reached) {
                    this.loading_sales_person =
                        true;
                    /**@params = search_key, @params = skip,@params = limit,@params = sort_key,@params = sort_value,@params =active_status  */
                    let params = {
                        search_key: this
                            .search_key,
                        skip: this
                            .skip,
                        limit: 10,
                        company_id: this
                            .loggedInUser
                            .company_id,
                        sort_key: 'full_name',
                        sort_value: 1,
                        active_status: "active",
                    };
                    let res =
                        await this
                        .getAssigned(
                            params
                        );
                    if (res
                        .skip ==
                        this
                        .skip
                    ) {
                        let tempFiles =
                            res
                            .response;
                        tempFiles
                            .forEach(
                                el => {
                                    this.salesperson
                                        .push(
                                            el
                                        );
                                }
                            );
                        this.salesperson =
                            this
                            .salesperson
                            .filter(
                                (thing,
                                    index
                                ) => {
                                    const
                                        payload =
                                        JSON
                                        .stringify(
                                            thing
                                        );
                                    return index ===
                                        this
                                        .salesperson
                                        .findIndex(
                                            obj => {
                                                return JSON
                                                    .stringify(
                                                        obj
                                                    ) ===
                                                    payload;
                                            }
                                        );
                                }
                            );
                        this.skip +=
                            res
                            .response
                            .length;
                        this.loading_sales_person =
                            false;
                    }
                }
            },
             //Fetch sales person data
            /**@params = reached*/
            async fetchSalesPersonAfter(
                reached
            ) {
                if (
                    reached) {
                    let search =
                        "";
                    //**@params = search_key, @params = skip,@params = limit,@params = sort_key,@params = sort_value,@params =active_status  */
                    let params = {
                        search_key: this
                            .search_key,
                        skip: this
                            .this
                            .salesperson
                            .length,
                        limit: this
                            .limit,
                        company_id: this
                            .loggedInUser
                            .company_id,
                        sort_key: 'full_name',
                        sort_value: 1,
                        active_status: "active",
                    };
                    let res =
                        await this
                        .getAssigned(
                            params
                        );
                    if (res
                        .status_id ==
                        1
                    ) {
                        res.response
                            .forEach(
                                x => {
                                    this.salesperson
                                        .push(
                                            x
                                        );
                                }
                            );
                    }
                };
            },
            //Api call to Search unit of measure data
            async searchUomsDebouncer(key) {
                this.isUomLoading = true
                if (key) {
                    this.search_key = key;
                }
                let params = {
                    search_key: this.search_key,
                    skip: 0,
                    limit: 10,
                };
                let res = await this.$http.post(
                    globals.SCM_API + "/fnb/scm/get_unit_of_measurements",
                    params
                );
                if (res.data.status_id == 1) {
                    if (res.data.unit_of_measurements) {
                        this.uoms = [];
                        res.data.unit_of_measurements.forEach(x => {
                            this.uoms.push(x.name);
                        });
                    }
                }
                 this.isUomLoading = false
            },
            //Lazy loading to fetch UOM data
            /**params = reached */
            async searchUomsAfter(reached) {
                if (reached) {
                    let params = {
                        search_key: this.search_key,
                        skip: this.uoms.length,
                        limit: 10,
                    };
                    let res = await this.$http.post(
                        globals.SCM_API + "/fnb/scm/get_unit_of_measurements",
                        params
                    );
                    if (res.data.status_id == 1) {
                        if (res.data.unit_of_measurements) {
                            res.data.unit_of_measurements.forEach(x => {
                                this.uoms.push(x.name);
                            });
                        }
                    }
                };
            },
            backToPrev() {
                this.owner_name =
                    "",
                    this
                    .owner_email =
                    "",
                    this
                    .internalCompanyObject =
                    "";
                this
                    .internal_primary_attendee = [];
                this.internal_primary_attendee_id =
                    "";
                this.internalPrimaryAttendee =
                    "";
                this.callreporttab =
                    true;
                this.meetingnotestab =
                    false;
                this.followuptab =
                    false;
                this.salestargettab =
                    false;
                this.showAddress =
                    false;
                this
                    .countriesCaps = [];
                this.newplace =
                    "";
                this.newplaceFormat =
                    "";
                this.title =
                    "";
                this.callReportType =
                    "";
                this.meetingType =
                    "";
                this.countries =
                    countries;
                this.maxlengthaccountzipcode =
                    10;
                this.maxlengthaccounttownship =
                    20;
                this.maxlengthaccountstreet =
                    50;
                this.addressField =
                    "";
                this.addressFieldCompany =
                    "";
                this.addressFieldMeeting =
                    "";
                this.meetingstartdate =
                    new Date();
                this.meetingstarttime =
                    new Date()
                    .getTime();
                this.meetingenddate =
                    new Date();
                this.meetingendtime =
                    new Date()
                    .getTime();
                this.content =
                    "";
                this.assignedT =
                    "";
                this.statusMeeting =
                    "";
                this.selectQuarter =
                    "";
                this.salesYear =
                    "";
                this.salesYearType =
                    "";
                this.selectQuarterRevenue =
                    "";
                this
                    .places = [];
                //currentPlace: null,
                this.attendeesUserCompany =
                    "";
                this.showTitle =
                    true;
                this.showTitleSales =
                    true;
                this.showExternal = [0];
                this.showReceiverDetails = [0];
                this.showContactDetails= [0];
                this.showInternal =
                    true;
                this.showEmailRecipients =
                    true;
                this.showMeetingNotes =
                    true;
                this.showAttachments =
                    true;
                this.showMeetingInformation =
                    true;
                this.showPermissions =
                    true;
                this.showFollowUps = [
                    0
                ];
                this.showFollowUpsNotes = [
                    0
                ];
                this.showSales = [
                    0
                ];
                this.productName =
                    "";
                this.meetingNotes =
                    "";
                this.meetingNotesSubject =
                    "";
                this.maxlengthFollowUpNotes =
                    500;
                this.minHeight =
                    63;
                this.maxHeight =
                    350;
                this.productSalesQuarter =
                    "";
                this
                    .locations = [];
                this
                    .formatedAddresses = [];
                this
                    .userAttendees = [];
                this
                    .optionsUserAttendees = [];
                this
                    .push_optionsUserAttendees = [];
                this
                    .optionsEmailRecipients = [];
                this.salesPerson =
                    "";
                this.timezone =
                    timezone;
                this.time_zone =
                    "";
                this.timezoneShow =
                    false;
                this.total =
                    0;
                this.skip =
                    0;
                this.limit =
                    10;
                this.search_term =
                    "";
                this.isLoading =
                    false;
                this.scrollableCustomer =
                    false;
                this.count =
                    0;
                this
                    .tempoptionsUserAttendees = [];
                this.isVisible =
                    false;
                this.email_regex =
                    /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/;
                this.invalidEmail =
                    false;
                this.noEmail =
                    false;
                this
                    .companyList = [];
                this
                    .optionsCompanies = [];
                this
                    .tempoptionsCompanies = [];
                this.scrollableCompanies =
                    false;
                this.search_key =
                    "";
                this
                    .optionsCustomers = [];
                this
                    .employeeAttendees = [];
                this
                    .optionsEmployeeAttendeesExternal = [];
                this
                    .tempoptionsEmployeeAttendeesExternal = [];
                this
                    .optionsEmployeeAttendees = [];
                this
                    .push_optionsEmployeeAttendeesInternal = [];
                this
                    .push_emailRecipients = [];
                this
                    .tempoptionsEmployeeAttendees = [];
                this
                    .push_optionsEmployeeAttendees = [];
                this.scrollableEmployee =
                    false;
                this.isLoadingemployees =
                    false;
                this.isLoadingemployeesExternal =
                    false;
                this.scrollableEmployeeExternal =
                    false;
                this.company_attendees = [{
                    companyList: [],
                    employeeAttendees: [],
                }, ];
                this.follow_ups = [{
                    products: "",
                    assigned_to: "",
                    status: "",
                    notes: "",
                    due_date: "",
                    is_follow_expanded:true
                }, ];
                this.companyRepeat = {
                    company_name: "",
                    primary_employee: "",
                    secondary_employees: [],
                    department: "",
                    branch: "",
                    status: "",
                };
                this.follows = {
                    products: "",
                    assigned_to: "",
                    status: "",
                    notes: "",
                    due_date: "",
                    time:"",
                    is_follow_expanded:true,
                    price: null,
                };
                this.meeting_location = {
                    city: "",
                    street: "",
                    state: "",
                    township: "",
                    country: "",
                    zip_code: "",
                    address_type: "",
                };
                this
                    .assignUsers = [];
                this.firstTab =
                    false;
                this.customerStatusValue =
                    "";
                this.customerStatusOptions = [
                    "Demo",
                    "Existing Customer",
                    "Follow Up",
                    "Hot Lead",
                    "Interested",
                    "Negative Lead",
                    "New Customer",
                    "Positive Customer",
                    "Potential Customer",
                    "Referral Lead",
                    "Unassigned Lead",
                ];
                this
                    .issueTypeOptions = [];
                this.due_date =
                    "";
                this.customerNameValue =
                    "";
                this.customerNameOptions = [
                    "Company 1",
                    "Company 2"
                ];
                this.branchNameValue =
                    "";
                this
                    .branchs = [];
                this.internal_branchs =
                    "";
                this
                    .internal_development = [];
                this
                    .internal_employees = [];
                this.departmentNameValue =
                    "";
                this
                    .departmentNameOptions = [];
                this.maxlengthtitlename =
                    100;
                this.maxlengthsubjectname =
                    200;
                this.maxlengthproductname =
                    50;
                this
                    .tempcompany_ids = [];
                // CreateJson
                this.salestarget = {
                    customer_id: "",
                    branch: "",
                    department: "",
                    product: "",
                    target_year: "",
                    target: {
                        jan: 0,
                        feb: 0,
                        mar: 0,
                        apr: 0,
                        may: 0,
                        jun: 0,
                        jul: 0,
                        aug: 0,
                        sept: 0,
                        oct: 0,
                        nov: 0,
                        dec: 0,
                        sum: 0,
                    },
                };
                this
                    .compressed_external_attendees = {};
                this
                    .compressed_sales_target = {};
                this.createJson = {
                    author_name: this
                        .createJson
                        .author_name,
                    branch_name: this
                        .createJson
                        .branch,
                    author_email: this
                        .createJson
                        .author_email,
                    call_report_category: [],
                    meeting_notes_table: [],
                    title: "",
                    meeting_time_from: new Date(),
                    meeting_time_to: new Date(),
                    meeting_date_from: new Date(),
                    meeting_date_to: new Date(),
                    meeting_type: "",
                    meeting_notes_subject: "",
                    call_report_type: "",
                    meeting_location: {
                        street: "",
                        city: "",
                        township: "",
                        state: "",
                        zip_code: "",
                        country: "",
                        address_type: "",
                    },
                    internal_company: {
                        other_attendees: [],
                        external_attendees: [],
                        branch: this
                            .createJson
                            .internal_company
                            .branch,
                        department: this
                            .createJson
                            .internal_company
                            .department,
                        primary_attendee: "",
                    },
                    external_attendees: [{
                        company_name: "",
                        primary_employee: "",
                        secondary_employees: [],
                        department: "",
                        branch: "",
                        status: "",
                    }, ],
                    follow_ups: [{
                        products: "",
                        assigned_to: "",
                        status: "",
                        notes: "",
                        due_date: "",
                        issue_type: "",
                        is_follow_expanded:true
                    }, ],
                    meeting_timezone: {},
                    meeting_notes: "",
                    sales_target: {
                        forecast: [{
                            product_code: "",
                            customer_id: "",
                            branch: "",
                            department: "",
                            product: "",
                            target_year: "",
                            target: {
                                jan: 0,
                                feb: 0,
                                mar: 0,
                                apr: 0,
                                may: 0,
                                jun: 0,
                                jul: 0,
                                aug: 0,
                                sept: 0,
                                oct: 0,
                                nov: 0,
                                dec: 0,
                                sum: 0,
                            },
                        }, ],
                    },
                    recipient_email: [],
                    status: "",
                    send_copy_to_me: false,
                };
                this.meeting_location_vmodel =
                    "";
                this.countPrimaryAttendee =
                    0;
                this.search_key_internal_primary =
                    "";
                this.indexToPass =
                    "";
                this
                    .attachments = [];
                this.hide_el_dropdown =
                    false;
                this
                    .years_to_set = [];
                this
                    .productoptions = [];
                this.saveandclose =
                    false;
                this
                    .noFiscalYear = [];
                this.disableSend =
                    false;
                this.callreporttab =
                    true;
                if (this
                    .$route
                    .params
                    .id ==
                    'new'
                ) {
                    this.$router
                        .push(
                            '/callreport'
                        )
                }
                // } else {
                //     this.$router.go(-1);
                // }
            },
            async getOrganisationSettings() {
                this.callInProgress =
                    true;
                let res =
                    await this
                    .$http
                    .get(
                        "/organisation_settings/list"
                    );
                if (res
                    .data
                    .status_id ==
                    1
                ) {
                    this.organisationSettings =
                        res
                        .data
                        .response;
                    this.customerStatusOptions =
                        this
                        .organisationSettings
                        .hasOwnProperty(
                            'call_report_settings'
                        ) ?
                        this
                        .organisationSettings
                        .call_report_settings
                        .customer_status : []
                    this.issueTypeOptions =
                        this
                        .organisationSettings
                        .hasOwnProperty(
                            'call_report_settings'
                        ) ?
                        this
                        .organisationSettings
                        .call_report_settings
                        .issue_type : []
                    // this.leadTypes = this.organisationSettings.leads_settings.lead_type
                    // this.meetingTypes = this.organisationSettings.leads_settings.meeting_type
                    this.callInProgress =
                        false;
                }
            },
            dataClear() {
                this.backToPrev()
                this.createJson
                    .call_report_category =
                    "Internal Meeting";
                this.$forceUpdate()
                //     this.resetInternalCo()
                //     this.resetEmailRecipients()
                //     this.resetMeting()
                //     this.resetFollowUp()
                //     this.resetSales()
            },
            convertTZ(
                date,
                tzString
            ) {
                return new Date(
                    (typeof date ===
                        "string" ?
                        new Date(
                            date
                        ) :
                        date
                    )
                    .toLocaleString(
                        "en-US", {
                            timeZone: tzString
                        }
                    )
                );
            },
            updateAttachments() {
                EventBus.$on('edit_from_preview', () => {
                    this.editPreview = true
                });
            },
            //get Call report data from main dashbaord
            async getCRDataFromDashboard(){
                let type = localStorage.getItem("callReportCategory")
                let data = JSON.parse(localStorage.getItem("meetingDetails"))
                let start_date,start_time, end_date,end_time
                let id
                if(data.source == 'lead'){
                    id = data.activity_id
                    start_date = data.schedule_start_date
                    start_time = data.schedule_start_time_meredian
                    end_date = data.schedule_end_date
                    end_time = data.schedule_end_time_meredian
                } else {
                    id = data.id
                    start_date = data.start_date
                    start_time = data.start_time_meredian
                    end_date = data.end_date
                    end_time = data.end_time_meredian
                }
                let params = {
                    id: id,
                    source:data.source,
                    category:type
                }
                let res = await this.copyCallReportById(params);
                this.createJson = res.response;
                setTimeout(() => {
                    let md1 = start_date.split("-")
                    let md2 = end_date.split("-")
                    var meeting_date1 = md1[1] + '/' + md1[2] + '/' + md1[0];
                    var meeting_date2 = md2[1] + '/' + md2[2] + '/' + md2[0];
                    this.meeting_start_date = meeting_date1
                    this.meeting_start_time = start_time
                    this.meeting_end_date = meeting_date2
                    this.meeting_end_time = end_time
                    let meeting_n = start_date
                    let meeting_n_split = meeting_n.split("/")
                    var date1 = meeting_n_split[2] + '-' + meeting_n_split[1] + '-' + meeting_n_split[0];
                    let d_obj = new Date(date1 + ' ' + '00:00:00');
                    this.not_before_start_date = d_obj;
                }, 500);
                //this.loadUTCTime();
                this.createJson.branch_name = this.loggedInUser.branch_details.name,
                this.meeting_location_vmodel = this.createJson.meeting_location.street + ((this.createJson
                .meeting_location.street).length > 0 ? "," : '') + this.createJson
                .meeting_location.city + ((this.createJson.meeting_location.city).length > 0 ? "," : '') +
                this.createJson.meeting_location.state + ((this.createJson.meeting_location.state).length >
                0 ? "," : '') + this
                .createJson.meeting_location.zip_code + ((this.createJson.meeting_location.zip_code)
                .length > 0 ? "," : '') + this.createJson.meeting_location.country;

                if (this.createJson.lead_info.length < 1) {
                    this.createJson.lead_info = [{
                        id: "",
                        name: "",
                        company_name: "",
                        status:""  ,
                        is_lead_loading:false,
                        is_expanded:true
                    }]
                } else{
                    this.createJson.lead_info.forEach((x, index) => {
                        this.createJson.lead_info[index] = ({
                            id: x.id,
                            name: {
                                full_name: x.name
                            },
                            company_name: x.company_name,
                            status:x.status ,
                            is_lead_loading:false,
                            is_expanded:true
                        });
                    });
                }
                if (this.createJson.contact_info.length < 1) {
                    this.createJson.contact_info = [{
                        id: "",
                        name: "",
                        company_name: "",
                        is_contact_loading:false,
                        is_contact_expanded:true
                    }]
                } else{
                    this.createJson.contact_info.forEach((x, index) => {
                        this.createJson.contact_info[index] =({
                            id: x.id,
                            name: {
                                full_name: x.name
                            },
                            company_name: x.company_name,
                            is_contact_loading:false,
                            is_contact_expanded:true
                        });
                    });
                    //this.showContactDetails.push(index)
                }
                if (this.createJson.internal_company.other_attendees) {
                    this.createJson.internal_company.other_attendees.forEach((email, index) => {
                        this.createJson.internal_company.other_attendees[index] = {
                            email: email.email_id,
                            full_name: email.full_name
                        };

                    });
                }
                if(this.createJson.hasOwnProperty("external_attendees")){
                    if(this.createJson.external_attendees.length < 1){
                        this.createJson.external_attendees = [{
                            company_name: "",
                            primary_employee: "",
                            secondary_employees: [],
                            department: "",
                            branch: "",
                            status: "",
                            id:"",
                            is_cust_expanded:true,
                        }]
                    }
                    else {
                        this.createJson.external_attendees.forEach((item, index) => {
                            if(item.hasOwnProperty('secondary_employees')) {
                                // item.secondary_employees.forEach((element, item_index) => {
                                //     item.secondary_employees[item_index] = {
                                //         primary_email: element
                                //     };
                                // });
                                let secondary_list = []
                                if (Array.isArray(item.secondary_employees)) {
                                    secondary_list = item.secondary_employees
                                } else if (item.secondary_employees) {
                                    secondary_list = [item.secondary_employees]
                                }
                                item.secondary_employees = secondary_list.map((element) => {
                                    if (element && element.primary_email && typeof element.primary_email == 'string') {
                                        return { primary_email: element.primary_email }
                                    } else if (typeof element == 'string' && element != '') {
                                        return { primary_email: element }
                                    }
                                    return null
                                }).filter((element) => element)
                            }
                            this.createJson.external_attendees[index] = {
                                branch: item.branch,
                                department: item.department,
                                company_name: {
                                    customer_name: item.name,
                                    id:item.id
                                },
                                primary_employee: {
                                    primary_email:item.primary_employee
                                },
                                // secondary_employees: item.secondary_employees || '',
                                secondary_employees: item.secondary_employees || [],
                                status: item.status,
                                is_cust_expanded:true
                            }
                            this.showExternal.push(index)
                        });
                    }
                }
                else {
                    Object.assign(this.createJson, {
                    external_attendees: [{
                            company_name: "",
                            primary_employee: "",
                            secondary_employees: [],
                            department: "",
                            branch: "",
                            status: "",
                            id:"",
                            is_cust_expanded:true
                        }, ],
                    });
                }
                if(this.createJson.follow_ups.length < 1){
                        this.createJson.follow_ups = [{
                            products: "",
                            assigned_to: "",
                            notes: "",
                            due_date: "",
                            price: null,
                            time:"",
                            is_follow_expanded:true
                        }]
                    } else if (this.createJson.hasOwnProperty("follow_ups")) {
                        if (this.createJson.follow_ups.length) {
                            this.createJson.follow_ups.forEach((x, index) => {
                                x['is_follow_expanded'] = true
                                //this.showFollowUps.push(index)
                                this.showFollowUpsNotes.push(index);
                                this.$forceUpdate()
                            });
                        } else {
                            this.createJson.follow_ups.push({
                                products: "",
                                assigned_to: "",
                                notes: "",
                                due_date: "",
                                price: null,
                                time:"",
                                is_follow_expanded:true,
                            }, );
                        }
                    }
            },
        },
        created() {
            this.internalCompanyObject = this.account;
            for (let i = 0; i < 6; i++) {
                let year = new Date().getFullYear();
                this.years_to_set.push(year + i);
            };

            this.internalCompanyObject = this.account;
            for (let i = 0; i < 6; i++) {
                let year = new Date().getFullYear();
                this.years_to_set.push(year + i);
            };
            this.createJson.sales_target.forecast[0].target_year = this.years_to_set[0] + "-" + this.years_to_set[
                1];
            this.salestarget.target_year = this.years_to_set[0] + "-" + this.years_to_set[1];
            this.createJson.internal_company.branch = this.loggedInUser.branch_details;
            this.createJson.internal_company.branch_name = this.loggedInUser.branch_details.name
            this.createJson.internal_company.department = this.loggedInUser.department_details.name;

            if (localStorage.hasOwnProperty("partToShow")) {
                let part = localStorage.getItem("partToShow");
                if (part == "callreporttab") {
                    this.callreporttab = true;
                    this.meetingnotestab = false;
                    this.followuptab = false;
                    this.salestargettab = false;
                } else if (part == "meetingnotestab") {
                    this.callreporttab = false;
                    this.meetingnotestab = true;
                    this.followuptab = false;
                    this.salestargettab = false;
                } else if (part == "followuptab") {
                    this.callreporttab = false;
                    this.meetingnotestab = false;
                    this.followuptab = true;
                    this.salestargettab = false;
                } else if (part == "salestargettab") {
                    this.callreporttab = false;
                    this.meetingnotestab = false;
                    this.followuptab = false;
                    this.salestargettab = true;
                }
            }
            const dict = {
                custom: {
                    internal_branch_name: {
                        required: () => "Internal branch is required"
                    },
                    external_employee_attendees: {
                        required: () => "Email Address is required",
                        email: () => "Please Enter Valid Email Address"
                    },
                    external_employee_attendee: {
                        required: () => "Email Address is required",
                        email: () => "Please Enter Valid Email Address"
                    },
                    email_recipients: {
                        email: () => "Please Enter Valid Email Address"
                    }
                },

            }
            this.$validator.localize("en", dict);
            this.loadEmployeeSearch = debounce(this.loadEmployeeSearchDebouncer, 500)
            this.loadEmployeeSearchExternal = debounce(this.loadEmployeeSearchExternalDebouncer, 500)
            this.searchLeadName = debounce(this.searchLeadNameDebouncer, 500)
            this.searchContactName = debounce(this.searchContactNameDebouncer, 500)
            this.loadCompanySearch = debounce(this.loadCompanySearchDebouncer, 500)
            this.searchPrimaryAttendees = debounce(this.searchPrimaryAttendeesDebouncer, 500)
            this.searchSecondaryAttendees = debounce(this.searchSecondaryAttendeesDebouncer, 500)
            this.searchCustomerInside = debounce(this.searchCustomerInsideDebouncer, 500)
            this.searchPermissionEmail = debounce(this.searchPermissionEmailDebouncer, 500)
            this.searchGroup = debounce(this.searchGroupDebouncer, 500)
            this.searchPermissionTeam= debounce(this.searchPermissionTeamDebouncer, 500)
            this.getProduts= debounce(this.getProductsDebouncer, 500)
            this.assignToInside = debounce(this.assignToInsideDebouncer, 500)
            this.searchCompaniesInside = debounce(this.searchCompaniesInsideDebouncer, 500)
            this.fetchSalesPerson = debounce(this.fetchSalesPersonDebouncer, 500)
            this.searchUoms = debounce(this.searchUomsDebouncer, 500)

        },
        mounted() {
            this.showManualEntry = ''
            this.manualFallback = true;
            let data = JSON.parse(localStorage.getItem("meeting_id"))
            if(data){
                this.schedule_meeting = true
                this.meeting_id = data
                this.getMeetingData();
            }
            if (!this.$route.path.startsWith('/callreport')) {
                this.ajaxCallInProgress = true;
            }
            this.transition_format = this.loggedInUser.currency.symbol;
            setTimeout(()=>{
                EventBus.$on('edit_from_preview', () => {
                    this.editPreview = true
                });
            },500);
            setTimeout(() => {
                let copyData = JSON.parse(localStorage.getItem("meetingDetails"))
                if (copyData){
                    this.getCRDataFromDashboard()
                    this.loadLocalTime()
                } else if (this.createJson.title == '') {
                    this.loadLocalTime()
                }
            }, 1000);
            this.createJson.branch_name = this.loggedInUser.branch_details.name,
            this.assignTo();
            this.getProduts();
            this.getOrganisationSettings();
            if (!(localStorage.getItem("callReportCategory"))) {
                localStorage.setItem("callReportCategory", this.callReportCategory);
            }
            this.createJson.call_report_category = localStorage.getItem("callReportCategory");
            this.createJson.call_report_type = localStorage.getItem("callReportCategory");
            this.countries.forEach(x => {
                this.countriesCaps.push(x.toUpperCase());
            });
            this.createJson.author_name = this.loggedInUser.full_name;
            this.createJson.author_email = this.loggedInUser.login_id;
            EventBus.$on('load_countries', () => {
                this.countries.forEach(x => {
                    this.countriesCaps.push(x.toUpperCase());
                });
                this.createJson.receiver_type = "lead"
                this.createJson.general_access = "private"
                this.createJson.lead_info = [{
                        id: "",
                        name: "",
                        company_name: "",
                        status:""  ,
                        is_lead_loading:false,
                        is_expanded:true
                }]
                this.createJson.contact_info = [{
                    id: "",
                    name: "",
                    company_name: "",
                    is_contact_loading:false,
                    is_contact_expanded:true
                }]
                this.createJson.external_attendees = [{
                    company_name: "",
                    primary_employee: "",
                    secondary_employees: [],
                    department: "",
                    branch: "",
                    status: "",
                    id:"",
                    is_cust_expanded:true,
                    is_company_loading:false
                }]


                if (!this.$route.path.startsWith('copycallreport')) {
                    //this.loadLocalTime()
                    // this.createJson.meeting_date_from = new Date()
                    // this.$forceUpdate()
                    // this.createJson.meeting_date_to = new Date()
                    // this.$forceUpdate()
                }
                this.$validator.reset()
            })
            if (this.$route.path.startsWith('/copycallreport')) {
                setTimeout(() =>{
                    if(this.editPreview == false){
                        this.copyCallReport(this.$route.params.id);
                    } else {
                        if (localStorage.hasOwnProperty("callReportReviewData")) {
                            this.createJson = JSON.parse(localStorage.getItem(
                                "callReportReviewData"));
                            this.meeting_start_date = this.createJson.meeting_start_date
                            this.meeting_start_time = this.createJson.meeting_start_time
                            this.meeting_end_date = this.createJson.meeting_end_date
                            this.meeting_end_time = this.createJson.meeting_end_time
                            this.showSales = [];
                            this.createJson.sales_target.forecast.forEach((showSales_index_el, showSales_index) => {
                                if(this.createJson.sales_target.forecast.length != showSales_index){
                                    this.showSales.push(showSales_index);
                                }
                            });
                            this.$forceUpdate()
                            this.meeting_location_vmodel = this.createJson.meeting_location.street +
                                ((
                                        this.createJson.meeting_location.street).length > 0 ? ", " :
                                    '') +
                                this.createJson
                                .meeting_location.city + ((this.createJson.meeting_location.city)
                                    .length > 0 ? ", " : '') + this.createJson.meeting_location
                                .state +
                                ((this.createJson.meeting_location.state).length > 0 ? ", " : '') +
                                this
                                .createJson
                                .meeting_location.zip_code + ((this.createJson.meeting_location
                                    .zip_code).length > 0 ? ", " : '') + this.createJson
                                .meeting_location.country;
                        }
                        if (localStorage.hasOwnProperty("internalCompanyObject")) {
                            this.internalCompanyObject = JSON.parse(localStorage.getItem(
                                "internalCompanyObject"));
                        }
                        if (localStorage.hasOwnProperty("attachments")) {
                            this.attachments = JSON.parse(localStorage.getItem("attachments"));
                        }
                    }
                },1000);
                this.updateAttachments();
                this.$forceUpdate()
            }

            if (this.$route.params.id == 'new') {
                this.backToPrev()
            }
            if (this.$route.path.startsWith('/callreport')) {
                EventBus.$on('edit_from_preview', () => {
                this.editPreview = true
                    setTimeout(() => {
                        if (localStorage.hasOwnProperty("callReportReviewData")) {
                            this.createJson = JSON.parse(localStorage.getItem(
                                "callReportReviewData"));
                            this.meeting_start_date = this.createJson.meeting_start_date
                            this.meeting_start_time = this.createJson.meeting_start_time
                            this.meeting_end_date = this.createJson.meeting_end_date
                            this.meeting_end_time = this.createJson.meeting_end_time
                            this.showSales = [];
                            this.createJson.sales_target.forecast.forEach((showSales_index_el, showSales_index) => {
                                if(this.createJson.sales_target.forecast.length != showSales_index){
                                    this.showSales.push(showSales_index);
                                }
                            });
                            this.$forceUpdate()
                            //this.loadUTCTime()
                            this.meeting_location_vmodel = this.createJson.meeting_location.street +
                                ((
                                        this.createJson.meeting_location.street).length > 0 ? ", " :
                                    '') +
                                this.createJson
                                .meeting_location.city + ((this.createJson.meeting_location.city)
                                    .length > 0 ? ", " : '') + this.createJson.meeting_location
                                .state +
                                ((this.createJson.meeting_location.state).length > 0 ? ", " : '') +
                                this
                                .createJson
                                .meeting_location.zip_code + ((this.createJson.meeting_location
                                    .zip_code).length > 0 ? ", " : '') + this.createJson
                                .meeting_location.country;
                        }
                        if (this.createJson.contact_info.length) {
                            this.createJson.contact_info.forEach((x, index) => {
                                this.createJson.contact_info[index].is_lead_loading= false
                                //this.showContactDetails.push(index);
                            });
                        }
                        if (this.createJson.external_attendees.length) {
                            this.createJson.external_attendees.forEach((x, index) => {
                                this.createJson.external_attendees[index].is_company_loading= false
                                //this.showContactDetails.push(index);
                            });
                        }

                        if (this.createJson.lead_info.length) {
                            this.createJson.lead_info.forEach((x, index) => {
                                x['is_expanded'] = true
                                this.createJson.lead_info[index].is_lead_loading= false
                                //this.showReceiverDetails.push(index);
                            });
                        }

                        if (localStorage.hasOwnProperty("internalCompanyObject")) {
                            this.internalCompanyObject = JSON.parse(localStorage.getItem(
                                "internalCompanyObject"));
                        }
                        if (localStorage.hasOwnProperty("attachments")) {
                            this.attachments = JSON.parse(localStorage.getItem("attachments"));
                        }

                    }, 1500);
                    this.editPreview = false
                    this.$forceUpdate()

                })
                if (localStorage.hasOwnProperty("lead_data")) {
                    let lead_data = [] 
                    lead_data = JSON.parse(localStorage.getItem("lead_data"));
                    if(this.createJson.call_report_category === 'External Meeting' || this.createJson.call_report_category === 'Sales Meeting' || this.createJson.call_report_category === 'Release Notes'){
                        this.createJson.lead_info[0].id = lead_data.id
                        this.createJson.lead_info[0].name = lead_data.full_name == '' ? '-' : lead_data
                        this.createJson.lead_info[0].company_name = lead_data.company_name ? lead_data.company_name : '-'
                        this.createJson.lead_info[0].status = lead_data.lead_type ? lead_data.lead_type.replaceAll("_", " ") : '-'
                    }
                }
            }
            setTimeout(() => {
                this.ajaxCallInProgress = false;
            }, 2500);
        },
        beforeRouteLeave (to, from, next) {
            if(this.saveandclose == true){
                if(to.path != `/callreport` && to.path != `/callreportlist` && to.path != `/callreportreview` && to.path != `/copycallreportreview/${this.$route.params.id}` && to.path != `/copycallreport/${this.$route.params.id}`){
                    let message = "<img src='/static/images/exclamation-yellow.svg' class='d-block h-100px mx-auto mb-5'/><br><div class='d-block'>Unsaved Call Report Data would be lost <br><br> Do you want to proceed?</div>";
                    let options = {
                        html: true,
                        loader: false,
                        reverse: false, // switch the button positions (left to right, and vise versa)
                        okText: 'Yes',
                        cancelText: 'No',
                        animation: 'fade',
                        type: 'basic',
                        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
                        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
                        backdropClose: true,
                    };
                    this.$dialog.confirm(message, options)
                    .then(function () {
                        next();
                    })
                    .catch(function () {
                        next(false);
                    });
                } else {
                    next()
                }
            } else {
                if(to.path != `/callreport` && to.path != `/callreportreview` && to.path != `/copycallreportreview/${this.$route.params.id}` && to.path != `/copycallreport/${this.$route.params.id}`){
                    let message = "<img src='/static/images/exclamation-yellow.svg' class='d-block h-100px mx-auto mb-5'/><br><div class='d-block'>Unsaved Call Report Data would be lost <br><br> Do you want to proceed?</div>";
                    let options = {
                        html: true,
                        loader: false,
                        reverse: false, // switch the button positions (left to right, and vise versa)
                        okText: 'Yes',
                        cancelText: 'No',
                        animation: 'fade',
                        type: 'basic',
                        verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
                        verificationHelp: 'Type "[+:verification]" below to confirm', // Verification help text. [+:verification] will be matched with 'options.verification' (i.e 'Type "continue" below to confirm')
                        backdropClose: true,
                    };
                    this.$dialog.confirm(message, options)
                    .then(function () {
                        localStorage.removeItem("callReportCategory")
                        localStorage.removeItem("lead_data")
                        localStorage.removeItem("partToShow")
                        if(to.path.startsWith(`/leads/viewLeads`)){
                            localStorage.setItem('leads_type', 'Manual')
                        }
                        next();
                    })
                    .catch(function () {
                        next(false);
                    });
                } else {
                    next()
                }
            }
        },
        computed: {
            editor() {
                return this.$refs.myTextEditor.quill
            },
            contentCode() {
                return hljs.highlightAuto(this.content).value
            },
            searchProuctName(){
                return debounce(this.searchProuctNameDebouncer, 500)
            },
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            account() {
                return this.$store.getters.selectedCompany;
            },
            selectedCompany() {
                return this.$store.getters.selectedCompany;
            },
            callReportCategory() {
                return this.$store.getters.callReportCategory;
            },
            userPermissions() {
                return this.$store.getters.userPermissions;
            },
        },
        beforeDestroy() {
            localStorage.removeItem('individual_data');
            localStorage.removeItem('team_data')
        }
    };
</script>
<style>
    .input-field.placeholder-text-product::placeholder {
		font-weight: 600 !important;
		color: #000 !important;
	}
    .input-field.placeholder-text-product::-ms-input-placeholder {
		font-weight: 600 !important;
		color: #000 !important;
	}
    .input-field.placeholder-text-product::-webkit-input-placeholder {
		font-weight: 600 !important;
		color: #000 !important;
	}
    .mx-datepicker.dateborderDarkGrey.date-height .mx-input{
        height:42px !important;
    }
    .mx-datepicker-popup {
        position: absolute !important;
        margin-top: 8px !important;
        top: -144px !important;
    }

    .block-callreport {
        border-radius: 11px;
        box-shadow: 0 1.5px 3px 0 rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
        padding: 5px 50px 15px 50px;
        margin-bottom: 22px;
    }

    .doccrm .example>.description {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 8px 12px;
        border-bottom: 1px solid transparent;
    }

    .doccrm .example>.description .description-text h5 {
        font-size: 14px;
        font-weight: 600;
        margin: 0;
    }

    .doccrm .example>.description .toggle-source-preview {
        cursor: pointer;
        font-family: inherit;
        font-size: 12px;
        margin-left: auto;
        padding-left: 24px;
        color: rgba(0, 0, 0, 0.54);
    }

    .doccrm .example {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 0px;
        height: 100%;
        position: relative;
        opacity: 1;
        border-radius: 5px;
        background-color: rgba(13, 132, 242, 0.4);
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .doccrm .example>.description .description-text h5 {
        text-align: center;
        color: #303031 !important;
        font-size: 16px;
        font-weight: 600;
    }

    .infoHeaderHideShow {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 40px;
        position: relative;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 5px;
        line-height: 40px;
        cursor: pointer;
    }

    .infoHeaderHideShow>.descriptionheader {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 4px 10px;
        background-color: #00448b;
        border-radius: 2px;
        /* border-bottom: 1px solid transparent; */
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-left h5 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
        color: #ffffff !important;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right {
        font-size: 13px;
        margin-left: auto;
        padding-left: 12px;
        color: #00448b;
        font-weight: 500;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right {
        width: 100%;
        margin-left: 10px;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right i {
        color: #00448b;
        font-size: 24px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        cursor: pointer;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right img {
        float: right;
        color: #00448b;
        width: 28px;
        cursor: pointer;
        position: absolute;
        right: 0px;
        bottom: -15px;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-left h5 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
        color: #ffffff;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right-small {
        font-size: 13px;
        margin-left: auto;
        padding-left: 12px;
        color: #00448b;
        font-weight: 500;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right-small {
        display: block;
        border-bottom: 1px solid #b2b2b3;
        width: 100%;
        margin-left: 10px;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right-small i {
        color: #00448b;
        font-size: 16px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        cursor: pointer;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right-small img {
        float: right;
        color: #00448b;
        width: 28px;
        cursor: pointer;
        position: absolute;
        right: 3px;
        bottom: -15px;
    }

    .iconRotate {
        transform: rotate(0deg) !important;
    }

    .whiteSpace {
        white-space: nowrap;
    }

    .collapse-addon {
        position: relative;
        display: flex;
        float: right;
        cursor: pointer;
    }

    .rotateIcon {
        transform: rotate(180deg);
    }

    .callreport-uk-text-truncate {
        display: block;
    }

    .callreport-uk-text-truncate {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .quillWrapper {
        background: #fff;
        border-radius: 6px;
    }

    .ql-container.ql-snow {
        border-radius: 0px 0px 6px 6px;
    }

    .btn-transparent-grey {
        border: 1px solid #00448b;
        color: #00448b;
        background: transparent;
    }

    .callreport-section {
        text-align: left;
        padding-top: 0px;
        padding-bottom: 20px;
    }

    .callreportpanel.callreportpanel-prod {
        margin-bottom: 0px;
        background-color: transparent;
        border: 1px solid transparent;
        border-radius: 0px;
        -webkit-box-shadow: none;
        box-shadow: none;
        color: #303031;
        padding: 0.8rem 1.2rem;
    }

    .callreportpanel.callreportpanel-prod.prod-h {
        padding: 1.8rem 1.2rem;
    }

    .callreportpanel-body.callreportpanel-prod:before {
        content: " ";
        display: table;
    }

    .callreportprod {
        margin-top: 0px;
        position: relative;
    }

    .callreportprod,
    .callreportprod .callreport-body {
        zoom: 1;
        overflow: visible;
    }

    .callreportprod .callreport-body {
        display: table-cell;
        vertical-align: top;
        position: relative;
    }

    .callreportprod .callreport-body.callreport-text-middle {
        display: table-cell;
        vertical-align: middle;
        position: relative;
    }

    .callreportprod .callreport-left,
    .callreportprod .callreport-right {
        display: table-cell;
        vertical-align: middle;
        position: relative;
    }

    .callreportprod .callreport-left {
        padding-right: 20px;
    }

    .callreportprod .callreport-left a {
        outline: 0;
        cursor: pointer;
        text-decoration: none;
        background-color: transparent;
    }

    .callreportprod .callreport-body {
        width: 10000px;
    }

    .callreportprod .callreport-left .divimg {
        width: 40px !important;
        height: 40px !important;
        line-height: 36px !important;
        border: 1px solid #00448b;
        border-radius: 50%;
    }

    .callreportprod .callreport-left .divimg img {
        width: 35px !important;
        height: 35px !important;
        line-height: 35px !important;
        border-radius: 50%;
        margin-left: 1px;
    }

    .callreportprod .callreport-body h6.callreport-heading {
        margin-bottom: 2px;
        display: block;
        margin-top: 0;
        font-size: 15px;
        letter-spacing: -0.015em;
        line-height: 1.5384616;
        color: #303031;
        width: 170px;
        font-weight: bold;
    }

    .callreportprod .callreport-body p {
        margin: 0 0 10px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0.6px;
        margin: 1px 0 1px 0;
        color: #303031;
        width: 145px;
        height: 24px;
    }

    .callreportprod .callreport-right {
        padding-left: 5px;
    }

    .callreportprod .callreport-right i {
        color: #00448b;
    }

    .callreport-middle {
        vertical-align: middle;
    }

    .callreport-uk-grid {
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -ms-flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .callreport-uk-grid:after,
    .callreport-uk-grid:before {
        content: "";
        display: block;
        overflow: hidden;
    }

    .callreport-uk-grid:after {
        clear: both;
    }

    .callreport-uk-grid>* {
        -ms-flex: none;
        -webkit-flex: none;
        flex: none;
        margin: 0;
        float: left;
    }

    .callreport-uk-grid>*> :last-child {
        margin-bottom: 0;
    }

    .callreport-uk-grid {
        margin-left: -25px;
    }

    .callreport-uk-grid>* {
        padding-left: 25px;
    }

    .callreport-uk-grid+.callreport-uk-grid,
    .callreport-uk-grid-margin,
    .callreport-uk-grid>*>.callreport-uk-panel+.callreport-uk-panel {
        margin-top: 25px;
    }

    @media (min-width: 1220px) {
        .callreport-uk-grid {
            margin-left: -35px;
        }

        .callreport-uk-grid>* {
            padding-left: 35px;
        }

        .callreport-uk-grid+.callreport-uk-grid,
        .callreport-uk-grid-margin,
        .callreport-uk-grid>*>.callreport-uk-panel+.callreport-uk-panel {
            margin-top: 35px;
        }
    }

    .callreport-uk-grid-collapse {
        margin-left: 0;
    }

    .callreport-uk-grid-collapse>* {
        padding-left: 0;
    }

    .callreport-uk-grid-collapse+.callreport-uk-grid-collapse,
    .callreport-uk-grid-collapse>*>.callreport-uk-panel+.callreport-uk-panel,
    .callreport-uk-grid-collapse>.callreport-uk-grid-margin {
        margin-top: 0;
    }

    .callreport-uk-grid-small {
        margin-left: -10px;
    }

    .callreport-uk-grid-small>* {
        padding-left: 10px;
    }

    .callreport-uk-grid-small+.callreport-uk-grid-small,
    .callreport-uk-grid-small>*>.callreport-uk-panel+.callreport-uk-panel,
    .callreport-uk-grid-small>.callreport-uk-grid-margin {
        margin-top: 10px;
    }

    .callreport-uk-grid-medium {
        margin-left: -25px;
    }

    .callreport-uk-grid-medium>* {
        padding-left: 25px;
    }

    .callreport-uk-grid-medium+.callreport-uk-grid-medium,
    .callreport-uk-grid-medium>*>.callreport-uk-panel+.callreport-uk-panel,
    .callreport-uk-grid-medium>.callreport-uk-grid-margin {
        margin-top: 25px;
    }

    @media (min-width: 960px) {
        .callreport-uk-grid-large {
            margin-left: -35px;
        }

        .callreport-uk-grid-large>* {
            padding-left: 35px;
        }

        .callreport-uk-grid-large+.callreport-uk-grid-large,
        .callreport-uk-grid-large-margin,
        .callreport-uk-grid-large>*>.callreport-uk-panel+.callreport-uk-panel {
            margin-top: 35px;
        }
    }

    @media (min-width: 1220px) {
        .callreport-uk-grid-large {
            margin-left: -50px;
        }

        .callreport-uk-grid-large>* {
            padding-left: 50px;
        }

        .callreport-uk-grid-large+.callreport-uk-grid-large,
        .callreport-uk-grid-large-margin,
        .callreport-uk-grid-large>*>.callreport-uk-panel+.callreport-uk-panel {
            margin-top: 50px;
        }
    }

    .callreport-uk-grid-divider:not(:empty) {
        margin-left: -25px;
        margin-right: -25px;
    }

    .callreport-uk-grid-divider>* {
        padding-left: 25px;
        padding-right: 25px;
    }

    .callreport-uk-grid-divider>[class*="callreport-uk-width-9-"]:nth-child(n + 2),
    .callreport-uk-grid-divider>[class*="callreport-uk-width-1-"]:not(.callreport-uk-width-1-1):nth-child(n + 2),
    .callreport-uk-grid-divider>[class*="callreport-uk-width-2-"]:nth-child(n + 2),
    .callreport-uk-grid-divider>[class*="callreport-uk-width-3-"]:nth-child(n + 2),
    .callreport-uk-grid-divider>[class*="callreport-uk-width-4-"]:nth-child(n + 2),
    .callreport-uk-grid-divider>[class*="callreport-uk-width-5-"]:nth-child(n + 2),
    .callreport-uk-grid-divider>[class*="callreport-uk-width-6-"]:nth-child(n + 2),
    .callreport-uk-grid-divider>[class*="callreport-uk-width-7-"]:nth-child(n + 2),
    .callreport-uk-grid-divider>[class*="callreport-uk-width-8-"]:nth-child(n + 2) {
        border-left: 1px solid #ddd;
    }

    @media (min-width: 768px) {
        .callreport-uk-grid-divider>[class*="callreport-uk-width-medium-"]:not(.callreport-uk-width-medium-1-1):nth-child(n + 2) {
            border-left: 1px solid #ddd;
        }
    }

    @media (min-width: 960px) {
        .callreport-uk-grid-divider>[class*="callreport-uk-width-large-"]:not(.callreport-uk-width-large-1-1):nth-child(n + 2) {
            border-left: 1px solid #ddd;
        }
    }

    @media (min-width: 1220px) {
        .callreport-uk-grid-divider:not(:empty) {
            margin-left: -35px;
            margin-right: -35px;
        }

        .callreport-uk-grid-divider>* {
            padding-left: 35px;
            padding-right: 35px;
        }

        .callreport-uk-grid-divider:empty {
            margin-top: 35px;
            margin-bottom: 35px;
        }
    }

    .callreport-uk-grid-divider:empty {
        margin-top: 25px;
        margin-bottom: 25px;
        border-top: 1px solid #ddd;
    }

    .callreport-uk-grid-match>* {
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -ms-flex-wrap: wrap;
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
    }

    .callreport-uk-grid-match>*>* {
        -ms-flex: none;
        -webkit-flex: none;
        flex: none;
        box-sizing: border-box;
        width: 100%;
    }

    /* [class*=callreport-uk-grid-width]>*{
    box-sizing:border-box;
    width:100%
} */
    .callreport-uk-grid-width-1-2>* {
        width: 50%;
    }

    .callreport-uk-grid-width-1-3>* {
        width: 33.333%;
    }

    .callreport-uk-grid-width-1-4>* {
        width: 25%;
    }

    .callreport-uk-grid-width-1-5>* {
        width: 20%;
    }

    .callreport-uk-grid-width-1-6>* {
        width: 16.666%;
    }

    .callreport-uk-grid-width-1-10>* {
        width: 10%;
    }

    .callreport-uk-grid-width-auto>* {
        width: auto;
    }

    @media (min-width: 480px) {
        .callreport-uk-grid-width-small-1-1>* {
            width: 100%;
        }

        .callreport-uk-grid-width-small-1-2>* {
            width: 50%;
        }

        .callreport-uk-grid-width-small-1-3>* {
            width: 33.333%;
        }

        .callreport-uk-grid-width-small-1-4>* {
            width: 25%;
        }

        .callreport-uk-grid-width-small-1-5>* {
            width: 20%;
        }

        .callreport-uk-grid-width-small-1-6>* {
            width: 16.666%;
        }

        .callreport-uk-grid-width-small-1-10>* {
            width: 10%;
        }
    }

    @media (min-width: 768px) {
        .callreport-uk-grid-width-medium-1-1>* {
            width: 100%;
        }

        .callreport-uk-grid-width-medium-1-2>* {
            width: 50%;
        }

        .callreport-uk-grid-width-medium-1-3>* {
            width: 33.333%;
        }

        .callreport-uk-grid-width-medium-1-4>* {
            width: 25%;
        }

        .callreport-uk-grid-width-medium-1-5>* {
            width: 20%;
        }

        .callreport-uk-grid-width-medium-1-6>* {
            width: 16.666%;
        }

        .callreport-uk-grid-width-medium-1-10>* {
            width: 10%;
        }
    }

    @media (min-width: 960px) {
        .callreport-uk-grid-width-large-1-1>* {
            width: 100%;
        }

        .callreport-uk-grid-width-large-1-2>* {
            width: 50%;
        }

        .callreport-uk-grid-width-large-1-3>* {
            width: 33.333%;
        }

        .callreport-uk-grid-width-large-1-31>* {
            width: 31.333%;
        }

        .callreport-uk-grid-width-large-1-4>* {
            width: 25%;
        }

        .callreport-uk-grid-width-large-1-24>* {
            width: 24%;
        }

        .callreport-uk-grid-width-large-1-5>* {
            width: 20%;
        }

        .callreport-uk-grid-width-large-1-6>* {
            width: 16.666%;
        }

        .callreport-uk-grid-width-large-1-10>* {
            width: 10%;
        }
    }

    @media (min-width: 1220px) {
        .callreport-uk-grid-width-xlarge-1-1>* {
            width: 100%;
        }

        .callreport-uk-grid-width-xlarge-1-2>* {
            width: 50%;
        }

        .callreport-uk-grid-width-xlarge-1-3>* {
            width: 33.333%;
        }

        .callreport-uk-grid-width-xlarge-1-32>* {
            width: 32.333%;
        }

        .callreport-uk-grid-width-xlarge-1-4>* {
            width: 25%;
        }

        .callreport-uk-grid-width-xlarge-1-5>* {
            width: 20%;
        }

        .callreport-uk-grid-width-xlarge-1-23>* {
            width: 23%;
        }

        .callreport-uk-grid-width-xlarge-1-6>* {
            width: 16.666%;
        }

        .callreport-uk-grid-width-xlarge-1-16>* {
            width: 16% !important;
        }

        .callreport-uk-grid-width-xlarge-1-10>* {
            width: 10%;
        }
    }

    [class*="callreport-uk-width"] {
        box-sizing: border-box;
        width: 100%;
    }

    .callreport-uk-width-1-1 {
        width: 100%;
    }

    .callreport-uk-width-1-2,
    .callreport-uk-width-2-4,
    .callreport-uk-width-3-6,
    .callreport-uk-width-5-10 {
        width: 50%;
    }

    .callreport-uk-width-1-3,
    .callreport-uk-width-2-6 {
        width: 33.333%;
    }

    .callreport-uk-width-2-3,
    .callreport-uk-width-4-6 {
        width: 66.666%;
    }

    .callreport-uk-width-1-4 {
        width: 25%;
    }

    .callreport-uk-width-3-4 {
        width: 75%;
    }

    .callreport-uk-width-1-5,
    .callreport-uk-width-2-10 {
        width: 20%;
    }

    .callreport-uk-width-2-5,
    .callreport-uk-width-4-10 {
        width: 40%;
    }

    .callreport-uk-width-3-5,
    .callreport-uk-width-6-10 {
        width: 60%;
    }

    .callreport-uk-width-4-5,
    .callreport-uk-width-8-10 {
        width: 80%;
    }

    .callreport-uk-width-1-6 {
        width: 16.666%;
    }

    .callreport-uk-width-5-6 {
        width: 83.333%;
    }

    .callreport-uk-width-1-10 {
        width: 10%;
    }

    .callreport-uk-width-3-10 {
        width: 30%;
    }

    .callreport-uk-width-7-10 {
        width: 70%;
    }

    .callreport-uk-width-9-10 {
        width: 90%;
    }

    @media (min-width: 480px) {
        .callreport-uk-width-small-1-1 {
            width: 100%;
        }

        .callreport-uk-width-small-1-2,
        .callreport-uk-width-small-2-4,
        .callreport-uk-width-small-3-6,
        .callreport-uk-width-small-5-10 {
            width: 50%;
        }

        .callreport-uk-width-small-1-3,
        .callreport-uk-width-small-2-6 {
            width: 33.333%;
        }

        .callreport-uk-width-small-2-3,
        .callreport-uk-width-small-4-6 {
            width: 66.666%;
        }

        .callreport-uk-width-small-1-4 {
            width: 25%;
        }

        .callreport-uk-width-small-3-4 {
            width: 75%;
        }

        .callreport-uk-width-small-1-5,
        .callreport-uk-width-small-2-10 {
            width: 20%;
        }

        .callreport-uk-width-small-2-5,
        .callreport-uk-width-small-4-10 {
            width: 40%;
        }

        .callreport-uk-width-small-3-5,
        .callreport-uk-width-small-6-10 {
            width: 60%;
        }

        .callreport-uk-width-small-4-5,
        .callreport-uk-width-small-8-10 {
            width: 80%;
        }

        .callreport-uk-width-small-1-6 {
            width: 16.666%;
        }

        .callreport-uk-width-small-5-6 {
            width: 83.333%;
        }

        .callreport-uk-width-small-1-10 {
            width: 10%;
        }

        .callreport-uk-width-small-3-10 {
            width: 30%;
        }

        .callreport-uk-width-small-7-10 {
            width: 70%;
        }

        .callreport-uk-width-small-9-10 {
            width: 90%;
        }
    }

    @media (min-width: 768px) {
        .callreport-uk-width-medium-1-1 {
            width: 100%;
        }

        .callreport-uk-width-medium-1-2,
        .callreport-uk-width-medium-2-4,
        .callreport-uk-width-medium-3-6,
        .callreport-uk-width-medium-5-10 {
            width: 50%;
        }

        .callreport-uk-width-medium-1-3,
        .callreport-uk-width-medium-2-6 {
            width: 33.333%;
        }

        .callreport-uk-width-medium-2-3,
        .callreport-uk-width-medium-4-6 {
            width: 66.666%;
        }

        .callreport-uk-width-medium-1-4 {
            width: 25%;
        }

        .callreport-uk-width-medium-3-4 {
            width: 75%;
        }

        .callreport-uk-width-medium-1-5,
        .callreport-uk-width-medium-2-10 {
            width: 20%;
        }

        .callreport-uk-width-medium-2-5,
        .callreport-uk-width-medium-4-10 {
            width: 40%;
        }

        .callreport-uk-width-medium-3-5,
        .callreport-uk-width-medium-6-10 {
            width: 60%;
        }

        .callreport-uk-width-medium-4-5,
        .callreport-uk-width-medium-8-10 {
            width: 80%;
        }

        .callreport-uk-width-medium-1-6 {
            width: 16.666%;
        }

        .callreport-uk-width-medium-5-6 {
            width: 83.333%;
        }

        .callreport-uk-width-medium-1-10 {
            width: 10%;
        }

        .callreport-uk-width-medium-3-10 {
            width: 30%;
        }

        .callreport-uk-width-medium-7-10 {
            width: 70%;
        }

        .callreport-uk-width-medium-9-10 {
            width: 90%;
        }
    }

    @media (min-width: 960px) {
        .callreport-uk-width-large-1-1 {
            width: 100%;
        }

        .callreport-uk-width-large-1-2,
        .callreport-uk-width-large-2-4,
        .callreport-uk-width-large-3-6,
        .callreport-uk-width-large-5-10 {
            width: 50%;
        }

        .callreport-uk-width-large-1-3,
        .callreport-uk-width-large-2-6 {
            width: 33.333%;
        }

        .callreport-uk-width-large-2-3,
        .callreport-uk-width-large-4-6 {
            width: 66.666%;
        }

        .callreport-uk-width-large-1-4 {
            width: 25%;
        }

        .callreport-uk-width-large-3-4 {
            width: 75%;
        }

        .callreport-uk-width-large-1-5,
        .callreport-uk-width-large-2-10 {
            width: 20%;
        }

        .callreport-uk-width-large-2-5,
        .callreport-uk-width-large-4-10 {
            width: 40%;
        }

        .callreport-uk-width-large-3-5,
        .callreport-uk-width-large-6-10 {
            width: 60%;
        }

        .callreport-uk-width-large-4-5,
        .callreport-uk-width-large-8-10 {
            width: 80%;
        }

        .callreport-uk-width-large-1-6 {
            width: 16.666%;
        }

        .callreport-uk-width-large-5-6 {
            width: 83.333%;
        }

        .callreport-uk-width-large-1-10 {
            width: 10%;
        }

        .callreport-uk-width-large-3-10 {
            width: 30%;
        }

        .callreport-uk-width-large-7-10 {
            width: 70%;
        }

        .callreport-uk-width-large-9-10 {
            width: 90%;
        }
    }

    @media (min-width: 1220px) {
        .callreport-uk-width-xlarge-1-1 {
            width: 100%;
        }

        .callreport-uk-width-xlarge-1-2,
        .callreport-uk-width-xlarge-2-4,
        .callreport-uk-width-xlarge-3-6,
        .callreport-uk-width-xlarge-5-10 {
            width: 50%;
        }

        .callreport-uk-width-xlarge-1-3,
        .callreport-uk-width-xlarge-2-6 {
            width: 33.333%;
        }

        .callreport-uk-width-xlarge-2-3,
        .callreport-uk-width-xlarge-4-6 {
            width: 66.666%;
        }

        .callreport-uk-width-xlarge-1-4 {
            width: 25%;
        }

        .callreport-uk-width-xlarge-3-4 {
            width: 75%;
        }

        .callreport-uk-width-xlarge-1-5,
        .callreport-uk-width-xlarge-2-10 {
            width: 20%;
        }

        .callreport-uk-width-xlarge-2-5,
        .callreport-uk-width-xlarge-4-10 {
            width: 40%;
        }

        .callreport-uk-width-xlarge-3-5,
        .callreport-uk-width-xlarge-6-10 {
            width: 60%;
        }

        .callreport-uk-width-xlarge-4-5,
        .callreport-uk-width-xlarge-8-10 {
            width: 80%;
        }

        .callreport-uk-width-xlarge-1-6 {
            width: 16.666%;
        }

        .callreport-uk-width-xlarge-5-6 {
            width: 83.333%;
        }

        .callreport-uk-width-xlarge-1-10 {
            width: 10%;
        }

        .callreport-uk-width-xlarge-3-10 {
            width: 30%;
        }

        .callreport-uk-width-xlarge-7-10 {
            width: 70%;
        }

        .callreport-uk-width-xlarge-9-10 {
            width: 90%;
        }
    }

    @media (min-width: 768px) {

        [class*="callreport-uk-push-"],
        [class*="callreport-uk-pull-"] {
            position: relative;
        }

        .callreport-uk-push-1-2,
        .callreport-uk-push-2-4,
        .callreport-uk-push-3-6,
        .callreport-uk-push-5-10 {
            left: 50%;
        }

        .callreport-uk-push-1-3,
        .callreport-uk-push-2-6 {
            left: 33.333%;
        }

        .callreport-uk-push-2-3,
        .callreport-uk-push-4-6 {
            left: 66.666%;
        }

        .callreport-uk-push-1-4 {
            left: 25%;
        }

        .callreport-uk-push-3-4 {
            left: 75%;
        }

        .callreport-uk-push-1-5,
        .callreport-uk-push-2-10 {
            left: 20%;
        }

        .callreport-uk-push-2-5,
        .callreport-uk-push-4-10 {
            left: 40%;
        }

        .callreport-uk-push-3-5,
        .callreport-uk-push-6-10 {
            left: 60%;
        }

        .callreport-uk-push-4-5,
        .callreport-uk-push-8-10 {
            left: 80%;
        }

        .callreport-uk-push-1-6 {
            left: 16.666%;
        }

        .callreport-uk-push-5-6 {
            left: 83.333%;
        }

        .callreport-uk-push-1-10 {
            left: 10%;
        }

        .callreport-uk-push-3-10 {
            left: 30%;
        }

        .callreport-uk-push-7-10 {
            left: 70%;
        }

        .callreport-uk-push-9-10 {
            left: 90%;
        }

        .callreport-uk-pull-1-2,
        .callreport-uk-pull-2-4,
        .callreport-uk-pull-3-6,
        .callreport-uk-pull-5-10 {
            left: -50%;
        }

        .callreport-uk-pull-1-3,
        .callreport-uk-pull-2-6 {
            left: -33.333%;
        }

        .callreport-uk-pull-2-3,
        .callreport-uk-pull-4-6 {
            left: -66.666%;
        }

        .callreport-uk-pull-1-4 {
            left: -25%;
        }

        .callreport-uk-pull-3-4 {
            left: -75%;
        }

        .callreport-uk-pull-1-5,
        .callreport-uk-pull-2-10 {
            left: -20%;
        }

        .callreport-uk-pull-2-5,
        .callreport-uk-pull-4-10 {
            left: -40%;
        }

        .callreport-uk-pull-3-5,
        .callreport-uk-pull-6-10 {
            left: -60%;
        }

        .callreport-uk-pull-4-5,
        .callreport-uk-pull-8-10 {
            left: -80%;
        }

        .callreport-uk-pull-1-6 {
            left: -16.666%;
        }

        .callreport-uk-pull-5-6 {
            left: -83.333%;
        }

        .callreport-uk-pull-1-10 {
            left: -10%;
        }

        .callreport-uk-pull-3-10 {
            left: -30%;
        }

        .callreport-uk-pull-7-10 {
            left: -70%;
        }

        .callreport-uk-pull-9-10 {
            left: -90%;
        }
    }

    .callreport-uk-panel {
        display: block;
        position: relative;
    }

    .callreport-uk-panel,
    .callreport-uk-panel:hover {
        text-decoration: none;
    }

    .callreport-uk-panel:after,
    .callreport-uk-panel:before {
        content: "";
        display: table;
    }

    .callreport-uk-panel:after {
        clear: both;
    }

    .callreport-uk-panel> :not(.callreport-uk-panel-title):last-child {
        margin-bottom: 0;
    }

    .callreport-uk-panel-title {
        margin-top: 0;
        margin-bottom: 15px;
        font-size: 18px;
        line-height: 24px;
        font-weight: 400;
        text-transform: none;
        color: #444;
    }

    .callreport-uk-panel-badge {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 1;
    }

    .callreport-uk-panel-teaser {
        margin-bottom: 15px;
    }

    .callreport-uk-panel-body {
        padding: 15px;
    }

    .callreport-uk-panel-box {
        padding: 15px;
        background: #fafafa;
        color: #444;
        border: 1px solid #ddd;
        border-radius: 4px;
    }

    .callreport-uk-panel-box-hover:hover {
        color: #444;
    }

    .callreport-uk-panel-box .callreport-uk-panel-title {
        color: #444;
    }

    .callreport-uk-panel-box .callreport-uk-panel-badge {
        top: 10px;
        right: 10px;
    }

    .callreport-uk-panel-box>.callreport-uk-panel-teaser {
        margin-top: -16px;
        margin-left: -16px;
        margin-right: -16px;
    }

    .callreport-uk-panel-box>.callreport-uk-nav-side {
        margin: 0 -15px;
    }

    .callreport-uk-panel-box-primary {
        background-color: #ebf7fd;
        color: #2d7091;
        border-color: rgba(45, 112, 145, 0.3);
    }

    .callreport-uk-panel-box-primary-hover:hover {
        color: #2d7091;
    }

    .callreport-uk-panel-box-primary .callreport-uk-panel-title {
        color: #2d7091;
    }

    .callreport-uk-panel-box-secondary {
        background-color: #fff;
        color: #444;
    }

    .callreport-uk-panel-box-secondary-hover:hover {
        color: #444;
    }

    .callreport-uk-panel-box-secondary .callreport-uk-panel-title {
        color: #444;
    }

    .callreport-uk-panel-hover {
        padding: 15px;
        color: #444;
        border: 1px solid transparent;
        border-radius: 4px;
    }

    .callreport-uk-panel-hover:hover {
        background: #fafafa;
        color: #444;
        border-color: #ddd;
    }

    .callreport-uk-panel-hover .callreport-uk-panel-badge {
        top: 10px;
        right: 10px;
    }

    .callreport-uk-panel-hover>.callreport-uk-panel-teaser {
        margin-top: -16px;
        margin-left: -16px;
        margin-right: -16px;
    }

    .callreport-uk-panel-header .callreport-uk-panel-title {
        padding-bottom: 10px;
        border-bottom: 1px solid #ddd;
        color: #444;
    }

    .callreport-uk-panel-space {
        padding: 30px;
    }

    .callreport-uk-panel-space .callreport-uk-panel-badge {
        top: 30px;
        right: 30px;
    }

    .callreport-uk-panel+.callreport-uk-panel-divider {
        margin-top: 50px !important;
    }

    .callreport-uk-panel+.callreport-uk-panel-divider:before {
        content: "";
        display: block;
        position: absolute;
        top: -25px;
        left: 0;
        right: 0;
        border-top: 1px solid #ddd;
    }

    @media (min-width: 1220px) {
        .callreport-uk-panel+.callreport-uk-panel-divider {
            margin-top: 70px !important;
        }

        .callreport-uk-panel+.callreport-uk-panel-divider:before {
            top: -35px;
        }
    }

    .callreport-uk-panel-box .callreport-uk-panel-teaser {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        overflow: hidden;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }

    .callreport-uk-block {
        position: relative;
        box-sizing: border-box;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    @media (min-width: 768px) {
        .callreport-uk-block {
            padding-top: 50px;
            padding-bottom: 50px;
        }
    }

    .callreport-uk-block:after,
    .callreport-uk-block:before {
        content: "";
        display: table;
    }

    .callreport-uk-block:after {
        clear: both;
    }

    .callreport-uk-block> :last-child {
        margin-bottom: 0;
    }

    .callreport-uk-block-large {
        padding-top: 20px;
        padding-bottom: 20px;
    }

    @media (min-width: 768px) {
        .callreport-uk-block-large {
            padding-top: 50px;
            padding-bottom: 50px;
        }
    }

    @media (min-width: 960px) {
        .callreport-uk-block-large {
            padding-top: 100px;
            padding-bottom: 100px;
        }
    }

    .callreport-uk-block-default {
        background: #fff;
    }

    .callreport-uk-block-muted {
        background: #f9f9f9;
    }

    .callreport-uk-block-primary {
        background: #00a8e6;
    }

    .callreport-uk-block-secondary {
        background: #222;
    }

    .callreport-uk-block-default+.callreport-uk-block-default,
    .callreport-uk-block-muted+.callreport-uk-block-muted,
    .callreport-uk-block-primary+.callreport-uk-block-primary,
    .callreport-uk-block-secondary+.callreport-uk-block-secondary {
        padding-top: 0;
    }

    .md-card.callreport-card {
        position: relative;
        border-radius: 6px;
        -webkit-backdrop-filter: blur(30px);
        backdrop-filter: blur(30px);
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
        border: solid 1px #00448b;
        background-color: #ffffff;
        cursor: pointer;
    }

    .md-card.callreport-card+.md-card.callreport-card,
    .md-card.callreport-card+.callreport-uk-grid,
    .callreport-uk-grid+.md-card.callreport-card {
        margin-top: 25px;
    }

    .md-card.callreport-card .full_width_in_card {
        padding: 16px 24px;
        background: rgba(0, 0, 0, 0.085);
    }

    .md-card.callreport-card .md-card-toolbar {
        height: 48px;
        padding: 0 16px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        background: #fff;
    }

    .md-card.callreport-card .md-card-toolbar:after,
    .md-card.callreport-card .md-card-toolbar:before {
        content: " ";
        display: table;
    }

    .md-card.callreport-card .md-card-toolbar:after {
        clear: both;
    }

    .md-card.callreport-card .md-card-toolbar:after,
    .md-card.callreport-card .md-card-toolbar:before {
        content: " ";
        display: table;
    }

    .md-card.callreport-card .md-card-toolbar:after {
        clear: both;
    }

    .md-card.callreport-card .md-card-toolbar-heading-text {
        font: 500 14px/50px Roboto, sans-serif;
        color: #212121;
        margin: 0;
        float: left;
        overflow: hidden;
        height: 48px;
    }

    .md-card.callreport-card .md-card-toolbar-heading-text.large {
        font-size: 18px;
        font-weight: 400;
    }

    .md-card.callreport-card .md-card-toolbar .md-toggle-group {
        float: left;
        margin: 8px 0 0 16px;
    }

    .md-card.callreport-card .md-card-toolbar .md-toggle-group.md-toggle-group-small {
        margin-top: 10px;
    }

    .md-card.callreport-card .md-card-toolbar .md-card-toolbar-actions {
        float: right;
        padding-top: 10px;
    }

    .md-card.callreport-card .md-card-toolbar .md-card-toolbar-actions .callreport-uk-open .md-card-toolbar-icon {
        background: rgba(0, 0, 0, 0.085);
        color: #212121;
    }

    .md-card.callreport-card .md-card-toolbar .md-card-toolbar-actions .md-card-dropdown {
        display: inline-block;
        position: relative;
    }

    .md-card.callreport-card .md-card-toolbar .md-card-toolbar-actions .selectize-control {
        min-width: 220px;
        margin-top: -3px;
    }

    .md-card.callreport-card .md-card-toolbar .md-card-toolbar-actions .selectize-control .selectize-input {
        min-height: 30px;
        padding: 4px 8px;
    }

    .md-card.callreport-card .md-card-toolbar .md-card-toolbar-actions .selectize-control .selectize-dropdown {
        margin-top: -34px;
    }

    .md-card.callreport-card .md-card-toolbar .md-icon+.md-card-dropdown {
        margin-left: 4px;
    }

    .md-card.callreport-card .md-card-toolbar .md-card-fullscreen-deactivate {
        margin: 9px 8px 0 0;
    }

    .md-card.callreport-card .md-card-toolbar-input {
        border: none;
        font: 400 18px/24px Roboto, sans-serif;
        height: auto;
        background: 0 0 !important;
        padding: 12px 0;
        width: 50%;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .md-card.callreport-card .md-card-toolbar .callreport-uk-tab {
        margin-top: -2px;
        border-bottom: none;
    }

    .md-card.callreport-card .md-card-toolbar .callreport-uk-tab li>a {
        padding: 10px 8px !important;
    }

    .md-card.callreport-card .md-card-head {
        height: 75px;
        position: relative;
        border-bottom: 1px solid transparent;
    }

    .md-card.callreport-card .md-card-head-menu {
        position: absolute;
        right: 8px;
        top: 8px;
        border: 1px solid #e0e3e6;
        border-radius: 4px;
        background: #fff;
    }

    .img-div-callreport {
        width: 86px;
        height: 86px;
        border-radius: 50%;
        margin-top: 20px;
        display: inline-block;
    }

    .md-card.callreport-card .md-card-head-avatar {
        width: 75px;
        height: 75px;
        border-radius: 50%;
        margin-top: 4px;
        display: inline-block;
    }

    .md-card.callreport-card .md-card-head-text {
        padding: 8px 10px 8px;
        font-size: 15px;
        color: #4e5764;
        margin: 0;
        font-weight: 600;
        line-height: 1.19;
    }

    .md-card.callreport-card .md-card-head-text span:not(.listNavSelector) {
        display: block;
        font-size: 13px;
        margin-top: 5px;
        margin-bottom: 0px;
        color: #43425d;
        font-weight: 400;
        line-height: 1.25;
    }

    .md-card.callreport-card .md-card-head-text.text_dark {
        color: #303031 !important;
    }

    .md-card.callreport-card .md-card-head-text-over {
        background-image: -webkit-gradient(linear,
                left top,
                left bottom,
                from(rgba(0, 0, 0, 0.65)),
                to(rgba(0, 0, 0, 0)));
        background-image: linear-gradient(to bottom,
                rgba(0, 0, 0, 0.65) 0,
                rgba(0, 0, 0, 0) 100%);
    }

    .md-card.callreport-card .md-card-head-subtext {
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
        padding: 0 16px;
        text-align: right;
        color: #fff;
    }

    .md-card.callreport-card .md-card-head-subtext span {
        font-size: 26px;
    }

    .md-card.callreport-card .md-card-head-icon {
        font-size: 48px;
        color: #fff;
        vertical-align: middle;
    }

    .md-card.callreport-card .md-card-head.head_background {
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        border-bottom-color: transparent;
    }

    .md-card.callreport-card .md-card-head.head_background .md-card-head-text {
        color: #fff;
    }

    .md-card.callreport-card .md-card-head.head_background_top {
        background-repeat: no-repeat;
        background-position: center top;
    }

    .md-card.callreport-card .md-card-head.head_background_bottom {
        background-repeat: no-repeat;
        background-position: center bottom;
    }

    .md-card.callreport-card .md-card-head .head_chart {
        height: 100px;
        width: 100%;
        position: absolute !important;
        left: 0;
        top: 40px;
    }

    .md-card.callreport-card .md-card-head .fitVid_player {
        width: 100%;
        height: 160px;
        overflow: hidden;
    }

    .md-card.callreport-card .md-card-head-img {
        height: 100%;
        width: auto;
    }

    .md-card.callreport-card .md-card-head iframe {
        height: 160px;
    }

    .md-card.callreport-card .md-card-content {
        padding: 5px 12px 5px;
    }

    .md-card.callreport-card .md-card-content.padding-reset {
        padding: 0;
    }

    .md-card.callreport-card .md-card-content.large-padding {
        padding: 24px 35px;
    }

    .md-card.callreport-card .md-card-content.small-padding {
        padding: 8px;
    }

    .md-card.md-card-fullscreen-activate {
        cursor: pointer;
    }

    .md-card.md-card-fullscreen {
        position: fixed;
        z-index: 9998;
        overflow-x: hidden;
        cursor: default;
    }

    .md-card.md-card-fullscreen .md-card-fullscreen-activate {
        display: none;
    }

    .md-card.md-card-fullscreen .md-card-fullscreen-hide {
        display: none;
    }

    .md-card.callreport-card .md-card-fullscreen-content {
        display: none;
        padding: 16px;
    }

    .md-card-fullscreen-content-hidden .md-card.callreport-card .md-card-fullscreen-content {
        display: block;
        visibility: hidden;
        padding: 0;
    }

    .md-card.mdToolbar_fixed {
        overflow-y: hidden;
    }

    .md-card.mdToolbar_fixed>.md-card-toolbar {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        z-index: 9999;
        -webkit-box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16),
            0 3px 6px rgba(0, 0, 0, 0.23);
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    }

    .md-card.mdToolbar_fixed>.md-card-content {
        overflow-y: scroll;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        position: absolute;
        width: 100%;
        top: 48px;
        bottom: 0;
    }

    .md-card.mdToolbar_fixed>.md-card-content .md-card-fullscreen-content {
        padding: 16px 0;
    }

    .md-card.callreport-card.md-card-overlay {
        overflow: hidden;
        padding-bottom: 54px;
    }

    .md-card.callreport-card .md-card-overlay .md-card-content {
        height: 142px;
        overflow: hidden;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .md-card.callreport-card .md-card-overlay .md-card-content.no_truncate {
        position: relative;
    }

    .md-card.callreport-card.md-card-overlay .md-card-content.no_truncate:after {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 8px;
        background-image: -webkit-gradient(linear,
                left bottom,
                left top,
                color-stop(50%, #fff),
                to(rgba(255, 255, 255, 0)));
        background-image: linear-gradient(to top,
                #fff 50%,
                rgba(255, 255, 255, 0) 100%);
        display: block;
        content: "";
        z-index: 10;
    }

    .md-card.callreport-card.md-card-overlay .md-card-content>pre {
        margin-top: 0;
        max-height: 110px;
    }

    .md-card.callreport-card.md-card-overlay .md-card-content>pre>code {
        overflow: hidden;
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-content {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        padding: 0 16px;
        margin-top: -54px;
        border-top: 1px solid rgba(0, 0, 0, 0.12);
        text-align: left;
        bottom: 0;
        background: #fff;
        z-index: 10;
        -webkit-transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1);
        transition: all 280ms cubic-bezier(0.4, 0, 0.2, 1);
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-content p {
        margin: 0;
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-content p+* {
        margin-top: 16px;
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-content p+p {
        margin-top: 4px;
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-header {
        padding: 12px 0;
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-header:after,
    .md-card.callreport-card.md-card-overlay .md-card-overlay-header:before {
        content: " ";
        display: table;
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-header:after {
        clear: both;
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-header:after,
    .md-card.callreport-card.md-card-overlay .md-card-overlay-header:before {
        content: " ";
        display: table;
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-header:after {
        clear: both;
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-header h3,
    .md-card.callreport-card.md-card-overlay .md-card-overlay-header h4 {
        margin: 0;
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        padding-right: 32px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .md-card.callreport-card.md-card-overlay .md-card-overlay-header .md-icon {
        position: absolute;
        right: 12px;
        top: 11px;
    }

    .md-card.callreport-card.md-card-overlay-active .md-card-overlay-content {
        top: -1px;
        margin-top: 0;
    }

    /* .md-card.md-card-hover{
    -webkit-transition:all 280ms cubic-bezier(.4,0,.2,1);
    transition:all 280ms cubic-bezier(.4,0,.2,1);
    will-change:box-shadow
}
.md-card.md-card-hover:hover{
    -webkit-box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23);
    box-shadow:0 10px 20px rgba(0,0,0,.19),0 6px 6px rgba(0,0,0,.23)
} */
    .callreport-uk-sortable-dragged .md-card {
        -webkit-box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19),
            0 6px 6px rgba(0, 0, 0, 0.23);
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
    }

    .callreport-uk-sortable-dragged .md-card.callreport-card canvas {
        margin: 0 auto;
        display: block;
    }

    .md-card.callreport-card .heading_list {
        padding: 0;
    }

    .md-card-danger,
    .md-card-primary,
    .md-card-success,
    .md-card-warning {
        border-left: 4px solid transparent;
    }

    .md-card-primary {
        border-left-color: #00448b;
    }

    .md-card-success {
        border-left-color: #7cb342;
    }

    .md-card-danger {
        border-left-color: #e53935;
    }

    .md-card-warning {
        border-left-color: #ffa000;
    }

    .md-card-horizontal {
        position: relative;
        min-height: 200px;
    }

    .md-card-horizontal:after,
    .md-card-horizontal:before {
        content: " ";
        display: table;
    }

    .md-card-horizontal:after {
        clear: both;
    }

    .md-card-horizontal:after,
    .md-card-horizontal:before {
        content: " ";
        display: table;
    }

    .md-card-horizontal:after {
        clear: both;
    }

    .md-card-horizontal-grid {
        min-height: auto;
    }

    .md-card-horizontal .md-card-head {
        border-right: 1px solid rgba(0, 0, 0, 0.12);
        border-bottom: none;
        width: 200px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
    }

    @media only screen and (max-width: 767px) {
        .md-card-horizontal .md-card-head {
            width: 140px;
        }
    }

    .md-card-horizontal .md-card-head-grid {
        border-right: 1px solid rgba(0, 0, 0, 0.12);
    }

    .md-card-horizontal .md-card-head-menu {
        right: auto;
        left: 8px;
    }

    .md-card-horizontal .md-card-content {
        margin-left: 200px;
    }

    @media only screen and (max-width: 767px) {
        .md-card-horizontal .md-card-content {
            margin-left: 140px;
        }
    }

    .md-card-horizontal .md-card-content-grid {
        padding: 16px;
    }

    .md-expand,
    .md-expand-group>* {
        opacity: 0;
    }

    .md-card-placeholder {
        min-width: 100%;
    }

    .md-card-list-wrapper,
    .md-card-list-wrapper *,
    .md-card-list-wrapper :after,
    .md-card-list-wrapper :before,
    .md-card-list-wrapper:after,
    .md-card-list-wrapper:before {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .md-card-list-wrapper .md-card-list-header {
        position: absolute;
        top: -24px;
        left: 0;
    }

    .md-card-list-wrapper .md-card-list {
        margin: 48px 0 0 0;
        position: relative;
    }

    .md-card-list-wrapper .md-card-list:first-child {
        margin-top: 24px;
    }

    .md-card-list-wrapper .md-card-list>ul {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .md-card-list-wrapper .md-card-list>ul>li {
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .md-card-list-wrapper .md-card-list>ul>li {
        min-height: 34px;
        padding: 8px 16px;
        font-size: 13px;
        -webkit-transition: background 150ms, padding 0.2s;
        transition: background 150ms, padding 0.2s;
        background: #fff;
        -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
            0 1px 2px rgba(0, 0, 0, 0.24);
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    }

    .md-card-list-wrapper .md-card-list>ul>li:after,
    .md-card-list-wrapper .md-card-list>ul>li:before {
        content: " ";
        display: table;
    }

    .md-card-list-wrapper .md-card-list>ul>li:after {
        clear: both;
    }

    .md-card-list-wrapper .md-card-list>ul>li:after,
    .md-card-list-wrapper .md-card-list>ul>li:before {
        content: " ";
        display: table;
    }

    .md-card-list-wrapper .md-card-list>ul>li:after {
        clear: both;
    }

    .md-card-list-wrapper .md-card-list>ul>li.item-shown {
        background: #fff;
        padding: 8px 36px;
    }

    @media only screen and (max-width: 767px) {
        .md-card-list-wrapper .md-card-list>ul>li.item-shown .md-card-list-item-subject {
            clear: both;
            float: none;
            padding-top: 16px;
        }

        .md-card-list-wrapper .md-card-list>ul>li.item-shown .md-card-list-item-subject>span {
            white-space: normal;
        }
    }

    .md-card-list-wrapper .md-card-list>ul>li.item-shown .md-card-list-item-sender {
        width: auto;
        overflow: hidden;
    }

    .md-card-list-wrapper .md-card-list>ul>li.item-shown.md-card-list-item-selected {
        position: relative;
    }

    .md-card-list-wrapper .md-card-list>ul>li.item-shown.md-card-list-item-selected:before {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        top: 0;
        bottom: 0;
        width: 8px;
        background: #e3f2fd;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,
    .md-card-list-wrapper .md-card-list .md-card-list-item-select,
    .md-card-list-wrapper .md-card-list .md-card-list-item-sender {
        float: left;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-select {
        padding: 6px 8px 0 0;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper,
    .md-card-list-wrapper .md-card-list .md-card-list-item-date,
    .md-card-list-wrapper .md-card-list .md-card-list-item-sender,
    .md-card-list-wrapper .md-card-list .md-card-list-item-subject {
        padding: 0 8px;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper .md-card-list-item-avatar {
        background: #757575;
        color: #fff;
        width: 34px;
        border-radius: 50%;
        display: block;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper .md-card-list-item-avatar-large {
        width: 82px;
        border-radius: 50%;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-avatar-wrapper span.md-card-list-item-avatar {
        line-height: 34px;
        text-transform: uppercase;
        text-align: center;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-sender {
        width: 220px;
        line-height: 34px;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-sender>span {
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
    }

    @media only screen and (max-width: 1219px) {
        .md-card-list-wrapper .md-card-list .md-card-list-item-sender {
            display: none;
        }
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-subject {
        overflow: hidden;
        font-weight: 500;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-subject>span {
        line-height: 34px;
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small {
        display: none;
    }

    @media only screen and (max-width: 1219px) {
        .md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small {
            display: block;
        }

        .md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small+span {
            line-height: inherit;
        }
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-subject .md-card-list-item-sender-small>span {
        text-overflow: ellipsis;
        display: inline-block;
        vertical-align: top;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        font-size: 12px;
        color: #999;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-date {
        line-height: 34px;
        float: right;
        color: #999;
    }

    @media only screen and (max-width: 479px) {
        .md-card-list-wrapper .md-card-list .md-card-list-item-date {
            display: none;
        }
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-menu {
        float: right;
        margin: 0 0 0 8px;
        position: relative;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-menu .callreport-uk-dropdown .material-icons {
        margin-right: 8px;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-content-wrapper {
        display: none;
        clear: both;
        opacity: 0;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-content {
        padding: 16px 16px 0 0;
        max-height: 360px;
        overflow-x: hidden;
        margin: 0 0 40px;
        top: 20px;
        position: relative;
        font-size: 14px;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-content+.md-card-list-item-reply {
        padding-top: 10px;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-reply {
        padding: 16px 0;
    }

    .md-card-list-wrapper .md-card-list .md-card-list-item-selected {
        background: #e3f2fd;
    }

    .md-list {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .md-list>li {
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .md-list,
    .md-list *,
    .md-list :after,
    .md-list :before,
    .md-list:after,
    .md-list:before {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .md-list .callreport-uk-nestable-list>li,
    .md-list>li {
        min-height: 48px;
        padding: 8px 4px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        position: relative;
    }

    .md-list .callreport-uk-nestable-list>li>.md-list-content,
    .md-list>li>.md-list-content {
        overflow: hidden;
    }

    .md-list .callreport-uk-nestable-list>li>.md-list-content>span,
    .md-list>li>.md-list-content>span {
        display: block;
    }

    .md-list .callreport-uk-nestable-list>li>.md-list-content .md-list-heading,
    .md-list>li>.md-list-content .md-list-heading {
        margin: 0;
        font-weight: 500;
        display: block;
        overflow: hidden;
        padding-bottom: 1px;
    }

    .md-list .callreport-uk-nestable-list>li>.md-list-content .md-list-menu,
    .md-list>li>.md-list-content .md-list-menu {
        float: right;
    }

    .md-list .callreport-uk-nestable-list>li>.md-list-content .md-list-menu .md-list-menu-toggle,
    .md-list>li>.md-list-content .md-list-menu .md-list-menu-toggle {
        display: block;
        font-size: 18px;
        color: rgba(0, 0, 0, 0.8);
        width: 28px;
        height: 28px;
        line-height: 28px;
        border-radius: 14px;
        text-align: center;
    }

    .md-list .callreport-uk-nestable-list>li>.md-list-content .callreport-uk-badge,
    .md-list>li>.md-list-content .callreport-uk-badge {
        float: right;
        color: #fff !important;
    }

    .md-list .callreport-uk-nestable-list>li>.md-list-content .md-list-action,
    .md-list>li>.md-list-content .md-list-action {
        float: right;
        margin-left: 8px;
        margin-top: 2px;
        display: none;
    }

    .md-list .callreport-uk-nestable-list>li>.md-list-content .md-list-action-placeholder,
    .md-list>li>.md-list-content .md-list-action-placeholder {
        float: right;
        margin-left: 8px;
        display: none;
        width: 32px;
        height: 32px;
    }

    .md-list .callreport-uk-nestable-list>li .md-list-action-dropdown,
    .md-list>li .md-list-action-dropdown {
        position: absolute;
        right: 16px;
        top: 10px;
        display: none;
    }

    .md-list .callreport-uk-nestable-list>li>a.md-list-content,
    .md-list>li>a.md-list-content {
        display: block;
        color: #212121;
    }

    .md-list .callreport-uk-nestable-list>li:last-child,
    .md-list>li:last-child {
        border-bottom: none;
    }

    .md-list .callreport-uk-nestable-list>li.md-list-item-active,
    .md-list>li.md-list-item-active {
        color: #7cb342;
        background: #ededed;
    }

    .md-list .callreport-uk-nestable-list>li.md-list-item-disabled>.md-list-content,
    .md-list>li.md-list-item-disabled>.md-list-content {
        color: #bdbdbd;
    }

    .md-list .callreport-uk-nestable-list>li.md-list-item-disabled>.md-list-content span,
    .md-list>li.md-list-item-disabled>.md-list-content span {
        color: #bdbdbd !important;
    }

    .md-list .callreport-uk-nestable-list>li.heading_list,
    .md-list>li.heading_list {
        min-height: 32px;
        padding: 32px 8px 16px;
        border-bottom: none;
        background: 0 0 !important;
        text-transform: uppercase;
    }

    .md-list .callreport-uk-nestable-list>li:hover>.md-list-addon-element .callreport-uk-nestable-handle,
    .md-list>li:hover>.md-list-addon-element .callreport-uk-nestable-handle,
    .callreport-uk-touch .md-list .callreport-uk-nestable-list>li>.md-list-addon-element .callreport-uk-nestable-handle,
    .callreport-uk-touch .md-list>li>.md-list-addon-element .callreport-uk-nestable-handle {
        display: block;
    }

    .md-list .callreport-uk-nestable-list>li:hover>.md-list-content .md-list-action,
    .md-list .callreport-uk-nestable-list>li:hover>.md-list-content .md-list-action-placeholder,
    .md-list>li:hover>.md-list-content .md-list-action,
    .md-list>li:hover>.md-list-content .md-list-action-placeholder,
    .callreport-uk-touch .md-list .callreport-uk-nestable-list>li>.md-list-content .md-list-action,
    .callreport-uk-touch .md-list .callreport-uk-nestable-list>li>.md-list-content .md-list-action-placeholder,
    .callreport-uk-touch .md-list>li>.md-list-content .md-list-action,
    .callreport-uk-touch .md-list>li>.md-list-content .md-list-action-placeholder {
        display: block;
    }

    .md-list .callreport-uk-nestable-list>li:hover .md-list-action-dropdown,
    .md-list>li:hover .md-list-action-dropdown,
    .callreport-uk-touch .md-list .callreport-uk-nestable-list>li .md-list-action-dropdown,
    .callreport-uk-touch .md-list>li .md-list-action-dropdown {
        display: block;
    }

    .md-list .callreport-uk-nestable-list>li {
        margin-left: 64px;
    }

    .md-list-addon>li {
        margin-left: 64px;
        position: relative;
    }

    .md-list-addon>li:last-child .md-list-addon-element {
        border-bottom: none;
        bottom: 0;
    }

    .md-list-addon>li:first-child .md-list-addon-element {
        top: 0;
    }

    .md-list-addon>li.md-list-item-active .md-list-addon-element,
    .md-list-addon>li.md-list-item-active .md-list-addon-element .material-icons {
        color: #7cb342;
    }

    .md-list-addon-element {
        position: absolute;
        left: -64px;
        top: -1px;
        bottom: -1px;
        width: 64px;
        text-align: center;
        padding: 8px 0;
        display: block;
    }

    .md-list-addon-element .element-status {
        position: absolute;
        right: 12px;
        top: 10px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #bdbdbd;
        border: 1px solid #fff;
    }

    .md-list-addon-element .element-status-danger {
        background: #e53935;
    }

    .md-list-addon-element .element-status-success {
        background: #7cb342;
    }

    .md-list-addon-element .element-status-warning {
        background: #ffa000;
    }

    .md-list-addon-element>.md-list-addon-avatar {
        margin-top: 2px;
    }

    .md-list-addon-element>.md-list-addon-icon {
        font-size: 28px;
        margin-top: 4px;
        color: #727272;
    }

    .md-list-addon-element>.material-icons {
        margin-top: 6px;
    }

    .md-list-addon-element .icheckbox_md,
    .md-list-addon-element .iradio_md {
        margin-top: 10px;
    }

    .md-list-addon-element .callreport-uk-nestable-handle {
        position: absolute;
        left: -2px;
        top: 12px;
        display: none;
    }

    .md-list-interactive li {
        cursor: pointer;
    }

    .md-list-bg {
        background: #fff;
    }

    .md-list-separated li {
        background: #fff;
        padding: 8px;
    }

    .md-list-separated li+li {
        border-top: none;
        margin-top: 8px;
    }

    .md-list-bg-no-sep {
        background: #fff;
        padding: 8px;
    }

    .md-list-bg-no-sep li>.md-list-content {
        padding: 0 4px;
    }

    .md-list-outside>li {
        padding: 0;
    }

    .md-list-outside>li>.md-list-content {
        padding: 8px 16px;
        display: block;
        color: #212121;
    }

    .md-list-outside>li.md-list-item-active,
    .md-list-outside>li:hover:not(.heading_list) {
        background: rgba(0, 0, 0, 0.085);
    }

    .md-list-outside>li.heading_list {
        padding: 32px 16px 16px;
    }

    .md-list-outside.md-list-addon li {
        margin-left: 0;
    }

    .md-list-outside.md-list-addon li .md-list-addon-element {
        position: relative;
        top: auto;
        left: auto;
        float: left;
    }

    .md-list-outside.md-list-addon li .md-list-content {
        padding-left: 0;
    }

    .md-list-outside-wrapper {
        position: relative;
    }

    .md-list-outside-wrapper .md-list-outside-search {
        position: absolute;
        top: -46px;
        left: 16px;
        right: 16px;
        z-index: 1000;
    }

    .md-list-outside-wrapper .md-list-outside-search .md-input-wrapper {
        padding: 0;
    }

    .md-list-outside-wrapper .md-list-outside-search .md-input-wrapper .md-input-bar:after,
    .md-list-outside-wrapper .md-list-outside-search .md-input-wrapper .md-input-bar:before {
        background: #fff;
    }

    .md-list-outside-wrapper .md-list-outside-search .md-input {
        border-bottom-color: transparent !important;
    }

    .md-list .callreport-uk-nestable-list {
        padding-left: 0;
    }

    .md-list .callreport-uk-nestable-list .callreport-uk-nestable-item {
        padding-right: 0;
    }

    .md-list .callreport-uk-nestable-item+.callreport-uk-nestable-item {
        margin-top: 0;
    }

    .md-list-right.md-list-addon>li {
        margin-left: 0;
        margin-right: 64px;
    }

    .md-list-right.md-list-addon>li .md-list-addon-element {
        left: auto;
        right: -64px;
    }

    .callreport-uk-touch .md-list-addon-element .callreport-uk-nestable-handle {
        display: block !important;
    }

    .callreport-uk-touch .md-list-content .md-list-action,
    .callreport-uk-touch .md-list-content .md-list-action-placeholder {
        display: block !important;
    }

    .callreport-uk-touch .md-list-action-dropdown {
        display: block !important;
    }

    .card-box.callreport-box {
        box-sizing: border-box;
        padding-left: 15px;
        padding-bottom: 20px;
        display: inline-block;
    }

    .pink-box {
        box-shadow: 0 2px 10px 0 rgba(255, 38, 138, 0.55);
        background-color: #ff268a;
    }

    .blue-box {
        box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
        background-color: #00448b;
    }

    .lightblue-box {
        box-shadow: 0 2px 10px 0 rgba(13, 132, 242, 0.36);
        background-color: #50bcff;
    }

    .orange-box {
        box-shadow: 0 2px 10px 0 rgba(245, 166, 35, 0.35);
        background-color: #f5a623;
    }

    .border-orange1 {
        border-color: #ff7f00 !important;
    }

    .border-green1 {
        border-color: #1a9347 !important;
    }

    .border-red1 {
        border-color: #e82828 !important;
    }

    /* Employes List CSS */
    /* .md-white-bg, .white-bg {
    background-color: #fff!important;
    color: #303031!important;
}

.content-table {
    position: relative;
    width: 100%;
}
.mat-table {
    background: #fff;
    display: block;
    box-shadow: none;
}
.mat-table-header, .mat-table-block {
    display: flex;
    box-sizing: border-box;
    flex-direction: row;
}
.mat-header-row, .mat-row {
    border-bottom-color: rgba(0,0,0,0);
    display: flex;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    align-items: center;
    min-height: 60px;
    padding: 0 10px;
    margin: 0 24px;
}
.mat-icon-header, .mat-icon-cell {
    max-width: 64px;
    min-width: 64px;
    flex: 1 1 64px;
    box-sizing: border-box;
}
.mat-cell, .mat-header-cell {
    flex: 1;
}
.mat-header-cell {
    color: #4e5764;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
}
.m-r-5 {
    margin-right: 5px!important;
}
.md-light-blue-50-bg {
    color: rgba(0,0,0,.87)!important;
}
.list-item:last-child {
    min-height: 65px;
    border-radius: 9px;
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.09);
    background-color: #fff;
}
.list-item:last-child {
    border-bottom: 2px solid rgba(231, 236, 241, 0) !important;
}

.mat-ripple {
    overflow: visible;
}
.mat-cell {
    color: rgba(0,0,0,.87);
}
.form-image {
    width: 36px !important;
    height: 36px !important;
}
.formimg img {
    box-shadow: 0 5px 11px 0 rgba(0, 0, 0, 0.18), 0 4px 15px 0 rgba(0, 0, 0, 0.15);
    transition: all 0.2s linear;
}
.rounded-circle {
    border-radius: 50%!important;
    box-shadow: 0px 4px 5px -2px rgba(0,0,0,0.2), 0px 7px 10px 1px rgba(0,0,0,0.14), 0px 2px 16px 1px rgba(0,0,0,0.12);
    border: 2px solid #fff;
} */

    .mat-table {
        background: #fff;
        box-shadow: none;
        display: block;
        margin: 0px 5px 20px;
    }

    .mat-header-row,
    .mat-row {
        flex-direction: row;
        box-sizing: border-box;
        display: flex;
        padding: 0px 14px;
    }

    .mat-header-cell {
        font-size: 14px;
        font-weight: 600;
        color: #005dae;
        display: flex;
        align-items: center;
        overflow: hidden;
        word-wrap: break-word;
        min-height: inherit;
        text-transform: uppercase;
    }

    .mat-cell,
    .mat-footer-cell,
    .mat-header-cell {
        flex: 1;
        display: flex;
        align-items: center;
        overflow: hidden;
        word-wrap: break-word;
        min-height: inherit;
    }

    .mat-header-cell.mat-header-first,
    .mat-cell.mat-cell-first {
        flex: 1 1 200px;
        box-sizing: border-box;
        max-width: 200px;
        min-width: 200px;
    }

    .mat-header-row {
        min-height: 56px;
    }

    .mat-table .mat-row {
        position: relative;
        cursor: pointer;
        min-height: 65px;
        border-radius: 9px;
        box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.09);
        background-color: #fff;
        margin-bottom: 10px;
    }

    .mat-header-row,
    .mat-row {
        border-width: 0;
        border-bottom-width: 1px;
        border-style: solid;
        align-items: center;
        border-bottom-color: rgba(0, 0, 0, 0);
    }

    .mat-cell .mat-icon {
        background-repeat: no-repeat;
        display: inline-block;
        fill: currentColor;
        height: 24px;
        width: 24px;
        font-weight: 400 !important;
        line-height: 1;
    }

    .mat-cell,
    .mat-footer-cell {
        font-size: 14px;
        color: #303031;
    }

    .avatar.avatar-border {
        border: 1.5px solid rgb(205, 210, 218);
        background-color: rgba(255, 255, 255, 0);
        width: 47px !important;
        height: 47px !important;
        border-radius: 50%;
        margin-top: 20px;
        display: inline-block;
        min-width: 47px !important;
    }

    .avatar.avatar-border img {
        width: 37px !important;
        height: 37px !important;
        border-radius: 50%;
        min-width: 37px !important;
        max-width: 37px !important;
        max-height: 37px !important;
    }

    .mat-cell .list-group .list-group-item h3 {
        font-size: 14px !important;
        font-weight: 600;
    }

    .mat-cell .list-group .list-group-item p {
        font-size: 12px !important;
        font-weight: 600 !important;
        color: #4e5764 !important;
    }

    .mat-cell .list-group .list-group-item>.avatar {
        margin: 0 1rem 0 0 !important;
    }

    .des-list-box {
        border-radius: 5px;
        padding: 7px 10px;
        color: #fff;
        width: 110px;
        text-align: center;
    }

    .mat-row:hover .eyeIcon {
        color: #00448b !important;
    }

    .mat-row:hover .editIcon {
        color: #00448b !important;
    }

    .mat-row:hover .deleteIcon {
        color: #00448b !important;
    }

    .mat-row:hover .cloudIcon {
        color: #e82828 !important;
    }

    .card-group {
        margin-bottom: 2.143rem;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        flex-direction: column;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
    }

    .card-block {
        position: relative;
        padding: 1.429rem;
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 auto;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
    }

    .card.card-block {
        box-shadow: none;
    }

    @media (min-width: 480px) {
        .card-group {
            -webkit-flex-flow: row wrap;
            -ms-flex-flow: row wrap;
            flex-flow: row wrap;
        }

        .card-group .card:first-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
        }

        .card-group .card {
            margin-bottom: 0;
            -webkit-box-flex: 1;
            -webkit-flex: 1 0 0%;
            -ms-flex: 1 0 0%;
            flex: 1 0 0%;
        }
    }

    .counter {
        text-align: center;
    }

    .vertical-align:before {
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        content: "";
    }

    .vertical-align-bottom,
    .vertical-align-middle {
        display: inline-block;
        max-width: 100%;
        font-size: 1rem;
    }

    .vertical-align-middle {
        vertical-align: middle;
    }

    .counter-lg .counter-icon {
        font-size: 40px;
    }

    .counter-inverse .counter-icon {
        color: #00448b;
    }

    .counter-inverse {
        color: #303031;
    }

    .h-150 {
        height: 150px !important;
    }

    .modal-qr-block {
        width: 100%;
        position: relative;
        display: block;
        padding: 20px 10px 0px;
        text-align: center;
    }

    .modal-passport-block {
        width: 100%;
        position: relative;
        display: block;
        padding: 5px 10px 0px;
    }

    .option__image {
        max-height: 80px;
        margin-right: 10px;
    }

    .option__desc,
    .option__image {
        display: inline-block;
        vertical-align: middle;
    }

    .option__desc {
        padding: rem(10px);
    }

    .option__title {
        font-size: rem(24px);
    }

    .option__small {
        margin-top: rem(10px);
        display: block;
    }

    .form__label {
        margin-top: 5px !important;
    }

    .badge__img {
        vertical-align: middle;
        float: right;
    }

    .badge__name {
        vertical-align: middle;
        display: inline-block;
        margin-left: 5px;
    }

    .request-section {
        border: solid 1px #70707017;
        background-color: rgba(13, 132, 242, 0.1);
        text-align: center;
        padding-top: 20px;
        padding-bottom: 20px;
    }

    .callreportheader {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 40px;
        height: 100%;
        position: relative;
        background: #d6e2ef;
        -webkit-box-shadow: none;
        box-shadow: none;
    }

    .callreportheader>.descriptionheader {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 16px 25px;
        border-bottom: 1px solid transparent;
        justify-content: center;
    }

    .callreportheader>.descriptionheader .description-text-header-left h5 {
        font-size: 16px;
        font-weight: 600;
        margin: 0;
        color: #00448b;
        text-align: center !important;
        text-transform: uppercase;
    }

    .callreportheader>.descriptionheader .description-text-header-right {
        font-size: 13px;
        margin-left: auto;
        padding-left: 12px;
        color: #4e5764;
        font-weight: 500;
    }

    .callreportheader>.descriptionheader .description-text-header-right {
        display: block;
        margin-top: 30px;
    }

    .request-tab-header {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.22;
        letter-spacing: 0.77px;
        color: #303031;
        margin-top: 10px;
        margin-bottom: 20px;
        width: 100% !important;
        text-align: left;
        padding-left: 63px;
    }

    .see-link {
        text-decoration: underline;
        font-size: 13px;
        font-weight: normal;
        line-height: 1.2;
        color: #00448b;
        cursor: pointer;
        float: right;
    }

    .btn-outline-danger:hover {
        color: #fff !important;
        background-color: #f44336;
        border-color: #f44336;
    }

    .btn-outline-danger {
        color: #f44336 !important;
        background-color: transparent;
        background-image: none;
        border-color: #f44336;
    }

    .btn-secondary.btn-outline {
        color: #00448b !important;
        background-color: transparent;
        background-image: none;
        border: 1px solid #00448b;
    }

    .btn-secondary.btn-outline:hover {
        color: #fff !important;
        background-color: #00448b;
        border-color: #00448b;
    }

    .nav-tabs.nav-callreport .nav-link.active,
    .nav-tabs.nav-callreport .nav-item.show .nav-link {
        color: #00448b;
        background-color: transparent;
    }

    .nav-tabs.nav-callreport .nav-link.active:not(.dropdown-toggle):after,
    .nav-tabs.nav-callreport .nav-item.show .nav-link:not(.dropdown-toggle):after {
        background-color: #00448b;
    }

    .nav.nav-tabs.nav-callreport {
        background: transparent;
        border-radius: 15px 15px 0px 0px;
        padding: 0px 150px;
    }

    @media (max-width: 992px) {
        .nav.nav-tabs.nav-callreport {
            padding: 0px 70px !important;
        }
    }

    @media (max-width: 768px) {
        .nav.nav-tabs.nav-callreport {
            padding: 0px 40px !important;
        }
    }

    @media (max-width: 562px) {
        .nav.nav-tabs.nav-callreport {
            padding: 0px 20px !important;
        }
    }

    .nav-tabs.nav-callreport .nav-link.active {
        overflow: visible;
    }

    .nav-tabs.nav-callreport .nav-link:hover,
    .nav-tabs.nav-callreport .nav-link:focus {
        border-color: #00448b;
        background-image: linear-gradient(to left, #005dae, #005dae 53%, #005dae);
        color: #fff !important;
    }

    .nav-tabs.nav-callreport .nav-link.active,
    .nav-tabs.nav-callreport .nav-item.show .nav-link {
        border-color: #00448b;
        background-image: linear-gradient(to left, #005dae, #005dae 53%, #005dae);
        color: #fff;
    }

    .nav-tabs.nav-callreport .nav-link {
        border: 1px solid #00448b;
        position: relative;
        display: block;
        height: 70px !important;
        border-radius: 0px;
        pointer-events: none;
    }

    .nav-tabs.nav-callreport .nav-link img {
        display: block;
        text-align: center;
        margin: 8px auto 6px;
    }

    .nav-tabs.nav-callreport .nav-link i {
        display: block;
        text-align: center;
        margin: 12px auto 6px;
        font-size: 18px !important;
        width: 18px;
        height: 18px;
        line-height: 18px;
        color: #00448b;
    }

    .nav-tabs.nav-callreport .nav-link.active i,
    .nav-tabs.nav-callreport .nav-item.show .nav-link i {
        color: #fff !important;
    }

    .nav-tabs.nav-callreport .nav-link:hover i,
    .nav-tabs.nav-callreport .nav-link:focus i {
        color: #fff;
    }

    .nav-tabs.nav-callreport .nav-link h6 {
        display: block;
        font-size: 14px;
        text-align: center;
        font-weight: 800;
        color: #303031;
    }

    .nav-tabs.nav-callreport .nav-link.active h6,
    .nav-tabs.nav-callreport .nav-item.show .nav-link h6 {
        color: #fff;
    }

    .nav-tabs.nav-callreport .nav-link:hover h6,
    .nav-tabs.nav-callreport .nav-link:focus h6 {
        color: #fff;
    }

    .tabs.tabs-style-iconbox {
        position: relative;
        margin: 0 auto;
        width: 100%;
        font-weight: 600;
        font-size: 14px;
    }

    .tabs.tabs-style-iconbox {
        background: rgba(255, 255, 255, 0.4);
    }

    .tabs.tabs-style-iconbox {
        text-align: center;
    }

    .tabs.tabs-style-iconbox {
        position: relative;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: flex;
        margin: 0 auto;
        padding: 0;
        max-width: 1200px;
        list-style: none;
        -ms-box-orient: horizontal;
        -ms-box-pack: center;
        -webkit-flex-flow: row wrap;
        -moz-flex-flow: row wrap;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        -webkit-justify-content: center;
        -moz-justify-content: center;
        -ms-justify-content: center;
        justify-content: center;
    }

    .tabs.tabs-style-iconbox li {
        position: relative;
        z-index: 1;
        display: block;
        margin: 0;
        text-align: center;
        -webkit-flex: 1;
        -moz-flex: 1;
        -ms-flex: 1;
        flex: 1;
    }

    .tabs.tabs-style-iconbox li.tab-current {
        z-index: 100;
    }

    .tabs.tabs-style-iconbox a {
        position: relative;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 2.5;
        text-decoration: none;
        outline: none;
        width: 100%;
    }

    .tabs.tabs-style-iconbox li a {
        overflow: visible;
        padding: 2em 0;
        line-height: 1;
        -webkit-transition: color 0.2s;
        transition: color 0.2s;
    }

    .tabs.tabs-style-iconbox li.tab-current a {
        color: #74777b;
    }

    .tabs.tabs-style-iconbox li.tab-current a {
        background: #fff;
        box-shadow: -1px 0 0 #fff;
    }

    .tabs.tabs-style-iconbox .icon::before {
        display: block;
        margin: 0 0 0.25em 0;
    }

    .tabs.tabs-style-iconbox a span {
        vertical-align: middle;
        font-size: 0.75em;
    }

    .tabs.tabs-style-iconbox li a span {
        font-weight: 700;
        font-size: 0.7em;
    }

    .tabs.tabs-style-iconbox li.tab-current a::after,
    .nav-tabs .nav-link.active:not(.dropdown-toggle):after,
    .nav-tabs .nav-item.show .nav-link:not(.dropdown-toggle):after {
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -10px;
        width: 0;
        height: 0;
        border: solid transparent;
        border-width: 10px;
        border-top-color: #00448b;
        content: "";
        pointer-events: none;
        background-color: transparent !important;
    }

    .inputFieldSalesTable {
        font-size: 14px !important;
        padding: 15px 2px 5px 2px !important;
        display: block;
        width: 8rem;
        border: none;
        background: transparent !important;
        color: #303031;
        font-weight: 600;
    }

    .inputFieldSalesTableFlex {
        margin-bottom: 1.6rem;
    }

    .btn-table {
        border-radius: 1px;
        border: dotted 0.5px #aaaaaa;
        background-color: rgba(214, 226, 239, 0.34);
        width: 100%;
        text-align: center;
        color: #303031;
        font-size: 14px;
        font-weight: 600;
        padding-top: 10px;
        padding-bottom: 10px;
        border-radius: 4px;
    }

    /* .pac-container.pac-logo::after {
  display: none !important;
} */
    .quillWrapper .ql-toolbar.ql-snow .ql-formats .ql-image,
    .quillWrapper .ql-toolbar.ql-snow .ql-formats .ql-video {
        display: none !important;
    }
</style>

<style scoped>
    .unfinishedCircle {
        background: #e8e8e8;
        border-radius: 50%;
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: rgba(0, 0, 0, 0.32);
        font-weight: 500;
    }

    .finishedCircle {
        background: #128807;
        border-radius: 50%;
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-weight: 500;
    }

    .selectedCircle {
        background: #ff9a06;
        border-radius: 50%;
        height: 50px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ffffff;
        font-weight: 500;
    }

    .finishedCircleText {
        position: absolute;
        font-size: 14px;
        color: #303031;
        margin-top: 6em;
        font-weight: 600;
    }

    .unfinishedCircleText {
        position: absolute;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.32);
        margin-top: 6em;
        font-weight: 600;
    }

    .unfinishedDash {
        color: #e8e8e8;
        font-size: 20px;
        border-top: 1px dashed rgba(0, 0, 0, 0.32);
        width: 100px;
    }

    .finishedDash {
        color: #128807;
        font-size: 20px;
        border: 1px dashed #128807;
        width: 100px;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #00448b !important;
        border-color: #00448b !important;
    }

    .input-width {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px !important;
    }

    .input-field {
        border-radius: 5px !important;
        border: solid 0.5px #3f3f3f;
        background-color: #fff;
        padding: 8px 10px;
        width: 100% !important;
        height: 40px;
        font-weight: 600;
    }

    .text-line {
        text-decoration: none !important;
    }

    .date-picker-clock-svg-icon {
        padding-left: 10px !important;
    }

    .mx-calendar-content .cell.actived {
        color: #fff !important;
        height: 70px;
        border-radius: 50%;
        left: 0px;
        top: 0px
    }

    .upload-img {
        margin-left: 52px;
        width: 42px;
        margin-bottom: 12px;
    }

    .icon-img {
        width: 40px;
        height: 40px;
    }
    .iconsize-16{
        line-height:22px !important;
    }
    .editor-container {
        position: relative;
        transition: all 0.3s;
    }
    .fullscreen-btn {
        position: absolute;
        right: 7px;
        top: 6px;
        z-index: 99;
    }
    .exit-fullscreen-btn {
        position: absolute;
        right: 7px;
        top: 33px;
        z-index: 99;
    }
    .editor-fullscreen {
        position: fixed !important;
        z-index: 10000 !important;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background: #fff;
        padding: 20px 10px 0 10px;
        box-sizing: border-box;
    }
    .editor-fullscreen .mt-2.wyseditor {
        height: 100vh !important;
        min-height: 80vh;
        max-height: 100vh;
    }
</style>


// WEBPACK FOOTER //
// src/components/CallReport.vue